import "./chunk-BFS324UO.js";
import {
  MembersPage
} from "./chunk-6Y5SDRY4.js";
import "./chunk-5AHL7NPT.js";
import {
  EditMemberProvider
} from "./chunk-RCE3XEVC.js";
import "./chunk-LQPMEKFY.js";
import "./chunk-5JRJQK3J.js";
import "./chunk-HZ3OFIQH.js";
import {
  EditRoleProvider
} from "./chunk-IQ7GR5QS.js";
import "./chunk-ETATWG4J.js";
import "./chunk-VCJMA6AO.js";
import {
  RolesPage
} from "./chunk-CZPCBQ2E.js";
import "./chunk-TI2UK6ZV.js";
import "./chunk-6TGZT635.js";
import {
  PermissionPage
} from "./chunk-RTARS36X.js";
import "./chunk-GOI2S3PC.js";
import "./chunk-BH5BVBWY.js";
import "./chunk-22SAVPKI.js";
import "./chunk-3DKAWVGO.js";
import "./chunk-364LXEWW.js";
import "./chunk-WJJKQGYK.js";
import {
  ProfilePage
} from "./chunk-6E7IJ5JY.js";
import "./chunk-ITKU2TZO.js";
import "./chunk-R57YCOHE.js";
import "./chunk-ZXCN2AFP.js";
import {
  EditMemberRoleProvider
} from "./chunk-ZGACIDGI.js";
import "./chunk-LDLRZFVY.js";
import "./chunk-HQRF5ZRF.js";
import "./chunk-UUCAFOTX.js";
import "./chunk-DOLETXOX.js";
import "./chunk-BDYOI5R6.js";
import "./chunk-EBEDYFR7.js";
import "./chunk-IZPGLWFT.js";
import "./chunk-7SX54CPA.js";
import "./chunk-TBVUSQGR.js";
import "./chunk-IVGRCTQI.js";
import {
  MemberRolePage
} from "./chunk-R5WNNYS4.js";
import "./chunk-KLI3PVOY.js";
import "./chunk-N5PAYPRJ.js";
import "./chunk-JZ6IDXRF.js";
import "./chunk-JSQNGOOA.js";
import "./chunk-5ZYEZAFF.js";
import "./chunk-VLR4SFUO.js";
import {
  Licenses
} from "./chunk-CQCF4OAH.js";
import "./chunk-IZ72HZWM.js";
import "./chunk-BTGE2OKJ.js";
import "./chunk-KPGV6YXG.js";
import "./chunk-NNZB4Z3C.js";
import "./chunk-ZCUA6X2A.js";
import {
  DigitalAssetsPage
} from "./chunk-YTZANEVI.js";
import {
  LoginPage
} from "./chunk-B2MSTDTH.js";
import "./chunk-ZVOJGXKE.js";
import "./chunk-MPXR4OUE.js";
import "./chunk-M54HUBSG.js";
import "./chunk-YWY6L42Z.js";
import "./chunk-3TVYLYMS.js";
import "./chunk-SAX2OUG2.js";
import "./chunk-EIXBWIAA.js";
import "./chunk-LRQNUSLO.js";
import "./chunk-JH6MKNTA.js";
import "./chunk-7TYPSGBS.js";
import "./chunk-UNJCJGB4.js";
import {
  isLogin,
  login,
  logout
} from "./chunk-VYVU7WCO.js";
import "./chunk-7DXXLXSE.js";
import {
  A as A6,
  AppProvider,
  FormSelection,
  Header,
  MainLayout,
  Menu,
  SbarLeft,
  renderField,
  renderingGroupFieldHandler,
  useAppContext
} from "./chunk-G4Q7KMKF.js";
import {
  InputPassword
} from "./chunk-YJN4ZFM6.js";
import {
  FormDateRangePicker
} from "./chunk-WVY656PJ.js";
import "./chunk-NCTNDEQ3.js";
import {
  FormRadio
} from "./chunk-DFHZIFWP.js";
import "./chunk-KBLS5ZZS.js";
import {
  A as A4
} from "./chunk-G4NJKMR2.js";
import {
  FormVideo
} from "./chunk-UNTJS24T.js";
import {
  A as A5
} from "./chunk-BPE5XHEH.js";
import {
  A
} from "./chunk-TSTKR7BL.js";
import "./chunk-JWEI4U7J.js";
import {
  FormCheckbox
} from "./chunk-RBHCGDN4.js";
import {
  A as A2
} from "./chunk-BJU2BZOM.js";
import {
  FormDAMImage
} from "./chunk-ZIXZUI2P.js";
import {
  FormEditor
} from "./chunk-DGBNAAC6.js";
import {
  A as A3
} from "./chunk-SX7KNHCV.js";
import "./chunk-572FBZJF.js";
import {
  A as A7
} from "./chunk-4COC2UV3.js";
import "./chunk-UPWSIKF4.js";
import {
  TableBar
} from "./chunk-SM6B6XM3.js";
import "./chunk-DXNAHFM5.js";
import {
  ThumbWithTranslation
} from "./chunk-KZPC2LDV.js";
import "./chunk-YEAUZ2ZG.js";
import {
  SVGComponent
} from "./chunk-C5UZGLWY.js";
import {
  Hambuger
} from "./chunk-FB6FH7DE.js";
import {
  LanguagesSwitcher
} from "./chunk-2RZXKXSF.js";
import {
  AesirXSelectExtended
} from "./chunk-HMAYFD5S.js";
import "./chunk-5IAIJTV5.js";
import {
  Logo
} from "./chunk-6LYV7PFE.js";
import {
  ModalDAMComponent
} from "./chunk-25MFLZ6O.js";
import {
  ModalComponentExtended
} from "./chunk-RG5IZ5BE.js";
import "./chunk-R5DSNFA2.js";
import {
  CustomizedDatePicker
} from "./chunk-7SBVZY5O.js";
import {
  AesirXDatePicker
} from "./chunk-VZ3UDYEH.js";
import {
  GlobalFilter
} from "./chunk-TB2DL46M.js";
import "./chunk-VN5TCXRT.js";
import {
  A as A8
} from "./chunk-NNGRNXS6.js";
import {
  Button
} from "./chunk-3RL7KU3G.js";
import {
  Image
} from "./chunk-2MXWHUGP.js";
import {
  B
} from "./chunk-FGYRF4SY.js";
import {
  Checkbox
} from "./chunk-BYTQRG5C.js";
import {
  ComponentCard
} from "./chunk-LNELISX4.js";
import "./chunk-EUVCSI7K.js";
import {
  Spinner
} from "./chunk-POLRV4GK.js";
import {
  PulseLoaderComponent
} from "./chunk-IU6SKPZA.js";
import {
  RingLoaderComponent
} from "./chunk-25DH6MKJ.js";
import "./chunk-APR4SZIP.js";
import {
  Toast,
  notify,
  notifyHTML
} from "./chunk-DL5QNKBI.js";
import {
  history
} from "./chunk-MX4OMHUR.js";
import "./chunk-7EEEIQ7E.js";
import "./chunk-5KSDJ76Q.js";
import {
  ErrorBoundary
} from "./chunk-GNASQP25.js";
import {
  AesirXI18nextProvider,
  useI18nextContext,
  withI18nextContext
} from "./chunk-DQPEKNUI.js";
import {
  ThemesContext,
  ThemesContextProvider,
  listThemes,
  useThemeContext,
  withThemeContext
} from "./chunk-DB7NRMFG.js";
import "./chunk-RZDQLH3W.js";
import {
  FORMAT_DATE,
  FORMAT_DATE_TIME_UPDATE_POST,
  FORMAT_DATE_UPDATE_POST,
  FORMAT_TIME,
  FORM_FIELD_TYPE
} from "./chunk-IIJXEE2D.js";
import {
  PAGE_STATUS
} from "./chunk-OSVSI4BW.js";
import "./chunk-2IELYSVJ.js";
import "./chunk-JCO6WRHX.js";

// src/scss/app.scss
var css = `@charset "UTF-8";
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
:root,
[data-bs-theme=light] {
  --aesirxui-blue: #0a5aff;
  --aesirxui-indigo: #6610f2;
  --aesirxui-purple: #6a3e73;
  --aesirxui-pink: #d63384;
  --aesirxui-red: #cb222c;
  --aesirxui-orange: #f78464;
  --aesirxui-yellow: #ff9e01;
  --aesirxui-green: #1ab394;
  --aesirxui-green-light: #d1fae5;
  --aesirxui-teal: #20c997;
  --aesirxui-cyan: #1a73e8;
  --aesirxui-white: #fff;
  --aesirxui-gray: #8e8e8e;
  --aesirxui-gray-dark: #e9e9e9;
  --aesirxui-gray-100: #f6f8fa;
  --aesirxui-gray-200: #f9f9f9;
  --aesirxui-gray-300: #ebebeb;
  --aesirxui-gray-400: #e3e3e3;
  --aesirxui-gray-500: #d2d2d2;
  --aesirxui-gray-600: #8e8e8e;
  --aesirxui-gray-700: #c4c4c4;
  --aesirxui-gray-800: #e9e9e9;
  --aesirxui-gray-900: #222328;
  --aesirxui-primary: #0a083b;
  --aesirxui-secondary: #004d6c;
  --aesirxui-success: #1ab394;
  --aesirxui-info: #3b7ab5;
  --aesirxui-warning: #f07e25;
  --aesirxui-danger: #c8192e;
  --aesirxui-light: #f6f8fa;
  --aesirxui-dark: #222328;
  --aesirxui-noti-error: #c8192e;
  --aesirxui-noti-warn: #946300;
  --aesirxui-noti-bg-error: #fee2e2;
  --aesirxui-noti-bg-warn: #fff8e9;
  --aesirxui-noti-bg-success: #d1fae5;
  --aesirxui-custom-color: #712cf9;
  --aesirxui-purple: #6a3e73;
  --aesirxui-secondary-25: #f0f3fb;
  --aesirxui-secondary-50: #1d55a9;
  --aesirxui-secondary-100: #0d588a;
  --aesirxui-success-dark: #1c9678;
  --aesirxui-success-darken: #0f674c;
  --aesirxui-warning-50: #fff8e9;
  --aesirxui-warning-100: #946300;
  --aesirxui-warning-200: #ffe6b2;
  --aesirxui-gray-100: #f6f8fa;
  --aesirxui-gray-400: #e3e3e3;
  --aesirxui-gray-500: #d2d2d2;
  --aesirxui-gray-600: #8e8e8e;
  --aesirxui-gray-700: #c4c4c4;
  --aesirxui-gray-800: #e9e9e9;
  --aesirxui-gray-900: #222328;
  --aesirxui-gray-stroke-1: #f3f3f3;
  --aesirxui-gray-stroke-2: #dedede;
  --aesirxui-gray-light: #97979e;
  --aesirxui-gray-heading: #5f5e70;
  --aesirxui-blue: #0a5aff;
  --aesirxui-blue-light: #edf8fd;
  --aesirxui-color-blue-6: #dce6eb;
  --aesirxui-color-blue-9: #f0f3fb;
  --aesirxui-green-light: #d1fae5;
  --aesirxui-telegram: #039be5;
  --aesirxui-facebook: #3a559f;
  --aesirxui-twitter: #26a6d1;
  --aesirxui-linkedin: #007ab9;
  --aesirxui-instagram: #b334af;
  --aesirxui-chatgpt: #00a481;
  --aesirxui-dark-blue: #3e545e;
  --aesirxui-button-color: white;
  --aesirxui-body-color: #0a083b;
  --aesirxui-primary-rgb: 10, 8, 59;
  --aesirxui-secondary-rgb: 0, 77, 108;
  --aesirxui-success-rgb: 26, 179, 148;
  --aesirxui-info-rgb: 59, 122, 181;
  --aesirxui-warning-rgb: 240, 126, 37;
  --aesirxui-danger-rgb: 200, 25, 46;
  --aesirxui-light-rgb: 246, 248, 250;
  --aesirxui-dark-rgb: 34, 35, 40;
  --aesirxui-noti-error-rgb: 200, 25, 46;
  --aesirxui-noti-warn-rgb: 148, 99, 0;
  --aesirxui-noti-bg-error-rgb: 254, 226, 226;
  --aesirxui-noti-bg-warn-rgb: 255, 248, 233;
  --aesirxui-noti-bg-success-rgb: 209, 250, 229;
  --aesirxui-custom-color-rgb: 113, 44, 249;
  --aesirxui-purple-rgb: 106, 62, 115;
  --aesirxui-secondary-25-rgb: 240, 243, 251;
  --aesirxui-secondary-50-rgb: 29, 85, 169;
  --aesirxui-secondary-100-rgb: 13, 88, 138;
  --aesirxui-success-dark-rgb: 28, 150, 120;
  --aesirxui-success-darken-rgb: 15, 103, 76;
  --aesirxui-warning-50-rgb: 255, 248, 233;
  --aesirxui-warning-100-rgb: 148, 99, 0;
  --aesirxui-warning-200-rgb: 255, 230, 178;
  --aesirxui-gray-100-rgb: 246, 248, 250;
  --aesirxui-gray-400-rgb: 227, 227, 227;
  --aesirxui-gray-500-rgb: 210, 210, 210;
  --aesirxui-gray-600-rgb: 142, 142, 142;
  --aesirxui-gray-700-rgb: 196, 196, 196;
  --aesirxui-gray-800-rgb: 233, 233, 233;
  --aesirxui-gray-900-rgb: 34, 35, 40;
  --aesirxui-gray-stroke-1-rgb: 243, 243, 243;
  --aesirxui-gray-stroke-2-rgb: 222, 222, 222;
  --aesirxui-gray-light-rgb: 151, 151, 158;
  --aesirxui-gray-heading-rgb: 95, 94, 112;
  --aesirxui-blue-rgb: 10, 90, 255;
  --aesirxui-blue-light-rgb: 237, 248, 253;
  --aesirxui-color-blue-6-rgb: 220, 230, 235;
  --aesirxui-color-blue-9-rgb: 240, 243, 251;
  --aesirxui-green-light-rgb: 209, 250, 229;
  --aesirxui-telegram-rgb: 3, 155, 229;
  --aesirxui-facebook-rgb: 58, 85, 159;
  --aesirxui-twitter-rgb: 38, 166, 209;
  --aesirxui-linkedin-rgb: 0, 122, 185;
  --aesirxui-instagram-rgb: 179, 52, 175;
  --aesirxui-chatgpt-rgb: 0, 164, 129;
  --aesirxui-dark-blue-rgb: 62, 84, 94;
  --aesirxui-button-color-rgb: 255, 255, 255;
  --aesirxui-body-color-rgb: 10, 8, 59;
  --aesirxui-primary-text-emphasis: rgb(4, 3.2, 23.6);
  --aesirxui-secondary-text-emphasis: rgb(0, 30.8, 43.2);
  --aesirxui-success-text-emphasis: rgb(10.4, 71.6, 59.2);
  --aesirxui-info-text-emphasis: rgb(23.6, 48.8, 72.4);
  --aesirxui-warning-text-emphasis: rgb(96, 50.4, 14.8);
  --aesirxui-danger-text-emphasis: rgb(80, 10, 18.4);
  --aesirxui-light-text-emphasis: #c4c4c4;
  --aesirxui-dark-text-emphasis: #c4c4c4;
  --aesirxui-primary-bg-subtle: rgb(206, 205.6, 215.8);
  --aesirxui-secondary-bg-subtle: rgb(204, 219.4, 225.6);
  --aesirxui-success-bg-subtle: rgb(209.2, 239.8, 233.6);
  --aesirxui-info-bg-subtle: rgb(215.8, 228.4, 240.2);
  --aesirxui-warning-bg-subtle: rgb(252, 229.2, 211.4);
  --aesirxui-danger-bg-subtle: rgb(244, 209, 213.2);
  --aesirxui-light-bg-subtle: rgb(250.5, 251.5, 252.5);
  --aesirxui-dark-bg-subtle: #e3e3e3;
  --aesirxui-primary-border-subtle: rgb(157, 156.2, 176.6);
  --aesirxui-secondary-border-subtle: rgb(153, 183.8, 196.2);
  --aesirxui-success-border-subtle: rgb(163.4, 224.6, 212.2);
  --aesirxui-info-border-subtle: rgb(176.6, 201.8, 225.4);
  --aesirxui-warning-border-subtle: rgb(249, 203.4, 167.8);
  --aesirxui-danger-border-subtle: rgb(233, 163, 171.4);
  --aesirxui-light-border-subtle: #f9f9f9;
  --aesirxui-dark-border-subtle: #d2d2d2;
  --aesirxui-white-rgb: 255, 255, 255;
  --aesirxui-black-rgb: 0, 0, 0;
  --aesirxui-font-sans-serif: "Inter", sans-serif;
  --aesirxui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --aesirxui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --aesirxui-root-font-size: 16px;
  --aesirxui-body-font-family: var(--aesirxui-font-sans-serif);
  --aesirxui-body-font-size: 1rem;
  --aesirxui-body-font-weight: 400;
  --aesirxui-body-line-height: 1.5;
  --aesirxui-body-color: #0a083b;
  --aesirxui-body-color-rgb: 10, 8, 59;
  --aesirxui-body-bg: #f8f9fa;
  --aesirxui-body-bg-rgb: 248, 249, 250;
  --aesirxui-emphasis-color: #000;
  --aesirxui-emphasis-color-rgb: 0, 0, 0;
  --aesirxui-secondary-color: rgba(10, 8, 59, 0.75);
  --aesirxui-secondary-color-rgb: 10, 8, 59;
  --aesirxui-secondary-bg: #f9f9f9;
  --aesirxui-secondary-bg-rgb: 249, 249, 249;
  --aesirxui-tertiary-color: rgba(10, 8, 59, 0.5);
  --aesirxui-tertiary-color-rgb: 10, 8, 59;
  --aesirxui-tertiary-bg: #f6f8fa;
  --aesirxui-tertiary-bg-rgb: 246, 248, 250;
  --aesirxui-heading-color: inherit;
  --aesirxui-link-color: #0a083b;
  --aesirxui-link-color-rgb: 10, 8, 59;
  --aesirxui-link-decoration: none;
  --aesirxui-link-hover-color: rgb(8, 6.4, 47.2);
  --aesirxui-link-hover-color-rgb: 8, 6, 47;
  --aesirxui-link-hover-decoration: underline;
  --aesirxui-code-color: #d63384;
  --aesirxui-highlight-color: #0a083b;
  --aesirxui-highlight-bg: rgb(255, 235.6, 204.2);
  --aesirxui-border-width: 1px;
  --aesirxui-border-style: solid;
  --aesirxui-border-color: #d5d5d5;
  --aesirxui-border-color-translucent: rgba(0, 0, 0, 0.175);
  --aesirxui-border-radius: 0.25rem;
  --aesirxui-border-radius-sm: 5px;
  --aesirxui-border-radius-lg: 10px;
  --aesirxui-border-radius-xl: 1rem;
  --aesirxui-border-radius-xxl: 2rem;
  --aesirxui-border-radius-2xl: var(--aesirxui-border-radius-xxl);
  --aesirxui-border-radius-pill: 50rem;
  --aesirxui-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --aesirxui-box-shadow-sm: 0px 0px 5px 0px rgba(34, 35, 40, 0.0509803922);
  --aesirxui-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --aesirxui-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --aesirxui-focus-ring-width: 0.25rem;
  --aesirxui-focus-ring-opacity: 0.25;
  --aesirxui-focus-ring-color: rgba(10, 8, 59, 0.25);
  --aesirxui-form-valid-color: #1ab394;
  --aesirxui-form-valid-border-color: #1ab394;
  --aesirxui-form-invalid-color: #c8192e;
  --aesirxui-form-invalid-border-color: #c8192e;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --aesirxui-body-color: #ebebeb;
  --aesirxui-body-color-rgb: 235, 235, 235;
  --aesirxui-body-bg: #222328;
  --aesirxui-body-bg-rgb: 34, 35, 40;
  --aesirxui-emphasis-color: #fff;
  --aesirxui-emphasis-color-rgb: 255, 255, 255;
  --aesirxui-secondary-color: rgba(235, 235, 235, 0.75);
  --aesirxui-secondary-color-rgb: 235, 235, 235;
  --aesirxui-secondary-bg: #e9e9e9;
  --aesirxui-secondary-bg-rgb: 233, 233, 233;
  --aesirxui-tertiary-color: rgba(235, 235, 235, 0.5);
  --aesirxui-tertiary-color-rgb: 235, 235, 235;
  --aesirxui-tertiary-bg: rgb(133.5, 134, 136.5);
  --aesirxui-tertiary-bg-rgb: 134, 134, 137;
  --aesirxui-primary-text-emphasis: rgb(108, 106.8, 137.4);
  --aesirxui-secondary-text-emphasis: rgb(102, 148.2, 166.8);
  --aesirxui-success-text-emphasis: rgb(117.6, 209.4, 190.8);
  --aesirxui-info-text-emphasis: rgb(137.4, 175.2, 210.6);
  --aesirxui-warning-text-emphasis: rgb(246, 177.6, 124.2);
  --aesirxui-danger-text-emphasis: rgb(222, 117, 129.6);
  --aesirxui-light-text-emphasis: #f6f8fa;
  --aesirxui-dark-text-emphasis: #ebebeb;
  --aesirxui-primary-bg-subtle: rgb(2, 1.6, 11.8);
  --aesirxui-secondary-bg-subtle: rgb(0, 15.4, 21.6);
  --aesirxui-success-bg-subtle: rgb(5.2, 35.8, 29.6);
  --aesirxui-info-bg-subtle: rgb(11.8, 24.4, 36.2);
  --aesirxui-warning-bg-subtle: rgb(48, 25.2, 7.4);
  --aesirxui-danger-bg-subtle: rgb(40, 5, 9.2);
  --aesirxui-light-bg-subtle: #e9e9e9;
  --aesirxui-dark-bg-subtle: rgb(116.5, 116.5, 116.5);
  --aesirxui-primary-border-subtle: rgb(6, 4.8, 35.4);
  --aesirxui-secondary-border-subtle: rgb(0, 46.2, 64.8);
  --aesirxui-success-border-subtle: rgb(15.6, 107.4, 88.8);
  --aesirxui-info-border-subtle: rgb(35.4, 73.2, 108.6);
  --aesirxui-warning-border-subtle: rgb(144, 75.6, 22.2);
  --aesirxui-danger-border-subtle: rgb(120, 15, 27.6);
  --aesirxui-light-border-subtle: #c4c4c4;
  --aesirxui-dark-border-subtle: #e9e9e9;
  --aesirxui-heading-color: inherit;
  --aesirxui-link-color: rgb(108, 106.8, 137.4);
  --aesirxui-link-hover-color: rgb(137.4, 136.44, 160.92);
  --aesirxui-link-color-rgb: 108, 107, 137;
  --aesirxui-link-hover-color-rgb: 137, 136, 161;
  --aesirxui-code-color: rgb(230.4, 132.6, 181.2);
  --aesirxui-highlight-color: #ebebeb;
  --aesirxui-highlight-bg: rgb(102, 63.2, 0.4);
  --aesirxui-border-color: #c4c4c4;
  --aesirxui-border-color-translucent: rgba(255, 255, 255, 0.15);
  --aesirxui-form-valid-color: rgb(117.6, 209.4, 190.8);
  --aesirxui-form-valid-border-color: rgb(117.6, 209.4, 190.8);
  --aesirxui-form-invalid-color: rgb(223.8, 122.4, 128.4);
  --aesirxui-form-invalid-border-color: rgb(223.8, 122.4, 128.4);
}

.aesirxui {
  /* rtl:raw:
  [type="tel"],
  [type="url"],
  [type="email"],
  [type="number"] {
    direction: ltr;
  }
  */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:remove */
  /* rtl:end:remove */
  overflow: hidden;
}
.aesirxui *,
.aesirxui *::before,
.aesirxui *::after {
  box-sizing: border-box;
}
.aesirxui :root {
  font-size: var(--aesirxui-root-font-size);
}
@media (prefers-reduced-motion: no-preference) {
  .aesirxui :root {
    scroll-behavior: smooth;
  }
}
.aesirxui body {
  margin: 0;
  font-family: var(--aesirxui-body-font-family);
  font-size: var(--aesirxui-body-font-size);
  font-weight: var(--aesirxui-body-font-weight);
  line-height: var(--aesirxui-body-line-height);
  color: var(--aesirxui-body-color);
  text-align: var(--aesirxui-body-text-align);
  background-color: var(--aesirxui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.aesirxui hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--aesirxui-border-width) solid;
  opacity: 0.25;
}
.aesirxui h6, .aesirxui .h6, .aesirxui h5, .aesirxui .h5, .aesirxui h4, .aesirxui .h4, .aesirxui h3, .aesirxui .h3, .aesirxui h2, .aesirxui .h2, .aesirxui h1, .aesirxui .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--aesirxui-heading-color);
}
.aesirxui h1, .aesirxui .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .aesirxui h1, .aesirxui .h1 {
    font-size: 2.5rem;
  }
}
.aesirxui h2, .aesirxui .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  .aesirxui h2, .aesirxui .h2 {
    font-size: 2rem;
  }
}
.aesirxui h3, .aesirxui .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  .aesirxui h3, .aesirxui .h3 {
    font-size: 1.75rem;
  }
}
.aesirxui h4, .aesirxui .h4 {
  font-size: 1.25rem;
}
.aesirxui h5, .aesirxui .h5 {
  font-size: 1.125rem;
}
.aesirxui h6, .aesirxui .h6 {
  font-size: 1rem;
}
.aesirxui p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.aesirxui abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}
.aesirxui address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
.aesirxui ol,
.aesirxui ul {
  padding-left: 2rem;
}
.aesirxui ol,
.aesirxui ul,
.aesirxui dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
.aesirxui ol ol,
.aesirxui ul ul,
.aesirxui ol ul,
.aesirxui ul ol {
  margin-bottom: 0;
}
.aesirxui dt {
  font-weight: 700;
}
.aesirxui dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
.aesirxui blockquote {
  margin: 0 0 1rem;
}
.aesirxui b,
.aesirxui strong {
  font-weight: bolder;
}
.aesirxui small, .aesirxui .small {
  font-size: 0.875em;
}
.aesirxui mark, .aesirxui .mark {
  padding: 0.1875em;
  color: var(--aesirxui-highlight-color);
  background-color: var(--aesirxui-highlight-bg);
}
.aesirxui sub,
.aesirxui sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}
.aesirxui sub {
  bottom: -0.25em;
}
.aesirxui sup {
  top: -0.5em;
}
.aesirxui a {
  color: rgba(var(--aesirxui-link-color-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration: none;
}
.aesirxui a:hover {
  --aesirxui-link-color-rgb: var(--aesirxui-link-hover-color-rgb);
  text-decoration: underline;
}
.aesirxui a:not([href]):not([class]), .aesirxui a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}
.aesirxui pre,
.aesirxui code,
.aesirxui kbd,
.aesirxui samp {
  font-family: var(--aesirxui-font-monospace);
  font-size: 1em;
}
.aesirxui pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
.aesirxui pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
.aesirxui code {
  font-size: 0.875em;
  color: var(--aesirxui-code-color);
  word-wrap: break-word;
}
a > .aesirxui code {
  color: inherit;
}
.aesirxui kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--aesirxui-body-bg);
  background-color: var(--aesirxui-body-color);
  border-radius: 5px;
}
.aesirxui kbd kbd {
  padding: 0;
  font-size: 1em;
}
.aesirxui figure {
  margin: 0 0 1rem;
}
.aesirxui img,
.aesirxui svg {
  vertical-align: middle;
}
.aesirxui table {
  caption-side: bottom;
  border-collapse: collapse;
}
.aesirxui caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--aesirxui-secondary-color);
  text-align: left;
}
.aesirxui th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
.aesirxui thead,
.aesirxui tbody,
.aesirxui tfoot,
.aesirxui tr,
.aesirxui td,
.aesirxui th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}
.aesirxui label {
  display: inline-block;
}
.aesirxui button {
  border-radius: 0;
}
.aesirxui button:focus:not(:focus-visible) {
  outline: 0;
}
.aesirxui input,
.aesirxui button,
.aesirxui select,
.aesirxui optgroup,
.aesirxui textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.aesirxui button,
.aesirxui select {
  text-transform: none;
}
.aesirxui [role=button] {
  cursor: pointer;
}
.aesirxui select {
  word-wrap: normal;
}
.aesirxui select:disabled {
  opacity: 1;
}
.aesirxui [list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}
.aesirxui button,
.aesirxui [type=button],
.aesirxui [type=reset],
.aesirxui [type=submit] {
  -webkit-appearance: button;
}
.aesirxui button:not(:disabled),
.aesirxui [type=button]:not(:disabled),
.aesirxui [type=reset]:not(:disabled),
.aesirxui [type=submit]:not(:disabled) {
  cursor: pointer;
}
.aesirxui ::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
.aesirxui textarea {
  resize: vertical;
}
.aesirxui fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.aesirxui legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  .aesirxui legend {
    font-size: 1.5rem;
  }
}
.aesirxui legend + * {
  clear: left;
}
.aesirxui ::-webkit-datetime-edit-fields-wrapper,
.aesirxui ::-webkit-datetime-edit-text,
.aesirxui ::-webkit-datetime-edit-minute,
.aesirxui ::-webkit-datetime-edit-hour-field,
.aesirxui ::-webkit-datetime-edit-day-field,
.aesirxui ::-webkit-datetime-edit-month-field,
.aesirxui ::-webkit-datetime-edit-year-field {
  padding: 0;
}
.aesirxui ::-webkit-inner-spin-button {
  height: auto;
}
.aesirxui [type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
.aesirxui ::-webkit-search-decoration {
  -webkit-appearance: none;
}
.aesirxui ::-webkit-color-swatch-wrapper {
  padding: 0;
}
.aesirxui ::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}
.aesirxui output {
  display: inline-block;
}
.aesirxui iframe {
  border: 0;
}
.aesirxui summary {
  display: list-item;
  cursor: pointer;
}
.aesirxui progress {
  vertical-align: baseline;
}
.aesirxui [hidden] {
  display: none !important;
}
.aesirxui .lead {
  font-size: 1.25rem;
  font-weight: 300;
}
.aesirxui .display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxui .display-1 {
    font-size: 5rem;
  }
}
.aesirxui .display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxui .display-2 {
    font-size: 4.5rem;
  }
}
.aesirxui .display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxui .display-3 {
    font-size: 4rem;
  }
}
.aesirxui .display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxui .display-4 {
    font-size: 3.5rem;
  }
}
.aesirxui .display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxui .display-5 {
    font-size: 3rem;
  }
}
.aesirxui .display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxui .display-6 {
    font-size: 2.5rem;
  }
}
.aesirxui .list-unstyled {
  padding-left: 0;
  list-style: none;
}
.aesirxui .list-inline {
  padding-left: 0;
  list-style: none;
}
.aesirxui .list-inline-item {
  display: inline-block;
}
.aesirxui .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.aesirxui .initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}
.aesirxui .blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.aesirxui .blockquote > :last-child {
  margin-bottom: 0;
}
.aesirxui .blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #8e8e8e;
}
.aesirxui .blockquote-footer::before {
  content: "\u2014\xA0";
}
.aesirxui .dropup,
.aesirxui .dropend,
.aesirxui .dropdown,
.aesirxui .dropstart,
.aesirxui .dropup-center,
.aesirxui .dropdown-center {
  position: relative;
}
.aesirxui .dropdown-toggle {
  white-space: nowrap;
}
.aesirxui .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.aesirxui .dropdown-toggle:empty::after {
  margin-left: 0;
}
.aesirxui .dropdown-menu {
  --aesirxui-dropdown-zindex: 1000;
  --aesirxui-dropdown-min-width: 10rem;
  --aesirxui-dropdown-padding-x: 0;
  --aesirxui-dropdown-padding-y: 0.5rem;
  --aesirxui-dropdown-spacer: 0.125rem;
  --aesirxui-dropdown-font-size: 1rem;
  --aesirxui-dropdown-color: var(--aesirxui-body-color);
  --aesirxui-dropdown-bg: var(--aesirxui-body-bg);
  --aesirxui-dropdown-border-color: var(--aesirxui-border-color-translucent);
  --aesirxui-dropdown-border-radius: var(--aesirxui-border-radius);
  --aesirxui-dropdown-border-width: var(--aesirxui-border-width);
  --aesirxui-dropdown-inner-border-radius: calc(var(--aesirxui-border-radius) - var(--aesirxui-border-width));
  --aesirxui-dropdown-divider-bg: var(--aesirxui-border-color-translucent);
  --aesirxui-dropdown-divider-margin-y: 0.5rem;
  --aesirxui-dropdown-box-shadow: var(--aesirxui-box-shadow);
  --aesirxui-dropdown-link-color: var(--aesirxui-body-color);
  --aesirxui-dropdown-link-hover-color: var(--aesirxui-body-color);
  --aesirxui-dropdown-link-hover-bg: var(--aesirxui-tertiary-bg);
  --aesirxui-dropdown-link-active-color: #fff;
  --aesirxui-dropdown-link-active-bg: #1ab394;
  --aesirxui-dropdown-link-disabled-color: var(--aesirxui-tertiary-color);
  --aesirxui-dropdown-item-padding-x: 1rem;
  --aesirxui-dropdown-item-padding-y: 0.25rem;
  --aesirxui-dropdown-header-color: #8e8e8e;
  --aesirxui-dropdown-header-padding-x: 1rem;
  --aesirxui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--aesirxui-dropdown-zindex);
  display: none;
  min-width: var(--aesirxui-dropdown-min-width);
  padding: var(--aesirxui-dropdown-padding-y) var(--aesirxui-dropdown-padding-x);
  margin: 0;
  font-size: var(--aesirxui-dropdown-font-size);
  color: var(--aesirxui-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--aesirxui-dropdown-bg);
  background-clip: padding-box;
  border: var(--aesirxui-dropdown-border-width) solid var(--aesirxui-dropdown-border-color);
  border-radius: var(--aesirxui-dropdown-border-radius);
}
.aesirxui .dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--aesirxui-dropdown-spacer);
}
.aesirxui .dropdown-menu-start {
  --bs-position: start;
}
.aesirxui .dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}
.aesirxui .dropdown-menu-end {
  --bs-position: end;
}
.aesirxui .dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}
@media (min-width: 576px) {
  .aesirxui .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .aesirxui .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .aesirxui .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .aesirxui .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .aesirxui .dropdown-menu-md-start {
    --bs-position: start;
  }
  .aesirxui .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .aesirxui .dropdown-menu-md-end {
    --bs-position: end;
  }
  .aesirxui .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .aesirxui .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .aesirxui .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .aesirxui .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .aesirxui .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .aesirxui .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .aesirxui .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .aesirxui .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .aesirxui .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .aesirxui .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .aesirxui .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .aesirxui .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .aesirxui .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.aesirxui .dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--aesirxui-dropdown-spacer);
}
.aesirxui .dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.aesirxui .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
.aesirxui .dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--aesirxui-dropdown-spacer);
}
.aesirxui .dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.aesirxui .dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.aesirxui .dropend .dropdown-toggle::after {
  vertical-align: 0;
}
.aesirxui .dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--aesirxui-dropdown-spacer);
}
.aesirxui .dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.aesirxui .dropstart .dropdown-toggle::after {
  display: none;
}
.aesirxui .dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.aesirxui .dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.aesirxui .dropstart .dropdown-toggle::before {
  vertical-align: 0;
}
.aesirxui .dropdown-divider {
  height: 0;
  margin: var(--aesirxui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--aesirxui-dropdown-divider-bg);
  opacity: 1;
}
.aesirxui .dropdown-item {
  display: block;
  width: 100%;
  padding: var(--aesirxui-dropdown-item-padding-y) var(--aesirxui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--aesirxui-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--aesirxui-dropdown-item-border-radius, 0);
}
.aesirxui .dropdown-item:hover, .aesirxui .dropdown-item:focus {
  color: var(--aesirxui-dropdown-link-hover-color);
  text-decoration: none;
  background-color: var(--aesirxui-dropdown-link-hover-bg);
}
.aesirxui .dropdown-item.active, .aesirxui .dropdown-item:active {
  color: var(--aesirxui-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--aesirxui-dropdown-link-active-bg);
}
.aesirxui .dropdown-item.disabled, .aesirxui .dropdown-item:disabled {
  color: var(--aesirxui-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}
.aesirxui .dropdown-menu.show {
  display: block;
}
.aesirxui .dropdown-header {
  display: block;
  padding: var(--aesirxui-dropdown-header-padding-y) var(--aesirxui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--aesirxui-dropdown-header-color);
  white-space: nowrap;
}
.aesirxui .dropdown-item-text {
  display: block;
  padding: var(--aesirxui-dropdown-item-padding-y) var(--aesirxui-dropdown-item-padding-x);
  color: var(--aesirxui-dropdown-link-color);
}
.aesirxui .dropdown-menu-dark {
  --aesirxui-dropdown-color: #ebebeb;
  --aesirxui-dropdown-bg: #e9e9e9;
  --aesirxui-dropdown-border-color: var(--aesirxui-border-color-translucent);
  --aesirxui-dropdown-box-shadow: ;
  --aesirxui-dropdown-link-color: #ebebeb;
  --aesirxui-dropdown-link-hover-color: #fff;
  --aesirxui-dropdown-divider-bg: var(--aesirxui-border-color-translucent);
  --aesirxui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --aesirxui-dropdown-link-active-color: #fff;
  --aesirxui-dropdown-link-active-bg: #1ab394;
  --aesirxui-dropdown-link-disabled-color: #d2d2d2;
  --aesirxui-dropdown-header-color: #d2d2d2;
}
.aesirxui .img-fluid {
  max-width: 100%;
  height: auto;
}
.aesirxui .img-thumbnail {
  padding: 0.25rem;
  background-color: var(--aesirxui-body-bg);
  border: var(--aesirxui-border-width) solid var(--aesirxui-border-color);
  border-radius: var(--aesirxui-border-radius);
  max-width: 100%;
  height: auto;
}
.aesirxui .figure {
  display: inline-block;
}
.aesirxui .figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}
.aesirxui .figure-caption {
  font-size: 0.875em;
  color: var(--aesirxui-secondary-color);
}
.aesirxui .container,
.aesirxui .container-fluid,
.aesirxui .container-xxl,
.aesirxui .container-xl,
.aesirxui .container-lg,
.aesirxui .container-md,
.aesirxui .container-sm {
  --aesirxui-gutter-x: 1.25rem;
  --aesirxui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--aesirxui-gutter-x) * 0.5);
  padding-left: calc(var(--aesirxui-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .aesirxui .container-sm, .aesirxui .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .aesirxui .container-md, .aesirxui .container-sm, .aesirxui .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .aesirxui .container-lg, .aesirxui .container-md, .aesirxui .container-sm, .aesirxui .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .aesirxui .container-xl, .aesirxui .container-lg, .aesirxui .container-md, .aesirxui .container-sm, .aesirxui .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .aesirxui .container-xxl, .aesirxui .container-xl, .aesirxui .container-lg, .aesirxui .container-md, .aesirxui .container-sm, .aesirxui .container {
    max-width: 1320px;
  }
}
.aesirxui :root {
  --aesirxui-breakpoint-xs: 0;
  --aesirxui-breakpoint-sm: 576px;
  --aesirxui-breakpoint-md: 768px;
  --aesirxui-breakpoint-lg: 992px;
  --aesirxui-breakpoint-xl: 1200px;
  --aesirxui-breakpoint-xxl: 1400px;
}
.aesirxui .row {
  --aesirxui-gutter-x: 1.25rem;
  --aesirxui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--aesirxui-gutter-y));
  margin-right: calc(-0.5 * var(--aesirxui-gutter-x));
  margin-left: calc(-0.5 * var(--aesirxui-gutter-x));
}
.aesirxui .row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--aesirxui-gutter-x) * 0.5);
  padding-left: calc(var(--aesirxui-gutter-x) * 0.5);
  margin-top: var(--aesirxui-gutter-y);
}
.aesirxui .col {
  flex: 1 0 0%;
}
.aesirxui .row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}
.aesirxui .row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}
.aesirxui .row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}
.aesirxui .row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.aesirxui .row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}
.aesirxui .row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}
.aesirxui .row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.aesirxui .col-auto {
  flex: 0 0 auto;
  width: auto;
}
.aesirxui .col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}
.aesirxui .col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.aesirxui .col-3 {
  flex: 0 0 auto;
  width: 25%;
}
.aesirxui .col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.aesirxui .col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}
.aesirxui .col-6 {
  flex: 0 0 auto;
  width: 50%;
}
.aesirxui .col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}
.aesirxui .col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}
.aesirxui .col-9 {
  flex: 0 0 auto;
  width: 75%;
}
.aesirxui .col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}
.aesirxui .col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}
.aesirxui .col-12 {
  flex: 0 0 auto;
  width: 100%;
}
.aesirxui .offset-1 {
  margin-left: 8.33333333%;
}
.aesirxui .offset-2 {
  margin-left: 16.66666667%;
}
.aesirxui .offset-3 {
  margin-left: 25%;
}
.aesirxui .offset-4 {
  margin-left: 33.33333333%;
}
.aesirxui .offset-5 {
  margin-left: 41.66666667%;
}
.aesirxui .offset-6 {
  margin-left: 50%;
}
.aesirxui .offset-7 {
  margin-left: 58.33333333%;
}
.aesirxui .offset-8 {
  margin-left: 66.66666667%;
}
.aesirxui .offset-9 {
  margin-left: 75%;
}
.aesirxui .offset-10 {
  margin-left: 83.33333333%;
}
.aesirxui .offset-11 {
  margin-left: 91.66666667%;
}
.aesirxui .g-0,
.aesirxui .gx-0 {
  --aesirxui-gutter-x: 0;
}
.aesirxui .g-0,
.aesirxui .gy-0 {
  --aesirxui-gutter-y: 0;
}
.aesirxui .g-1,
.aesirxui .gx-1 {
  --aesirxui-gutter-x: 0.25rem;
}
.aesirxui .g-1,
.aesirxui .gy-1 {
  --aesirxui-gutter-y: 0.25rem;
}
.aesirxui .g-2,
.aesirxui .gx-2 {
  --aesirxui-gutter-x: 0.5rem;
}
.aesirxui .g-2,
.aesirxui .gy-2 {
  --aesirxui-gutter-y: 0.5rem;
}
.aesirxui .g-3,
.aesirxui .gx-3 {
  --aesirxui-gutter-x: 1rem;
}
.aesirxui .g-3,
.aesirxui .gy-3 {
  --aesirxui-gutter-y: 1rem;
}
.aesirxui .g-4,
.aesirxui .gx-4 {
  --aesirxui-gutter-x: 1.5rem;
}
.aesirxui .g-4,
.aesirxui .gy-4 {
  --aesirxui-gutter-y: 1.5rem;
}
.aesirxui .g-5,
.aesirxui .gx-5 {
  --aesirxui-gutter-x: 3rem;
}
.aesirxui .g-5,
.aesirxui .gy-5 {
  --aesirxui-gutter-y: 3rem;
}
.aesirxui .g-sm,
.aesirxui .gx-sm {
  --aesirxui-gutter-x: 5px;
}
.aesirxui .g-sm,
.aesirxui .gy-sm {
  --aesirxui-gutter-y: 5px;
}
.aesirxui .g-8px,
.aesirxui .gx-8px {
  --aesirxui-gutter-x: 8px;
}
.aesirxui .g-8px,
.aesirxui .gy-8px {
  --aesirxui-gutter-y: 8px;
}
.aesirxui .g-15,
.aesirxui .gx-15 {
  --aesirxui-gutter-x: 15px;
}
.aesirxui .g-15,
.aesirxui .gy-15 {
  --aesirxui-gutter-y: 15px;
}
.aesirxui .g-16,
.aesirxui .gx-16 {
  --aesirxui-gutter-x: 16px;
}
.aesirxui .g-16,
.aesirxui .gy-16 {
  --aesirxui-gutter-y: 16px;
}
.aesirxui .g-20,
.aesirxui .gx-20 {
  --aesirxui-gutter-x: 20px;
}
.aesirxui .g-20,
.aesirxui .gy-20 {
  --aesirxui-gutter-y: 20px;
}
.aesirxui .g-24,
.aesirxui .gx-24 {
  --aesirxui-gutter-x: 24px;
}
.aesirxui .g-24,
.aesirxui .gy-24 {
  --aesirxui-gutter-y: 24px;
}
.aesirxui .g-6,
.aesirxui .gx-6 {
  --aesirxui-gutter-x: 60px;
}
.aesirxui .g-6,
.aesirxui .gy-6 {
  --aesirxui-gutter-y: 60px;
}
.aesirxui .g-7,
.aesirxui .gx-7 {
  --aesirxui-gutter-x: 70px;
}
.aesirxui .g-7,
.aesirxui .gy-7 {
  --aesirxui-gutter-y: 70px;
}
.aesirxui .g-8,
.aesirxui .gx-8 {
  --aesirxui-gutter-x: 80px;
}
.aesirxui .g-8,
.aesirxui .gy-8 {
  --aesirxui-gutter-y: 80px;
}
.aesirxui .g-10,
.aesirxui .gx-10 {
  --aesirxui-gutter-x: 10px;
}
.aesirxui .g-10,
.aesirxui .gy-10 {
  --aesirxui-gutter-y: 10px;
}
.aesirxui .g-13,
.aesirxui .gx-13 {
  --aesirxui-gutter-x: 13px;
}
.aesirxui .g-13,
.aesirxui .gy-13 {
  --aesirxui-gutter-y: 13px;
}
.aesirxui .g-14,
.aesirxui .gx-14 {
  --aesirxui-gutter-x: 14px;
}
.aesirxui .g-14,
.aesirxui .gy-14 {
  --aesirxui-gutter-y: 14px;
}
.aesirxui .g-40,
.aesirxui .gx-40 {
  --aesirxui-gutter-x: 40px;
}
.aesirxui .g-40,
.aesirxui .gy-40 {
  --aesirxui-gutter-y: 40px;
}
.aesirxui .g-18px,
.aesirxui .gx-18px {
  --aesirxui-gutter-x: 18px;
}
.aesirxui .g-18px,
.aesirxui .gy-18px {
  --aesirxui-gutter-y: 18px;
}
.aesirxui .g-32px,
.aesirxui .gx-32px {
  --aesirxui-gutter-x: 32px;
}
.aesirxui .g-32px,
.aesirxui .gy-32px {
  --aesirxui-gutter-y: 32px;
}
.aesirxui .g-9px,
.aesirxui .gx-9px {
  --aesirxui-gutter-x: 9px;
}
.aesirxui .g-9px,
.aesirxui .gy-9px {
  --aesirxui-gutter-y: 9px;
}
.aesirxui .g-12px,
.aesirxui .gx-12px {
  --aesirxui-gutter-x: 12px;
}
.aesirxui .g-12px,
.aesirxui .gy-12px {
  --aesirxui-gutter-y: 12px;
}
.aesirxui .g-19px,
.aesirxui .gx-19px {
  --aesirxui-gutter-x: 19px;
}
.aesirxui .g-19px,
.aesirxui .gy-19px {
  --aesirxui-gutter-y: 19px;
}
@media (min-width: 576px) {
  .aesirxui .col-sm {
    flex: 1 0 0%;
  }
  .aesirxui .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxui .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxui .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxui .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxui .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxui .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxui .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxui .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxui .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .offset-sm-0 {
    margin-left: 0;
  }
  .aesirxui .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .aesirxui .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .aesirxui .offset-sm-3 {
    margin-left: 25%;
  }
  .aesirxui .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .aesirxui .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .aesirxui .offset-sm-6 {
    margin-left: 50%;
  }
  .aesirxui .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .aesirxui .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .aesirxui .offset-sm-9 {
    margin-left: 75%;
  }
  .aesirxui .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .aesirxui .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .aesirxui .g-sm-0,
  .aesirxui .gx-sm-0 {
    --aesirxui-gutter-x: 0;
  }
  .aesirxui .g-sm-0,
  .aesirxui .gy-sm-0 {
    --aesirxui-gutter-y: 0;
  }
  .aesirxui .g-sm-1,
  .aesirxui .gx-sm-1 {
    --aesirxui-gutter-x: 0.25rem;
  }
  .aesirxui .g-sm-1,
  .aesirxui .gy-sm-1 {
    --aesirxui-gutter-y: 0.25rem;
  }
  .aesirxui .g-sm-2,
  .aesirxui .gx-sm-2 {
    --aesirxui-gutter-x: 0.5rem;
  }
  .aesirxui .g-sm-2,
  .aesirxui .gy-sm-2 {
    --aesirxui-gutter-y: 0.5rem;
  }
  .aesirxui .g-sm-3,
  .aesirxui .gx-sm-3 {
    --aesirxui-gutter-x: 1rem;
  }
  .aesirxui .g-sm-3,
  .aesirxui .gy-sm-3 {
    --aesirxui-gutter-y: 1rem;
  }
  .aesirxui .g-sm-4,
  .aesirxui .gx-sm-4 {
    --aesirxui-gutter-x: 1.5rem;
  }
  .aesirxui .g-sm-4,
  .aesirxui .gy-sm-4 {
    --aesirxui-gutter-y: 1.5rem;
  }
  .aesirxui .g-sm-5,
  .aesirxui .gx-sm-5 {
    --aesirxui-gutter-x: 3rem;
  }
  .aesirxui .g-sm-5,
  .aesirxui .gy-sm-5 {
    --aesirxui-gutter-y: 3rem;
  }
  .aesirxui .g-sm-sm,
  .aesirxui .gx-sm-sm {
    --aesirxui-gutter-x: 5px;
  }
  .aesirxui .g-sm-sm,
  .aesirxui .gy-sm-sm {
    --aesirxui-gutter-y: 5px;
  }
  .aesirxui .g-sm-8px,
  .aesirxui .gx-sm-8px {
    --aesirxui-gutter-x: 8px;
  }
  .aesirxui .g-sm-8px,
  .aesirxui .gy-sm-8px {
    --aesirxui-gutter-y: 8px;
  }
  .aesirxui .g-sm-15,
  .aesirxui .gx-sm-15 {
    --aesirxui-gutter-x: 15px;
  }
  .aesirxui .g-sm-15,
  .aesirxui .gy-sm-15 {
    --aesirxui-gutter-y: 15px;
  }
  .aesirxui .g-sm-16,
  .aesirxui .gx-sm-16 {
    --aesirxui-gutter-x: 16px;
  }
  .aesirxui .g-sm-16,
  .aesirxui .gy-sm-16 {
    --aesirxui-gutter-y: 16px;
  }
  .aesirxui .g-sm-20,
  .aesirxui .gx-sm-20 {
    --aesirxui-gutter-x: 20px;
  }
  .aesirxui .g-sm-20,
  .aesirxui .gy-sm-20 {
    --aesirxui-gutter-y: 20px;
  }
  .aesirxui .g-sm-24,
  .aesirxui .gx-sm-24 {
    --aesirxui-gutter-x: 24px;
  }
  .aesirxui .g-sm-24,
  .aesirxui .gy-sm-24 {
    --aesirxui-gutter-y: 24px;
  }
  .aesirxui .g-sm-6,
  .aesirxui .gx-sm-6 {
    --aesirxui-gutter-x: 60px;
  }
  .aesirxui .g-sm-6,
  .aesirxui .gy-sm-6 {
    --aesirxui-gutter-y: 60px;
  }
  .aesirxui .g-sm-7,
  .aesirxui .gx-sm-7 {
    --aesirxui-gutter-x: 70px;
  }
  .aesirxui .g-sm-7,
  .aesirxui .gy-sm-7 {
    --aesirxui-gutter-y: 70px;
  }
  .aesirxui .g-sm-8,
  .aesirxui .gx-sm-8 {
    --aesirxui-gutter-x: 80px;
  }
  .aesirxui .g-sm-8,
  .aesirxui .gy-sm-8 {
    --aesirxui-gutter-y: 80px;
  }
  .aesirxui .g-sm-10,
  .aesirxui .gx-sm-10 {
    --aesirxui-gutter-x: 10px;
  }
  .aesirxui .g-sm-10,
  .aesirxui .gy-sm-10 {
    --aesirxui-gutter-y: 10px;
  }
  .aesirxui .g-sm-13,
  .aesirxui .gx-sm-13 {
    --aesirxui-gutter-x: 13px;
  }
  .aesirxui .g-sm-13,
  .aesirxui .gy-sm-13 {
    --aesirxui-gutter-y: 13px;
  }
  .aesirxui .g-sm-14,
  .aesirxui .gx-sm-14 {
    --aesirxui-gutter-x: 14px;
  }
  .aesirxui .g-sm-14,
  .aesirxui .gy-sm-14 {
    --aesirxui-gutter-y: 14px;
  }
  .aesirxui .g-sm-40,
  .aesirxui .gx-sm-40 {
    --aesirxui-gutter-x: 40px;
  }
  .aesirxui .g-sm-40,
  .aesirxui .gy-sm-40 {
    --aesirxui-gutter-y: 40px;
  }
  .aesirxui .g-sm-18px,
  .aesirxui .gx-sm-18px {
    --aesirxui-gutter-x: 18px;
  }
  .aesirxui .g-sm-18px,
  .aesirxui .gy-sm-18px {
    --aesirxui-gutter-y: 18px;
  }
  .aesirxui .g-sm-32px,
  .aesirxui .gx-sm-32px {
    --aesirxui-gutter-x: 32px;
  }
  .aesirxui .g-sm-32px,
  .aesirxui .gy-sm-32px {
    --aesirxui-gutter-y: 32px;
  }
  .aesirxui .g-sm-9px,
  .aesirxui .gx-sm-9px {
    --aesirxui-gutter-x: 9px;
  }
  .aesirxui .g-sm-9px,
  .aesirxui .gy-sm-9px {
    --aesirxui-gutter-y: 9px;
  }
  .aesirxui .g-sm-12px,
  .aesirxui .gx-sm-12px {
    --aesirxui-gutter-x: 12px;
  }
  .aesirxui .g-sm-12px,
  .aesirxui .gy-sm-12px {
    --aesirxui-gutter-y: 12px;
  }
  .aesirxui .g-sm-19px,
  .aesirxui .gx-sm-19px {
    --aesirxui-gutter-x: 19px;
  }
  .aesirxui .g-sm-19px,
  .aesirxui .gy-sm-19px {
    --aesirxui-gutter-y: 19px;
  }
}
@media (min-width: 768px) {
  .aesirxui .col-md {
    flex: 1 0 0%;
  }
  .aesirxui .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxui .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxui .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxui .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxui .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxui .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxui .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxui .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxui .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .offset-md-0 {
    margin-left: 0;
  }
  .aesirxui .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .aesirxui .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .aesirxui .offset-md-3 {
    margin-left: 25%;
  }
  .aesirxui .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .aesirxui .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .aesirxui .offset-md-6 {
    margin-left: 50%;
  }
  .aesirxui .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .aesirxui .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .aesirxui .offset-md-9 {
    margin-left: 75%;
  }
  .aesirxui .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .aesirxui .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .aesirxui .g-md-0,
  .aesirxui .gx-md-0 {
    --aesirxui-gutter-x: 0;
  }
  .aesirxui .g-md-0,
  .aesirxui .gy-md-0 {
    --aesirxui-gutter-y: 0;
  }
  .aesirxui .g-md-1,
  .aesirxui .gx-md-1 {
    --aesirxui-gutter-x: 0.25rem;
  }
  .aesirxui .g-md-1,
  .aesirxui .gy-md-1 {
    --aesirxui-gutter-y: 0.25rem;
  }
  .aesirxui .g-md-2,
  .aesirxui .gx-md-2 {
    --aesirxui-gutter-x: 0.5rem;
  }
  .aesirxui .g-md-2,
  .aesirxui .gy-md-2 {
    --aesirxui-gutter-y: 0.5rem;
  }
  .aesirxui .g-md-3,
  .aesirxui .gx-md-3 {
    --aesirxui-gutter-x: 1rem;
  }
  .aesirxui .g-md-3,
  .aesirxui .gy-md-3 {
    --aesirxui-gutter-y: 1rem;
  }
  .aesirxui .g-md-4,
  .aesirxui .gx-md-4 {
    --aesirxui-gutter-x: 1.5rem;
  }
  .aesirxui .g-md-4,
  .aesirxui .gy-md-4 {
    --aesirxui-gutter-y: 1.5rem;
  }
  .aesirxui .g-md-5,
  .aesirxui .gx-md-5 {
    --aesirxui-gutter-x: 3rem;
  }
  .aesirxui .g-md-5,
  .aesirxui .gy-md-5 {
    --aesirxui-gutter-y: 3rem;
  }
  .aesirxui .g-md-sm,
  .aesirxui .gx-md-sm {
    --aesirxui-gutter-x: 5px;
  }
  .aesirxui .g-md-sm,
  .aesirxui .gy-md-sm {
    --aesirxui-gutter-y: 5px;
  }
  .aesirxui .g-md-8px,
  .aesirxui .gx-md-8px {
    --aesirxui-gutter-x: 8px;
  }
  .aesirxui .g-md-8px,
  .aesirxui .gy-md-8px {
    --aesirxui-gutter-y: 8px;
  }
  .aesirxui .g-md-15,
  .aesirxui .gx-md-15 {
    --aesirxui-gutter-x: 15px;
  }
  .aesirxui .g-md-15,
  .aesirxui .gy-md-15 {
    --aesirxui-gutter-y: 15px;
  }
  .aesirxui .g-md-16,
  .aesirxui .gx-md-16 {
    --aesirxui-gutter-x: 16px;
  }
  .aesirxui .g-md-16,
  .aesirxui .gy-md-16 {
    --aesirxui-gutter-y: 16px;
  }
  .aesirxui .g-md-20,
  .aesirxui .gx-md-20 {
    --aesirxui-gutter-x: 20px;
  }
  .aesirxui .g-md-20,
  .aesirxui .gy-md-20 {
    --aesirxui-gutter-y: 20px;
  }
  .aesirxui .g-md-24,
  .aesirxui .gx-md-24 {
    --aesirxui-gutter-x: 24px;
  }
  .aesirxui .g-md-24,
  .aesirxui .gy-md-24 {
    --aesirxui-gutter-y: 24px;
  }
  .aesirxui .g-md-6,
  .aesirxui .gx-md-6 {
    --aesirxui-gutter-x: 60px;
  }
  .aesirxui .g-md-6,
  .aesirxui .gy-md-6 {
    --aesirxui-gutter-y: 60px;
  }
  .aesirxui .g-md-7,
  .aesirxui .gx-md-7 {
    --aesirxui-gutter-x: 70px;
  }
  .aesirxui .g-md-7,
  .aesirxui .gy-md-7 {
    --aesirxui-gutter-y: 70px;
  }
  .aesirxui .g-md-8,
  .aesirxui .gx-md-8 {
    --aesirxui-gutter-x: 80px;
  }
  .aesirxui .g-md-8,
  .aesirxui .gy-md-8 {
    --aesirxui-gutter-y: 80px;
  }
  .aesirxui .g-md-10,
  .aesirxui .gx-md-10 {
    --aesirxui-gutter-x: 10px;
  }
  .aesirxui .g-md-10,
  .aesirxui .gy-md-10 {
    --aesirxui-gutter-y: 10px;
  }
  .aesirxui .g-md-13,
  .aesirxui .gx-md-13 {
    --aesirxui-gutter-x: 13px;
  }
  .aesirxui .g-md-13,
  .aesirxui .gy-md-13 {
    --aesirxui-gutter-y: 13px;
  }
  .aesirxui .g-md-14,
  .aesirxui .gx-md-14 {
    --aesirxui-gutter-x: 14px;
  }
  .aesirxui .g-md-14,
  .aesirxui .gy-md-14 {
    --aesirxui-gutter-y: 14px;
  }
  .aesirxui .g-md-40,
  .aesirxui .gx-md-40 {
    --aesirxui-gutter-x: 40px;
  }
  .aesirxui .g-md-40,
  .aesirxui .gy-md-40 {
    --aesirxui-gutter-y: 40px;
  }
  .aesirxui .g-md-18px,
  .aesirxui .gx-md-18px {
    --aesirxui-gutter-x: 18px;
  }
  .aesirxui .g-md-18px,
  .aesirxui .gy-md-18px {
    --aesirxui-gutter-y: 18px;
  }
  .aesirxui .g-md-32px,
  .aesirxui .gx-md-32px {
    --aesirxui-gutter-x: 32px;
  }
  .aesirxui .g-md-32px,
  .aesirxui .gy-md-32px {
    --aesirxui-gutter-y: 32px;
  }
  .aesirxui .g-md-9px,
  .aesirxui .gx-md-9px {
    --aesirxui-gutter-x: 9px;
  }
  .aesirxui .g-md-9px,
  .aesirxui .gy-md-9px {
    --aesirxui-gutter-y: 9px;
  }
  .aesirxui .g-md-12px,
  .aesirxui .gx-md-12px {
    --aesirxui-gutter-x: 12px;
  }
  .aesirxui .g-md-12px,
  .aesirxui .gy-md-12px {
    --aesirxui-gutter-y: 12px;
  }
  .aesirxui .g-md-19px,
  .aesirxui .gx-md-19px {
    --aesirxui-gutter-x: 19px;
  }
  .aesirxui .g-md-19px,
  .aesirxui .gy-md-19px {
    --aesirxui-gutter-y: 19px;
  }
}
@media (min-width: 992px) {
  .aesirxui .col-lg {
    flex: 1 0 0%;
  }
  .aesirxui .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxui .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxui .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxui .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxui .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxui .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxui .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxui .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxui .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .offset-lg-0 {
    margin-left: 0;
  }
  .aesirxui .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .aesirxui .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .aesirxui .offset-lg-3 {
    margin-left: 25%;
  }
  .aesirxui .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .aesirxui .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .aesirxui .offset-lg-6 {
    margin-left: 50%;
  }
  .aesirxui .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .aesirxui .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .aesirxui .offset-lg-9 {
    margin-left: 75%;
  }
  .aesirxui .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .aesirxui .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .aesirxui .g-lg-0,
  .aesirxui .gx-lg-0 {
    --aesirxui-gutter-x: 0;
  }
  .aesirxui .g-lg-0,
  .aesirxui .gy-lg-0 {
    --aesirxui-gutter-y: 0;
  }
  .aesirxui .g-lg-1,
  .aesirxui .gx-lg-1 {
    --aesirxui-gutter-x: 0.25rem;
  }
  .aesirxui .g-lg-1,
  .aesirxui .gy-lg-1 {
    --aesirxui-gutter-y: 0.25rem;
  }
  .aesirxui .g-lg-2,
  .aesirxui .gx-lg-2 {
    --aesirxui-gutter-x: 0.5rem;
  }
  .aesirxui .g-lg-2,
  .aesirxui .gy-lg-2 {
    --aesirxui-gutter-y: 0.5rem;
  }
  .aesirxui .g-lg-3,
  .aesirxui .gx-lg-3 {
    --aesirxui-gutter-x: 1rem;
  }
  .aesirxui .g-lg-3,
  .aesirxui .gy-lg-3 {
    --aesirxui-gutter-y: 1rem;
  }
  .aesirxui .g-lg-4,
  .aesirxui .gx-lg-4 {
    --aesirxui-gutter-x: 1.5rem;
  }
  .aesirxui .g-lg-4,
  .aesirxui .gy-lg-4 {
    --aesirxui-gutter-y: 1.5rem;
  }
  .aesirxui .g-lg-5,
  .aesirxui .gx-lg-5 {
    --aesirxui-gutter-x: 3rem;
  }
  .aesirxui .g-lg-5,
  .aesirxui .gy-lg-5 {
    --aesirxui-gutter-y: 3rem;
  }
  .aesirxui .g-lg-sm,
  .aesirxui .gx-lg-sm {
    --aesirxui-gutter-x: 5px;
  }
  .aesirxui .g-lg-sm,
  .aesirxui .gy-lg-sm {
    --aesirxui-gutter-y: 5px;
  }
  .aesirxui .g-lg-8px,
  .aesirxui .gx-lg-8px {
    --aesirxui-gutter-x: 8px;
  }
  .aesirxui .g-lg-8px,
  .aesirxui .gy-lg-8px {
    --aesirxui-gutter-y: 8px;
  }
  .aesirxui .g-lg-15,
  .aesirxui .gx-lg-15 {
    --aesirxui-gutter-x: 15px;
  }
  .aesirxui .g-lg-15,
  .aesirxui .gy-lg-15 {
    --aesirxui-gutter-y: 15px;
  }
  .aesirxui .g-lg-16,
  .aesirxui .gx-lg-16 {
    --aesirxui-gutter-x: 16px;
  }
  .aesirxui .g-lg-16,
  .aesirxui .gy-lg-16 {
    --aesirxui-gutter-y: 16px;
  }
  .aesirxui .g-lg-20,
  .aesirxui .gx-lg-20 {
    --aesirxui-gutter-x: 20px;
  }
  .aesirxui .g-lg-20,
  .aesirxui .gy-lg-20 {
    --aesirxui-gutter-y: 20px;
  }
  .aesirxui .g-lg-24,
  .aesirxui .gx-lg-24 {
    --aesirxui-gutter-x: 24px;
  }
  .aesirxui .g-lg-24,
  .aesirxui .gy-lg-24 {
    --aesirxui-gutter-y: 24px;
  }
  .aesirxui .g-lg-6,
  .aesirxui .gx-lg-6 {
    --aesirxui-gutter-x: 60px;
  }
  .aesirxui .g-lg-6,
  .aesirxui .gy-lg-6 {
    --aesirxui-gutter-y: 60px;
  }
  .aesirxui .g-lg-7,
  .aesirxui .gx-lg-7 {
    --aesirxui-gutter-x: 70px;
  }
  .aesirxui .g-lg-7,
  .aesirxui .gy-lg-7 {
    --aesirxui-gutter-y: 70px;
  }
  .aesirxui .g-lg-8,
  .aesirxui .gx-lg-8 {
    --aesirxui-gutter-x: 80px;
  }
  .aesirxui .g-lg-8,
  .aesirxui .gy-lg-8 {
    --aesirxui-gutter-y: 80px;
  }
  .aesirxui .g-lg-10,
  .aesirxui .gx-lg-10 {
    --aesirxui-gutter-x: 10px;
  }
  .aesirxui .g-lg-10,
  .aesirxui .gy-lg-10 {
    --aesirxui-gutter-y: 10px;
  }
  .aesirxui .g-lg-13,
  .aesirxui .gx-lg-13 {
    --aesirxui-gutter-x: 13px;
  }
  .aesirxui .g-lg-13,
  .aesirxui .gy-lg-13 {
    --aesirxui-gutter-y: 13px;
  }
  .aesirxui .g-lg-14,
  .aesirxui .gx-lg-14 {
    --aesirxui-gutter-x: 14px;
  }
  .aesirxui .g-lg-14,
  .aesirxui .gy-lg-14 {
    --aesirxui-gutter-y: 14px;
  }
  .aesirxui .g-lg-40,
  .aesirxui .gx-lg-40 {
    --aesirxui-gutter-x: 40px;
  }
  .aesirxui .g-lg-40,
  .aesirxui .gy-lg-40 {
    --aesirxui-gutter-y: 40px;
  }
  .aesirxui .g-lg-18px,
  .aesirxui .gx-lg-18px {
    --aesirxui-gutter-x: 18px;
  }
  .aesirxui .g-lg-18px,
  .aesirxui .gy-lg-18px {
    --aesirxui-gutter-y: 18px;
  }
  .aesirxui .g-lg-32px,
  .aesirxui .gx-lg-32px {
    --aesirxui-gutter-x: 32px;
  }
  .aesirxui .g-lg-32px,
  .aesirxui .gy-lg-32px {
    --aesirxui-gutter-y: 32px;
  }
  .aesirxui .g-lg-9px,
  .aesirxui .gx-lg-9px {
    --aesirxui-gutter-x: 9px;
  }
  .aesirxui .g-lg-9px,
  .aesirxui .gy-lg-9px {
    --aesirxui-gutter-y: 9px;
  }
  .aesirxui .g-lg-12px,
  .aesirxui .gx-lg-12px {
    --aesirxui-gutter-x: 12px;
  }
  .aesirxui .g-lg-12px,
  .aesirxui .gy-lg-12px {
    --aesirxui-gutter-y: 12px;
  }
  .aesirxui .g-lg-19px,
  .aesirxui .gx-lg-19px {
    --aesirxui-gutter-x: 19px;
  }
  .aesirxui .g-lg-19px,
  .aesirxui .gy-lg-19px {
    --aesirxui-gutter-y: 19px;
  }
}
@media (min-width: 1200px) {
  .aesirxui .col-xl {
    flex: 1 0 0%;
  }
  .aesirxui .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxui .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxui .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxui .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxui .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxui .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxui .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxui .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxui .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .offset-xl-0 {
    margin-left: 0;
  }
  .aesirxui .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .aesirxui .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .aesirxui .offset-xl-3 {
    margin-left: 25%;
  }
  .aesirxui .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .aesirxui .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .aesirxui .offset-xl-6 {
    margin-left: 50%;
  }
  .aesirxui .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .aesirxui .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .aesirxui .offset-xl-9 {
    margin-left: 75%;
  }
  .aesirxui .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .aesirxui .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .aesirxui .g-xl-0,
  .aesirxui .gx-xl-0 {
    --aesirxui-gutter-x: 0;
  }
  .aesirxui .g-xl-0,
  .aesirxui .gy-xl-0 {
    --aesirxui-gutter-y: 0;
  }
  .aesirxui .g-xl-1,
  .aesirxui .gx-xl-1 {
    --aesirxui-gutter-x: 0.25rem;
  }
  .aesirxui .g-xl-1,
  .aesirxui .gy-xl-1 {
    --aesirxui-gutter-y: 0.25rem;
  }
  .aesirxui .g-xl-2,
  .aesirxui .gx-xl-2 {
    --aesirxui-gutter-x: 0.5rem;
  }
  .aesirxui .g-xl-2,
  .aesirxui .gy-xl-2 {
    --aesirxui-gutter-y: 0.5rem;
  }
  .aesirxui .g-xl-3,
  .aesirxui .gx-xl-3 {
    --aesirxui-gutter-x: 1rem;
  }
  .aesirxui .g-xl-3,
  .aesirxui .gy-xl-3 {
    --aesirxui-gutter-y: 1rem;
  }
  .aesirxui .g-xl-4,
  .aesirxui .gx-xl-4 {
    --aesirxui-gutter-x: 1.5rem;
  }
  .aesirxui .g-xl-4,
  .aesirxui .gy-xl-4 {
    --aesirxui-gutter-y: 1.5rem;
  }
  .aesirxui .g-xl-5,
  .aesirxui .gx-xl-5 {
    --aesirxui-gutter-x: 3rem;
  }
  .aesirxui .g-xl-5,
  .aesirxui .gy-xl-5 {
    --aesirxui-gutter-y: 3rem;
  }
  .aesirxui .g-xl-sm,
  .aesirxui .gx-xl-sm {
    --aesirxui-gutter-x: 5px;
  }
  .aesirxui .g-xl-sm,
  .aesirxui .gy-xl-sm {
    --aesirxui-gutter-y: 5px;
  }
  .aesirxui .g-xl-8px,
  .aesirxui .gx-xl-8px {
    --aesirxui-gutter-x: 8px;
  }
  .aesirxui .g-xl-8px,
  .aesirxui .gy-xl-8px {
    --aesirxui-gutter-y: 8px;
  }
  .aesirxui .g-xl-15,
  .aesirxui .gx-xl-15 {
    --aesirxui-gutter-x: 15px;
  }
  .aesirxui .g-xl-15,
  .aesirxui .gy-xl-15 {
    --aesirxui-gutter-y: 15px;
  }
  .aesirxui .g-xl-16,
  .aesirxui .gx-xl-16 {
    --aesirxui-gutter-x: 16px;
  }
  .aesirxui .g-xl-16,
  .aesirxui .gy-xl-16 {
    --aesirxui-gutter-y: 16px;
  }
  .aesirxui .g-xl-20,
  .aesirxui .gx-xl-20 {
    --aesirxui-gutter-x: 20px;
  }
  .aesirxui .g-xl-20,
  .aesirxui .gy-xl-20 {
    --aesirxui-gutter-y: 20px;
  }
  .aesirxui .g-xl-24,
  .aesirxui .gx-xl-24 {
    --aesirxui-gutter-x: 24px;
  }
  .aesirxui .g-xl-24,
  .aesirxui .gy-xl-24 {
    --aesirxui-gutter-y: 24px;
  }
  .aesirxui .g-xl-6,
  .aesirxui .gx-xl-6 {
    --aesirxui-gutter-x: 60px;
  }
  .aesirxui .g-xl-6,
  .aesirxui .gy-xl-6 {
    --aesirxui-gutter-y: 60px;
  }
  .aesirxui .g-xl-7,
  .aesirxui .gx-xl-7 {
    --aesirxui-gutter-x: 70px;
  }
  .aesirxui .g-xl-7,
  .aesirxui .gy-xl-7 {
    --aesirxui-gutter-y: 70px;
  }
  .aesirxui .g-xl-8,
  .aesirxui .gx-xl-8 {
    --aesirxui-gutter-x: 80px;
  }
  .aesirxui .g-xl-8,
  .aesirxui .gy-xl-8 {
    --aesirxui-gutter-y: 80px;
  }
  .aesirxui .g-xl-10,
  .aesirxui .gx-xl-10 {
    --aesirxui-gutter-x: 10px;
  }
  .aesirxui .g-xl-10,
  .aesirxui .gy-xl-10 {
    --aesirxui-gutter-y: 10px;
  }
  .aesirxui .g-xl-13,
  .aesirxui .gx-xl-13 {
    --aesirxui-gutter-x: 13px;
  }
  .aesirxui .g-xl-13,
  .aesirxui .gy-xl-13 {
    --aesirxui-gutter-y: 13px;
  }
  .aesirxui .g-xl-14,
  .aesirxui .gx-xl-14 {
    --aesirxui-gutter-x: 14px;
  }
  .aesirxui .g-xl-14,
  .aesirxui .gy-xl-14 {
    --aesirxui-gutter-y: 14px;
  }
  .aesirxui .g-xl-40,
  .aesirxui .gx-xl-40 {
    --aesirxui-gutter-x: 40px;
  }
  .aesirxui .g-xl-40,
  .aesirxui .gy-xl-40 {
    --aesirxui-gutter-y: 40px;
  }
  .aesirxui .g-xl-18px,
  .aesirxui .gx-xl-18px {
    --aesirxui-gutter-x: 18px;
  }
  .aesirxui .g-xl-18px,
  .aesirxui .gy-xl-18px {
    --aesirxui-gutter-y: 18px;
  }
  .aesirxui .g-xl-32px,
  .aesirxui .gx-xl-32px {
    --aesirxui-gutter-x: 32px;
  }
  .aesirxui .g-xl-32px,
  .aesirxui .gy-xl-32px {
    --aesirxui-gutter-y: 32px;
  }
  .aesirxui .g-xl-9px,
  .aesirxui .gx-xl-9px {
    --aesirxui-gutter-x: 9px;
  }
  .aesirxui .g-xl-9px,
  .aesirxui .gy-xl-9px {
    --aesirxui-gutter-y: 9px;
  }
  .aesirxui .g-xl-12px,
  .aesirxui .gx-xl-12px {
    --aesirxui-gutter-x: 12px;
  }
  .aesirxui .g-xl-12px,
  .aesirxui .gy-xl-12px {
    --aesirxui-gutter-y: 12px;
  }
  .aesirxui .g-xl-19px,
  .aesirxui .gx-xl-19px {
    --aesirxui-gutter-x: 19px;
  }
  .aesirxui .g-xl-19px,
  .aesirxui .gy-xl-19px {
    --aesirxui-gutter-y: 19px;
  }
}
@media (min-width: 1400px) {
  .aesirxui .col-xxl {
    flex: 1 0 0%;
  }
  .aesirxui .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxui .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxui .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxui .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxui .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxui .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxui .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxui .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxui .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxui .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxui .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxui .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxui .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxui .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxui .offset-xxl-0 {
    margin-left: 0;
  }
  .aesirxui .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .aesirxui .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .aesirxui .offset-xxl-3 {
    margin-left: 25%;
  }
  .aesirxui .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .aesirxui .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .aesirxui .offset-xxl-6 {
    margin-left: 50%;
  }
  .aesirxui .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .aesirxui .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .aesirxui .offset-xxl-9 {
    margin-left: 75%;
  }
  .aesirxui .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .aesirxui .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .aesirxui .g-xxl-0,
  .aesirxui .gx-xxl-0 {
    --aesirxui-gutter-x: 0;
  }
  .aesirxui .g-xxl-0,
  .aesirxui .gy-xxl-0 {
    --aesirxui-gutter-y: 0;
  }
  .aesirxui .g-xxl-1,
  .aesirxui .gx-xxl-1 {
    --aesirxui-gutter-x: 0.25rem;
  }
  .aesirxui .g-xxl-1,
  .aesirxui .gy-xxl-1 {
    --aesirxui-gutter-y: 0.25rem;
  }
  .aesirxui .g-xxl-2,
  .aesirxui .gx-xxl-2 {
    --aesirxui-gutter-x: 0.5rem;
  }
  .aesirxui .g-xxl-2,
  .aesirxui .gy-xxl-2 {
    --aesirxui-gutter-y: 0.5rem;
  }
  .aesirxui .g-xxl-3,
  .aesirxui .gx-xxl-3 {
    --aesirxui-gutter-x: 1rem;
  }
  .aesirxui .g-xxl-3,
  .aesirxui .gy-xxl-3 {
    --aesirxui-gutter-y: 1rem;
  }
  .aesirxui .g-xxl-4,
  .aesirxui .gx-xxl-4 {
    --aesirxui-gutter-x: 1.5rem;
  }
  .aesirxui .g-xxl-4,
  .aesirxui .gy-xxl-4 {
    --aesirxui-gutter-y: 1.5rem;
  }
  .aesirxui .g-xxl-5,
  .aesirxui .gx-xxl-5 {
    --aesirxui-gutter-x: 3rem;
  }
  .aesirxui .g-xxl-5,
  .aesirxui .gy-xxl-5 {
    --aesirxui-gutter-y: 3rem;
  }
  .aesirxui .g-xxl-sm,
  .aesirxui .gx-xxl-sm {
    --aesirxui-gutter-x: 5px;
  }
  .aesirxui .g-xxl-sm,
  .aesirxui .gy-xxl-sm {
    --aesirxui-gutter-y: 5px;
  }
  .aesirxui .g-xxl-8px,
  .aesirxui .gx-xxl-8px {
    --aesirxui-gutter-x: 8px;
  }
  .aesirxui .g-xxl-8px,
  .aesirxui .gy-xxl-8px {
    --aesirxui-gutter-y: 8px;
  }
  .aesirxui .g-xxl-15,
  .aesirxui .gx-xxl-15 {
    --aesirxui-gutter-x: 15px;
  }
  .aesirxui .g-xxl-15,
  .aesirxui .gy-xxl-15 {
    --aesirxui-gutter-y: 15px;
  }
  .aesirxui .g-xxl-16,
  .aesirxui .gx-xxl-16 {
    --aesirxui-gutter-x: 16px;
  }
  .aesirxui .g-xxl-16,
  .aesirxui .gy-xxl-16 {
    --aesirxui-gutter-y: 16px;
  }
  .aesirxui .g-xxl-20,
  .aesirxui .gx-xxl-20 {
    --aesirxui-gutter-x: 20px;
  }
  .aesirxui .g-xxl-20,
  .aesirxui .gy-xxl-20 {
    --aesirxui-gutter-y: 20px;
  }
  .aesirxui .g-xxl-24,
  .aesirxui .gx-xxl-24 {
    --aesirxui-gutter-x: 24px;
  }
  .aesirxui .g-xxl-24,
  .aesirxui .gy-xxl-24 {
    --aesirxui-gutter-y: 24px;
  }
  .aesirxui .g-xxl-6,
  .aesirxui .gx-xxl-6 {
    --aesirxui-gutter-x: 60px;
  }
  .aesirxui .g-xxl-6,
  .aesirxui .gy-xxl-6 {
    --aesirxui-gutter-y: 60px;
  }
  .aesirxui .g-xxl-7,
  .aesirxui .gx-xxl-7 {
    --aesirxui-gutter-x: 70px;
  }
  .aesirxui .g-xxl-7,
  .aesirxui .gy-xxl-7 {
    --aesirxui-gutter-y: 70px;
  }
  .aesirxui .g-xxl-8,
  .aesirxui .gx-xxl-8 {
    --aesirxui-gutter-x: 80px;
  }
  .aesirxui .g-xxl-8,
  .aesirxui .gy-xxl-8 {
    --aesirxui-gutter-y: 80px;
  }
  .aesirxui .g-xxl-10,
  .aesirxui .gx-xxl-10 {
    --aesirxui-gutter-x: 10px;
  }
  .aesirxui .g-xxl-10,
  .aesirxui .gy-xxl-10 {
    --aesirxui-gutter-y: 10px;
  }
  .aesirxui .g-xxl-13,
  .aesirxui .gx-xxl-13 {
    --aesirxui-gutter-x: 13px;
  }
  .aesirxui .g-xxl-13,
  .aesirxui .gy-xxl-13 {
    --aesirxui-gutter-y: 13px;
  }
  .aesirxui .g-xxl-14,
  .aesirxui .gx-xxl-14 {
    --aesirxui-gutter-x: 14px;
  }
  .aesirxui .g-xxl-14,
  .aesirxui .gy-xxl-14 {
    --aesirxui-gutter-y: 14px;
  }
  .aesirxui .g-xxl-40,
  .aesirxui .gx-xxl-40 {
    --aesirxui-gutter-x: 40px;
  }
  .aesirxui .g-xxl-40,
  .aesirxui .gy-xxl-40 {
    --aesirxui-gutter-y: 40px;
  }
  .aesirxui .g-xxl-18px,
  .aesirxui .gx-xxl-18px {
    --aesirxui-gutter-x: 18px;
  }
  .aesirxui .g-xxl-18px,
  .aesirxui .gy-xxl-18px {
    --aesirxui-gutter-y: 18px;
  }
  .aesirxui .g-xxl-32px,
  .aesirxui .gx-xxl-32px {
    --aesirxui-gutter-x: 32px;
  }
  .aesirxui .g-xxl-32px,
  .aesirxui .gy-xxl-32px {
    --aesirxui-gutter-y: 32px;
  }
  .aesirxui .g-xxl-9px,
  .aesirxui .gx-xxl-9px {
    --aesirxui-gutter-x: 9px;
  }
  .aesirxui .g-xxl-9px,
  .aesirxui .gy-xxl-9px {
    --aesirxui-gutter-y: 9px;
  }
  .aesirxui .g-xxl-12px,
  .aesirxui .gx-xxl-12px {
    --aesirxui-gutter-x: 12px;
  }
  .aesirxui .g-xxl-12px,
  .aesirxui .gy-xxl-12px {
    --aesirxui-gutter-y: 12px;
  }
  .aesirxui .g-xxl-19px,
  .aesirxui .gx-xxl-19px {
    --aesirxui-gutter-x: 19px;
  }
  .aesirxui .g-xxl-19px,
  .aesirxui .gy-xxl-19px {
    --aesirxui-gutter-y: 19px;
  }
}
.aesirxui .table {
  --aesirxui-table-color-type: initial;
  --aesirxui-table-bg-type: initial;
  --aesirxui-table-color-state: initial;
  --aesirxui-table-bg-state: initial;
  --aesirxui-table-color: var(--aesirxui-emphasis-color);
  --aesirxui-table-bg: var(--aesirxui-body-bg);
  --aesirxui-table-border-color: var(--aesirxui-border-color);
  --aesirxui-table-accent-bg: transparent;
  --aesirxui-table-striped-color: var(--aesirxui-emphasis-color);
  --aesirxui-table-striped-bg: rgba(var(--aesirxui-emphasis-color-rgb), 0.05);
  --aesirxui-table-active-color: var(--aesirxui-emphasis-color);
  --aesirxui-table-active-bg: rgba(var(--aesirxui-emphasis-color-rgb), 0.1);
  --aesirxui-table-hover-color: var(--aesirxui-emphasis-color);
  --aesirxui-table-hover-bg: rgba(var(--aesirxui-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--aesirxui-table-color-state, var(--aesirxui-table-color-type, var(--aesirxui-table-color)));
  background-color: var(--aesirxui-table-bg);
  border-bottom-width: var(--aesirxui-border-width);
  box-shadow: inset 0 0 0 9999px var(--aesirxui-table-bg-state, var(--aesirxui-table-bg-type, var(--aesirxui-table-accent-bg)));
}
.aesirxui .table > tbody {
  vertical-align: inherit;
}
.aesirxui .table > thead {
  vertical-align: bottom;
}
.aesirxui .table-group-divider {
  border-top: calc(var(--aesirxui-border-width) * 2) solid currentcolor;
}
.aesirxui .caption-top {
  caption-side: top;
}
.aesirxui .table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}
.aesirxui .table-bordered > :not(caption) > * {
  border-width: var(--aesirxui-border-width) 0;
}
.aesirxui .table-bordered > :not(caption) > * > * {
  border-width: 0 var(--aesirxui-border-width);
}
.aesirxui .table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.aesirxui .table-borderless > :not(:first-child) {
  border-top-width: 0;
}
.aesirxui .table-striped > tbody > tr:nth-of-type(odd) > * {
  --aesirxui-table-color-type: var(--aesirxui-table-striped-color);
  --aesirxui-table-bg-type: var(--aesirxui-table-striped-bg);
}
.aesirxui .table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --aesirxui-table-color-type: var(--aesirxui-table-striped-color);
  --aesirxui-table-bg-type: var(--aesirxui-table-striped-bg);
}
.aesirxui .table-active {
  --aesirxui-table-color-state: var(--aesirxui-table-active-color);
  --aesirxui-table-bg-state: var(--aesirxui-table-active-bg);
}
.aesirxui .table-hover > tbody > tr:hover > * {
  --aesirxui-table-color-state: var(--aesirxui-table-hover-color);
  --aesirxui-table-bg-state: var(--aesirxui-table-hover-bg);
}
.aesirxui .table-primary {
  --aesirxui-table-color: #000;
  --aesirxui-table-bg: rgb(206, 205.6, 215.8);
  --aesirxui-table-border-color: rgb(164.8, 164.48, 172.64);
  --aesirxui-table-striped-bg: rgb(195.7, 195.32, 205.01);
  --aesirxui-table-striped-color: #000;
  --aesirxui-table-active-bg: rgb(185.4, 185.04, 194.22);
  --aesirxui-table-active-color: #000;
  --aesirxui-table-hover-bg: rgb(190.55, 190.18, 199.615);
  --aesirxui-table-hover-color: #000;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-secondary {
  --aesirxui-table-color: #000;
  --aesirxui-table-bg: rgb(204, 219.4, 225.6);
  --aesirxui-table-border-color: rgb(163.2, 175.52, 180.48);
  --aesirxui-table-striped-bg: rgb(193.8, 208.43, 214.32);
  --aesirxui-table-striped-color: #000;
  --aesirxui-table-active-bg: rgb(183.6, 197.46, 203.04);
  --aesirxui-table-active-color: #000;
  --aesirxui-table-hover-bg: rgb(188.7, 202.945, 208.68);
  --aesirxui-table-hover-color: #000;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-success {
  --aesirxui-table-color: #000;
  --aesirxui-table-bg: rgb(209.2, 239.8, 233.6);
  --aesirxui-table-border-color: rgb(167.36, 191.84, 186.88);
  --aesirxui-table-striped-bg: rgb(198.74, 227.81, 221.92);
  --aesirxui-table-striped-color: #000;
  --aesirxui-table-active-bg: rgb(188.28, 215.82, 210.24);
  --aesirxui-table-active-color: #000;
  --aesirxui-table-hover-bg: rgb(193.51, 221.815, 216.08);
  --aesirxui-table-hover-color: #000;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-info {
  --aesirxui-table-color: #000;
  --aesirxui-table-bg: rgb(215.8, 228.4, 240.2);
  --aesirxui-table-border-color: rgb(172.64, 182.72, 192.16);
  --aesirxui-table-striped-bg: rgb(205.01, 216.98, 228.19);
  --aesirxui-table-striped-color: #000;
  --aesirxui-table-active-bg: rgb(194.22, 205.56, 216.18);
  --aesirxui-table-active-color: #000;
  --aesirxui-table-hover-bg: rgb(199.615, 211.27, 222.185);
  --aesirxui-table-hover-color: #000;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-warning {
  --aesirxui-table-color: #000;
  --aesirxui-table-bg: rgb(252, 229.2, 211.4);
  --aesirxui-table-border-color: rgb(201.6, 183.36, 169.12);
  --aesirxui-table-striped-bg: rgb(239.4, 217.74, 200.83);
  --aesirxui-table-striped-color: #000;
  --aesirxui-table-active-bg: rgb(226.8, 206.28, 190.26);
  --aesirxui-table-active-color: #000;
  --aesirxui-table-hover-bg: rgb(233.1, 212.01, 195.545);
  --aesirxui-table-hover-color: #000;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-danger {
  --aesirxui-table-color: #000;
  --aesirxui-table-bg: rgb(244, 209, 213.2);
  --aesirxui-table-border-color: rgb(195.2, 167.2, 170.56);
  --aesirxui-table-striped-bg: rgb(231.8, 198.55, 202.54);
  --aesirxui-table-striped-color: #000;
  --aesirxui-table-active-bg: rgb(219.6, 188.1, 191.88);
  --aesirxui-table-active-color: #000;
  --aesirxui-table-hover-bg: rgb(225.7, 193.325, 197.21);
  --aesirxui-table-hover-color: #000;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-light {
  --aesirxui-table-color: #000;
  --aesirxui-table-bg: #f6f8fa;
  --aesirxui-table-border-color: rgb(196.8, 198.4, 200);
  --aesirxui-table-striped-bg: rgb(233.7, 235.6, 237.5);
  --aesirxui-table-striped-color: #000;
  --aesirxui-table-active-bg: rgb(221.4, 223.2, 225);
  --aesirxui-table-active-color: #000;
  --aesirxui-table-hover-bg: rgb(227.55, 229.4, 231.25);
  --aesirxui-table-hover-color: #000;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-dark {
  --aesirxui-table-color: #fff;
  --aesirxui-table-bg: #222328;
  --aesirxui-table-border-color: rgb(78.2, 79, 83);
  --aesirxui-table-striped-bg: rgb(45.05, 46, 50.75);
  --aesirxui-table-striped-color: #fff;
  --aesirxui-table-active-bg: rgb(56.1, 57, 61.5);
  --aesirxui-table-active-color: #fff;
  --aesirxui-table-hover-bg: rgb(50.575, 51.5, 56.125);
  --aesirxui-table-hover-color: #fff;
  color: var(--aesirxui-table-color);
  border-color: var(--aesirxui-table-border-color);
}
.aesirxui .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 575.98px) {
  .aesirxui .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .aesirxui .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .aesirxui .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .aesirxui .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .aesirxui .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.aesirxui .form-label {
  margin-bottom: 0.5rem;
}
.aesirxui .col-form-label {
  padding-top: calc(0.75rem + var(--aesirxui-border-width));
  padding-bottom: calc(0.75rem + var(--aesirxui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
.aesirxui .col-form-label-lg {
  padding-top: calc(0.5rem + var(--aesirxui-border-width));
  padding-bottom: calc(0.5rem + var(--aesirxui-border-width));
  font-size: 1.25rem;
}
.aesirxui .col-form-label-sm {
  padding-top: calc(0.25rem + var(--aesirxui-border-width));
  padding-bottom: calc(0.25rem + var(--aesirxui-border-width));
  font-size: 0.875rem;
}
.aesirxui .form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--aesirxui-secondary-color);
}
.aesirxui .form-control {
  display: block;
  width: 100%;
  padding: 0.75rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--aesirxui-body-color);
  appearance: none;
  background-color: var(--aesirxui-body-bg);
  background-clip: padding-box;
  border: var(--aesirxui-border-width) solid var(--aesirxui-border-color);
  border-radius: var(--aesirxui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .form-control {
    transition: none;
  }
}
.aesirxui .form-control[type=file] {
  overflow: hidden;
}
.aesirxui .form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.aesirxui .form-control:focus {
  color: var(--aesirxui-body-color);
  background-color: var(--aesirxui-body-bg);
  border-color: rgb(140.5, 217, 201.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(10, 8, 59, 0.25);
}
.aesirxui .form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.aesirxui .form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.aesirxui .form-control::placeholder {
  color: var(--aesirxui-secondary-color);
  opacity: 1;
}
.aesirxui .form-control:disabled {
  background-color: var(--aesirxui-secondary-bg);
  opacity: 1;
}
.aesirxui .form-control::file-selector-button {
  padding: 0.75rem 0.75rem;
  margin: -0.75rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--aesirxui-body-color);
  background-color: var(--aesirxui-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--aesirxui-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .form-control::file-selector-button {
    transition: none;
  }
}
.aesirxui .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--aesirxui-secondary-bg);
}
.aesirxui .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--aesirxui-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--aesirxui-border-width) 0;
}
.aesirxui .form-control-plaintext:focus {
  outline: 0;
}
.aesirxui .form-control-plaintext.form-control-sm, .aesirxui .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
.aesirxui .form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--aesirxui-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}
.aesirxui .form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--aesirxui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}
.aesirxui textarea.form-control {
  min-height: calc(1.5em + 1.5rem + calc(var(--aesirxui-border-width) * 2));
}
.aesirxui textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--aesirxui-border-width) * 2));
}
.aesirxui textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--aesirxui-border-width) * 2));
}
.aesirxui .form-control-color {
  width: 3rem;
  height: calc(1.5em + 1.5rem + calc(var(--aesirxui-border-width) * 2));
  padding: 0.75rem;
}
.aesirxui .form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.aesirxui .form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--aesirxui-border-radius);
}
.aesirxui .form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--aesirxui-border-radius);
}
.aesirxui .form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--aesirxui-border-width) * 2));
}
.aesirxui .form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--aesirxui-border-width) * 2));
}
.aesirxui .form-select {
  --aesirxui-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23e9e9e9' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  display: block;
  width: 100%;
  padding: 0.75rem 2.25rem 0.75rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--aesirxui-body-color);
  appearance: none;
  background-color: var(--aesirxui-body-bg);
  background-image: var(--aesirxui-form-select-bg-img), var(--aesirxui-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--aesirxui-border-width) solid var(--aesirxui-border-color);
  border-radius: var(--aesirxui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .form-select {
    transition: none;
  }
}
.aesirxui .form-select:focus {
  border-color: rgb(140.5, 217, 201.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(10, 8, 59, 0.25);
}
.aesirxui .form-select[multiple], .aesirxui .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.aesirxui .form-select:disabled {
  background-color: var(--aesirxui-secondary-bg);
}
.aesirxui .form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--aesirxui-body-color);
}
.aesirxui .form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui [data-bs-theme=dark] .form-select {
  --aesirxui-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ebebeb' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
}
.aesirxui .form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 2em;
  margin-bottom: 0.125rem;
}
.aesirxui .form-check .form-check-input {
  float: left;
  margin-left: -2em;
}
.aesirxui .form-check-reverse {
  padding-right: 2em;
  padding-left: 0;
  text-align: right;
}
.aesirxui .form-check-reverse .form-check-input {
  float: right;
  margin-right: -2em;
  margin-left: 0;
}
.aesirxui .form-check-input {
  --aesirxui-form-check-bg: var(--aesirxui-body-bg);
  flex-shrink: 0;
  width: 1.5em;
  height: 1.5em;
  margin-top: 0em;
  vertical-align: top;
  appearance: none;
  background-color: var(--aesirxui-form-check-bg);
  background-image: var(--aesirxui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--aesirxui-border-width) solid var(--aesirxui-border-color);
  print-color-adjust: exact;
}
.aesirxui .form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.aesirxui .form-check-input[type=radio] {
  border-radius: 50%;
}
.aesirxui .form-check-input:active {
  filter: brightness(90%);
}
.aesirxui .form-check-input:focus {
  border-color: rgb(140.5, 217, 201.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(10, 8, 59, 0.25);
}
.aesirxui .form-check-input:checked {
  background-color: #fff;
  border-color: #1ab394;
}
.aesirxui .form-check-input:checked[type=checkbox] {
  --aesirxui-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
}
.aesirxui .form-check-input:checked[type=radio] {
  --aesirxui-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%231ab394'/%3e%3c/svg%3e");
}
.aesirxui .form-check-input[type=checkbox]:indeterminate {
  background-color: #1ab394;
  border-color: #1ab394;
  --aesirxui-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
.aesirxui .form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.aesirxui .form-check-input[disabled] ~ .form-check-label, .aesirxui .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}
.aesirxui .form-switch {
  padding-left: 3em;
}
.aesirxui .form-switch .form-check-input {
  --aesirxui-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e");
  width: 2.5em;
  margin-left: -3em;
  background-image: var(--aesirxui-form-switch-bg);
  background-position: left center;
  border-radius: 2.5em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .form-switch .form-check-input {
    transition: none;
  }
}
.aesirxui .form-switch .form-check-input:focus {
  --aesirxui-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%28140.5, 217, 201.5%29'/%3e%3c/svg%3e");
}
.aesirxui .form-switch .form-check-input:checked {
  background-position: right center;
  --aesirxui-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
.aesirxui .form-switch.form-check-reverse {
  padding-right: 3em;
  padding-left: 0;
}
.aesirxui .form-switch.form-check-reverse .form-check-input {
  margin-right: -3em;
  margin-left: 0;
}
.aesirxui .form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}
.aesirxui .btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.aesirxui .btn-check[disabled] + .btn, .aesirxui .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}
.aesirxui [data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --aesirxui-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e");
}
.aesirxui .form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.aesirxui .form-range:focus {
  outline: 0;
}
.aesirxui .form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f9fa, 0 0 0 0.25rem rgba(10, 8, 59, 0.25);
}
.aesirxui .form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f9fa, 0 0 0 0.25rem rgba(10, 8, 59, 0.25);
}
.aesirxui .form-range::-moz-focus-outer {
  border: 0;
}
.aesirxui .form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #1ab394;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.aesirxui .form-range::-webkit-slider-thumb:active {
  background-color: rgb(186.3, 232.2, 222.9);
}
.aesirxui .form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--aesirxui-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.aesirxui .form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #1ab394;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .form-range::-moz-range-thumb {
    transition: none;
  }
}
.aesirxui .form-range::-moz-range-thumb:active {
  background-color: rgb(186.3, 232.2, 222.9);
}
.aesirxui .form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--aesirxui-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.aesirxui .form-range:disabled {
  pointer-events: none;
}
.aesirxui .form-range:disabled::-webkit-slider-thumb {
  background-color: var(--aesirxui-secondary-color);
}
.aesirxui .form-range:disabled::-moz-range-thumb {
  background-color: var(--aesirxui-secondary-color);
}
.aesirxui .form-floating {
  position: relative;
}
.aesirxui .form-floating > .form-control,
.aesirxui .form-floating > .form-control-plaintext,
.aesirxui .form-floating > .form-select {
  height: calc(3.5rem + calc(var(--aesirxui-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--aesirxui-border-width) * 2));
  line-height: 1.25;
}
.aesirxui .form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--aesirxui-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .form-floating > label {
    transition: none;
  }
}
.aesirxui .form-floating > .form-control,
.aesirxui .form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.aesirxui .form-floating > .form-control::placeholder,
.aesirxui .form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.aesirxui .form-floating > .form-control:focus, .aesirxui .form-floating > .form-control:not(:placeholder-shown),
.aesirxui .form-floating > .form-control-plaintext:focus,
.aesirxui .form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.aesirxui .form-floating > .form-control:-webkit-autofill,
.aesirxui .form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.aesirxui .form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.aesirxui .form-floating > .form-control:focus ~ label,
.aesirxui .form-floating > .form-control:not(:placeholder-shown) ~ label,
.aesirxui .form-floating > .form-control-plaintext ~ label,
.aesirxui .form-floating > .form-select ~ label {
  color: rgba(var(--aesirxui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.aesirxui .form-floating > .form-control:focus ~ label::after,
.aesirxui .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.aesirxui .form-floating > .form-control-plaintext ~ label::after,
.aesirxui .form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--aesirxui-body-bg);
  border-radius: var(--aesirxui-border-radius);
}
.aesirxui .form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--aesirxui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.aesirxui .form-floating > .form-control-plaintext ~ label {
  border-width: var(--aesirxui-border-width) 0;
}
.aesirxui .form-floating > :disabled ~ label,
.aesirxui .form-floating > .form-control:disabled ~ label {
  color: #8e8e8e;
}
.aesirxui .form-floating > :disabled ~ label::after,
.aesirxui .form-floating > .form-control:disabled ~ label::after {
  background-color: var(--aesirxui-secondary-bg);
}
.aesirxui .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.aesirxui .input-group > .form-control,
.aesirxui .input-group > .form-select,
.aesirxui .input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.aesirxui .input-group > .form-control:focus,
.aesirxui .input-group > .form-select:focus,
.aesirxui .input-group > .form-floating:focus-within {
  z-index: 5;
}
.aesirxui .input-group .btn {
  position: relative;
  z-index: 2;
}
.aesirxui .input-group .btn:focus {
  z-index: 5;
}
.aesirxui .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--aesirxui-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--aesirxui-tertiary-bg);
  border: var(--aesirxui-border-width) solid var(--aesirxui-border-color);
  border-radius: var(--aesirxui-border-radius);
}
.aesirxui .input-group-lg > .form-control,
.aesirxui .input-group-lg > .form-select,
.aesirxui .input-group-lg > .input-group-text,
.aesirxui .input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .input-group-sm > .form-control,
.aesirxui .input-group-sm > .form-select,
.aesirxui .input-group-sm > .input-group-text,
.aesirxui .input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .input-group-lg > .form-select,
.aesirxui .input-group-sm > .form-select {
  padding-right: 3rem;
}
.aesirxui .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.aesirxui .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.aesirxui .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.aesirxui .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxui .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.aesirxui .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.aesirxui .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.aesirxui .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxui .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--aesirxui-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxui .input-group > .form-floating:not(:first-child) > .form-control,
.aesirxui .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxui .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--aesirxui-form-valid-color);
}
.aesirxui .valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--aesirxui-success);
  border-radius: var(--aesirxui-border-radius);
}
.was-validated .aesirxui:valid ~ .valid-feedback,
.was-validated .aesirxui:valid ~ .valid-tooltip, .aesirxui.is-valid ~ .valid-feedback,
.aesirxui.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .aesirxui .form-control:valid, .aesirxui .form-control.is-valid {
  border-color: var(--aesirxui-form-valid-border-color);
  padding-right: calc(1.5em + 1.5rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231ab394' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.375rem) center;
  background-size: calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .aesirxui .form-control:valid:focus, .aesirxui .form-control.is-valid:focus {
  border-color: var(--aesirxui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxui-success-rgb), 0.25);
}
.was-validated .aesirxui textarea.form-control:valid, .aesirxui textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.5rem);
  background-position: top calc(0.375em + 0.375rem) right calc(0.375em + 0.375rem);
}
.was-validated .aesirxui .form-select:valid, .aesirxui .form-select.is-valid {
  border-color: var(--aesirxui-form-valid-border-color);
}
.was-validated .aesirxui .form-select:valid:not([multiple]):not([size]), .was-validated .aesirxui .form-select:valid:not([multiple])[size="1"], .aesirxui .form-select.is-valid:not([multiple]):not([size]), .aesirxui .form-select.is-valid:not([multiple])[size="1"] {
  --aesirxui-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231ab394' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .aesirxui .form-select:valid:focus, .aesirxui .form-select.is-valid:focus {
  border-color: var(--aesirxui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxui-success-rgb), 0.25);
}
.was-validated .aesirxui .form-control-color:valid, .aesirxui .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1.5rem));
}
.was-validated .aesirxui .form-check-input:valid, .aesirxui .form-check-input.is-valid {
  border-color: var(--aesirxui-form-valid-border-color);
}
.was-validated .aesirxui .form-check-input:valid:checked, .aesirxui .form-check-input.is-valid:checked {
  background-color: var(--aesirxui-form-valid-color);
}
.was-validated .aesirxui .form-check-input:valid:focus, .aesirxui .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxui-success-rgb), 0.25);
}
.was-validated .aesirxui .form-check-input:valid ~ .form-check-label, .aesirxui .form-check-input.is-valid ~ .form-check-label {
  color: var(--aesirxui-form-valid-color);
}
.aesirxui .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
.was-validated .aesirxui .input-group > .form-control:not(:focus):valid, .aesirxui .input-group > .form-control:not(:focus).is-valid,
.was-validated .aesirxui .input-group > .form-select:not(:focus):valid,
.aesirxui .input-group > .form-select:not(:focus).is-valid,
.was-validated .aesirxui .input-group > .form-floating:not(:focus-within):valid,
.aesirxui .input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}
.aesirxui .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--aesirxui-form-invalid-color);
}
.aesirxui .invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--aesirxui-danger);
  border-radius: var(--aesirxui-border-radius);
}
.was-validated .aesirxui:invalid ~ .invalid-feedback,
.was-validated .aesirxui:invalid ~ .invalid-tooltip, .aesirxui.is-invalid ~ .invalid-feedback,
.aesirxui.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .aesirxui .form-control:invalid, .aesirxui .form-control.is-invalid {
  border-color: var(--aesirxui-form-invalid-border-color);
  padding-right: calc(1.5em + 1.5rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23c8192e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23c8192e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.375rem) center;
  background-size: calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .aesirxui .form-control:invalid:focus, .aesirxui .form-control.is-invalid:focus {
  border-color: var(--aesirxui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxui-danger-rgb), 0.25);
}
.was-validated .aesirxui textarea.form-control:invalid, .aesirxui textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.5rem);
  background-position: top calc(0.375em + 0.375rem) right calc(0.375em + 0.375rem);
}
.was-validated .aesirxui .form-select:invalid, .aesirxui .form-select.is-invalid {
  border-color: var(--aesirxui-form-invalid-border-color);
}
.was-validated .aesirxui .form-select:invalid:not([multiple]):not([size]), .was-validated .aesirxui .form-select:invalid:not([multiple])[size="1"], .aesirxui .form-select.is-invalid:not([multiple]):not([size]), .aesirxui .form-select.is-invalid:not([multiple])[size="1"] {
  --aesirxui-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23c8192e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23c8192e' stroke='none'/%3e%3c/svg%3e");
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .aesirxui .form-select:invalid:focus, .aesirxui .form-select.is-invalid:focus {
  border-color: var(--aesirxui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxui-danger-rgb), 0.25);
}
.was-validated .aesirxui .form-control-color:invalid, .aesirxui .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1.5rem));
}
.was-validated .aesirxui .form-check-input:invalid, .aesirxui .form-check-input.is-invalid {
  border-color: var(--aesirxui-form-invalid-border-color);
}
.was-validated .aesirxui .form-check-input:invalid:checked, .aesirxui .form-check-input.is-invalid:checked {
  background-color: var(--aesirxui-form-invalid-color);
}
.was-validated .aesirxui .form-check-input:invalid:focus, .aesirxui .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxui-danger-rgb), 0.25);
}
.was-validated .aesirxui .form-check-input:invalid ~ .form-check-label, .aesirxui .form-check-input.is-invalid ~ .form-check-label {
  color: var(--aesirxui-form-invalid-color);
}
.aesirxui .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
.was-validated .aesirxui .input-group > .form-control:not(:focus):invalid, .aesirxui .input-group > .form-control:not(:focus).is-invalid,
.was-validated .aesirxui .input-group > .form-select:not(:focus):invalid,
.aesirxui .input-group > .form-select:not(:focus).is-invalid,
.was-validated .aesirxui .input-group > .form-floating:not(:focus-within):invalid,
.aesirxui .input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}
.aesirxui .btn-group,
.aesirxui .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.aesirxui .btn-group > .btn,
.aesirxui .btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.aesirxui .btn-group > .btn-check:checked + .btn,
.aesirxui .btn-group > .btn-check:focus + .btn,
.aesirxui .btn-group > .btn:hover,
.aesirxui .btn-group > .btn:focus,
.aesirxui .btn-group > .btn:active,
.aesirxui .btn-group > .btn.active,
.aesirxui .btn-group-vertical > .btn-check:checked + .btn,
.aesirxui .btn-group-vertical > .btn-check:focus + .btn,
.aesirxui .btn-group-vertical > .btn:hover,
.aesirxui .btn-group-vertical > .btn:focus,
.aesirxui .btn-group-vertical > .btn:active,
.aesirxui .btn-group-vertical > .btn.active {
  z-index: 1;
}
.aesirxui .btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.aesirxui .btn-toolbar .input-group {
  width: auto;
}
.aesirxui .btn-group {
  border-radius: var(--aesirxui-border-radius);
}
.aesirxui .btn-group > :not(.btn-check:first-child) + .btn,
.aesirxui .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--aesirxui-border-width) * -1);
}
.aesirxui .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.aesirxui .btn-group > .btn.dropdown-toggle-split:first-child,
.aesirxui .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxui .btn-group > .btn:nth-child(n+3),
.aesirxui .btn-group > :not(.btn-check) + .btn,
.aesirxui .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxui .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.aesirxui .dropdown-toggle-split::after, .dropup .aesirxui .dropdown-toggle-split::after, .dropend .aesirxui .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .aesirxui .dropdown-toggle-split::before {
  margin-right: 0;
}
.aesirxui .btn-sm + .dropdown-toggle-split, .aesirxui .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}
.aesirxui .btn-lg + .dropdown-toggle-split, .aesirxui .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.aesirxui .btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.aesirxui .btn-group-vertical > .btn,
.aesirxui .btn-group-vertical > .btn-group {
  width: 100%;
}
.aesirxui .btn-group-vertical > .btn:not(:first-child),
.aesirxui .btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--aesirxui-border-width) * -1);
}
.aesirxui .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.aesirxui .btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxui .btn-group-vertical > .btn ~ .btn,
.aesirxui .btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.aesirxui .btn {
  --aesirxui-btn-padding-x: 0.75rem;
  --aesirxui-btn-padding-y: 0.75rem;
  --aesirxui-btn-font-family: ;
  --aesirxui-btn-font-size: 1rem;
  --aesirxui-btn-font-weight: 400;
  --aesirxui-btn-line-height: 1.5;
  --aesirxui-btn-color: var(--aesirxui-body-color);
  --aesirxui-btn-bg: transparent;
  --aesirxui-btn-border-width: var(--aesirxui-border-width);
  --aesirxui-btn-border-color: transparent;
  --aesirxui-btn-border-radius: var(--aesirxui-border-radius);
  --aesirxui-btn-hover-border-color: transparent;
  --aesirxui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --aesirxui-btn-disabled-opacity: 0.65;
  --aesirxui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--aesirxui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--aesirxui-btn-padding-y) var(--aesirxui-btn-padding-x);
  font-family: var(--aesirxui-btn-font-family);
  font-size: var(--aesirxui-btn-font-size);
  font-weight: var(--aesirxui-btn-font-weight);
  line-height: var(--aesirxui-btn-line-height);
  color: var(--aesirxui-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--aesirxui-btn-border-width) solid var(--aesirxui-btn-border-color);
  border-radius: var(--aesirxui-btn-border-radius);
  background-color: var(--aesirxui-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .btn {
    transition: none;
  }
}
.aesirxui .btn:hover {
  color: var(--aesirxui-btn-hover-color);
  text-decoration: none;
  background-color: var(--aesirxui-btn-hover-bg);
  border-color: var(--aesirxui-btn-hover-border-color);
}
.btn-check + .aesirxui .btn:hover {
  color: var(--aesirxui-btn-color);
  background-color: var(--aesirxui-btn-bg);
  border-color: var(--aesirxui-btn-border-color);
}
.aesirxui .btn:focus-visible {
  color: var(--aesirxui-btn-hover-color);
  background-color: var(--aesirxui-btn-hover-bg);
  border-color: var(--aesirxui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--aesirxui-btn-focus-box-shadow);
}
.btn-check:focus-visible + .aesirxui .btn {
  border-color: var(--aesirxui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--aesirxui-btn-focus-box-shadow);
}
.btn-check:checked + .aesirxui .btn, :not(.btn-check) + .aesirxui .btn:active, .aesirxui .btn:first-child:active, .aesirxui .btn.active, .aesirxui .btn.show {
  color: var(--aesirxui-btn-active-color);
  background-color: var(--aesirxui-btn-active-bg);
  border-color: var(--aesirxui-btn-active-border-color);
}
.btn-check:checked + .aesirxui .btn:focus-visible, :not(.btn-check) + .aesirxui .btn:active:focus-visible, .aesirxui .btn:first-child:active:focus-visible, .aesirxui .btn.active:focus-visible, .aesirxui .btn.show:focus-visible {
  box-shadow: var(--aesirxui-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .aesirxui .btn {
  box-shadow: var(--aesirxui-btn-focus-box-shadow);
}
.aesirxui .btn:disabled, .aesirxui .btn.disabled, fieldset:disabled .aesirxui .btn {
  color: var(--aesirxui-btn-disabled-color);
  pointer-events: none;
  background-color: var(--aesirxui-btn-disabled-bg);
  border-color: var(--aesirxui-btn-disabled-border-color);
  opacity: var(--aesirxui-btn-disabled-opacity);
}
.aesirxui .btn-primary {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #0a083b;
  --aesirxui-btn-border-color: #0a083b;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(8.5, 6.8, 50.15);
  --aesirxui-btn-hover-border-color: rgb(8, 6.4, 47.2);
  --aesirxui-btn-focus-shadow-rgb: 47, 45, 88;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(8, 6.4, 47.2);
  --aesirxui-btn-active-border-color: rgb(7.5, 6, 44.25);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #0a083b;
  --aesirxui-btn-disabled-border-color: #0a083b;
}
.aesirxui .btn-secondary {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #004d6c;
  --aesirxui-btn-border-color: #004d6c;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(0, 65.45, 91.8);
  --aesirxui-btn-hover-border-color: rgb(0, 61.6, 86.4);
  --aesirxui-btn-focus-shadow-rgb: 38, 104, 130;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(0, 61.6, 86.4);
  --aesirxui-btn-active-border-color: rgb(0, 57.75, 81);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #004d6c;
  --aesirxui-btn-disabled-border-color: #004d6c;
}
.aesirxui .btn-success {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #1ab394;
  --aesirxui-btn-border-color: #1ab394;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(60.35, 190.4, 164.05);
  --aesirxui-btn-hover-border-color: rgb(48.9, 186.6, 158.7);
  --aesirxui-btn-focus-shadow-rgb: 22, 152, 126;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(71.8, 194.2, 169.4);
  --aesirxui-btn-active-border-color: rgb(48.9, 186.6, 158.7);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #1ab394;
  --aesirxui-btn-disabled-border-color: #1ab394;
}
.aesirxui .btn-info {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #3b7ab5;
  --aesirxui-btn-border-color: #3b7ab5;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(50.15, 103.7, 153.85);
  --aesirxui-btn-hover-border-color: rgb(47.2, 97.6, 144.8);
  --aesirxui-btn-focus-shadow-rgb: 88, 142, 192;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(47.2, 97.6, 144.8);
  --aesirxui-btn-active-border-color: rgb(44.25, 91.5, 135.75);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #3b7ab5;
  --aesirxui-btn-disabled-border-color: #3b7ab5;
}
.aesirxui .btn-warning {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #f07e25;
  --aesirxui-btn-border-color: #f07e25;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(242.25, 145.35, 69.7);
  --aesirxui-btn-hover-border-color: rgb(241.5, 138.9, 58.8);
  --aesirxui-btn-focus-shadow-rgb: 204, 107, 31;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(243, 151.8, 80.6);
  --aesirxui-btn-active-border-color: rgb(241.5, 138.9, 58.8);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #f07e25;
  --aesirxui-btn-disabled-border-color: #f07e25;
}
.aesirxui .btn-danger {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #c8192e;
  --aesirxui-btn-border-color: #c8192e;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(170, 21.25, 39.1);
  --aesirxui-btn-hover-border-color: rgb(160, 20, 36.8);
  --aesirxui-btn-focus-shadow-rgb: 208, 60, 77;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(160, 20, 36.8);
  --aesirxui-btn-active-border-color: rgb(150, 18.75, 34.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #c8192e;
  --aesirxui-btn-disabled-border-color: #c8192e;
}
.aesirxui .btn-light {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #f6f8fa;
  --aesirxui-btn-border-color: #f6f8fa;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(209.1, 210.8, 212.5);
  --aesirxui-btn-hover-border-color: rgb(196.8, 198.4, 200);
  --aesirxui-btn-focus-shadow-rgb: 209, 211, 213;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(196.8, 198.4, 200);
  --aesirxui-btn-active-border-color: rgb(184.5, 186, 187.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #f6f8fa;
  --aesirxui-btn-disabled-border-color: #f6f8fa;
}
.aesirxui .btn-dark {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #222328;
  --aesirxui-btn-border-color: #222328;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(67.15, 68, 72.25);
  --aesirxui-btn-hover-border-color: rgb(56.1, 57, 61.5);
  --aesirxui-btn-focus-shadow-rgb: 67, 68, 72;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(78.2, 79, 83);
  --aesirxui-btn-active-border-color: rgb(56.1, 57, 61.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #222328;
  --aesirxui-btn-disabled-border-color: #222328;
}
.aesirxui .btn-noti-error {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #c8192e;
  --aesirxui-btn-border-color: #c8192e;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(170, 21.25, 39.1);
  --aesirxui-btn-hover-border-color: rgb(160, 20, 36.8);
  --aesirxui-btn-focus-shadow-rgb: 208, 60, 77;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(160, 20, 36.8);
  --aesirxui-btn-active-border-color: rgb(150, 18.75, 34.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #c8192e;
  --aesirxui-btn-disabled-border-color: #c8192e;
}
.aesirxui .btn-noti-warn {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #946300;
  --aesirxui-btn-border-color: #946300;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(125.8, 84.15, 0);
  --aesirxui-btn-hover-border-color: rgb(118.4, 79.2, 0);
  --aesirxui-btn-focus-shadow-rgb: 164, 122, 38;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(118.4, 79.2, 0);
  --aesirxui-btn-active-border-color: rgb(111, 74.25, 0);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #946300;
  --aesirxui-btn-disabled-border-color: #946300;
}
.aesirxui .btn-noti-bg-error {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #fee2e2;
  --aesirxui-btn-border-color: #fee2e2;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(254.15, 230.35, 230.35);
  --aesirxui-btn-hover-border-color: rgb(254.1, 228.9, 228.9);
  --aesirxui-btn-focus-shadow-rgb: 216, 192, 192;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(254.2, 231.8, 231.8);
  --aesirxui-btn-active-border-color: rgb(254.1, 228.9, 228.9);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #fee2e2;
  --aesirxui-btn-disabled-border-color: #fee2e2;
}
.aesirxui .btn-noti-bg-warn {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #fff8e9;
  --aesirxui-btn-border-color: #fff8e9;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(255, 249.05, 236.3);
  --aesirxui-btn-hover-border-color: rgb(255, 248.7, 235.2);
  --aesirxui-btn-focus-shadow-rgb: 217, 211, 198;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(255, 249.4, 237.4);
  --aesirxui-btn-active-border-color: rgb(255, 248.7, 235.2);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #fff8e9;
  --aesirxui-btn-disabled-border-color: #fff8e9;
}
.aesirxui .btn-noti-bg-success {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #d1fae5;
  --aesirxui-btn-border-color: #d1fae5;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(215.9, 250.75, 232.9);
  --aesirxui-btn-hover-border-color: rgb(213.6, 250.5, 231.6);
  --aesirxui-btn-focus-shadow-rgb: 178, 213, 195;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(218.2, 251, 234.2);
  --aesirxui-btn-active-border-color: rgb(213.6, 250.5, 231.6);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #d1fae5;
  --aesirxui-btn-disabled-border-color: #d1fae5;
}
.aesirxui .btn-custom-color {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #712cf9;
  --aesirxui-btn-border-color: #712cf9;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(96.05, 37.4, 211.65);
  --aesirxui-btn-hover-border-color: rgb(90.4, 35.2, 199.2);
  --aesirxui-btn-focus-shadow-rgb: 134, 76, 250;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(90.4, 35.2, 199.2);
  --aesirxui-btn-active-border-color: rgb(84.75, 33, 186.75);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #712cf9;
  --aesirxui-btn-disabled-border-color: #712cf9;
}
.aesirxui .btn-purple {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #6a3e73;
  --aesirxui-btn-border-color: #6a3e73;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(90.1, 52.7, 97.75);
  --aesirxui-btn-hover-border-color: rgb(84.8, 49.6, 92);
  --aesirxui-btn-focus-shadow-rgb: 128, 91, 136;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(84.8, 49.6, 92);
  --aesirxui-btn-active-border-color: rgb(79.5, 46.5, 86.25);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #6a3e73;
  --aesirxui-btn-disabled-border-color: #6a3e73;
}
.aesirxui .btn-secondary-25 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #f0f3fb;
  --aesirxui-btn-border-color: #f0f3fb;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(242.25, 244.8, 251.6);
  --aesirxui-btn-hover-border-color: rgb(241.5, 244.2, 251.4);
  --aesirxui-btn-focus-shadow-rgb: 204, 207, 213;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(243, 245.4, 251.8);
  --aesirxui-btn-active-border-color: rgb(241.5, 244.2, 251.4);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #f0f3fb;
  --aesirxui-btn-disabled-border-color: #f0f3fb;
}
.aesirxui .btn-secondary-50 {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #1d55a9;
  --aesirxui-btn-border-color: #1d55a9;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(24.65, 72.25, 143.65);
  --aesirxui-btn-hover-border-color: rgb(23.2, 68, 135.2);
  --aesirxui-btn-focus-shadow-rgb: 63, 111, 182;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(23.2, 68, 135.2);
  --aesirxui-btn-active-border-color: rgb(21.75, 63.75, 126.75);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #1d55a9;
  --aesirxui-btn-disabled-border-color: #1d55a9;
}
.aesirxui .btn-secondary-100 {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #0d588a;
  --aesirxui-btn-border-color: #0d588a;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(11.05, 74.8, 117.3);
  --aesirxui-btn-hover-border-color: rgb(10.4, 70.4, 110.4);
  --aesirxui-btn-focus-shadow-rgb: 49, 113, 156;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(10.4, 70.4, 110.4);
  --aesirxui-btn-active-border-color: rgb(9.75, 66, 103.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #0d588a;
  --aesirxui-btn-disabled-border-color: #0d588a;
}
.aesirxui .btn-success-dark {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #1c9678;
  --aesirxui-btn-border-color: #1c9678;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(62.05, 165.75, 140.25);
  --aesirxui-btn-hover-border-color: rgb(50.7, 160.5, 133.5);
  --aesirxui-btn-focus-shadow-rgb: 24, 128, 102;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(73.4, 171, 147);
  --aesirxui-btn-active-border-color: rgb(50.7, 160.5, 133.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #1c9678;
  --aesirxui-btn-disabled-border-color: #1c9678;
}
.aesirxui .btn-success-darken {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #0f674c;
  --aesirxui-btn-border-color: #0f674c;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(12.75, 87.55, 64.6);
  --aesirxui-btn-hover-border-color: rgb(12, 82.4, 60.8);
  --aesirxui-btn-focus-shadow-rgb: 51, 126, 103;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(12, 82.4, 60.8);
  --aesirxui-btn-active-border-color: rgb(11.25, 77.25, 57);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #0f674c;
  --aesirxui-btn-disabled-border-color: #0f674c;
}
.aesirxui .btn-warning-50 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #fff8e9;
  --aesirxui-btn-border-color: #fff8e9;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(255, 249.05, 236.3);
  --aesirxui-btn-hover-border-color: rgb(255, 248.7, 235.2);
  --aesirxui-btn-focus-shadow-rgb: 217, 211, 198;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(255, 249.4, 237.4);
  --aesirxui-btn-active-border-color: rgb(255, 248.7, 235.2);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #fff8e9;
  --aesirxui-btn-disabled-border-color: #fff8e9;
}
.aesirxui .btn-warning-100 {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #946300;
  --aesirxui-btn-border-color: #946300;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(125.8, 84.15, 0);
  --aesirxui-btn-hover-border-color: rgb(118.4, 79.2, 0);
  --aesirxui-btn-focus-shadow-rgb: 164, 122, 38;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(118.4, 79.2, 0);
  --aesirxui-btn-active-border-color: rgb(111, 74.25, 0);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #946300;
  --aesirxui-btn-disabled-border-color: #946300;
}
.aesirxui .btn-warning-200 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #ffe6b2;
  --aesirxui-btn-border-color: #ffe6b2;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(255, 233.75, 189.55);
  --aesirxui-btn-hover-border-color: rgb(255, 232.5, 185.7);
  --aesirxui-btn-focus-shadow-rgb: 217, 196, 151;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(255, 235, 193.4);
  --aesirxui-btn-active-border-color: rgb(255, 232.5, 185.7);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #ffe6b2;
  --aesirxui-btn-disabled-border-color: #ffe6b2;
}
.aesirxui .btn-gray-100 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #f6f8fa;
  --aesirxui-btn-border-color: #f6f8fa;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(247.35, 249.05, 250.75);
  --aesirxui-btn-hover-border-color: rgb(246.9, 248.7, 250.5);
  --aesirxui-btn-focus-shadow-rgb: 209, 211, 213;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(247.8, 249.4, 251);
  --aesirxui-btn-active-border-color: rgb(246.9, 248.7, 250.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #f6f8fa;
  --aesirxui-btn-disabled-border-color: #f6f8fa;
}
.aesirxui .btn-gray-400 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #e3e3e3;
  --aesirxui-btn-border-color: #e3e3e3;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(231.2, 231.2, 231.2);
  --aesirxui-btn-hover-border-color: rgb(229.8, 229.8, 229.8);
  --aesirxui-btn-focus-shadow-rgb: 193, 193, 193;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(232.6, 232.6, 232.6);
  --aesirxui-btn-active-border-color: rgb(229.8, 229.8, 229.8);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #e3e3e3;
  --aesirxui-btn-disabled-border-color: #e3e3e3;
}
.aesirxui .btn-gray-500 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #d2d2d2;
  --aesirxui-btn-border-color: #d2d2d2;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(216.75, 216.75, 216.75);
  --aesirxui-btn-hover-border-color: rgb(214.5, 214.5, 214.5);
  --aesirxui-btn-focus-shadow-rgb: 179, 179, 179;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #dbdbdb;
  --aesirxui-btn-active-border-color: rgb(214.5, 214.5, 214.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #d2d2d2;
  --aesirxui-btn-disabled-border-color: #d2d2d2;
}
.aesirxui .btn-gray-600 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #8e8e8e;
  --aesirxui-btn-border-color: #8e8e8e;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(158.95, 158.95, 158.95);
  --aesirxui-btn-hover-border-color: rgb(153.3, 153.3, 153.3);
  --aesirxui-btn-focus-shadow-rgb: 121, 121, 121;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(164.6, 164.6, 164.6);
  --aesirxui-btn-active-border-color: rgb(153.3, 153.3, 153.3);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #8e8e8e;
  --aesirxui-btn-disabled-border-color: #8e8e8e;
}
.aesirxui .btn-gray-700 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #c4c4c4;
  --aesirxui-btn-border-color: #c4c4c4;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(204.85, 204.85, 204.85);
  --aesirxui-btn-hover-border-color: rgb(201.9, 201.9, 201.9);
  --aesirxui-btn-focus-shadow-rgb: 167, 167, 167;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(207.8, 207.8, 207.8);
  --aesirxui-btn-active-border-color: rgb(201.9, 201.9, 201.9);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #c4c4c4;
  --aesirxui-btn-disabled-border-color: #c4c4c4;
}
.aesirxui .btn-gray-800 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #e9e9e9;
  --aesirxui-btn-border-color: #e9e9e9;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(236.3, 236.3, 236.3);
  --aesirxui-btn-hover-border-color: rgb(235.2, 235.2, 235.2);
  --aesirxui-btn-focus-shadow-rgb: 198, 198, 198;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(237.4, 237.4, 237.4);
  --aesirxui-btn-active-border-color: rgb(235.2, 235.2, 235.2);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #e9e9e9;
  --aesirxui-btn-disabled-border-color: #e9e9e9;
}
.aesirxui .btn-gray-900 {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #222328;
  --aesirxui-btn-border-color: #222328;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(28.9, 29.75, 34);
  --aesirxui-btn-hover-border-color: rgb(27.2, 28, 32);
  --aesirxui-btn-focus-shadow-rgb: 67, 68, 72;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(27.2, 28, 32);
  --aesirxui-btn-active-border-color: rgb(25.5, 26.25, 30);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #222328;
  --aesirxui-btn-disabled-border-color: #222328;
}
.aesirxui .btn-gray-stroke-1 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #f3f3f3;
  --aesirxui-btn-border-color: #f3f3f3;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(244.8, 244.8, 244.8);
  --aesirxui-btn-hover-border-color: rgb(244.2, 244.2, 244.2);
  --aesirxui-btn-focus-shadow-rgb: 207, 207, 207;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(245.4, 245.4, 245.4);
  --aesirxui-btn-active-border-color: rgb(244.2, 244.2, 244.2);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #f3f3f3;
  --aesirxui-btn-disabled-border-color: #f3f3f3;
}
.aesirxui .btn-gray-stroke-2 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #dedede;
  --aesirxui-btn-border-color: #dedede;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(226.95, 226.95, 226.95);
  --aesirxui-btn-hover-border-color: rgb(225.3, 225.3, 225.3);
  --aesirxui-btn-focus-shadow-rgb: 189, 189, 189;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(228.6, 228.6, 228.6);
  --aesirxui-btn-active-border-color: rgb(225.3, 225.3, 225.3);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #dedede;
  --aesirxui-btn-disabled-border-color: #dedede;
}
.aesirxui .btn-gray-light {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #97979e;
  --aesirxui-btn-border-color: #97979e;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(166.6, 166.6, 172.55);
  --aesirxui-btn-hover-border-color: rgb(161.4, 161.4, 167.7);
  --aesirxui-btn-focus-shadow-rgb: 128, 128, 134;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(171.8, 171.8, 177.4);
  --aesirxui-btn-active-border-color: rgb(161.4, 161.4, 167.7);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #97979e;
  --aesirxui-btn-disabled-border-color: #97979e;
}
.aesirxui .btn-gray-heading {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #5f5e70;
  --aesirxui-btn-border-color: #5f5e70;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(80.75, 79.9, 95.2);
  --aesirxui-btn-hover-border-color: rgb(76, 75.2, 89.6);
  --aesirxui-btn-focus-shadow-rgb: 119, 118, 133;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(76, 75.2, 89.6);
  --aesirxui-btn-active-border-color: rgb(71.25, 70.5, 84);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #5f5e70;
  --aesirxui-btn-disabled-border-color: #5f5e70;
}
.aesirxui .btn-blue {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #0a5aff;
  --aesirxui-btn-border-color: #0a5aff;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(8.5, 76.5, 216.75);
  --aesirxui-btn-hover-border-color: #0848cc;
  --aesirxui-btn-focus-shadow-rgb: 47, 115, 255;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #0848cc;
  --aesirxui-btn-active-border-color: rgb(7.5, 67.5, 191.25);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #0a5aff;
  --aesirxui-btn-disabled-border-color: #0a5aff;
}
.aesirxui .btn-blue-light {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #edf8fd;
  --aesirxui-btn-border-color: #edf8fd;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(239.7, 249.05, 253.3);
  --aesirxui-btn-hover-border-color: rgb(238.8, 248.7, 253.2);
  --aesirxui-btn-focus-shadow-rgb: 201, 211, 215;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(240.6, 249.4, 253.4);
  --aesirxui-btn-active-border-color: rgb(238.8, 248.7, 253.2);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #edf8fd;
  --aesirxui-btn-disabled-border-color: #edf8fd;
}
.aesirxui .btn-color-blue-6 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #dce6eb;
  --aesirxui-btn-border-color: #dce6eb;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(225.25, 233.75, 238);
  --aesirxui-btn-hover-border-color: rgb(223.5, 232.5, 237);
  --aesirxui-btn-focus-shadow-rgb: 187, 196, 200;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #e3ebef;
  --aesirxui-btn-active-border-color: rgb(223.5, 232.5, 237);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #dce6eb;
  --aesirxui-btn-disabled-border-color: #dce6eb;
}
.aesirxui .btn-color-blue-9 {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #f0f3fb;
  --aesirxui-btn-border-color: #f0f3fb;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(242.25, 244.8, 251.6);
  --aesirxui-btn-hover-border-color: rgb(241.5, 244.2, 251.4);
  --aesirxui-btn-focus-shadow-rgb: 204, 207, 213;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(243, 245.4, 251.8);
  --aesirxui-btn-active-border-color: rgb(241.5, 244.2, 251.4);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #f0f3fb;
  --aesirxui-btn-disabled-border-color: #f0f3fb;
}
.aesirxui .btn-green-light {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #d1fae5;
  --aesirxui-btn-border-color: #d1fae5;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(215.9, 250.75, 232.9);
  --aesirxui-btn-hover-border-color: rgb(213.6, 250.5, 231.6);
  --aesirxui-btn-focus-shadow-rgb: 178, 213, 195;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(218.2, 251, 234.2);
  --aesirxui-btn-active-border-color: rgb(213.6, 250.5, 231.6);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #d1fae5;
  --aesirxui-btn-disabled-border-color: #d1fae5;
}
.aesirxui .btn-telegram {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #039be5;
  --aesirxui-btn-border-color: #039be5;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(40.8, 170, 232.9);
  --aesirxui-btn-hover-border-color: rgb(28.2, 165, 231.6);
  --aesirxui-btn-focus-shadow-rgb: 3, 132, 195;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(53.4, 175, 234.2);
  --aesirxui-btn-active-border-color: rgb(28.2, 165, 231.6);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #039be5;
  --aesirxui-btn-disabled-border-color: #039be5;
}
.aesirxui .btn-facebook {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #3a559f;
  --aesirxui-btn-border-color: #3a559f;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(49.3, 72.25, 135.15);
  --aesirxui-btn-hover-border-color: rgb(46.4, 68, 127.2);
  --aesirxui-btn-focus-shadow-rgb: 88, 111, 173;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(46.4, 68, 127.2);
  --aesirxui-btn-active-border-color: rgb(43.5, 63.75, 119.25);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #3a559f;
  --aesirxui-btn-disabled-border-color: #3a559f;
}
.aesirxui .btn-twitter {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #26a6d1;
  --aesirxui-btn-border-color: #26a6d1;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(70.55, 179.35, 215.9);
  --aesirxui-btn-hover-border-color: rgb(59.7, 174.9, 213.6);
  --aesirxui-btn-focus-shadow-rgb: 32, 141, 178;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(81.4, 183.8, 218.2);
  --aesirxui-btn-active-border-color: rgb(59.7, 174.9, 213.6);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #26a6d1;
  --aesirxui-btn-disabled-border-color: #26a6d1;
}
.aesirxui .btn-linkedin {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #007ab9;
  --aesirxui-btn-border-color: #007ab9;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(0, 103.7, 157.25);
  --aesirxui-btn-hover-border-color: rgb(0, 97.6, 148);
  --aesirxui-btn-focus-shadow-rgb: 38, 142, 196;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(0, 97.6, 148);
  --aesirxui-btn-active-border-color: rgb(0, 91.5, 138.75);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #007ab9;
  --aesirxui-btn-disabled-border-color: #007ab9;
}
.aesirxui .btn-instagram {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #b334af;
  --aesirxui-btn-border-color: #b334af;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(152.15, 44.2, 148.75);
  --aesirxui-btn-hover-border-color: rgb(143.2, 41.6, 140);
  --aesirxui-btn-focus-shadow-rgb: 190, 82, 187;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(143.2, 41.6, 140);
  --aesirxui-btn-active-border-color: rgb(134.25, 39, 131.25);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #b334af;
  --aesirxui-btn-disabled-border-color: #b334af;
}
.aesirxui .btn-chatgpt {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: #00a481;
  --aesirxui-btn-border-color: #00a481;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: rgb(38.25, 177.65, 147.9);
  --aesirxui-btn-hover-border-color: rgb(25.5, 173.1, 141.6);
  --aesirxui-btn-focus-shadow-rgb: 0, 139, 110;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: rgb(51, 182.2, 154.2);
  --aesirxui-btn-active-border-color: rgb(25.5, 173.1, 141.6);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #00a481;
  --aesirxui-btn-disabled-border-color: #00a481;
}
.aesirxui .btn-dark-blue {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #3e545e;
  --aesirxui-btn-border-color: #3e545e;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(52.7, 71.4, 79.9);
  --aesirxui-btn-hover-border-color: rgb(49.6, 67.2, 75.2);
  --aesirxui-btn-focus-shadow-rgb: 91, 110, 118;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(49.6, 67.2, 75.2);
  --aesirxui-btn-active-border-color: rgb(46.5, 63, 70.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #3e545e;
  --aesirxui-btn-disabled-border-color: #3e545e;
}
.aesirxui .btn-button-color {
  --aesirxui-btn-color: #000;
  --aesirxui-btn-bg: white;
  --aesirxui-btn-border-color: white;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: white;
  --aesirxui-btn-hover-border-color: white;
  --aesirxui-btn-focus-shadow-rgb: 217, 217, 217;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: white;
  --aesirxui-btn-active-border-color: white;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: white;
  --aesirxui-btn-disabled-border-color: white;
}
.aesirxui .btn-body-color {
  --aesirxui-btn-color: #fff;
  --aesirxui-btn-bg: #0a083b;
  --aesirxui-btn-border-color: #0a083b;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: rgb(8.5, 6.8, 50.15);
  --aesirxui-btn-hover-border-color: rgb(8, 6.4, 47.2);
  --aesirxui-btn-focus-shadow-rgb: 47, 45, 88;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: rgb(8, 6.4, 47.2);
  --aesirxui-btn-active-border-color: rgb(7.5, 6, 44.25);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff;
  --aesirxui-btn-disabled-bg: #0a083b;
  --aesirxui-btn-disabled-border-color: #0a083b;
}
.aesirxui .btn-outline-primary {
  --aesirxui-btn-color: #0a083b;
  --aesirxui-btn-border-color: #0a083b;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #0a083b;
  --aesirxui-btn-hover-border-color: #0a083b;
  --aesirxui-btn-focus-shadow-rgb: 10, 8, 59;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #0a083b;
  --aesirxui-btn-active-border-color: #0a083b;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #0a083b;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #0a083b;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-secondary {
  --aesirxui-btn-color: #004d6c;
  --aesirxui-btn-border-color: #004d6c;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #004d6c;
  --aesirxui-btn-hover-border-color: #004d6c;
  --aesirxui-btn-focus-shadow-rgb: 0, 77, 108;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #004d6c;
  --aesirxui-btn-active-border-color: #004d6c;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #004d6c;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #004d6c;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-success {
  --aesirxui-btn-color: #1ab394;
  --aesirxui-btn-border-color: #1ab394;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #1ab394;
  --aesirxui-btn-hover-border-color: #1ab394;
  --aesirxui-btn-focus-shadow-rgb: 26, 179, 148;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #1ab394;
  --aesirxui-btn-active-border-color: #1ab394;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #1ab394;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #1ab394;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-info {
  --aesirxui-btn-color: #3b7ab5;
  --aesirxui-btn-border-color: #3b7ab5;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #3b7ab5;
  --aesirxui-btn-hover-border-color: #3b7ab5;
  --aesirxui-btn-focus-shadow-rgb: 59, 122, 181;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #3b7ab5;
  --aesirxui-btn-active-border-color: #3b7ab5;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #3b7ab5;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #3b7ab5;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-warning {
  --aesirxui-btn-color: #f07e25;
  --aesirxui-btn-border-color: #f07e25;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #f07e25;
  --aesirxui-btn-hover-border-color: #f07e25;
  --aesirxui-btn-focus-shadow-rgb: 240, 126, 37;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #f07e25;
  --aesirxui-btn-active-border-color: #f07e25;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #f07e25;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #f07e25;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-danger {
  --aesirxui-btn-color: #c8192e;
  --aesirxui-btn-border-color: #c8192e;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #c8192e;
  --aesirxui-btn-hover-border-color: #c8192e;
  --aesirxui-btn-focus-shadow-rgb: 200, 25, 46;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #c8192e;
  --aesirxui-btn-active-border-color: #c8192e;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #c8192e;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #c8192e;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-light {
  --aesirxui-btn-color: #f6f8fa;
  --aesirxui-btn-border-color: #f6f8fa;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #f6f8fa;
  --aesirxui-btn-hover-border-color: #f6f8fa;
  --aesirxui-btn-focus-shadow-rgb: 246, 248, 250;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #f6f8fa;
  --aesirxui-btn-active-border-color: #f6f8fa;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #f6f8fa;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #f6f8fa;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-dark {
  --aesirxui-btn-color: #222328;
  --aesirxui-btn-border-color: #222328;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #222328;
  --aesirxui-btn-hover-border-color: #222328;
  --aesirxui-btn-focus-shadow-rgb: 34, 35, 40;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #222328;
  --aesirxui-btn-active-border-color: #222328;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #222328;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #222328;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-noti-error {
  --aesirxui-btn-color: #c8192e;
  --aesirxui-btn-border-color: #c8192e;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #c8192e;
  --aesirxui-btn-hover-border-color: #c8192e;
  --aesirxui-btn-focus-shadow-rgb: 200, 25, 46;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #c8192e;
  --aesirxui-btn-active-border-color: #c8192e;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #c8192e;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #c8192e;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-noti-warn {
  --aesirxui-btn-color: #946300;
  --aesirxui-btn-border-color: #946300;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #946300;
  --aesirxui-btn-hover-border-color: #946300;
  --aesirxui-btn-focus-shadow-rgb: 148, 99, 0;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #946300;
  --aesirxui-btn-active-border-color: #946300;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #946300;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #946300;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-noti-bg-error {
  --aesirxui-btn-color: #fee2e2;
  --aesirxui-btn-border-color: #fee2e2;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #fee2e2;
  --aesirxui-btn-hover-border-color: #fee2e2;
  --aesirxui-btn-focus-shadow-rgb: 254, 226, 226;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #fee2e2;
  --aesirxui-btn-active-border-color: #fee2e2;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fee2e2;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #fee2e2;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-noti-bg-warn {
  --aesirxui-btn-color: #fff8e9;
  --aesirxui-btn-border-color: #fff8e9;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #fff8e9;
  --aesirxui-btn-hover-border-color: #fff8e9;
  --aesirxui-btn-focus-shadow-rgb: 255, 248, 233;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #fff8e9;
  --aesirxui-btn-active-border-color: #fff8e9;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff8e9;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #fff8e9;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-noti-bg-success {
  --aesirxui-btn-color: #d1fae5;
  --aesirxui-btn-border-color: #d1fae5;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #d1fae5;
  --aesirxui-btn-hover-border-color: #d1fae5;
  --aesirxui-btn-focus-shadow-rgb: 209, 250, 229;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #d1fae5;
  --aesirxui-btn-active-border-color: #d1fae5;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #d1fae5;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #d1fae5;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-custom-color {
  --aesirxui-btn-color: #712cf9;
  --aesirxui-btn-border-color: #712cf9;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #712cf9;
  --aesirxui-btn-hover-border-color: #712cf9;
  --aesirxui-btn-focus-shadow-rgb: 113, 44, 249;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #712cf9;
  --aesirxui-btn-active-border-color: #712cf9;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #712cf9;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #712cf9;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-purple {
  --aesirxui-btn-color: #6a3e73;
  --aesirxui-btn-border-color: #6a3e73;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #6a3e73;
  --aesirxui-btn-hover-border-color: #6a3e73;
  --aesirxui-btn-focus-shadow-rgb: 106, 62, 115;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #6a3e73;
  --aesirxui-btn-active-border-color: #6a3e73;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #6a3e73;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #6a3e73;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-secondary-25 {
  --aesirxui-btn-color: #f0f3fb;
  --aesirxui-btn-border-color: #f0f3fb;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #f0f3fb;
  --aesirxui-btn-hover-border-color: #f0f3fb;
  --aesirxui-btn-focus-shadow-rgb: 240, 243, 251;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #f0f3fb;
  --aesirxui-btn-active-border-color: #f0f3fb;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #f0f3fb;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #f0f3fb;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-secondary-50 {
  --aesirxui-btn-color: #1d55a9;
  --aesirxui-btn-border-color: #1d55a9;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #1d55a9;
  --aesirxui-btn-hover-border-color: #1d55a9;
  --aesirxui-btn-focus-shadow-rgb: 29, 85, 169;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #1d55a9;
  --aesirxui-btn-active-border-color: #1d55a9;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #1d55a9;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #1d55a9;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-secondary-100 {
  --aesirxui-btn-color: #0d588a;
  --aesirxui-btn-border-color: #0d588a;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #0d588a;
  --aesirxui-btn-hover-border-color: #0d588a;
  --aesirxui-btn-focus-shadow-rgb: 13, 88, 138;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #0d588a;
  --aesirxui-btn-active-border-color: #0d588a;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #0d588a;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #0d588a;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-success-dark {
  --aesirxui-btn-color: #1c9678;
  --aesirxui-btn-border-color: #1c9678;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #1c9678;
  --aesirxui-btn-hover-border-color: #1c9678;
  --aesirxui-btn-focus-shadow-rgb: 28, 150, 120;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #1c9678;
  --aesirxui-btn-active-border-color: #1c9678;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #1c9678;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #1c9678;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-success-darken {
  --aesirxui-btn-color: #0f674c;
  --aesirxui-btn-border-color: #0f674c;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #0f674c;
  --aesirxui-btn-hover-border-color: #0f674c;
  --aesirxui-btn-focus-shadow-rgb: 15, 103, 76;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #0f674c;
  --aesirxui-btn-active-border-color: #0f674c;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #0f674c;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #0f674c;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-warning-50 {
  --aesirxui-btn-color: #fff8e9;
  --aesirxui-btn-border-color: #fff8e9;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #fff8e9;
  --aesirxui-btn-hover-border-color: #fff8e9;
  --aesirxui-btn-focus-shadow-rgb: 255, 248, 233;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #fff8e9;
  --aesirxui-btn-active-border-color: #fff8e9;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #fff8e9;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #fff8e9;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-warning-100 {
  --aesirxui-btn-color: #946300;
  --aesirxui-btn-border-color: #946300;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #946300;
  --aesirxui-btn-hover-border-color: #946300;
  --aesirxui-btn-focus-shadow-rgb: 148, 99, 0;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #946300;
  --aesirxui-btn-active-border-color: #946300;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #946300;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #946300;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-warning-200 {
  --aesirxui-btn-color: #ffe6b2;
  --aesirxui-btn-border-color: #ffe6b2;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #ffe6b2;
  --aesirxui-btn-hover-border-color: #ffe6b2;
  --aesirxui-btn-focus-shadow-rgb: 255, 230, 178;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #ffe6b2;
  --aesirxui-btn-active-border-color: #ffe6b2;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #ffe6b2;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #ffe6b2;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-100 {
  --aesirxui-btn-color: #f6f8fa;
  --aesirxui-btn-border-color: #f6f8fa;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #f6f8fa;
  --aesirxui-btn-hover-border-color: #f6f8fa;
  --aesirxui-btn-focus-shadow-rgb: 246, 248, 250;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #f6f8fa;
  --aesirxui-btn-active-border-color: #f6f8fa;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #f6f8fa;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #f6f8fa;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-400 {
  --aesirxui-btn-color: #e3e3e3;
  --aesirxui-btn-border-color: #e3e3e3;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #e3e3e3;
  --aesirxui-btn-hover-border-color: #e3e3e3;
  --aesirxui-btn-focus-shadow-rgb: 227, 227, 227;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #e3e3e3;
  --aesirxui-btn-active-border-color: #e3e3e3;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #e3e3e3;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #e3e3e3;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-500 {
  --aesirxui-btn-color: #d2d2d2;
  --aesirxui-btn-border-color: #d2d2d2;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #d2d2d2;
  --aesirxui-btn-hover-border-color: #d2d2d2;
  --aesirxui-btn-focus-shadow-rgb: 210, 210, 210;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #d2d2d2;
  --aesirxui-btn-active-border-color: #d2d2d2;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #d2d2d2;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #d2d2d2;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-600 {
  --aesirxui-btn-color: #8e8e8e;
  --aesirxui-btn-border-color: #8e8e8e;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #8e8e8e;
  --aesirxui-btn-hover-border-color: #8e8e8e;
  --aesirxui-btn-focus-shadow-rgb: 142, 142, 142;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #8e8e8e;
  --aesirxui-btn-active-border-color: #8e8e8e;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #8e8e8e;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #8e8e8e;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-700 {
  --aesirxui-btn-color: #c4c4c4;
  --aesirxui-btn-border-color: #c4c4c4;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #c4c4c4;
  --aesirxui-btn-hover-border-color: #c4c4c4;
  --aesirxui-btn-focus-shadow-rgb: 196, 196, 196;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #c4c4c4;
  --aesirxui-btn-active-border-color: #c4c4c4;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #c4c4c4;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #c4c4c4;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-800 {
  --aesirxui-btn-color: #e9e9e9;
  --aesirxui-btn-border-color: #e9e9e9;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #e9e9e9;
  --aesirxui-btn-hover-border-color: #e9e9e9;
  --aesirxui-btn-focus-shadow-rgb: 233, 233, 233;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #e9e9e9;
  --aesirxui-btn-active-border-color: #e9e9e9;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #e9e9e9;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #e9e9e9;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-900 {
  --aesirxui-btn-color: #222328;
  --aesirxui-btn-border-color: #222328;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #222328;
  --aesirxui-btn-hover-border-color: #222328;
  --aesirxui-btn-focus-shadow-rgb: 34, 35, 40;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #222328;
  --aesirxui-btn-active-border-color: #222328;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #222328;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #222328;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-stroke-1 {
  --aesirxui-btn-color: #f3f3f3;
  --aesirxui-btn-border-color: #f3f3f3;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #f3f3f3;
  --aesirxui-btn-hover-border-color: #f3f3f3;
  --aesirxui-btn-focus-shadow-rgb: 243, 243, 243;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #f3f3f3;
  --aesirxui-btn-active-border-color: #f3f3f3;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #f3f3f3;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #f3f3f3;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-stroke-2 {
  --aesirxui-btn-color: #dedede;
  --aesirxui-btn-border-color: #dedede;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #dedede;
  --aesirxui-btn-hover-border-color: #dedede;
  --aesirxui-btn-focus-shadow-rgb: 222, 222, 222;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #dedede;
  --aesirxui-btn-active-border-color: #dedede;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #dedede;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #dedede;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-light {
  --aesirxui-btn-color: #97979e;
  --aesirxui-btn-border-color: #97979e;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #97979e;
  --aesirxui-btn-hover-border-color: #97979e;
  --aesirxui-btn-focus-shadow-rgb: 151, 151, 158;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #97979e;
  --aesirxui-btn-active-border-color: #97979e;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #97979e;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #97979e;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-gray-heading {
  --aesirxui-btn-color: #5f5e70;
  --aesirxui-btn-border-color: #5f5e70;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #5f5e70;
  --aesirxui-btn-hover-border-color: #5f5e70;
  --aesirxui-btn-focus-shadow-rgb: 95, 94, 112;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #5f5e70;
  --aesirxui-btn-active-border-color: #5f5e70;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #5f5e70;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #5f5e70;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-blue {
  --aesirxui-btn-color: #0a5aff;
  --aesirxui-btn-border-color: #0a5aff;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #0a5aff;
  --aesirxui-btn-hover-border-color: #0a5aff;
  --aesirxui-btn-focus-shadow-rgb: 10, 90, 255;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #0a5aff;
  --aesirxui-btn-active-border-color: #0a5aff;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #0a5aff;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #0a5aff;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-blue-light {
  --aesirxui-btn-color: #edf8fd;
  --aesirxui-btn-border-color: #edf8fd;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #edf8fd;
  --aesirxui-btn-hover-border-color: #edf8fd;
  --aesirxui-btn-focus-shadow-rgb: 237, 248, 253;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #edf8fd;
  --aesirxui-btn-active-border-color: #edf8fd;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #edf8fd;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #edf8fd;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-color-blue-6 {
  --aesirxui-btn-color: #dce6eb;
  --aesirxui-btn-border-color: #dce6eb;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #dce6eb;
  --aesirxui-btn-hover-border-color: #dce6eb;
  --aesirxui-btn-focus-shadow-rgb: 220, 230, 235;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #dce6eb;
  --aesirxui-btn-active-border-color: #dce6eb;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #dce6eb;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #dce6eb;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-color-blue-9 {
  --aesirxui-btn-color: #f0f3fb;
  --aesirxui-btn-border-color: #f0f3fb;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #f0f3fb;
  --aesirxui-btn-hover-border-color: #f0f3fb;
  --aesirxui-btn-focus-shadow-rgb: 240, 243, 251;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #f0f3fb;
  --aesirxui-btn-active-border-color: #f0f3fb;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #f0f3fb;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #f0f3fb;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-green-light {
  --aesirxui-btn-color: #d1fae5;
  --aesirxui-btn-border-color: #d1fae5;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #d1fae5;
  --aesirxui-btn-hover-border-color: #d1fae5;
  --aesirxui-btn-focus-shadow-rgb: 209, 250, 229;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #d1fae5;
  --aesirxui-btn-active-border-color: #d1fae5;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #d1fae5;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #d1fae5;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-telegram {
  --aesirxui-btn-color: #039be5;
  --aesirxui-btn-border-color: #039be5;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #039be5;
  --aesirxui-btn-hover-border-color: #039be5;
  --aesirxui-btn-focus-shadow-rgb: 3, 155, 229;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #039be5;
  --aesirxui-btn-active-border-color: #039be5;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #039be5;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #039be5;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-facebook {
  --aesirxui-btn-color: #3a559f;
  --aesirxui-btn-border-color: #3a559f;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #3a559f;
  --aesirxui-btn-hover-border-color: #3a559f;
  --aesirxui-btn-focus-shadow-rgb: 58, 85, 159;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #3a559f;
  --aesirxui-btn-active-border-color: #3a559f;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #3a559f;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #3a559f;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-twitter {
  --aesirxui-btn-color: #26a6d1;
  --aesirxui-btn-border-color: #26a6d1;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #26a6d1;
  --aesirxui-btn-hover-border-color: #26a6d1;
  --aesirxui-btn-focus-shadow-rgb: 38, 166, 209;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #26a6d1;
  --aesirxui-btn-active-border-color: #26a6d1;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #26a6d1;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #26a6d1;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-linkedin {
  --aesirxui-btn-color: #007ab9;
  --aesirxui-btn-border-color: #007ab9;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #007ab9;
  --aesirxui-btn-hover-border-color: #007ab9;
  --aesirxui-btn-focus-shadow-rgb: 0, 122, 185;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #007ab9;
  --aesirxui-btn-active-border-color: #007ab9;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #007ab9;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #007ab9;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-instagram {
  --aesirxui-btn-color: #b334af;
  --aesirxui-btn-border-color: #b334af;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #b334af;
  --aesirxui-btn-hover-border-color: #b334af;
  --aesirxui-btn-focus-shadow-rgb: 179, 52, 175;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #b334af;
  --aesirxui-btn-active-border-color: #b334af;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #b334af;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #b334af;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-chatgpt {
  --aesirxui-btn-color: #00a481;
  --aesirxui-btn-border-color: #00a481;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: #00a481;
  --aesirxui-btn-hover-border-color: #00a481;
  --aesirxui-btn-focus-shadow-rgb: 0, 164, 129;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: #00a481;
  --aesirxui-btn-active-border-color: #00a481;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #00a481;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #00a481;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-dark-blue {
  --aesirxui-btn-color: #3e545e;
  --aesirxui-btn-border-color: #3e545e;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #3e545e;
  --aesirxui-btn-hover-border-color: #3e545e;
  --aesirxui-btn-focus-shadow-rgb: 62, 84, 94;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #3e545e;
  --aesirxui-btn-active-border-color: #3e545e;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #3e545e;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #3e545e;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-button-color {
  --aesirxui-btn-color: white;
  --aesirxui-btn-border-color: white;
  --aesirxui-btn-hover-color: #000;
  --aesirxui-btn-hover-bg: white;
  --aesirxui-btn-hover-border-color: white;
  --aesirxui-btn-focus-shadow-rgb: 255, 255, 255;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: white;
  --aesirxui-btn-active-border-color: white;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: white;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: white;
  --aesirxui-gradient: none;
}
.aesirxui .btn-outline-body-color {
  --aesirxui-btn-color: #0a083b;
  --aesirxui-btn-border-color: #0a083b;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #0a083b;
  --aesirxui-btn-hover-border-color: #0a083b;
  --aesirxui-btn-focus-shadow-rgb: 10, 8, 59;
  --aesirxui-btn-active-color: #fff;
  --aesirxui-btn-active-bg: #0a083b;
  --aesirxui-btn-active-border-color: #0a083b;
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #0a083b;
  --aesirxui-btn-disabled-bg: transparent;
  --aesirxui-btn-disabled-border-color: #0a083b;
  --aesirxui-gradient: none;
}
.aesirxui .btn-link {
  --aesirxui-btn-font-weight: 400;
  --aesirxui-btn-color: var(--aesirxui-link-color);
  --aesirxui-btn-bg: transparent;
  --aesirxui-btn-border-color: transparent;
  --aesirxui-btn-hover-color: var(--aesirxui-link-hover-color);
  --aesirxui-btn-hover-border-color: transparent;
  --aesirxui-btn-active-color: var(--aesirxui-link-hover-color);
  --aesirxui-btn-active-border-color: transparent;
  --aesirxui-btn-disabled-color: #8e8e8e;
  --aesirxui-btn-disabled-border-color: transparent;
  --aesirxui-btn-box-shadow: 0 0 0 #000;
  --aesirxui-btn-focus-shadow-rgb: 47, 45, 88;
  text-decoration: none;
}
.aesirxui .btn-link:hover, .aesirxui .btn-link:focus-visible {
  text-decoration: underline;
}
.aesirxui .btn-link:focus-visible {
  color: var(--aesirxui-btn-color);
}
.aesirxui .btn-link:hover {
  color: var(--aesirxui-btn-hover-color);
}
.aesirxui .btn-lg, .aesirxui .btn-group-lg > .btn {
  --aesirxui-btn-padding-y: 0.5rem;
  --aesirxui-btn-padding-x: 1rem;
  --aesirxui-btn-font-size: 1.25rem;
  --aesirxui-btn-border-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .btn-sm, .aesirxui .btn-group-sm > .btn {
  --aesirxui-btn-padding-y: 0.25rem;
  --aesirxui-btn-padding-x: 0.5rem;
  --aesirxui-btn-font-size: 0.875rem;
  --aesirxui-btn-border-radius: var(--aesirxui-border-radius-sm);
}
@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.aesirxui .progress,
.aesirxui .progress-stacked {
  --aesirxui-progress-height: 1rem;
  --aesirxui-progress-font-size: 0.75rem;
  --aesirxui-progress-bg: var(--aesirxui-secondary-bg);
  --aesirxui-progress-border-radius: var(--aesirxui-border-radius);
  --aesirxui-progress-box-shadow: var(--aesirxui-box-shadow-inset);
  --aesirxui-progress-bar-color: #fff;
  --aesirxui-progress-bar-bg: #0a083b;
  --aesirxui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--aesirxui-progress-height);
  overflow: hidden;
  font-size: var(--aesirxui-progress-font-size);
  background-color: var(--aesirxui-progress-bg);
  border-radius: var(--aesirxui-progress-border-radius);
}
.aesirxui .progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--aesirxui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--aesirxui-progress-bar-bg);
  transition: var(--aesirxui-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .progress-bar {
    transition: none;
  }
}
.aesirxui .progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--aesirxui-progress-height) var(--aesirxui-progress-height);
}
.aesirxui .progress-stacked > .progress {
  overflow: visible;
}
.aesirxui .progress-stacked > .progress > .progress-bar {
  width: 100%;
}
.aesirxui .progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .progress-bar-animated {
    animation: none;
  }
}
.aesirxui .tooltip {
  --aesirxui-tooltip-zindex: 1080;
  --aesirxui-tooltip-max-width: 200px;
  --aesirxui-tooltip-padding-x: 0.5rem;
  --aesirxui-tooltip-padding-y: 0.25rem;
  --aesirxui-tooltip-margin: ;
  --aesirxui-tooltip-font-size: 0.875rem;
  --aesirxui-tooltip-color: var(--aesirxui-body-bg);
  --aesirxui-tooltip-bg: var(--aesirxui-emphasis-color);
  --aesirxui-tooltip-border-radius: var(--aesirxui-border-radius);
  --aesirxui-tooltip-opacity: 0.9;
  --aesirxui-tooltip-arrow-width: 0.8rem;
  --aesirxui-tooltip-arrow-height: 0.4rem;
  z-index: var(--aesirxui-tooltip-zindex);
  display: block;
  margin: var(--aesirxui-tooltip-margin);
  font-family: var(--aesirxui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--aesirxui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.aesirxui .tooltip.show {
  opacity: var(--aesirxui-tooltip-opacity);
}
.aesirxui .tooltip .tooltip-arrow {
  display: block;
  width: var(--aesirxui-tooltip-arrow-width);
  height: var(--aesirxui-tooltip-arrow-height);
}
.aesirxui .tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}
.aesirxui .bs-tooltip-top .tooltip-arrow, .aesirxui .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--aesirxui-tooltip-arrow-height));
}
.aesirxui .bs-tooltip-top .tooltip-arrow::before, .aesirxui .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--aesirxui-tooltip-arrow-height) calc(var(--aesirxui-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--aesirxui-tooltip-bg);
}
.aesirxui .bs-tooltip-end .tooltip-arrow, .aesirxui .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--aesirxui-tooltip-arrow-height));
  width: var(--aesirxui-tooltip-arrow-height);
  height: var(--aesirxui-tooltip-arrow-width);
}
.aesirxui .bs-tooltip-end .tooltip-arrow::before, .aesirxui .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--aesirxui-tooltip-arrow-width) * 0.5) var(--aesirxui-tooltip-arrow-height) calc(var(--aesirxui-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--aesirxui-tooltip-bg);
}
.aesirxui .bs-tooltip-bottom .tooltip-arrow, .aesirxui .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--aesirxui-tooltip-arrow-height));
}
.aesirxui .bs-tooltip-bottom .tooltip-arrow::before, .aesirxui .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--aesirxui-tooltip-arrow-width) * 0.5) var(--aesirxui-tooltip-arrow-height);
  border-bottom-color: var(--aesirxui-tooltip-bg);
}
.aesirxui .bs-tooltip-start .tooltip-arrow, .aesirxui .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--aesirxui-tooltip-arrow-height));
  width: var(--aesirxui-tooltip-arrow-height);
  height: var(--aesirxui-tooltip-arrow-width);
}
.aesirxui .bs-tooltip-start .tooltip-arrow::before, .aesirxui .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--aesirxui-tooltip-arrow-width) * 0.5) 0 calc(var(--aesirxui-tooltip-arrow-width) * 0.5) var(--aesirxui-tooltip-arrow-height);
  border-left-color: var(--aesirxui-tooltip-bg);
}
.aesirxui .tooltip-inner {
  max-width: var(--aesirxui-tooltip-max-width);
  padding: var(--aesirxui-tooltip-padding-y) var(--aesirxui-tooltip-padding-x);
  color: var(--aesirxui-tooltip-color);
  text-align: center;
  background-color: var(--aesirxui-tooltip-bg);
  border-radius: var(--aesirxui-tooltip-border-radius);
}
.aesirxui .fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .fade {
    transition: none;
  }
}
.aesirxui .fade:not(.show) {
  opacity: 0;
}
.aesirxui .collapse:not(.show) {
  display: none;
}
.aesirxui .collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .collapsing {
    transition: none;
  }
}
.aesirxui .collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .collapsing.collapse-horizontal {
    transition: none;
  }
}
.aesirxui .nav {
  --aesirxui-nav-link-padding-x: 1rem;
  --aesirxui-nav-link-padding-y: 0.5rem;
  --aesirxui-nav-link-font-weight: ;
  --aesirxui-nav-link-color: #949494;
  --aesirxui-nav-link-hover-color: #949494;
  --aesirxui-nav-link-disabled-color: var(--aesirxui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.aesirxui .nav-link {
  display: block;
  padding: var(--aesirxui-nav-link-padding-y) var(--aesirxui-nav-link-padding-x);
  font-size: var(--aesirxui-nav-link-font-size);
  font-weight: var(--aesirxui-nav-link-font-weight);
  color: var(--aesirxui-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .nav-link {
    transition: none;
  }
}
.aesirxui .nav-link:hover, .aesirxui .nav-link:focus {
  color: var(--aesirxui-nav-link-hover-color);
  text-decoration: none;
}
.aesirxui .nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(10, 8, 59, 0.25);
}
.aesirxui .nav-link.disabled, .aesirxui .nav-link:disabled {
  color: var(--aesirxui-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}
.aesirxui .nav-tabs {
  --aesirxui-nav-tabs-border-width: 1px;
  --aesirxui-nav-tabs-border-color: #ebebeb;
  --aesirxui-nav-tabs-border-radius: 0;
  --aesirxui-nav-tabs-link-hover-border-color: var(--aesirxui-secondary-bg) var(--aesirxui-secondary-bg) #ebebeb;
  --aesirxui-nav-tabs-link-active-color: #222328;
  --aesirxui-nav-tabs-link-active-bg: transparent;
  --aesirxui-nav-tabs-link-active-border-color: transparent transparent #1ab394;
  border-bottom: var(--aesirxui-nav-tabs-border-width) solid var(--aesirxui-nav-tabs-border-color);
}
.aesirxui .nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--aesirxui-nav-tabs-border-width));
  border: var(--aesirxui-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--aesirxui-nav-tabs-border-radius);
  border-top-right-radius: var(--aesirxui-nav-tabs-border-radius);
}
.aesirxui .nav-tabs .nav-link:hover, .aesirxui .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--aesirxui-nav-tabs-link-hover-border-color);
}
.aesirxui .nav-tabs .nav-link.active,
.aesirxui .nav-tabs .nav-item.show .nav-link {
  color: var(--aesirxui-nav-tabs-link-active-color);
  background-color: var(--aesirxui-nav-tabs-link-active-bg);
  border-color: var(--aesirxui-nav-tabs-link-active-border-color);
}
.aesirxui .nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--aesirxui-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.aesirxui .nav-pills {
  --aesirxui-nav-pills-border-radius: var(--aesirxui-border-radius);
  --aesirxui-nav-pills-link-active-color: #fff;
  --aesirxui-nav-pills-link-active-bg: #1ab394;
}
.aesirxui .nav-pills .nav-link {
  border-radius: var(--aesirxui-nav-pills-border-radius);
}
.aesirxui .nav-pills .nav-link.active,
.aesirxui .nav-pills .show > .nav-link {
  color: var(--aesirxui-nav-pills-link-active-color);
  background-color: var(--aesirxui-nav-pills-link-active-bg);
}
.aesirxui .nav-underline {
  --aesirxui-nav-underline-gap: 1rem;
  --aesirxui-nav-underline-border-width: 0.125rem;
  --aesirxui-nav-underline-link-active-color: var(--aesirxui-emphasis-color);
  gap: var(--aesirxui-nav-underline-gap);
}
.aesirxui .nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--aesirxui-nav-underline-border-width) solid transparent;
}
.aesirxui .nav-underline .nav-link:hover, .aesirxui .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.aesirxui .nav-underline .nav-link.active,
.aesirxui .nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--aesirxui-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}
.aesirxui .nav-fill > .nav-link,
.aesirxui .nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
.aesirxui .nav-justified > .nav-link,
.aesirxui .nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
.aesirxui .nav-fill .nav-item .nav-link,
.aesirxui .nav-justified .nav-item .nav-link {
  width: 100%;
}
.aesirxui .tab-content > .tab-pane {
  display: none;
}
.aesirxui .tab-content > .active {
  display: block;
}
.aesirxui .modal {
  --aesirxui-modal-zindex: 1055;
  --aesirxui-modal-width: 500px;
  --aesirxui-modal-padding: 1rem;
  --aesirxui-modal-margin: 0.5rem;
  --aesirxui-modal-color: ;
  --aesirxui-modal-bg: var(--aesirxui-body-bg);
  --aesirxui-modal-border-color: var(--aesirxui-border-color-translucent);
  --aesirxui-modal-border-width: var(--aesirxui-border-width);
  --aesirxui-modal-border-radius: var(--aesirxui-border-radius-lg);
  --aesirxui-modal-box-shadow: var(--aesirxui-box-shadow-sm);
  --aesirxui-modal-inner-border-radius: calc(var(--aesirxui-border-radius-lg) - (var(--aesirxui-border-width)));
  --aesirxui-modal-header-padding-x: 1rem;
  --aesirxui-modal-header-padding-y: 1rem;
  --aesirxui-modal-header-padding: 1rem 1rem;
  --aesirxui-modal-header-border-color: var(--aesirxui-border-color);
  --aesirxui-modal-header-border-width: var(--aesirxui-border-width);
  --aesirxui-modal-title-line-height: 1.5;
  --aesirxui-modal-footer-gap: 0.5rem;
  --aesirxui-modal-footer-bg: ;
  --aesirxui-modal-footer-border-color: var(--aesirxui-border-color);
  --aesirxui-modal-footer-border-width: var(--aesirxui-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--aesirxui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
.aesirxui .modal-dialog {
  position: relative;
  width: auto;
  margin: var(--aesirxui-modal-margin);
  pointer-events: none;
}
.modal.fade .aesirxui .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .aesirxui .modal-dialog {
    transition: none;
  }
}
.modal.show .aesirxui .modal-dialog {
  transform: none;
}
.modal.modal-static .aesirxui .modal-dialog {
  transform: scale(1.02);
}
.aesirxui .modal-dialog-scrollable {
  height: calc(100% - var(--aesirxui-modal-margin) * 2);
}
.aesirxui .modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.aesirxui .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
.aesirxui .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--aesirxui-modal-margin) * 2);
}
.aesirxui .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--aesirxui-modal-color);
  pointer-events: auto;
  background-color: var(--aesirxui-modal-bg);
  background-clip: padding-box;
  border: var(--aesirxui-modal-border-width) solid var(--aesirxui-modal-border-color);
  border-radius: var(--aesirxui-modal-border-radius);
  outline: 0;
}
.aesirxui .modal-backdrop {
  --aesirxui-backdrop-zindex: 1050;
  --aesirxui-backdrop-bg: #000;
  --aesirxui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--aesirxui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--aesirxui-backdrop-bg);
}
.aesirxui .modal-backdrop.fade {
  opacity: 0;
}
.aesirxui .modal-backdrop.show {
  opacity: var(--aesirxui-backdrop-opacity);
}
.aesirxui .modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--aesirxui-modal-header-padding);
  border-bottom: var(--aesirxui-modal-header-border-width) solid var(--aesirxui-modal-header-border-color);
  border-top-left-radius: var(--aesirxui-modal-inner-border-radius);
  border-top-right-radius: var(--aesirxui-modal-inner-border-radius);
}
.aesirxui .modal-header .btn-close {
  padding: calc(var(--aesirxui-modal-header-padding-y) * 0.5) calc(var(--aesirxui-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--aesirxui-modal-header-padding-y)) calc(-0.5 * var(--aesirxui-modal-header-padding-x)) calc(-0.5 * var(--aesirxui-modal-header-padding-y)) auto;
}
.aesirxui .modal-title {
  margin-bottom: 0;
  line-height: var(--aesirxui-modal-title-line-height);
}
.aesirxui .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--aesirxui-modal-padding);
}
.aesirxui .modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--aesirxui-modal-padding) - var(--aesirxui-modal-footer-gap) * 0.5);
  background-color: var(--aesirxui-modal-footer-bg);
  border-top: var(--aesirxui-modal-footer-border-width) solid var(--aesirxui-modal-footer-border-color);
  border-bottom-right-radius: var(--aesirxui-modal-inner-border-radius);
  border-bottom-left-radius: var(--aesirxui-modal-inner-border-radius);
}
.aesirxui .modal-footer > * {
  margin: calc(var(--aesirxui-modal-footer-gap) * 0.5);
}
@media (min-width: 576px) {
  .aesirxui .modal {
    --aesirxui-modal-margin: 1.75rem;
    --aesirxui-modal-box-shadow: var(--aesirxui-box-shadow);
  }
  .aesirxui .modal-dialog {
    max-width: var(--aesirxui-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxui .modal-sm {
    --aesirxui-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .aesirxui .modal-lg,
  .aesirxui .modal-xl {
    --aesirxui-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .aesirxui .modal-xl {
    --aesirxui-modal-width: 1140px;
  }
}
.aesirxui .modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.aesirxui .modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.aesirxui .modal-fullscreen .modal-header,
.aesirxui .modal-fullscreen .modal-footer {
  border-radius: 0;
}
.aesirxui .modal-fullscreen .modal-body {
  overflow-y: auto;
}
@media (max-width: 575.98px) {
  .aesirxui .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxui .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-sm-down .modal-header,
  .aesirxui .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .aesirxui .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxui .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-md-down .modal-header,
  .aesirxui .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .aesirxui .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxui .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-lg-down .modal-header,
  .aesirxui .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .aesirxui .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxui .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-xl-down .modal-header,
  .aesirxui .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .aesirxui .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxui .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-xxl-down .modal-header,
  .aesirxui .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .aesirxui .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.aesirxui .btn-close {
  --aesirxui-btn-close-color: #000;
  --aesirxui-btn-close-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
  --aesirxui-btn-close-opacity: 0.5;
  --aesirxui-btn-close-hover-opacity: 0.75;
  --aesirxui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(10, 8, 59, 0.25);
  --aesirxui-btn-close-focus-opacity: 1;
  --aesirxui-btn-close-disabled-opacity: 0.25;
  --aesirxui-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--aesirxui-btn-close-color);
  background: transparent var(--aesirxui-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--aesirxui-btn-close-opacity);
}
.aesirxui .btn-close:hover {
  color: var(--aesirxui-btn-close-color);
  text-decoration: none;
  opacity: var(--aesirxui-btn-close-hover-opacity);
}
.aesirxui .btn-close:focus {
  outline: 0;
  box-shadow: var(--aesirxui-btn-close-focus-shadow);
  opacity: var(--aesirxui-btn-close-focus-opacity);
}
.aesirxui .btn-close:disabled, .aesirxui .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--aesirxui-btn-close-disabled-opacity);
}
.aesirxui .btn-close-white {
  filter: var(--aesirxui-btn-close-white-filter);
}
.aesirxui [data-bs-theme=dark] .btn-close {
  filter: var(--aesirxui-btn-close-white-filter);
}
.aesirxui .spinner-grow,
.aesirxui .spinner-border {
  display: inline-block;
  width: var(--aesirxui-spinner-width);
  height: var(--aesirxui-spinner-height);
  vertical-align: var(--aesirxui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--aesirxui-spinner-animation-speed) linear infinite var(--aesirxui-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.aesirxui .spinner-border {
  --aesirxui-spinner-width: 2rem;
  --aesirxui-spinner-height: 2rem;
  --aesirxui-spinner-vertical-align: -0.125em;
  --aesirxui-spinner-border-width: 0.25em;
  --aesirxui-spinner-animation-speed: 0.75s;
  --aesirxui-spinner-animation-name: spinner-border;
  border: var(--aesirxui-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}
.aesirxui .spinner-border-sm {
  --aesirxui-spinner-width: 1rem;
  --aesirxui-spinner-height: 1rem;
  --aesirxui-spinner-border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.aesirxui .spinner-grow {
  --aesirxui-spinner-width: 2rem;
  --aesirxui-spinner-height: 2rem;
  --aesirxui-spinner-vertical-align: -0.125em;
  --aesirxui-spinner-animation-speed: 0.75s;
  --aesirxui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}
.aesirxui .spinner-grow-sm {
  --aesirxui-spinner-width: 1rem;
  --aesirxui-spinner-height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .spinner-border,
  .aesirxui .spinner-grow {
    --aesirxui-spinner-animation-speed: 1.5s;
  }
}
.aesirxui .clearfix::after {
  display: block;
  clear: both;
  content: "";
}
.aesirxui .text-bg-primary {
  color: #fff;
  background-color: RGBA(var(--aesirxui-primary-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-secondary {
  color: #fff;
  background-color: RGBA(var(--aesirxui-secondary-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-success {
  color: #000;
  background-color: RGBA(var(--aesirxui-success-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-info {
  color: #fff;
  background-color: RGBA(var(--aesirxui-info-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-warning {
  color: #000;
  background-color: RGBA(var(--aesirxui-warning-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-danger {
  color: #fff;
  background-color: RGBA(var(--aesirxui-danger-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-light {
  color: #000;
  background-color: RGBA(var(--aesirxui-light-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-dark {
  color: #fff;
  background-color: RGBA(var(--aesirxui-dark-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-noti-error {
  color: #fff;
  background-color: RGBA(var(--aesirxui-noti-error-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-noti-warn {
  color: #fff;
  background-color: RGBA(var(--aesirxui-noti-warn-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-noti-bg-error {
  color: #000;
  background-color: RGBA(var(--aesirxui-noti-bg-error-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-noti-bg-warn {
  color: #000;
  background-color: RGBA(var(--aesirxui-noti-bg-warn-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-noti-bg-success {
  color: #000;
  background-color: RGBA(var(--aesirxui-noti-bg-success-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-custom-color {
  color: #fff;
  background-color: RGBA(var(--aesirxui-custom-color-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-purple {
  color: #fff;
  background-color: RGBA(var(--aesirxui-purple-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-secondary-25 {
  color: #000;
  background-color: RGBA(var(--aesirxui-secondary-25-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-secondary-50 {
  color: #fff;
  background-color: RGBA(var(--aesirxui-secondary-50-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-secondary-100 {
  color: #fff;
  background-color: RGBA(var(--aesirxui-secondary-100-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-success-dark {
  color: #000;
  background-color: RGBA(var(--aesirxui-success-dark-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-success-darken {
  color: #fff;
  background-color: RGBA(var(--aesirxui-success-darken-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-warning-50 {
  color: #000;
  background-color: RGBA(var(--aesirxui-warning-50-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-warning-100 {
  color: #fff;
  background-color: RGBA(var(--aesirxui-warning-100-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-warning-200 {
  color: #000;
  background-color: RGBA(var(--aesirxui-warning-200-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-100 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-100-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-400 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-400-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-500 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-500-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-600 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-600-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-700 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-700-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-800 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-800-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-900 {
  color: #fff;
  background-color: RGBA(var(--aesirxui-gray-900-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-stroke-1 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-stroke-1-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-stroke-2 {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-stroke-2-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-light {
  color: #000;
  background-color: RGBA(var(--aesirxui-gray-light-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-gray-heading {
  color: #fff;
  background-color: RGBA(var(--aesirxui-gray-heading-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-blue {
  color: #fff;
  background-color: RGBA(var(--aesirxui-blue-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-blue-light {
  color: #000;
  background-color: RGBA(var(--aesirxui-blue-light-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-color-blue-6 {
  color: #000;
  background-color: RGBA(var(--aesirxui-color-blue-6-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-color-blue-9 {
  color: #000;
  background-color: RGBA(var(--aesirxui-color-blue-9-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-green-light {
  color: #000;
  background-color: RGBA(var(--aesirxui-green-light-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-telegram {
  color: #000;
  background-color: RGBA(var(--aesirxui-telegram-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-facebook {
  color: #fff;
  background-color: RGBA(var(--aesirxui-facebook-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-twitter {
  color: #000;
  background-color: RGBA(var(--aesirxui-twitter-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-linkedin {
  color: #fff;
  background-color: RGBA(var(--aesirxui-linkedin-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-instagram {
  color: #fff;
  background-color: RGBA(var(--aesirxui-instagram-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-chatgpt {
  color: #000;
  background-color: RGBA(var(--aesirxui-chatgpt-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-dark-blue {
  color: #fff;
  background-color: RGBA(var(--aesirxui-dark-blue-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-button-color {
  color: #000;
  background-color: RGBA(var(--aesirxui-button-color-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .text-bg-body-color {
  color: #fff;
  background-color: RGBA(var(--aesirxui-body-color-rgb), var(--aesirxui-bg-opacity, 1));
}
.aesirxui .link-primary {
  color: RGBA(var(--aesirxui-primary-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-primary-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-primary:hover, .aesirxui .link-primary:focus {
  color: RGBA(8, 6, 47, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(8, 6, 47, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary {
  color: RGBA(var(--aesirxui-secondary-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-secondary-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary:hover, .aesirxui .link-secondary:focus {
  color: RGBA(0, 62, 86, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(0, 62, 86, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-success {
  color: RGBA(var(--aesirxui-success-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-success-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-success:hover, .aesirxui .link-success:focus {
  color: RGBA(72, 194, 169, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(72, 194, 169, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-info {
  color: RGBA(var(--aesirxui-info-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-info-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-info:hover, .aesirxui .link-info:focus {
  color: RGBA(47, 98, 145, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(47, 98, 145, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning {
  color: RGBA(var(--aesirxui-warning-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-warning-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning:hover, .aesirxui .link-warning:focus {
  color: RGBA(243, 152, 81, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(243, 152, 81, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-danger {
  color: RGBA(var(--aesirxui-danger-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-danger-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-danger:hover, .aesirxui .link-danger:focus {
  color: RGBA(160, 20, 37, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(160, 20, 37, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-light {
  color: RGBA(var(--aesirxui-light-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-light-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-light:hover, .aesirxui .link-light:focus {
  color: RGBA(248, 249, 251, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(248, 249, 251, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-dark {
  color: RGBA(var(--aesirxui-dark-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-dark-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-dark:hover, .aesirxui .link-dark:focus {
  color: RGBA(27, 28, 32, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(27, 28, 32, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-error {
  color: RGBA(var(--aesirxui-noti-error-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-noti-error-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-error:hover, .aesirxui .link-noti-error:focus {
  color: RGBA(160, 20, 37, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(160, 20, 37, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-warn {
  color: RGBA(var(--aesirxui-noti-warn-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-noti-warn-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-warn:hover, .aesirxui .link-noti-warn:focus {
  color: RGBA(118, 79, 0, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(118, 79, 0, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-bg-error {
  color: RGBA(var(--aesirxui-noti-bg-error-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-noti-bg-error-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-bg-error:hover, .aesirxui .link-noti-bg-error:focus {
  color: RGBA(254, 232, 232, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(254, 232, 232, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-bg-warn {
  color: RGBA(var(--aesirxui-noti-bg-warn-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-noti-bg-warn-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-bg-warn:hover, .aesirxui .link-noti-bg-warn:focus {
  color: RGBA(255, 249, 237, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(255, 249, 237, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-bg-success {
  color: RGBA(var(--aesirxui-noti-bg-success-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-noti-bg-success-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-noti-bg-success:hover, .aesirxui .link-noti-bg-success:focus {
  color: RGBA(218, 251, 234, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(218, 251, 234, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-custom-color {
  color: RGBA(var(--aesirxui-custom-color-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-custom-color-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-custom-color:hover, .aesirxui .link-custom-color:focus {
  color: RGBA(90, 35, 199, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(90, 35, 199, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-purple {
  color: RGBA(var(--aesirxui-purple-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-purple-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-purple:hover, .aesirxui .link-purple:focus {
  color: RGBA(85, 50, 92, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(85, 50, 92, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary-25 {
  color: RGBA(var(--aesirxui-secondary-25-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-secondary-25-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary-25:hover, .aesirxui .link-secondary-25:focus {
  color: RGBA(243, 245, 252, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(243, 245, 252, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary-50 {
  color: RGBA(var(--aesirxui-secondary-50-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-secondary-50-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary-50:hover, .aesirxui .link-secondary-50:focus {
  color: RGBA(23, 68, 135, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(23, 68, 135, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary-100 {
  color: RGBA(var(--aesirxui-secondary-100-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-secondary-100-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-secondary-100:hover, .aesirxui .link-secondary-100:focus {
  color: RGBA(10, 70, 110, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(10, 70, 110, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-success-dark {
  color: RGBA(var(--aesirxui-success-dark-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-success-dark-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-success-dark:hover, .aesirxui .link-success-dark:focus {
  color: RGBA(73, 171, 147, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(73, 171, 147, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-success-darken {
  color: RGBA(var(--aesirxui-success-darken-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-success-darken-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-success-darken:hover, .aesirxui .link-success-darken:focus {
  color: RGBA(12, 82, 61, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(12, 82, 61, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning-50 {
  color: RGBA(var(--aesirxui-warning-50-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-warning-50-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning-50:hover, .aesirxui .link-warning-50:focus {
  color: RGBA(255, 249, 237, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(255, 249, 237, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning-100 {
  color: RGBA(var(--aesirxui-warning-100-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-warning-100-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning-100:hover, .aesirxui .link-warning-100:focus {
  color: RGBA(118, 79, 0, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(118, 79, 0, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning-200 {
  color: RGBA(var(--aesirxui-warning-200-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-warning-200-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-warning-200:hover, .aesirxui .link-warning-200:focus {
  color: RGBA(255, 235, 193, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(255, 235, 193, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-100 {
  color: RGBA(var(--aesirxui-gray-100-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-100-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-100:hover, .aesirxui .link-gray-100:focus {
  color: RGBA(248, 249, 251, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(248, 249, 251, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-400 {
  color: RGBA(var(--aesirxui-gray-400-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-400-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-400:hover, .aesirxui .link-gray-400:focus {
  color: RGBA(233, 233, 233, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(233, 233, 233, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-500 {
  color: RGBA(var(--aesirxui-gray-500-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-500-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-500:hover, .aesirxui .link-gray-500:focus {
  color: RGBA(219, 219, 219, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(219, 219, 219, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-600 {
  color: RGBA(var(--aesirxui-gray-600-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-600-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-600:hover, .aesirxui .link-gray-600:focus {
  color: RGBA(165, 165, 165, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(165, 165, 165, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-700 {
  color: RGBA(var(--aesirxui-gray-700-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-700-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-700:hover, .aesirxui .link-gray-700:focus {
  color: RGBA(208, 208, 208, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(208, 208, 208, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-800 {
  color: RGBA(var(--aesirxui-gray-800-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-800-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-800:hover, .aesirxui .link-gray-800:focus {
  color: RGBA(237, 237, 237, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(237, 237, 237, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-900 {
  color: RGBA(var(--aesirxui-gray-900-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-900-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-900:hover, .aesirxui .link-gray-900:focus {
  color: RGBA(27, 28, 32, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(27, 28, 32, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-stroke-1 {
  color: RGBA(var(--aesirxui-gray-stroke-1-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-stroke-1-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-stroke-1:hover, .aesirxui .link-gray-stroke-1:focus {
  color: RGBA(245, 245, 245, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(245, 245, 245, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-stroke-2 {
  color: RGBA(var(--aesirxui-gray-stroke-2-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-stroke-2-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-stroke-2:hover, .aesirxui .link-gray-stroke-2:focus {
  color: RGBA(229, 229, 229, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(229, 229, 229, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-light {
  color: RGBA(var(--aesirxui-gray-light-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-light-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-light:hover, .aesirxui .link-gray-light:focus {
  color: RGBA(172, 172, 177, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(172, 172, 177, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-heading {
  color: RGBA(var(--aesirxui-gray-heading-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-gray-heading-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-gray-heading:hover, .aesirxui .link-gray-heading:focus {
  color: RGBA(76, 75, 90, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(76, 75, 90, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-blue {
  color: RGBA(var(--aesirxui-blue-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-blue-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-blue:hover, .aesirxui .link-blue:focus {
  color: RGBA(8, 72, 204, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(8, 72, 204, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-blue-light {
  color: RGBA(var(--aesirxui-blue-light-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-blue-light-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-blue-light:hover, .aesirxui .link-blue-light:focus {
  color: RGBA(241, 249, 253, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(241, 249, 253, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-color-blue-6 {
  color: RGBA(var(--aesirxui-color-blue-6-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-color-blue-6-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-color-blue-6:hover, .aesirxui .link-color-blue-6:focus {
  color: RGBA(227, 235, 239, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(227, 235, 239, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-color-blue-9 {
  color: RGBA(var(--aesirxui-color-blue-9-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-color-blue-9-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-color-blue-9:hover, .aesirxui .link-color-blue-9:focus {
  color: RGBA(243, 245, 252, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(243, 245, 252, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-green-light {
  color: RGBA(var(--aesirxui-green-light-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-green-light-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-green-light:hover, .aesirxui .link-green-light:focus {
  color: RGBA(218, 251, 234, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(218, 251, 234, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-telegram {
  color: RGBA(var(--aesirxui-telegram-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-telegram-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-telegram:hover, .aesirxui .link-telegram:focus {
  color: RGBA(53, 175, 234, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(53, 175, 234, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-facebook {
  color: RGBA(var(--aesirxui-facebook-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-facebook-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-facebook:hover, .aesirxui .link-facebook:focus {
  color: RGBA(46, 68, 127, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(46, 68, 127, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-twitter {
  color: RGBA(var(--aesirxui-twitter-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-twitter-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-twitter:hover, .aesirxui .link-twitter:focus {
  color: RGBA(81, 184, 218, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(81, 184, 218, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-linkedin {
  color: RGBA(var(--aesirxui-linkedin-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-linkedin-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-linkedin:hover, .aesirxui .link-linkedin:focus {
  color: RGBA(0, 98, 148, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(0, 98, 148, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-instagram {
  color: RGBA(var(--aesirxui-instagram-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-instagram-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-instagram:hover, .aesirxui .link-instagram:focus {
  color: RGBA(143, 42, 140, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(143, 42, 140, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-chatgpt {
  color: RGBA(var(--aesirxui-chatgpt-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-chatgpt-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-chatgpt:hover, .aesirxui .link-chatgpt:focus {
  color: RGBA(51, 182, 154, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(51, 182, 154, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-dark-blue {
  color: RGBA(var(--aesirxui-dark-blue-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-dark-blue-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-dark-blue:hover, .aesirxui .link-dark-blue:focus {
  color: RGBA(50, 67, 75, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(50, 67, 75, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-button-color {
  color: RGBA(var(--aesirxui-button-color-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-button-color-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-button-color:hover, .aesirxui .link-button-color:focus {
  color: RGBA(255, 255, 255, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(255, 255, 255, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-body-color {
  color: RGBA(var(--aesirxui-body-color-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-body-color-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-body-color:hover, .aesirxui .link-body-color:focus {
  color: RGBA(8, 6, 47, var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(8, 6, 47, var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-body-emphasis {
  color: RGBA(var(--aesirxui-emphasis-color-rgb), var(--aesirxui-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxui-emphasis-color-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-body-emphasis:hover, .aesirxui .link-body-emphasis:focus {
  color: RGBA(var(--aesirxui-emphasis-color-rgb), var(--aesirxui-link-opacity, 0.75));
  text-decoration-color: RGBA(var(--aesirxui-emphasis-color-rgb), var(--aesirxui-link-underline-opacity, 0.75));
}
.aesirxui .focus-ring:focus {
  outline: 0;
  box-shadow: var(--aesirxui-focus-ring-x, 0) var(--aesirxui-focus-ring-y, 0) var(--aesirxui-focus-ring-blur, 0) var(--aesirxui-focus-ring-width) var(--aesirxui-focus-ring-color);
}
.aesirxui .icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--aesirxui-link-color-rgb), var(--aesirxui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.aesirxui .icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxui .icon-link > .bi {
    transition: none;
  }
}
.aesirxui .icon-link-hover:hover > .bi, .aesirxui .icon-link-hover:focus-visible > .bi {
  transform: var(--aesirxui-icon-link-transform, translate3d(0.25em, 0, 0));
}
.aesirxui .ratio {
  position: relative;
  width: 100%;
}
.aesirxui .ratio::before {
  display: block;
  padding-top: var(--aesirxui-aspect-ratio);
  content: "";
}
.aesirxui .ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.aesirxui .ratio-1x1 {
  --aesirxui-aspect-ratio: 100%;
}
.aesirxui .ratio-4x3 {
  --aesirxui-aspect-ratio: 75%;
}
.aesirxui .ratio-16x9 {
  --aesirxui-aspect-ratio: 56.25%;
}
.aesirxui .ratio-21x9 {
  --aesirxui-aspect-ratio: 42.8571428571%;
}
.aesirxui .fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.aesirxui .fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.aesirxui .sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}
.aesirxui .sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}
@media (min-width: 576px) {
  .aesirxui .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxui .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .aesirxui .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxui .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .aesirxui .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxui .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .aesirxui .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxui .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .aesirxui .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxui .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.aesirxui .hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}
.aesirxui .vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}
.aesirxui .visually-hidden,
.aesirxui .visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.aesirxui .visually-hidden:not(caption),
.aesirxui .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.aesirxui .stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}
.aesirxui .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aesirxui .vr {
  display: inline-block;
  align-self: stretch;
  width: var(--aesirxui-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}
.aesirxui .align-baseline {
  vertical-align: baseline;
}
.aesirxui .align-top {
  vertical-align: top;
}
.aesirxui .align-middle {
  vertical-align: middle;
}
.aesirxui .align-bottom {
  vertical-align: bottom;
}
.aesirxui .align-text-bottom {
  vertical-align: text-bottom;
}
.aesirxui .align-text-top {
  vertical-align: text-top;
}
.aesirxui .float-start {
  float: left;
}
.aesirxui .float-end {
  float: right;
}
.aesirxui .float-none {
  float: none;
}
.aesirxui .object-fit-cover {
  object-fit: cover;
}
.aesirxui .object-fit-contain {
  object-fit: contain;
}
.aesirxui .opacity-0 {
  opacity: 0;
}
.aesirxui .opacity-25 {
  opacity: 0.25;
}
.aesirxui .opacity-50 {
  opacity: 0.5;
}
.aesirxui .opacity-75 {
  opacity: 0.75;
}
.aesirxui .opacity-80 {
  opacity: 0.8;
}
.aesirxui .opacity-100 {
  opacity: 1;
}
.aesirxui .overflow-auto {
  overflow: auto;
}
.aesirxui .overflow-hidden {
  overflow: hidden;
}
.aesirxui .overflow-visible {
  overflow: visible;
}
.aesirxui .overflow-scroll {
  overflow: scroll;
}
.aesirxui .overflow-x-auto {
  overflow-x: auto;
}
.aesirxui .overflow-x-hidden {
  overflow-x: hidden;
}
.aesirxui .overflow-x-visible {
  overflow-x: visible;
}
.aesirxui .overflow-x-scroll {
  overflow-x: scroll;
}
.aesirxui .overflow-y-auto {
  overflow-y: auto;
}
.aesirxui .d-inline {
  display: inline;
}
.aesirxui .d-inline-block {
  display: inline-block;
}
.aesirxui .d-block {
  display: block;
}
.aesirxui .d-grid {
  display: grid;
}
.aesirxui .d-inline-grid {
  display: inline-grid;
}
.aesirxui .d-table {
  display: table;
}
.aesirxui .d-table-row {
  display: table-row;
}
.aesirxui .d-table-cell {
  display: table-cell;
}
.aesirxui .d-flex {
  display: flex;
}
.aesirxui .d-inline-flex {
  display: inline-flex;
}
.aesirxui .d-none {
  display: none;
}
.aesirxui .shadow {
  box-shadow: var(--aesirxui-box-shadow);
}
.aesirxui .shadow-sm {
  box-shadow: var(--aesirxui-box-shadow-sm);
}
.aesirxui .shadow-lg {
  box-shadow: var(--aesirxui-box-shadow-lg);
}
.aesirxui .shadow-none {
  box-shadow: none;
}
.aesirxui .focus-ring-primary {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-primary-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-secondary {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-secondary-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-success {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-success-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-info {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-info-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-warning {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-warning-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-danger {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-danger-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-light {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-light-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-dark {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-dark-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-noti-error {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-noti-error-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-noti-warn {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-noti-warn-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-noti-bg-error {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-noti-bg-error-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-noti-bg-warn {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-noti-bg-warn-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-noti-bg-success {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-noti-bg-success-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-custom-color {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-custom-color-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-purple {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-purple-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-secondary-25 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-secondary-25-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-secondary-50 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-secondary-50-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-secondary-100 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-secondary-100-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-success-dark {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-success-dark-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-success-darken {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-success-darken-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-warning-50 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-warning-50-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-warning-100 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-warning-100-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-warning-200 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-warning-200-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-100 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-100-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-400 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-400-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-500 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-500-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-600 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-600-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-700 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-700-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-800 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-800-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-900 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-900-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-stroke-1 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-stroke-1-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-stroke-2 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-stroke-2-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-light {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-light-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-gray-heading {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-gray-heading-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-blue {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-blue-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-blue-light {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-blue-light-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-color-blue-6 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-color-blue-6-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-color-blue-9 {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-color-blue-9-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-green-light {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-green-light-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-telegram {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-telegram-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-facebook {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-facebook-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-twitter {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-twitter-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-linkedin {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-linkedin-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-instagram {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-instagram-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-chatgpt {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-chatgpt-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-dark-blue {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-dark-blue-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-button-color {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-button-color-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .focus-ring-body-color {
  --aesirxui-focus-ring-color: rgba(var(--aesirxui-body-color-rgb), var(--aesirxui-focus-ring-opacity));
}
.aesirxui .position-static {
  position: static;
}
.aesirxui .position-relative {
  position: relative;
}
.aesirxui .position-absolute {
  position: absolute;
}
.aesirxui .position-fixed {
  position: fixed;
}
.aesirxui .position-sticky {
  position: sticky;
}
.aesirxui .top-0 {
  top: 0;
}
.aesirxui .top-50 {
  top: 50%;
}
.aesirxui .top-100 {
  top: 100%;
}
.aesirxui .bottom-0 {
  bottom: 0;
}
.aesirxui .bottom-50 {
  bottom: 50%;
}
.aesirxui .bottom-100 {
  bottom: 100%;
}
.aesirxui .start-0 {
  left: 0;
}
.aesirxui .start-50 {
  left: 50%;
}
.aesirxui .start-100 {
  left: 100%;
}
.aesirxui .end-0 {
  right: 0;
}
.aesirxui .end-50 {
  right: 50%;
}
.aesirxui .end-100 {
  right: 100%;
}
.aesirxui .translate-middle {
  transform: translate(-50%, -50%);
}
.aesirxui .translate-middle-x {
  transform: translateX(-50%);
}
.aesirxui .translate-middle-y {
  transform: translateY(-50%);
}
.aesirxui .border {
  border: 1px solid #d5d5d5;
}
.aesirxui .border-0 {
  border: 0;
}
.aesirxui .border-1 {
  border: 1px solid #d5d5d5;
}
.aesirxui .border-da-1 {
  border: 1px dashed #d5d5d5;
}
.aesirxui .border-top {
  border-top: 1px solid #d5d5d5;
}
.aesirxui .border-top-0 {
  border-top: 0;
}
.aesirxui .border-top-1 {
  border-top: 1px solid #d5d5d5;
}
.aesirxui .border-end {
  border-right: 1px solid #d5d5d5;
}
.aesirxui .border-end-0 {
  border-right: 0;
}
.aesirxui .border-end-1 {
  border-right: 1px solid #d5d5d5;
}
.aesirxui .border-bottom {
  border-bottom: 1px solid #d5d5d5;
}
.aesirxui .border-bottom-0 {
  border-bottom: 0;
}
.aesirxui .border-bottom-1 {
  border-bottom: 1px solid #d5d5d5;
}
.aesirxui .border-start {
  border-left: 1px solid #d5d5d5;
}
.aesirxui .border-start-0 {
  border-left: 0;
}
.aesirxui .border-start-1 {
  border-left: 1px solid #d5d5d5;
}
.aesirxui .border-start-5 {
  border-left: 5px solid #d5d5d5;
}
.aesirxui .border-primary {
  border-color: #0a083b;
}
.aesirxui .border-secondary {
  border-color: #004d6c;
}
.aesirxui .border-success {
  border-color: #1ab394;
}
.aesirxui .border-info {
  border-color: #3b7ab5;
}
.aesirxui .border-warning {
  border-color: #f07e25;
}
.aesirxui .border-danger {
  border-color: #c8192e;
}
.aesirxui .border-light {
  border-color: #f6f8fa;
}
.aesirxui .border-dark {
  border-color: #222328;
}
.aesirxui .border-noti-error {
  border-color: #c8192e;
}
.aesirxui .border-noti-warn {
  border-color: #946300;
}
.aesirxui .border-noti-bg-error {
  border-color: #fee2e2;
}
.aesirxui .border-noti-bg-warn {
  border-color: #fff8e9;
}
.aesirxui .border-noti-bg-success {
  border-color: #d1fae5;
}
.aesirxui .border-custom-color {
  border-color: #712cf9;
}
.aesirxui .border-purple {
  border-color: #6a3e73;
}
.aesirxui .border-secondary-25 {
  border-color: #f0f3fb;
}
.aesirxui .border-secondary-50 {
  border-color: #1d55a9;
}
.aesirxui .border-secondary-100 {
  border-color: #0d588a;
}
.aesirxui .border-success-dark {
  border-color: #1c9678;
}
.aesirxui .border-success-darken {
  border-color: #0f674c;
}
.aesirxui .border-warning-50 {
  border-color: #fff8e9;
}
.aesirxui .border-warning-100 {
  border-color: #946300;
}
.aesirxui .border-warning-200 {
  border-color: #ffe6b2;
}
.aesirxui .border-gray-100 {
  border-color: #f6f8fa;
}
.aesirxui .border-gray-400 {
  border-color: #e3e3e3;
}
.aesirxui .border-gray-500 {
  border-color: #d2d2d2;
}
.aesirxui .border-gray-600 {
  border-color: #8e8e8e;
}
.aesirxui .border-gray-700 {
  border-color: #c4c4c4;
}
.aesirxui .border-gray-800 {
  border-color: #e9e9e9;
}
.aesirxui .border-gray-900 {
  border-color: #222328;
}
.aesirxui .border-gray-stroke-1 {
  border-color: #f3f3f3;
}
.aesirxui .border-gray-stroke-2 {
  border-color: #dedede;
}
.aesirxui .border-gray-light {
  border-color: #97979e;
}
.aesirxui .border-gray-heading {
  border-color: #5f5e70;
}
.aesirxui .border-blue {
  border-color: #0a5aff;
}
.aesirxui .border-blue-light {
  border-color: #edf8fd;
}
.aesirxui .border-color-blue-6 {
  border-color: #dce6eb;
}
.aesirxui .border-color-blue-9 {
  border-color: #f0f3fb;
}
.aesirxui .border-green-light {
  border-color: #d1fae5;
}
.aesirxui .border-telegram {
  border-color: #039be5;
}
.aesirxui .border-facebook {
  border-color: #3a559f;
}
.aesirxui .border-twitter {
  border-color: #26a6d1;
}
.aesirxui .border-linkedin {
  border-color: #007ab9;
}
.aesirxui .border-instagram {
  border-color: #b334af;
}
.aesirxui .border-chatgpt {
  border-color: #00a481;
}
.aesirxui .border-dark-blue {
  border-color: #3e545e;
}
.aesirxui .border-button-color {
  border-color: white;
}
.aesirxui .border-body-color {
  border-color: #0a083b;
}
.aesirxui .border-white {
  border-color: #fff;
}
.aesirxui .border-gray {
  border-color: #d5d5d5;
}
.aesirxui .border-green {
  border-color: #1ab394;
}
.aesirxui .border-red {
  border-color: #c60202;
}
.aesirxui .border-transparent {
  border-color: transparent;
}
.aesirxui .border-primary-subtle {
  border-color: var(--aesirxui-primary-border-subtle);
}
.aesirxui .border-secondary-subtle {
  border-color: var(--aesirxui-secondary-border-subtle);
}
.aesirxui .border-success-subtle {
  border-color: var(--aesirxui-success-border-subtle);
}
.aesirxui .border-info-subtle {
  border-color: var(--aesirxui-info-border-subtle);
}
.aesirxui .border-warning-subtle {
  border-color: var(--aesirxui-warning-border-subtle);
}
.aesirxui .border-danger-subtle {
  border-color: var(--aesirxui-danger-border-subtle);
}
.aesirxui .border-light-subtle {
  border-color: var(--aesirxui-light-border-subtle);
}
.aesirxui .border-dark-subtle {
  border-color: var(--aesirxui-dark-border-subtle);
}
.aesirxui .border-0 {
  border-width: 0;
}
.aesirxui .border-1 {
  border-width: 1px;
}
.aesirxui .border-2 {
  border-width: 2px;
}
.aesirxui .border-3 {
  border-width: 3px;
}
.aesirxui .border-4 {
  border-width: 4px;
}
.aesirxui .border-5 {
  border-width: 5px;
}
.aesirxui .border-opacity-10 {
  --aesirxui-border-opacity: 0.1;
}
.aesirxui .border-opacity-25 {
  --aesirxui-border-opacity: 0.25;
}
.aesirxui .border-opacity-50 {
  --aesirxui-border-opacity: 0.5;
}
.aesirxui .border-opacity-75 {
  --aesirxui-border-opacity: 0.75;
}
.aesirxui .border-opacity-100 {
  --aesirxui-border-opacity: 1;
}
.aesirxui .w-25 {
  width: 25%;
}
.aesirxui .w-20 {
  width: 20%;
}
.aesirxui .w-40 {
  width: 40%;
}
.aesirxui .w-50 {
  width: 50%;
}
.aesirxui .w-75 {
  width: 75%;
}
.aesirxui .w-100 {
  width: 100%;
}
.aesirxui .w-fit {
  width: fit-content;
}
.aesirxui .w-max {
  width: max-content;
}
.aesirxui .w-auto {
  width: auto;
}
.aesirxui .w-150px {
  width: 150px;
}
.aesirxui .w-40px {
  width: 40px;
}
.aesirxui .w-145px {
  width: 145px;
}
.aesirxui .mw-100 {
  max-width: 100%;
}
.aesirxui .mw-80 {
  max-width: 80%;
}
.aesirxui .mw-120 {
  max-width: 120px;
}
.aesirxui .mw-150 {
  max-width: 150px;
}
.aesirxui .mw-100px {
  max-width: 100px;
}
.aesirxui .vw-100 {
  width: 100vw;
}
.aesirxui .min-vw-100 {
  min-width: 100vw;
}
.aesirxui .h-25 {
  height: 25%;
}
.aesirxui .h-50 {
  height: 50%;
}
.aesirxui .h-75 {
  height: 75%;
}
.aesirxui .h-100 {
  height: 100%;
}
.aesirxui .h-auto {
  height: auto;
}
.aesirxui .h-40px {
  height: 40px;
}
.aesirxui .h-48px {
  height: 48px;
}
.aesirxui .h-80vh {
  height: 80vh;
}
.aesirxui .h-465px {
  height: 465px;
}
.aesirxui .h-680px {
  height: 680px;
}
.aesirxui .h-100px {
  height: 100px;
}
.aesirxui .h-150px {
  height: 150px;
}
.aesirxui .h-400px {
  height: 400px;
}
.aesirxui .mh-100 {
  max-height: 100%;
}
.aesirxui .mh-80 {
  max-height: 80%;
}
.aesirxui .mh-80vh {
  max-height: 80vh;
}
.aesirxui .mh-350px {
  max-height: 350px;
}
.aesirxui .vh-100 {
  height: 100vh;
}
.aesirxui .min-vh-100 {
  min-height: 100vh;
}
.aesirxui .flex-fill {
  flex: 1 1 auto;
}
.aesirxui .flex-1 {
  flex: 1;
}
.aesirxui .flex-row {
  flex-direction: row;
}
.aesirxui .flex-column {
  flex-direction: column;
}
.aesirxui .flex-row-reverse {
  flex-direction: row-reverse;
}
.aesirxui .flex-column-reverse {
  flex-direction: column-reverse;
}
.aesirxui .flex-grow-0 {
  flex-grow: 0;
}
.aesirxui .flex-grow-1 {
  flex-grow: 1;
}
.aesirxui .flex-shrink-0 {
  flex-shrink: 0;
}
.aesirxui .flex-shrink-1 {
  flex-shrink: 1;
}
.aesirxui .flex-wrap {
  flex-wrap: wrap;
}
.aesirxui .flex-nowrap {
  flex-wrap: nowrap;
}
.aesirxui .flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.aesirxui .justify-content-start {
  justify-content: flex-start;
}
.aesirxui .justify-content-end {
  justify-content: flex-end;
}
.aesirxui .justify-content-center {
  justify-content: center;
}
.aesirxui .justify-content-between {
  justify-content: space-between;
}
.aesirxui .justify-content-around {
  justify-content: space-around;
}
.aesirxui .justify-content-evenly {
  justify-content: space-evenly;
}
.aesirxui .align-items-start {
  align-items: flex-start;
}
.aesirxui .align-items-end {
  align-items: flex-end;
}
.aesirxui .align-items-center {
  align-items: center;
}
.aesirxui .align-items-baseline {
  align-items: baseline;
}
.aesirxui .align-items-stretch {
  align-items: stretch;
}
.aesirxui .align-content-start {
  align-content: flex-start;
}
.aesirxui .align-content-end {
  align-content: flex-end;
}
.aesirxui .align-content-center {
  align-content: center;
}
.aesirxui .align-content-between {
  align-content: space-between;
}
.aesirxui .align-content-around {
  align-content: space-around;
}
.aesirxui .align-content-stretch {
  align-content: stretch;
}
.aesirxui .align-self-auto {
  align-self: auto;
}
.aesirxui .align-self-start {
  align-self: flex-start;
}
.aesirxui .align-self-end {
  align-self: flex-end;
}
.aesirxui .align-self-center {
  align-self: center;
}
.aesirxui .align-self-baseline {
  align-self: baseline;
}
.aesirxui .align-self-stretch {
  align-self: stretch;
}
.aesirxui .order-first {
  order: -1;
}
.aesirxui .order-0 {
  order: 0;
}
.aesirxui .order-1 {
  order: 1;
}
.aesirxui .order-2 {
  order: 2;
}
.aesirxui .order-3 {
  order: 3;
}
.aesirxui .order-4 {
  order: 4;
}
.aesirxui .order-5 {
  order: 5;
}
.aesirxui .order-last {
  order: 6;
}
.aesirxui .m-0 {
  margin: 0;
}
.aesirxui .m-1 {
  margin: 0.25rem;
}
.aesirxui .m-2 {
  margin: 0.5rem;
}
.aesirxui .m-3 {
  margin: 1rem;
}
.aesirxui .m-4 {
  margin: 1.5rem;
}
.aesirxui .m-5 {
  margin: 3rem;
}
.aesirxui .m-sm {
  margin: 5px;
}
.aesirxui .m-8px {
  margin: 8px;
}
.aesirxui .m-15 {
  margin: 15px;
}
.aesirxui .m-16 {
  margin: 16px;
}
.aesirxui .m-20 {
  margin: 20px;
}
.aesirxui .m-24 {
  margin: 24px;
}
.aesirxui .m-6 {
  margin: 60px;
}
.aesirxui .m-7 {
  margin: 70px;
}
.aesirxui .m-8 {
  margin: 80px;
}
.aesirxui .m-10 {
  margin: 10px;
}
.aesirxui .m-13 {
  margin: 13px;
}
.aesirxui .m-14 {
  margin: 14px;
}
.aesirxui .m-40 {
  margin: 40px;
}
.aesirxui .m-18px {
  margin: 18px;
}
.aesirxui .m-32px {
  margin: 32px;
}
.aesirxui .m-9px {
  margin: 9px;
}
.aesirxui .m-12px {
  margin: 12px;
}
.aesirxui .m-19px {
  margin: 19px;
}
.aesirxui .m-auto {
  margin: auto;
}
.aesirxui .mx-0 {
  margin-right: 0;
  margin-left: 0;
}
.aesirxui .mx-1 {
  margin-right: 0.25rem;
  margin-left: 0.25rem;
}
.aesirxui .mx-2 {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}
.aesirxui .mx-3 {
  margin-right: 1rem;
  margin-left: 1rem;
}
.aesirxui .mx-4 {
  margin-right: 1.5rem;
  margin-left: 1.5rem;
}
.aesirxui .mx-5 {
  margin-right: 3rem;
  margin-left: 3rem;
}
.aesirxui .mx-sm {
  margin-right: 5px;
  margin-left: 5px;
}
.aesirxui .mx-8px {
  margin-right: 8px;
  margin-left: 8px;
}
.aesirxui .mx-15 {
  margin-right: 15px;
  margin-left: 15px;
}
.aesirxui .mx-16 {
  margin-right: 16px;
  margin-left: 16px;
}
.aesirxui .mx-20 {
  margin-right: 20px;
  margin-left: 20px;
}
.aesirxui .mx-24 {
  margin-right: 24px;
  margin-left: 24px;
}
.aesirxui .mx-6 {
  margin-right: 60px;
  margin-left: 60px;
}
.aesirxui .mx-7 {
  margin-right: 70px;
  margin-left: 70px;
}
.aesirxui .mx-8 {
  margin-right: 80px;
  margin-left: 80px;
}
.aesirxui .mx-10 {
  margin-right: 10px;
  margin-left: 10px;
}
.aesirxui .mx-13 {
  margin-right: 13px;
  margin-left: 13px;
}
.aesirxui .mx-14 {
  margin-right: 14px;
  margin-left: 14px;
}
.aesirxui .mx-40 {
  margin-right: 40px;
  margin-left: 40px;
}
.aesirxui .mx-18px {
  margin-right: 18px;
  margin-left: 18px;
}
.aesirxui .mx-32px {
  margin-right: 32px;
  margin-left: 32px;
}
.aesirxui .mx-9px {
  margin-right: 9px;
  margin-left: 9px;
}
.aesirxui .mx-12px {
  margin-right: 12px;
  margin-left: 12px;
}
.aesirxui .mx-19px {
  margin-right: 19px;
  margin-left: 19px;
}
.aesirxui .mx-auto {
  margin-right: auto;
  margin-left: auto;
}
.aesirxui .my-0 {
  margin-top: 0;
  margin-bottom: 0;
}
.aesirxui .my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.aesirxui .my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.aesirxui .my-3 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.aesirxui .my-4 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.aesirxui .my-5 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.aesirxui .my-sm {
  margin-top: 5px;
  margin-bottom: 5px;
}
.aesirxui .my-8px {
  margin-top: 8px;
  margin-bottom: 8px;
}
.aesirxui .my-15 {
  margin-top: 15px;
  margin-bottom: 15px;
}
.aesirxui .my-16 {
  margin-top: 16px;
  margin-bottom: 16px;
}
.aesirxui .my-20 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.aesirxui .my-24 {
  margin-top: 24px;
  margin-bottom: 24px;
}
.aesirxui .my-6 {
  margin-top: 60px;
  margin-bottom: 60px;
}
.aesirxui .my-7 {
  margin-top: 70px;
  margin-bottom: 70px;
}
.aesirxui .my-8 {
  margin-top: 80px;
  margin-bottom: 80px;
}
.aesirxui .my-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.aesirxui .my-13 {
  margin-top: 13px;
  margin-bottom: 13px;
}
.aesirxui .my-14 {
  margin-top: 14px;
  margin-bottom: 14px;
}
.aesirxui .my-40 {
  margin-top: 40px;
  margin-bottom: 40px;
}
.aesirxui .my-18px {
  margin-top: 18px;
  margin-bottom: 18px;
}
.aesirxui .my-32px {
  margin-top: 32px;
  margin-bottom: 32px;
}
.aesirxui .my-9px {
  margin-top: 9px;
  margin-bottom: 9px;
}
.aesirxui .my-12px {
  margin-top: 12px;
  margin-bottom: 12px;
}
.aesirxui .my-19px {
  margin-top: 19px;
  margin-bottom: 19px;
}
.aesirxui .my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.aesirxui .mt-0 {
  margin-top: 0;
}
.aesirxui .mt-1 {
  margin-top: 0.25rem;
}
.aesirxui .mt-2 {
  margin-top: 0.5rem;
}
.aesirxui .mt-3 {
  margin-top: 1rem;
}
.aesirxui .mt-4 {
  margin-top: 1.5rem;
}
.aesirxui .mt-5 {
  margin-top: 3rem;
}
.aesirxui .mt-sm {
  margin-top: 5px;
}
.aesirxui .mt-8px {
  margin-top: 8px;
}
.aesirxui .mt-15 {
  margin-top: 15px;
}
.aesirxui .mt-16 {
  margin-top: 16px;
}
.aesirxui .mt-20 {
  margin-top: 20px;
}
.aesirxui .mt-24 {
  margin-top: 24px;
}
.aesirxui .mt-6 {
  margin-top: 60px;
}
.aesirxui .mt-7 {
  margin-top: 70px;
}
.aesirxui .mt-8 {
  margin-top: 80px;
}
.aesirxui .mt-10 {
  margin-top: 10px;
}
.aesirxui .mt-13 {
  margin-top: 13px;
}
.aesirxui .mt-14 {
  margin-top: 14px;
}
.aesirxui .mt-40 {
  margin-top: 40px;
}
.aesirxui .mt-18px {
  margin-top: 18px;
}
.aesirxui .mt-32px {
  margin-top: 32px;
}
.aesirxui .mt-9px {
  margin-top: 9px;
}
.aesirxui .mt-12px {
  margin-top: 12px;
}
.aesirxui .mt-19px {
  margin-top: 19px;
}
.aesirxui .mt-auto {
  margin-top: auto;
}
.aesirxui .me-0 {
  margin-right: 0;
}
.aesirxui .me-1 {
  margin-right: 0.25rem;
}
.aesirxui .me-2 {
  margin-right: 0.5rem;
}
.aesirxui .me-3 {
  margin-right: 1rem;
}
.aesirxui .me-4 {
  margin-right: 1.5rem;
}
.aesirxui .me-5 {
  margin-right: 3rem;
}
.aesirxui .me-sm {
  margin-right: 5px;
}
.aesirxui .me-8px {
  margin-right: 8px;
}
.aesirxui .me-15 {
  margin-right: 15px;
}
.aesirxui .me-16 {
  margin-right: 16px;
}
.aesirxui .me-20 {
  margin-right: 20px;
}
.aesirxui .me-24 {
  margin-right: 24px;
}
.aesirxui .me-6 {
  margin-right: 60px;
}
.aesirxui .me-7 {
  margin-right: 70px;
}
.aesirxui .me-8 {
  margin-right: 80px;
}
.aesirxui .me-10 {
  margin-right: 10px;
}
.aesirxui .me-13 {
  margin-right: 13px;
}
.aesirxui .me-14 {
  margin-right: 14px;
}
.aesirxui .me-40 {
  margin-right: 40px;
}
.aesirxui .me-18px {
  margin-right: 18px;
}
.aesirxui .me-32px {
  margin-right: 32px;
}
.aesirxui .me-9px {
  margin-right: 9px;
}
.aesirxui .me-12px {
  margin-right: 12px;
}
.aesirxui .me-19px {
  margin-right: 19px;
}
.aesirxui .me-auto {
  margin-right: auto;
}
.aesirxui .mb-0 {
  margin-bottom: 0;
}
.aesirxui .mb-1 {
  margin-bottom: 0.25rem;
}
.aesirxui .mb-2 {
  margin-bottom: 0.5rem;
}
.aesirxui .mb-3 {
  margin-bottom: 1rem;
}
.aesirxui .mb-4 {
  margin-bottom: 1.5rem;
}
.aesirxui .mb-5 {
  margin-bottom: 3rem;
}
.aesirxui .mb-sm {
  margin-bottom: 5px;
}
.aesirxui .mb-8px {
  margin-bottom: 8px;
}
.aesirxui .mb-15 {
  margin-bottom: 15px;
}
.aesirxui .mb-16 {
  margin-bottom: 16px;
}
.aesirxui .mb-20 {
  margin-bottom: 20px;
}
.aesirxui .mb-24 {
  margin-bottom: 24px;
}
.aesirxui .mb-6 {
  margin-bottom: 60px;
}
.aesirxui .mb-7 {
  margin-bottom: 70px;
}
.aesirxui .mb-8 {
  margin-bottom: 80px;
}
.aesirxui .mb-10 {
  margin-bottom: 10px;
}
.aesirxui .mb-13 {
  margin-bottom: 13px;
}
.aesirxui .mb-14 {
  margin-bottom: 14px;
}
.aesirxui .mb-40 {
  margin-bottom: 40px;
}
.aesirxui .mb-18px {
  margin-bottom: 18px;
}
.aesirxui .mb-32px {
  margin-bottom: 32px;
}
.aesirxui .mb-9px {
  margin-bottom: 9px;
}
.aesirxui .mb-12px {
  margin-bottom: 12px;
}
.aesirxui .mb-19px {
  margin-bottom: 19px;
}
.aesirxui .mb-auto {
  margin-bottom: auto;
}
.aesirxui .ms-0 {
  margin-left: 0;
}
.aesirxui .ms-1 {
  margin-left: 0.25rem;
}
.aesirxui .ms-2 {
  margin-left: 0.5rem;
}
.aesirxui .ms-3 {
  margin-left: 1rem;
}
.aesirxui .ms-4 {
  margin-left: 1.5rem;
}
.aesirxui .ms-5 {
  margin-left: 3rem;
}
.aesirxui .ms-sm {
  margin-left: 5px;
}
.aesirxui .ms-8px {
  margin-left: 8px;
}
.aesirxui .ms-15 {
  margin-left: 15px;
}
.aesirxui .ms-16 {
  margin-left: 16px;
}
.aesirxui .ms-20 {
  margin-left: 20px;
}
.aesirxui .ms-24 {
  margin-left: 24px;
}
.aesirxui .ms-6 {
  margin-left: 60px;
}
.aesirxui .ms-7 {
  margin-left: 70px;
}
.aesirxui .ms-8 {
  margin-left: 80px;
}
.aesirxui .ms-10 {
  margin-left: 10px;
}
.aesirxui .ms-13 {
  margin-left: 13px;
}
.aesirxui .ms-14 {
  margin-left: 14px;
}
.aesirxui .ms-40 {
  margin-left: 40px;
}
.aesirxui .ms-18px {
  margin-left: 18px;
}
.aesirxui .ms-32px {
  margin-left: 32px;
}
.aesirxui .ms-9px {
  margin-left: 9px;
}
.aesirxui .ms-12px {
  margin-left: 12px;
}
.aesirxui .ms-19px {
  margin-left: 19px;
}
.aesirxui .ms-auto {
  margin-left: auto;
}
.aesirxui .m-n1 {
  margin: -0.25rem;
}
.aesirxui .m-n2 {
  margin: -0.5rem;
}
.aesirxui .m-n3 {
  margin: -1rem;
}
.aesirxui .m-n4 {
  margin: -1.5rem;
}
.aesirxui .m-n5 {
  margin: -3rem;
}
.aesirxui .m-nsm {
  margin: -5px;
}
.aesirxui .m-n8px {
  margin: -8px;
}
.aesirxui .m-n15 {
  margin: -15px;
}
.aesirxui .m-n16 {
  margin: -16px;
}
.aesirxui .m-n20 {
  margin: -20px;
}
.aesirxui .m-n24 {
  margin: -24px;
}
.aesirxui .m-n6 {
  margin: -60px;
}
.aesirxui .m-n7 {
  margin: -70px;
}
.aesirxui .m-n8 {
  margin: -80px;
}
.aesirxui .m-n10 {
  margin: -10px;
}
.aesirxui .m-n13 {
  margin: -13px;
}
.aesirxui .m-n14 {
  margin: -14px;
}
.aesirxui .m-n40 {
  margin: -40px;
}
.aesirxui .m-n18px {
  margin: -18px;
}
.aesirxui .m-n32px {
  margin: -32px;
}
.aesirxui .m-n9px {
  margin: -9px;
}
.aesirxui .m-n12px {
  margin: -12px;
}
.aesirxui .m-n19px {
  margin: -19px;
}
.aesirxui .mx-n1 {
  margin-right: -0.25rem;
  margin-left: -0.25rem;
}
.aesirxui .mx-n2 {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}
.aesirxui .mx-n3 {
  margin-right: -1rem;
  margin-left: -1rem;
}
.aesirxui .mx-n4 {
  margin-right: -1.5rem;
  margin-left: -1.5rem;
}
.aesirxui .mx-n5 {
  margin-right: -3rem;
  margin-left: -3rem;
}
.aesirxui .mx-nsm {
  margin-right: -5px;
  margin-left: -5px;
}
.aesirxui .mx-n8px {
  margin-right: -8px;
  margin-left: -8px;
}
.aesirxui .mx-n15 {
  margin-right: -15px;
  margin-left: -15px;
}
.aesirxui .mx-n16 {
  margin-right: -16px;
  margin-left: -16px;
}
.aesirxui .mx-n20 {
  margin-right: -20px;
  margin-left: -20px;
}
.aesirxui .mx-n24 {
  margin-right: -24px;
  margin-left: -24px;
}
.aesirxui .mx-n6 {
  margin-right: -60px;
  margin-left: -60px;
}
.aesirxui .mx-n7 {
  margin-right: -70px;
  margin-left: -70px;
}
.aesirxui .mx-n8 {
  margin-right: -80px;
  margin-left: -80px;
}
.aesirxui .mx-n10 {
  margin-right: -10px;
  margin-left: -10px;
}
.aesirxui .mx-n13 {
  margin-right: -13px;
  margin-left: -13px;
}
.aesirxui .mx-n14 {
  margin-right: -14px;
  margin-left: -14px;
}
.aesirxui .mx-n40 {
  margin-right: -40px;
  margin-left: -40px;
}
.aesirxui .mx-n18px {
  margin-right: -18px;
  margin-left: -18px;
}
.aesirxui .mx-n32px {
  margin-right: -32px;
  margin-left: -32px;
}
.aesirxui .mx-n9px {
  margin-right: -9px;
  margin-left: -9px;
}
.aesirxui .mx-n12px {
  margin-right: -12px;
  margin-left: -12px;
}
.aesirxui .mx-n19px {
  margin-right: -19px;
  margin-left: -19px;
}
.aesirxui .my-n1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.aesirxui .my-n2 {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}
.aesirxui .my-n3 {
  margin-top: -1rem;
  margin-bottom: -1rem;
}
.aesirxui .my-n4 {
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}
.aesirxui .my-n5 {
  margin-top: -3rem;
  margin-bottom: -3rem;
}
.aesirxui .my-nsm {
  margin-top: -5px;
  margin-bottom: -5px;
}
.aesirxui .my-n8px {
  margin-top: -8px;
  margin-bottom: -8px;
}
.aesirxui .my-n15 {
  margin-top: -15px;
  margin-bottom: -15px;
}
.aesirxui .my-n16 {
  margin-top: -16px;
  margin-bottom: -16px;
}
.aesirxui .my-n20 {
  margin-top: -20px;
  margin-bottom: -20px;
}
.aesirxui .my-n24 {
  margin-top: -24px;
  margin-bottom: -24px;
}
.aesirxui .my-n6 {
  margin-top: -60px;
  margin-bottom: -60px;
}
.aesirxui .my-n7 {
  margin-top: -70px;
  margin-bottom: -70px;
}
.aesirxui .my-n8 {
  margin-top: -80px;
  margin-bottom: -80px;
}
.aesirxui .my-n10 {
  margin-top: -10px;
  margin-bottom: -10px;
}
.aesirxui .my-n13 {
  margin-top: -13px;
  margin-bottom: -13px;
}
.aesirxui .my-n14 {
  margin-top: -14px;
  margin-bottom: -14px;
}
.aesirxui .my-n40 {
  margin-top: -40px;
  margin-bottom: -40px;
}
.aesirxui .my-n18px {
  margin-top: -18px;
  margin-bottom: -18px;
}
.aesirxui .my-n32px {
  margin-top: -32px;
  margin-bottom: -32px;
}
.aesirxui .my-n9px {
  margin-top: -9px;
  margin-bottom: -9px;
}
.aesirxui .my-n12px {
  margin-top: -12px;
  margin-bottom: -12px;
}
.aesirxui .my-n19px {
  margin-top: -19px;
  margin-bottom: -19px;
}
.aesirxui .mt-n1 {
  margin-top: -0.25rem;
}
.aesirxui .mt-n2 {
  margin-top: -0.5rem;
}
.aesirxui .mt-n3 {
  margin-top: -1rem;
}
.aesirxui .mt-n4 {
  margin-top: -1.5rem;
}
.aesirxui .mt-n5 {
  margin-top: -3rem;
}
.aesirxui .mt-nsm {
  margin-top: -5px;
}
.aesirxui .mt-n8px {
  margin-top: -8px;
}
.aesirxui .mt-n15 {
  margin-top: -15px;
}
.aesirxui .mt-n16 {
  margin-top: -16px;
}
.aesirxui .mt-n20 {
  margin-top: -20px;
}
.aesirxui .mt-n24 {
  margin-top: -24px;
}
.aesirxui .mt-n6 {
  margin-top: -60px;
}
.aesirxui .mt-n7 {
  margin-top: -70px;
}
.aesirxui .mt-n8 {
  margin-top: -80px;
}
.aesirxui .mt-n10 {
  margin-top: -10px;
}
.aesirxui .mt-n13 {
  margin-top: -13px;
}
.aesirxui .mt-n14 {
  margin-top: -14px;
}
.aesirxui .mt-n40 {
  margin-top: -40px;
}
.aesirxui .mt-n18px {
  margin-top: -18px;
}
.aesirxui .mt-n32px {
  margin-top: -32px;
}
.aesirxui .mt-n9px {
  margin-top: -9px;
}
.aesirxui .mt-n12px {
  margin-top: -12px;
}
.aesirxui .mt-n19px {
  margin-top: -19px;
}
.aesirxui .me-n1 {
  margin-right: -0.25rem;
}
.aesirxui .me-n2 {
  margin-right: -0.5rem;
}
.aesirxui .me-n3 {
  margin-right: -1rem;
}
.aesirxui .me-n4 {
  margin-right: -1.5rem;
}
.aesirxui .me-n5 {
  margin-right: -3rem;
}
.aesirxui .me-nsm {
  margin-right: -5px;
}
.aesirxui .me-n8px {
  margin-right: -8px;
}
.aesirxui .me-n15 {
  margin-right: -15px;
}
.aesirxui .me-n16 {
  margin-right: -16px;
}
.aesirxui .me-n20 {
  margin-right: -20px;
}
.aesirxui .me-n24 {
  margin-right: -24px;
}
.aesirxui .me-n6 {
  margin-right: -60px;
}
.aesirxui .me-n7 {
  margin-right: -70px;
}
.aesirxui .me-n8 {
  margin-right: -80px;
}
.aesirxui .me-n10 {
  margin-right: -10px;
}
.aesirxui .me-n13 {
  margin-right: -13px;
}
.aesirxui .me-n14 {
  margin-right: -14px;
}
.aesirxui .me-n40 {
  margin-right: -40px;
}
.aesirxui .me-n18px {
  margin-right: -18px;
}
.aesirxui .me-n32px {
  margin-right: -32px;
}
.aesirxui .me-n9px {
  margin-right: -9px;
}
.aesirxui .me-n12px {
  margin-right: -12px;
}
.aesirxui .me-n19px {
  margin-right: -19px;
}
.aesirxui .mb-n1 {
  margin-bottom: -0.25rem;
}
.aesirxui .mb-n2 {
  margin-bottom: -0.5rem;
}
.aesirxui .mb-n3 {
  margin-bottom: -1rem;
}
.aesirxui .mb-n4 {
  margin-bottom: -1.5rem;
}
.aesirxui .mb-n5 {
  margin-bottom: -3rem;
}
.aesirxui .mb-nsm {
  margin-bottom: -5px;
}
.aesirxui .mb-n8px {
  margin-bottom: -8px;
}
.aesirxui .mb-n15 {
  margin-bottom: -15px;
}
.aesirxui .mb-n16 {
  margin-bottom: -16px;
}
.aesirxui .mb-n20 {
  margin-bottom: -20px;
}
.aesirxui .mb-n24 {
  margin-bottom: -24px;
}
.aesirxui .mb-n6 {
  margin-bottom: -60px;
}
.aesirxui .mb-n7 {
  margin-bottom: -70px;
}
.aesirxui .mb-n8 {
  margin-bottom: -80px;
}
.aesirxui .mb-n10 {
  margin-bottom: -10px;
}
.aesirxui .mb-n13 {
  margin-bottom: -13px;
}
.aesirxui .mb-n14 {
  margin-bottom: -14px;
}
.aesirxui .mb-n40 {
  margin-bottom: -40px;
}
.aesirxui .mb-n18px {
  margin-bottom: -18px;
}
.aesirxui .mb-n32px {
  margin-bottom: -32px;
}
.aesirxui .mb-n9px {
  margin-bottom: -9px;
}
.aesirxui .mb-n12px {
  margin-bottom: -12px;
}
.aesirxui .mb-n19px {
  margin-bottom: -19px;
}
.aesirxui .ms-n1 {
  margin-left: -0.25rem;
}
.aesirxui .ms-n2 {
  margin-left: -0.5rem;
}
.aesirxui .ms-n3 {
  margin-left: -1rem;
}
.aesirxui .ms-n4 {
  margin-left: -1.5rem;
}
.aesirxui .ms-n5 {
  margin-left: -3rem;
}
.aesirxui .ms-nsm {
  margin-left: -5px;
}
.aesirxui .ms-n8px {
  margin-left: -8px;
}
.aesirxui .ms-n15 {
  margin-left: -15px;
}
.aesirxui .ms-n16 {
  margin-left: -16px;
}
.aesirxui .ms-n20 {
  margin-left: -20px;
}
.aesirxui .ms-n24 {
  margin-left: -24px;
}
.aesirxui .ms-n6 {
  margin-left: -60px;
}
.aesirxui .ms-n7 {
  margin-left: -70px;
}
.aesirxui .ms-n8 {
  margin-left: -80px;
}
.aesirxui .ms-n10 {
  margin-left: -10px;
}
.aesirxui .ms-n13 {
  margin-left: -13px;
}
.aesirxui .ms-n14 {
  margin-left: -14px;
}
.aesirxui .ms-n40 {
  margin-left: -40px;
}
.aesirxui .ms-n18px {
  margin-left: -18px;
}
.aesirxui .ms-n32px {
  margin-left: -32px;
}
.aesirxui .ms-n9px {
  margin-left: -9px;
}
.aesirxui .ms-n12px {
  margin-left: -12px;
}
.aesirxui .ms-n19px {
  margin-left: -19px;
}
.aesirxui .p-0 {
  padding: 0;
}
.aesirxui .p-1 {
  padding: 0.25rem;
}
.aesirxui .p-2 {
  padding: 0.5rem;
}
.aesirxui .p-3 {
  padding: 1rem;
}
.aesirxui .p-4 {
  padding: 1.5rem;
}
.aesirxui .p-5 {
  padding: 3rem;
}
.aesirxui .p-sm {
  padding: 5px;
}
.aesirxui .p-8px {
  padding: 8px;
}
.aesirxui .p-15 {
  padding: 15px;
}
.aesirxui .p-16 {
  padding: 16px;
}
.aesirxui .p-20 {
  padding: 20px;
}
.aesirxui .p-24 {
  padding: 24px;
}
.aesirxui .p-6 {
  padding: 60px;
}
.aesirxui .p-7 {
  padding: 70px;
}
.aesirxui .p-8 {
  padding: 80px;
}
.aesirxui .p-10 {
  padding: 10px;
}
.aesirxui .p-13 {
  padding: 13px;
}
.aesirxui .p-14 {
  padding: 14px;
}
.aesirxui .p-40 {
  padding: 40px;
}
.aesirxui .p-18px {
  padding: 18px;
}
.aesirxui .p-32px {
  padding: 32px;
}
.aesirxui .p-9px {
  padding: 9px;
}
.aesirxui .p-12px {
  padding: 12px;
}
.aesirxui .p-19px {
  padding: 19px;
}
.aesirxui .px-0 {
  padding-right: 0;
  padding-left: 0;
}
.aesirxui .px-1 {
  padding-right: 0.25rem;
  padding-left: 0.25rem;
}
.aesirxui .px-2 {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.aesirxui .px-3 {
  padding-right: 1rem;
  padding-left: 1rem;
}
.aesirxui .px-4 {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
.aesirxui .px-5 {
  padding-right: 3rem;
  padding-left: 3rem;
}
.aesirxui .px-sm {
  padding-right: 5px;
  padding-left: 5px;
}
.aesirxui .px-8px {
  padding-right: 8px;
  padding-left: 8px;
}
.aesirxui .px-15 {
  padding-right: 15px;
  padding-left: 15px;
}
.aesirxui .px-16 {
  padding-right: 16px;
  padding-left: 16px;
}
.aesirxui .px-20 {
  padding-right: 20px;
  padding-left: 20px;
}
.aesirxui .px-24 {
  padding-right: 24px;
  padding-left: 24px;
}
.aesirxui .px-6 {
  padding-right: 60px;
  padding-left: 60px;
}
.aesirxui .px-7 {
  padding-right: 70px;
  padding-left: 70px;
}
.aesirxui .px-8 {
  padding-right: 80px;
  padding-left: 80px;
}
.aesirxui .px-10 {
  padding-right: 10px;
  padding-left: 10px;
}
.aesirxui .px-13 {
  padding-right: 13px;
  padding-left: 13px;
}
.aesirxui .px-14 {
  padding-right: 14px;
  padding-left: 14px;
}
.aesirxui .px-40 {
  padding-right: 40px;
  padding-left: 40px;
}
.aesirxui .px-18px {
  padding-right: 18px;
  padding-left: 18px;
}
.aesirxui .px-32px {
  padding-right: 32px;
  padding-left: 32px;
}
.aesirxui .px-9px {
  padding-right: 9px;
  padding-left: 9px;
}
.aesirxui .px-12px {
  padding-right: 12px;
  padding-left: 12px;
}
.aesirxui .px-19px {
  padding-right: 19px;
  padding-left: 19px;
}
.aesirxui .py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.aesirxui .py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.aesirxui .py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.aesirxui .py-3 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.aesirxui .py-4 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.aesirxui .py-5 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.aesirxui .py-sm {
  padding-top: 5px;
  padding-bottom: 5px;
}
.aesirxui .py-8px {
  padding-top: 8px;
  padding-bottom: 8px;
}
.aesirxui .py-15 {
  padding-top: 15px;
  padding-bottom: 15px;
}
.aesirxui .py-16 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.aesirxui .py-20 {
  padding-top: 20px;
  padding-bottom: 20px;
}
.aesirxui .py-24 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.aesirxui .py-6 {
  padding-top: 60px;
  padding-bottom: 60px;
}
.aesirxui .py-7 {
  padding-top: 70px;
  padding-bottom: 70px;
}
.aesirxui .py-8 {
  padding-top: 80px;
  padding-bottom: 80px;
}
.aesirxui .py-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.aesirxui .py-13 {
  padding-top: 13px;
  padding-bottom: 13px;
}
.aesirxui .py-14 {
  padding-top: 14px;
  padding-bottom: 14px;
}
.aesirxui .py-40 {
  padding-top: 40px;
  padding-bottom: 40px;
}
.aesirxui .py-18px {
  padding-top: 18px;
  padding-bottom: 18px;
}
.aesirxui .py-32px {
  padding-top: 32px;
  padding-bottom: 32px;
}
.aesirxui .py-9px {
  padding-top: 9px;
  padding-bottom: 9px;
}
.aesirxui .py-12px {
  padding-top: 12px;
  padding-bottom: 12px;
}
.aesirxui .py-19px {
  padding-top: 19px;
  padding-bottom: 19px;
}
.aesirxui .pt-0 {
  padding-top: 0;
}
.aesirxui .pt-1 {
  padding-top: 0.25rem;
}
.aesirxui .pt-2 {
  padding-top: 0.5rem;
}
.aesirxui .pt-3 {
  padding-top: 1rem;
}
.aesirxui .pt-4 {
  padding-top: 1.5rem;
}
.aesirxui .pt-5 {
  padding-top: 3rem;
}
.aesirxui .pt-sm {
  padding-top: 5px;
}
.aesirxui .pt-8px {
  padding-top: 8px;
}
.aesirxui .pt-15 {
  padding-top: 15px;
}
.aesirxui .pt-16 {
  padding-top: 16px;
}
.aesirxui .pt-20 {
  padding-top: 20px;
}
.aesirxui .pt-24 {
  padding-top: 24px;
}
.aesirxui .pt-6 {
  padding-top: 60px;
}
.aesirxui .pt-7 {
  padding-top: 70px;
}
.aesirxui .pt-8 {
  padding-top: 80px;
}
.aesirxui .pt-10 {
  padding-top: 10px;
}
.aesirxui .pt-13 {
  padding-top: 13px;
}
.aesirxui .pt-14 {
  padding-top: 14px;
}
.aesirxui .pt-40 {
  padding-top: 40px;
}
.aesirxui .pt-18px {
  padding-top: 18px;
}
.aesirxui .pt-32px {
  padding-top: 32px;
}
.aesirxui .pt-9px {
  padding-top: 9px;
}
.aesirxui .pt-12px {
  padding-top: 12px;
}
.aesirxui .pt-19px {
  padding-top: 19px;
}
.aesirxui .pe-0 {
  padding-right: 0;
}
.aesirxui .pe-1 {
  padding-right: 0.25rem;
}
.aesirxui .pe-2 {
  padding-right: 0.5rem;
}
.aesirxui .pe-3 {
  padding-right: 1rem;
}
.aesirxui .pe-4 {
  padding-right: 1.5rem;
}
.aesirxui .pe-5 {
  padding-right: 3rem;
}
.aesirxui .pe-sm {
  padding-right: 5px;
}
.aesirxui .pe-8px {
  padding-right: 8px;
}
.aesirxui .pe-15 {
  padding-right: 15px;
}
.aesirxui .pe-16 {
  padding-right: 16px;
}
.aesirxui .pe-20 {
  padding-right: 20px;
}
.aesirxui .pe-24 {
  padding-right: 24px;
}
.aesirxui .pe-6 {
  padding-right: 60px;
}
.aesirxui .pe-7 {
  padding-right: 70px;
}
.aesirxui .pe-8 {
  padding-right: 80px;
}
.aesirxui .pe-10 {
  padding-right: 10px;
}
.aesirxui .pe-13 {
  padding-right: 13px;
}
.aesirxui .pe-14 {
  padding-right: 14px;
}
.aesirxui .pe-40 {
  padding-right: 40px;
}
.aesirxui .pe-18px {
  padding-right: 18px;
}
.aesirxui .pe-32px {
  padding-right: 32px;
}
.aesirxui .pe-9px {
  padding-right: 9px;
}
.aesirxui .pe-12px {
  padding-right: 12px;
}
.aesirxui .pe-19px {
  padding-right: 19px;
}
.aesirxui .pb-0 {
  padding-bottom: 0;
}
.aesirxui .pb-1 {
  padding-bottom: 0.25rem;
}
.aesirxui .pb-2 {
  padding-bottom: 0.5rem;
}
.aesirxui .pb-3 {
  padding-bottom: 1rem;
}
.aesirxui .pb-4 {
  padding-bottom: 1.5rem;
}
.aesirxui .pb-5 {
  padding-bottom: 3rem;
}
.aesirxui .pb-sm {
  padding-bottom: 5px;
}
.aesirxui .pb-8px {
  padding-bottom: 8px;
}
.aesirxui .pb-15 {
  padding-bottom: 15px;
}
.aesirxui .pb-16 {
  padding-bottom: 16px;
}
.aesirxui .pb-20 {
  padding-bottom: 20px;
}
.aesirxui .pb-24 {
  padding-bottom: 24px;
}
.aesirxui .pb-6 {
  padding-bottom: 60px;
}
.aesirxui .pb-7 {
  padding-bottom: 70px;
}
.aesirxui .pb-8 {
  padding-bottom: 80px;
}
.aesirxui .pb-10 {
  padding-bottom: 10px;
}
.aesirxui .pb-13 {
  padding-bottom: 13px;
}
.aesirxui .pb-14 {
  padding-bottom: 14px;
}
.aesirxui .pb-40 {
  padding-bottom: 40px;
}
.aesirxui .pb-18px {
  padding-bottom: 18px;
}
.aesirxui .pb-32px {
  padding-bottom: 32px;
}
.aesirxui .pb-9px {
  padding-bottom: 9px;
}
.aesirxui .pb-12px {
  padding-bottom: 12px;
}
.aesirxui .pb-19px {
  padding-bottom: 19px;
}
.aesirxui .ps-0 {
  padding-left: 0;
}
.aesirxui .ps-1 {
  padding-left: 0.25rem;
}
.aesirxui .ps-2 {
  padding-left: 0.5rem;
}
.aesirxui .ps-3 {
  padding-left: 1rem;
}
.aesirxui .ps-4 {
  padding-left: 1.5rem;
}
.aesirxui .ps-5 {
  padding-left: 3rem;
}
.aesirxui .ps-sm {
  padding-left: 5px;
}
.aesirxui .ps-8px {
  padding-left: 8px;
}
.aesirxui .ps-15 {
  padding-left: 15px;
}
.aesirxui .ps-16 {
  padding-left: 16px;
}
.aesirxui .ps-20 {
  padding-left: 20px;
}
.aesirxui .ps-24 {
  padding-left: 24px;
}
.aesirxui .ps-6 {
  padding-left: 60px;
}
.aesirxui .ps-7 {
  padding-left: 70px;
}
.aesirxui .ps-8 {
  padding-left: 80px;
}
.aesirxui .ps-10 {
  padding-left: 10px;
}
.aesirxui .ps-13 {
  padding-left: 13px;
}
.aesirxui .ps-14 {
  padding-left: 14px;
}
.aesirxui .ps-40 {
  padding-left: 40px;
}
.aesirxui .ps-18px {
  padding-left: 18px;
}
.aesirxui .ps-32px {
  padding-left: 32px;
}
.aesirxui .ps-9px {
  padding-left: 9px;
}
.aesirxui .ps-12px {
  padding-left: 12px;
}
.aesirxui .ps-19px {
  padding-left: 19px;
}
.aesirxui .gap-0 {
  gap: 0;
}
.aesirxui .gap-1 {
  gap: 0.25rem;
}
.aesirxui .gap-2 {
  gap: 0.5rem;
}
.aesirxui .gap-3 {
  gap: 1rem;
}
.aesirxui .gap-4 {
  gap: 1.5rem;
}
.aesirxui .gap-5 {
  gap: 3rem;
}
.aesirxui .gap-sm {
  gap: 5px;
}
.aesirxui .gap-8px {
  gap: 8px;
}
.aesirxui .gap-15 {
  gap: 15px;
}
.aesirxui .gap-16 {
  gap: 16px;
}
.aesirxui .gap-20 {
  gap: 20px;
}
.aesirxui .gap-24 {
  gap: 24px;
}
.aesirxui .gap-6 {
  gap: 60px;
}
.aesirxui .gap-7 {
  gap: 70px;
}
.aesirxui .gap-8 {
  gap: 80px;
}
.aesirxui .gap-10 {
  gap: 10px;
}
.aesirxui .gap-13 {
  gap: 13px;
}
.aesirxui .gap-14 {
  gap: 14px;
}
.aesirxui .gap-40 {
  gap: 40px;
}
.aesirxui .gap-18px {
  gap: 18px;
}
.aesirxui .gap-32px {
  gap: 32px;
}
.aesirxui .gap-9px {
  gap: 9px;
}
.aesirxui .gap-12px {
  gap: 12px;
}
.aesirxui .gap-19px {
  gap: 19px;
}
.aesirxui .row-gap-0 {
  row-gap: 0;
}
.aesirxui .row-gap-1 {
  row-gap: 0.25rem;
}
.aesirxui .row-gap-2 {
  row-gap: 0.5rem;
}
.aesirxui .row-gap-3 {
  row-gap: 1rem;
}
.aesirxui .row-gap-4 {
  row-gap: 1.5rem;
}
.aesirxui .row-gap-5 {
  row-gap: 3rem;
}
.aesirxui .row-gap-sm {
  row-gap: 5px;
}
.aesirxui .row-gap-8px {
  row-gap: 8px;
}
.aesirxui .row-gap-15 {
  row-gap: 15px;
}
.aesirxui .row-gap-16 {
  row-gap: 16px;
}
.aesirxui .row-gap-20 {
  row-gap: 20px;
}
.aesirxui .row-gap-24 {
  row-gap: 24px;
}
.aesirxui .row-gap-6 {
  row-gap: 60px;
}
.aesirxui .row-gap-7 {
  row-gap: 70px;
}
.aesirxui .row-gap-8 {
  row-gap: 80px;
}
.aesirxui .row-gap-10 {
  row-gap: 10px;
}
.aesirxui .row-gap-13 {
  row-gap: 13px;
}
.aesirxui .row-gap-14 {
  row-gap: 14px;
}
.aesirxui .row-gap-40 {
  row-gap: 40px;
}
.aesirxui .row-gap-18px {
  row-gap: 18px;
}
.aesirxui .row-gap-32px {
  row-gap: 32px;
}
.aesirxui .row-gap-9px {
  row-gap: 9px;
}
.aesirxui .row-gap-12px {
  row-gap: 12px;
}
.aesirxui .row-gap-19px {
  row-gap: 19px;
}
.aesirxui .column-gap-0 {
  column-gap: 0;
}
.aesirxui .column-gap-1 {
  column-gap: 0.25rem;
}
.aesirxui .column-gap-2 {
  column-gap: 0.5rem;
}
.aesirxui .column-gap-3 {
  column-gap: 1rem;
}
.aesirxui .column-gap-4 {
  column-gap: 1.5rem;
}
.aesirxui .column-gap-5 {
  column-gap: 3rem;
}
.aesirxui .column-gap-sm {
  column-gap: 5px;
}
.aesirxui .column-gap-8px {
  column-gap: 8px;
}
.aesirxui .column-gap-15 {
  column-gap: 15px;
}
.aesirxui .column-gap-16 {
  column-gap: 16px;
}
.aesirxui .column-gap-20 {
  column-gap: 20px;
}
.aesirxui .column-gap-24 {
  column-gap: 24px;
}
.aesirxui .column-gap-6 {
  column-gap: 60px;
}
.aesirxui .column-gap-7 {
  column-gap: 70px;
}
.aesirxui .column-gap-8 {
  column-gap: 80px;
}
.aesirxui .column-gap-10 {
  column-gap: 10px;
}
.aesirxui .column-gap-13 {
  column-gap: 13px;
}
.aesirxui .column-gap-14 {
  column-gap: 14px;
}
.aesirxui .column-gap-40 {
  column-gap: 40px;
}
.aesirxui .column-gap-18px {
  column-gap: 18px;
}
.aesirxui .column-gap-32px {
  column-gap: 32px;
}
.aesirxui .column-gap-9px {
  column-gap: 9px;
}
.aesirxui .column-gap-12px {
  column-gap: 12px;
}
.aesirxui .column-gap-19px {
  column-gap: 19px;
}
.aesirxui .font-monospace {
  font-family: var(--aesirxui-font-monospace);
}
.aesirxui .fs-1 {
  font-size: calc(1.375rem + 1.5vw);
}
.aesirxui .fs-2 {
  font-size: calc(1.325rem + 0.9vw);
}
.aesirxui .fs-3 {
  font-size: calc(1.3rem + 0.6vw);
}
.aesirxui .fs-4 {
  font-size: 1.25rem;
}
.aesirxui .fs-5 {
  font-size: 1.125rem;
}
.aesirxui .fs-6 {
  font-size: 1rem;
}
.aesirxui .fs-14 {
  font-size: 0.875rem;
}
.aesirxui .fs-12 {
  font-size: 0.75rem;
}
.aesirxui .fs-24 {
  font-size: calc(1.275rem + 0.3vw);
}
.aesirxui .fs-sm {
  font-size: 0.875rem;
}
.aesirxui .fst-italic {
  font-style: italic;
}
.aesirxui .fst-normal {
  font-style: normal;
}
.aesirxui .fw-light {
  font-weight: 300;
}
.aesirxui .fw-lighter {
  font-weight: lighter;
}
.aesirxui .fw-normal {
  font-weight: 400;
}
.aesirxui .fw-bold {
  font-weight: 700;
}
.aesirxui .fw-bolder {
  font-weight: bolder;
}
.aesirxui .fw-medium {
  font-weight: 500;
}
.aesirxui .fw-semibold {
  font-weight: 600;
}
.aesirxui .lh-1 {
  line-height: 1;
}
.aesirxui .lh-sm {
  line-height: 1.25;
}
.aesirxui .lh-base {
  line-height: 1.5;
}
.aesirxui .lh-lg {
  line-height: 2;
}
.aesirxui .text-start {
  text-align: left;
}
.aesirxui .text-end {
  text-align: right;
}
.aesirxui .text-center {
  text-align: center;
}
.aesirxui .text-decoration-none {
  text-decoration: none;
}
.aesirxui .text-decoration-underline {
  text-decoration: underline;
}
.aesirxui .text-decoration-line-through {
  text-decoration: line-through;
}
.aesirxui .text-lowercase {
  text-transform: lowercase;
}
.aesirxui .text-uppercase {
  text-transform: uppercase;
}
.aesirxui .text-capitalize {
  text-transform: capitalize;
}
.aesirxui .text-wrap {
  white-space: normal;
}
.aesirxui .text-nowrap {
  white-space: nowrap;
}
.aesirxui .text-break {
  word-wrap: break-word;
  word-break: break-word;
}
.aesirxui .text-primary {
  color: #0a083b;
}
.aesirxui .text-secondary {
  color: #004d6c;
}
.aesirxui .text-success {
  color: #1ab394;
}
.aesirxui .text-info {
  color: #3b7ab5;
}
.aesirxui .text-warning {
  color: #f07e25;
}
.aesirxui .text-danger {
  color: #c8192e;
}
.aesirxui .text-light {
  color: #f6f8fa;
}
.aesirxui .text-dark {
  color: #222328;
}
.aesirxui .text-noti-error {
  color: #c8192e;
}
.aesirxui .text-noti-warn {
  color: #946300;
}
.aesirxui .text-noti-bg-error {
  color: #fee2e2;
}
.aesirxui .text-noti-bg-warn {
  color: #fff8e9;
}
.aesirxui .text-noti-bg-success {
  color: #d1fae5;
}
.aesirxui .text-custom-color {
  color: #712cf9;
}
.aesirxui .text-purple {
  color: #6a3e73;
}
.aesirxui .text-secondary-25 {
  color: #f0f3fb;
}
.aesirxui .text-secondary-50 {
  color: #1d55a9;
}
.aesirxui .text-secondary-100 {
  color: #0d588a;
}
.aesirxui .text-success-dark {
  color: #1c9678;
}
.aesirxui .text-success-darken {
  color: #0f674c;
}
.aesirxui .text-warning-50 {
  color: #fff8e9;
}
.aesirxui .text-warning-100 {
  color: #946300;
}
.aesirxui .text-warning-200 {
  color: #ffe6b2;
}
.aesirxui .text-gray-100 {
  color: #f6f8fa;
}
.aesirxui .text-gray-400 {
  color: #e3e3e3;
}
.aesirxui .text-gray-500 {
  color: #d2d2d2;
}
.aesirxui .text-gray-600 {
  color: #8e8e8e;
}
.aesirxui .text-gray-700 {
  color: #c4c4c4;
}
.aesirxui .text-gray-800 {
  color: #e9e9e9;
}
.aesirxui .text-gray-900 {
  color: #222328;
}
.aesirxui .text-gray-stroke-1 {
  color: #f3f3f3;
}
.aesirxui .text-gray-stroke-2 {
  color: #dedede;
}
.aesirxui .text-gray-light {
  color: #97979e;
}
.aesirxui .text-gray-heading {
  color: #5f5e70;
}
.aesirxui .text-blue {
  color: #0a5aff;
}
.aesirxui .text-blue-light {
  color: #edf8fd;
}
.aesirxui .text-color-blue-6 {
  color: #dce6eb;
}
.aesirxui .text-color-blue-9 {
  color: #f0f3fb;
}
.aesirxui .text-green-light {
  color: #d1fae5;
}
.aesirxui .text-telegram {
  color: #039be5;
}
.aesirxui .text-facebook {
  color: #3a559f;
}
.aesirxui .text-twitter {
  color: #26a6d1;
}
.aesirxui .text-linkedin {
  color: #007ab9;
}
.aesirxui .text-instagram {
  color: #b334af;
}
.aesirxui .text-chatgpt {
  color: #00a481;
}
.aesirxui .text-dark-blue {
  color: #3e545e;
}
.aesirxui .text-button-color {
  color: white;
}
.aesirxui .text-body-color {
  color: #0a083b;
}
.aesirxui .text-white {
  color: #fff;
}
.aesirxui .text-body {
  color: #0a083b;
}
.aesirxui .text-color {
  color: #0a083b;
}
.aesirxui .text-muted {
  color: var(--aesirxui-secondary-color);
}
.aesirxui .text-black-50 {
  color: rgba(0, 0, 0, 0.5);
}
.aesirxui .text-white-50 {
  color: rgba(255, 255, 255, 0.5);
}
.aesirxui .text-reset {
  color: inherit;
}
.aesirxui .text-black {
  color: #000;
}
.aesirxui .text-green {
  color: #1ab394;
}
.aesirxui .text-blue-0 {
  color: #0a083b;
}
.aesirxui .text-red-1 {
  color: #c60202;
}
.aesirxui .text-blue-3 {
  color: #005f89;
}
.aesirxui .text-red-2 {
  color: #ff2366;
}
.aesirxui .text-gray-menu {
  color: #c8c8db;
}
.aesirxui .text-opacity-25 {
  --aesirxui-text-opacity: 0.25;
}
.aesirxui .text-opacity-50 {
  --aesirxui-text-opacity: 0.5;
}
.aesirxui .text-opacity-75 {
  --aesirxui-text-opacity: 0.75;
}
.aesirxui .text-opacity-100 {
  --aesirxui-text-opacity: 1;
}
.aesirxui .text-primary-emphasis {
  color: var(--aesirxui-primary-text-emphasis);
}
.aesirxui .text-secondary-emphasis {
  color: var(--aesirxui-secondary-text-emphasis);
}
.aesirxui .text-success-emphasis {
  color: var(--aesirxui-success-text-emphasis);
}
.aesirxui .text-info-emphasis {
  color: var(--aesirxui-info-text-emphasis);
}
.aesirxui .text-warning-emphasis {
  color: var(--aesirxui-warning-text-emphasis);
}
.aesirxui .text-danger-emphasis {
  color: var(--aesirxui-danger-text-emphasis);
}
.aesirxui .text-light-emphasis {
  color: var(--aesirxui-light-text-emphasis);
}
.aesirxui .text-dark-emphasis {
  color: var(--aesirxui-dark-text-emphasis);
}
.aesirxui .link-opacity-10 {
  --aesirxui-link-opacity: 0.1;
}
.aesirxui .link-opacity-10-hover:hover {
  --aesirxui-link-opacity: 0.1;
}
.aesirxui .link-opacity-25 {
  --aesirxui-link-opacity: 0.25;
}
.aesirxui .link-opacity-25-hover:hover {
  --aesirxui-link-opacity: 0.25;
}
.aesirxui .link-opacity-50 {
  --aesirxui-link-opacity: 0.5;
}
.aesirxui .link-opacity-50-hover:hover {
  --aesirxui-link-opacity: 0.5;
}
.aesirxui .link-opacity-75 {
  --aesirxui-link-opacity: 0.75;
}
.aesirxui .link-opacity-75-hover:hover {
  --aesirxui-link-opacity: 0.75;
}
.aesirxui .link-opacity-100 {
  --aesirxui-link-opacity: 1;
}
.aesirxui .link-opacity-100-hover:hover {
  --aesirxui-link-opacity: 1;
}
.aesirxui .link-offset-1 {
  text-underline-offset: 0.125em;
}
.aesirxui .link-offset-1-hover:hover {
  text-underline-offset: 0.125em;
}
.aesirxui .link-offset-2 {
  text-underline-offset: 0.25em;
}
.aesirxui .link-offset-2-hover:hover {
  text-underline-offset: 0.25em;
}
.aesirxui .link-offset-3 {
  text-underline-offset: 0.375em;
}
.aesirxui .link-offset-3-hover:hover {
  text-underline-offset: 0.375em;
}
.aesirxui .link-underline-primary {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-primary-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-secondary {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-secondary-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-success {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-success-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-info {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-info-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-warning {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-warning-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-danger {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-danger-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-light {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-light-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-dark {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-dark-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-noti-error {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-noti-error-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-noti-warn {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-noti-warn-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-noti-bg-error {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-noti-bg-error-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-noti-bg-warn {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-noti-bg-warn-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-noti-bg-success {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-noti-bg-success-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-custom-color {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-custom-color-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-purple {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-purple-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-secondary-25 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-secondary-25-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-secondary-50 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-secondary-50-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-secondary-100 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-secondary-100-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-success-dark {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-success-dark-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-success-darken {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-success-darken-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-warning-50 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-warning-50-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-warning-100 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-warning-100-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-warning-200 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-warning-200-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-100 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-100-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-400 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-400-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-500 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-500-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-600 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-600-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-700 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-700-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-800 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-800-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-900 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-900-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-stroke-1 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-stroke-1-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-stroke-2 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-stroke-2-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-light {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-light-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-gray-heading {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-gray-heading-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-blue {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-blue-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-blue-light {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-blue-light-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-color-blue-6 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-color-blue-6-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-color-blue-9 {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-color-blue-9-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-green-light {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-green-light-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-telegram {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-telegram-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-facebook {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-facebook-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-twitter {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-twitter-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-linkedin {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-linkedin-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-instagram {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-instagram-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-chatgpt {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-chatgpt-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-dark-blue {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-dark-blue-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-button-color {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-button-color-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline-body-color {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-body-color-rgb), var(--aesirxui-link-underline-opacity));
}
.aesirxui .link-underline {
  --aesirxui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxui-link-color-rgb), var(--aesirxui-link-underline-opacity, 1));
}
.aesirxui .link-underline-opacity-0 {
  --aesirxui-link-underline-opacity: 0;
}
.aesirxui .link-underline-opacity-0-hover:hover {
  --aesirxui-link-underline-opacity: 0;
}
.aesirxui .link-underline-opacity-10 {
  --aesirxui-link-underline-opacity: 0.1;
}
.aesirxui .link-underline-opacity-10-hover:hover {
  --aesirxui-link-underline-opacity: 0.1;
}
.aesirxui .link-underline-opacity-25 {
  --aesirxui-link-underline-opacity: 0.25;
}
.aesirxui .link-underline-opacity-25-hover:hover {
  --aesirxui-link-underline-opacity: 0.25;
}
.aesirxui .link-underline-opacity-50 {
  --aesirxui-link-underline-opacity: 0.5;
}
.aesirxui .link-underline-opacity-50-hover:hover {
  --aesirxui-link-underline-opacity: 0.5;
}
.aesirxui .link-underline-opacity-75 {
  --aesirxui-link-underline-opacity: 0.75;
}
.aesirxui .link-underline-opacity-75-hover:hover {
  --aesirxui-link-underline-opacity: 0.75;
}
.aesirxui .link-underline-opacity-100 {
  --aesirxui-link-underline-opacity: 1;
}
.aesirxui .link-underline-opacity-100-hover:hover {
  --aesirxui-link-underline-opacity: 1;
}
.aesirxui .bg-primary {
  background-color: #0a083b;
}
.aesirxui .bg-secondary {
  background-color: #004d6c;
}
.aesirxui .bg-success {
  background-color: #1ab394;
}
.aesirxui .bg-info {
  background-color: #3b7ab5;
}
.aesirxui .bg-warning {
  background-color: #f07e25;
}
.aesirxui .bg-danger {
  background-color: #c8192e;
}
.aesirxui .bg-light {
  background-color: #f6f8fa;
}
.aesirxui .bg-dark {
  background-color: #222328;
}
.aesirxui .bg-noti-error {
  background-color: #c8192e;
}
.aesirxui .bg-noti-warn {
  background-color: #946300;
}
.aesirxui .bg-noti-bg-error {
  background-color: #fee2e2;
}
.aesirxui .bg-noti-bg-warn {
  background-color: #fff8e9;
}
.aesirxui .bg-noti-bg-success {
  background-color: #d1fae5;
}
.aesirxui .bg-custom-color {
  background-color: #712cf9;
}
.aesirxui .bg-purple {
  background-color: #6a3e73;
}
.aesirxui .bg-secondary-25 {
  background-color: #f0f3fb;
}
.aesirxui .bg-secondary-50 {
  background-color: #1d55a9;
}
.aesirxui .bg-secondary-100 {
  background-color: #0d588a;
}
.aesirxui .bg-success-dark {
  background-color: #1c9678;
}
.aesirxui .bg-success-darken {
  background-color: #0f674c;
}
.aesirxui .bg-warning-50 {
  background-color: #fff8e9;
}
.aesirxui .bg-warning-100 {
  background-color: #946300;
}
.aesirxui .bg-warning-200 {
  background-color: #ffe6b2;
}
.aesirxui .bg-gray-100 {
  background-color: #f6f8fa;
}
.aesirxui .bg-gray-400 {
  background-color: #e3e3e3;
}
.aesirxui .bg-gray-500 {
  background-color: #d2d2d2;
}
.aesirxui .bg-gray-600 {
  background-color: #8e8e8e;
}
.aesirxui .bg-gray-700 {
  background-color: #c4c4c4;
}
.aesirxui .bg-gray-800 {
  background-color: #e9e9e9;
}
.aesirxui .bg-gray-900 {
  background-color: #222328;
}
.aesirxui .bg-gray-stroke-1 {
  background-color: #f3f3f3;
}
.aesirxui .bg-gray-stroke-2 {
  background-color: #dedede;
}
.aesirxui .bg-gray-light {
  background-color: #97979e;
}
.aesirxui .bg-gray-heading {
  background-color: #5f5e70;
}
.aesirxui .bg-blue {
  background-color: #f5f8fa;
}
.aesirxui .bg-blue-light {
  background-color: #edf8fd;
}
.aesirxui .bg-color-blue-6 {
  background-color: #dce6eb;
}
.aesirxui .bg-color-blue-9 {
  background-color: #f0f3fb;
}
.aesirxui .bg-green-light {
  background-color: #d1fae5;
}
.aesirxui .bg-telegram {
  background-color: #039be5;
}
.aesirxui .bg-facebook {
  background-color: #3a559f;
}
.aesirxui .bg-twitter {
  background-color: #26a6d1;
}
.aesirxui .bg-linkedin {
  background-color: #007ab9;
}
.aesirxui .bg-instagram {
  background-color: #b334af;
}
.aesirxui .bg-chatgpt {
  background-color: #00a481;
}
.aesirxui .bg-dark-blue {
  background-color: #3e545e;
}
.aesirxui .bg-button-color {
  background-color: white;
}
.aesirxui .bg-body-color {
  background-color: #0a083b;
}
.aesirxui .bg-body {
  background-color: #f8f9fa;
}
.aesirxui .bg-white {
  background-color: #fff;
}
.aesirxui .bg-orange {
  background-color: #f78464;
}
.aesirxui .bg-green {
  background-color: #1ab394;
}
.aesirxui .bg-yellow {
  background-color: #ff9e01;
}
.aesirxui .bg-red {
  background-color: #cb222c;
}
.aesirxui .bg-blue-1 {
  background-color: #e8f1f6;
}
.aesirxui .bg-blue-2 {
  background-color: #005f89;
}
.aesirxui .bg-blue-3 {
  background-color: #222328;
}
.aesirxui .bg-blue-4 {
  background-color: #54c7ec;
}
.aesirxui .bg-blue-5 {
  background-color: #fff;
}
.aesirxui .bg-gray-2 {
  background-color: rgba(242, 242, 242, 0.7);
}
.aesirxui .bg-gray-3 {
  background-color: #e9ebee;
}
.aesirxui .bg-gray-4 {
  background-color: #ebebeb;
}
.aesirxui .bg-transparent {
  background-color: transparent;
}
.aesirxui .bg-opacity-10 {
  --aesirxui-bg-opacity: 0.1;
}
.aesirxui .bg-opacity-25 {
  --aesirxui-bg-opacity: 0.25;
}
.aesirxui .bg-opacity-50 {
  --aesirxui-bg-opacity: 0.5;
}
.aesirxui .bg-opacity-75 {
  --aesirxui-bg-opacity: 0.75;
}
.aesirxui .bg-opacity-100 {
  --aesirxui-bg-opacity: 1;
}
.aesirxui .bg-primary-subtle {
  background-color: var(--aesirxui-primary-bg-subtle);
}
.aesirxui .bg-secondary-subtle {
  background-color: var(--aesirxui-secondary-bg-subtle);
}
.aesirxui .bg-success-subtle {
  background-color: var(--aesirxui-success-bg-subtle);
}
.aesirxui .bg-info-subtle {
  background-color: var(--aesirxui-info-bg-subtle);
}
.aesirxui .bg-warning-subtle {
  background-color: var(--aesirxui-warning-bg-subtle);
}
.aesirxui .bg-danger-subtle {
  background-color: var(--aesirxui-danger-bg-subtle);
}
.aesirxui .bg-light-subtle {
  background-color: var(--aesirxui-light-bg-subtle);
}
.aesirxui .bg-dark-subtle {
  background-color: var(--aesirxui-dark-bg-subtle);
}
.aesirxui .bg-gradient {
  background-image: var(--aesirxui-gradient);
}
.aesirxui .user-select-all {
  user-select: all;
}
.aesirxui .user-select-auto {
  user-select: auto;
}
.aesirxui .user-select-none {
  user-select: none;
}
.aesirxui .pe-none {
  pointer-events: none;
}
.aesirxui .pe-auto {
  pointer-events: auto;
}
.aesirxui .rounded {
  border-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-0 {
  border-radius: 0;
}
.aesirxui .rounded-1 {
  border-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .rounded-2 {
  border-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-3 {
  border-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .rounded-4 {
  border-radius: var(--aesirxui-border-radius-xl);
}
.aesirxui .rounded-5 {
  border-radius: var(--aesirxui-border-radius-xxl);
}
.aesirxui .rounded-6 {
  border-radius: 6px;
}
.aesirxui .rounded-circle {
  border-radius: 50%;
}
.aesirxui .rounded-pill {
  border-radius: var(--aesirxui-border-radius-pill);
}
.aesirxui .rounded-top {
  border-top-left-radius: var(--aesirxui-border-radius);
  border-top-right-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-top-0 {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.aesirxui .rounded-top-1 {
  border-top-left-radius: var(--aesirxui-border-radius-sm);
  border-top-right-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .rounded-top-2 {
  border-top-left-radius: var(--aesirxui-border-radius);
  border-top-right-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-top-3 {
  border-top-left-radius: var(--aesirxui-border-radius-lg);
  border-top-right-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .rounded-top-4 {
  border-top-left-radius: var(--aesirxui-border-radius-xl);
  border-top-right-radius: var(--aesirxui-border-radius-xl);
}
.aesirxui .rounded-top-5 {
  border-top-left-radius: var(--aesirxui-border-radius-xxl);
  border-top-right-radius: var(--aesirxui-border-radius-xxl);
}
.aesirxui .rounded-top-circle {
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
}
.aesirxui .rounded-top-pill {
  border-top-left-radius: var(--aesirxui-border-radius-pill);
  border-top-right-radius: var(--aesirxui-border-radius-pill);
}
.aesirxui .rounded-end {
  border-top-right-radius: var(--aesirxui-border-radius);
  border-bottom-right-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-end-0 {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxui .rounded-end-1 {
  border-top-right-radius: var(--aesirxui-border-radius-sm);
  border-bottom-right-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .rounded-end-2 {
  border-top-right-radius: var(--aesirxui-border-radius);
  border-bottom-right-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-end-3 {
  border-top-right-radius: var(--aesirxui-border-radius-lg);
  border-bottom-right-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .rounded-end-4 {
  border-top-right-radius: var(--aesirxui-border-radius-xl);
  border-bottom-right-radius: var(--aesirxui-border-radius-xl);
}
.aesirxui .rounded-end-5 {
  border-top-right-radius: var(--aesirxui-border-radius-xxl);
  border-bottom-right-radius: var(--aesirxui-border-radius-xxl);
}
.aesirxui .rounded-end-circle {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
}
.aesirxui .rounded-end-pill {
  border-top-right-radius: var(--aesirxui-border-radius-pill);
  border-bottom-right-radius: var(--aesirxui-border-radius-pill);
}
.aesirxui .rounded-bottom {
  border-bottom-right-radius: var(--aesirxui-border-radius);
  border-bottom-left-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-bottom-0 {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxui .rounded-bottom-1 {
  border-bottom-right-radius: var(--aesirxui-border-radius-sm);
  border-bottom-left-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .rounded-bottom-2 {
  border-bottom-right-radius: var(--aesirxui-border-radius);
  border-bottom-left-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-bottom-3 {
  border-bottom-right-radius: var(--aesirxui-border-radius-lg);
  border-bottom-left-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .rounded-bottom-4 {
  border-bottom-right-radius: var(--aesirxui-border-radius-xl);
  border-bottom-left-radius: var(--aesirxui-border-radius-xl);
}
.aesirxui .rounded-bottom-5 {
  border-bottom-right-radius: var(--aesirxui-border-radius-xxl);
  border-bottom-left-radius: var(--aesirxui-border-radius-xxl);
}
.aesirxui .rounded-bottom-circle {
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
}
.aesirxui .rounded-bottom-pill {
  border-bottom-right-radius: var(--aesirxui-border-radius-pill);
  border-bottom-left-radius: var(--aesirxui-border-radius-pill);
}
.aesirxui .rounded-start {
  border-bottom-left-radius: var(--aesirxui-border-radius);
  border-top-left-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-start-0 {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.aesirxui .rounded-start-1 {
  border-bottom-left-radius: var(--aesirxui-border-radius-sm);
  border-top-left-radius: var(--aesirxui-border-radius-sm);
}
.aesirxui .rounded-start-2 {
  border-bottom-left-radius: var(--aesirxui-border-radius);
  border-top-left-radius: var(--aesirxui-border-radius);
}
.aesirxui .rounded-start-3 {
  border-bottom-left-radius: var(--aesirxui-border-radius-lg);
  border-top-left-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .rounded-start-4 {
  border-bottom-left-radius: var(--aesirxui-border-radius-xl);
  border-top-left-radius: var(--aesirxui-border-radius-xl);
}
.aesirxui .rounded-start-5 {
  border-bottom-left-radius: var(--aesirxui-border-radius-xxl);
  border-top-left-radius: var(--aesirxui-border-radius-xxl);
}
.aesirxui .rounded-start-circle {
  border-bottom-left-radius: 50%;
  border-top-left-radius: 50%;
}
.aesirxui .rounded-start-pill {
  border-bottom-left-radius: var(--aesirxui-border-radius-pill);
  border-top-left-radius: var(--aesirxui-border-radius-pill);
}
.aesirxui .visible {
  visibility: visible;
}
.aesirxui .invisible {
  visibility: hidden;
}
.aesirxui .z-n1 {
  z-index: -1;
}
.aesirxui .z-0 {
  z-index: 0;
}
.aesirxui .z-1 {
  z-index: 1;
}
.aesirxui .z-2 {
  z-index: 2;
}
.aesirxui .z-3 {
  z-index: 3;
}
.aesirxui .cursor-none {
  cursor: none;
}
.aesirxui .cursor-auto {
  cursor: auto;
}
.aesirxui .cursor-pointer {
  cursor: pointer;
}
.aesirxui .zindex-n1 {
  z-index: -1;
}
.aesirxui .zindex-0 {
  z-index: 0;
}
.aesirxui .zindex-1 {
  z-index: 1;
}
.aesirxui .zindex-2 {
  z-index: 2;
}
.aesirxui .zindex-3 {
  z-index: 3;
}
.aesirxui .zindex-5 {
  z-index: 5;
}
.aesirxui .minh-auto {
  z-index: auto;
}
.aesirxui .minh-100 {
  z-index: 100%;
}
.aesirxui .minh-80 {
  z-index: 80%;
}
.aesirxui .wb-all {
  word-break: break-all;
}
.aesirxui .rounded-top-start {
  border-top-left-radius: 0.25rem;
}
.aesirxui .rounded-top-start-0 {
  border-top-left-radius: 0;
}
.aesirxui .rounded-top-start-1 {
  border-top-left-radius: 5px;
}
.aesirxui .rounded-top-start-2 {
  border-top-left-radius: 0.25rem;
}
.aesirxui .rounded-top-start-3 {
  border-top-left-radius: 10px;
}
.aesirxui .rounded-top-start-6 {
  border-top-left-radius: 6px;
}
.aesirxui .rounded-top-start-circle {
  border-top-left-radius: 50%;
}
.aesirxui .rounded-top-start-pill {
  border-top-left-radius: 50rem;
}
.aesirxui .rounded-top-end {
  border-top-right-radius: 0.25rem;
}
.aesirxui .rounded-top-end-0 {
  border-top-right-radius: 0;
}
.aesirxui .rounded-top-end-1 {
  border-top-right-radius: 5px;
}
.aesirxui .rounded-top-end-2 {
  border-top-right-radius: 0.25rem;
}
.aesirxui .rounded-top-end-3 {
  border-top-right-radius: 10px;
}
.aesirxui .rounded-top-end-6 {
  border-top-right-radius: 6px;
}
.aesirxui .rounded-top-end-circle {
  border-top-right-radius: 50%;
}
.aesirxui .rounded-top-end-pill {
  border-top-right-radius: 50rem;
}
.aesirxui .rounded-bottom-start {
  border-bottom-left-radius: 0.25rem;
}
.aesirxui .rounded-bottom-start-0 {
  border-bottom-left-radius: 0;
}
.aesirxui .rounded-bottom-start-1 {
  border-bottom-left-radius: 5px;
}
.aesirxui .rounded-bottom-start-2 {
  border-bottom-left-radius: 0.25rem;
}
.aesirxui .rounded-bottom-start-3 {
  border-bottom-left-radius: 10px;
}
.aesirxui .rounded-bottom-start-6 {
  border-bottom-left-radius: 6px;
}
.aesirxui .rounded-bottom-start-circle {
  border-bottom-left-radius: 50%;
}
.aesirxui .rounded-bottom-start-pill {
  border-bottom-left-radius: 50rem;
}
.aesirxui .rounded-bottom-end {
  border-bottom-right-radius: 0.25rem;
}
.aesirxui .rounded-bottom-end-0 {
  border-bottom-right-radius: 0;
}
.aesirxui .rounded-bottom-end-1 {
  border-bottom-right-radius: 5px;
}
.aesirxui .rounded-bottom-end-2 {
  border-bottom-right-radius: 0.25rem;
}
.aesirxui .rounded-bottom-end-3 {
  border-bottom-right-radius: 10px;
}
.aesirxui .rounded-bottom-end-6 {
  border-bottom-right-radius: 6px;
}
.aesirxui .rounded-bottom-end-circle {
  border-bottom-right-radius: 50%;
}
.aesirxui .rounded-bottom-end-pill {
  border-bottom-right-radius: 50rem;
}
@media (min-width: 576px) {
  .aesirxui .float-sm-start {
    float: left;
  }
  .aesirxui .float-sm-end {
    float: right;
  }
  .aesirxui .float-sm-none {
    float: none;
  }
  .aesirxui .d-sm-inline {
    display: inline;
  }
  .aesirxui .d-sm-inline-block {
    display: inline-block;
  }
  .aesirxui .d-sm-block {
    display: block;
  }
  .aesirxui .d-sm-grid {
    display: grid;
  }
  .aesirxui .d-sm-inline-grid {
    display: inline-grid;
  }
  .aesirxui .d-sm-table {
    display: table;
  }
  .aesirxui .d-sm-table-row {
    display: table-row;
  }
  .aesirxui .d-sm-table-cell {
    display: table-cell;
  }
  .aesirxui .d-sm-flex {
    display: flex;
  }
  .aesirxui .d-sm-inline-flex {
    display: inline-flex;
  }
  .aesirxui .d-sm-none {
    display: none;
  }
  .aesirxui .w-sm-25 {
    width: 25%;
  }
  .aesirxui .w-sm-20 {
    width: 20%;
  }
  .aesirxui .w-sm-40 {
    width: 40%;
  }
  .aesirxui .w-sm-50 {
    width: 50%;
  }
  .aesirxui .w-sm-75 {
    width: 75%;
  }
  .aesirxui .w-sm-100 {
    width: 100%;
  }
  .aesirxui .w-sm-fit {
    width: fit-content;
  }
  .aesirxui .w-sm-max {
    width: max-content;
  }
  .aesirxui .w-sm-auto {
    width: auto;
  }
  .aesirxui .w-sm-150px {
    width: 150px;
  }
  .aesirxui .w-sm-40px {
    width: 40px;
  }
  .aesirxui .w-sm-145px {
    width: 145px;
  }
  .aesirxui .flex-sm-fill {
    flex: 1 1 auto;
  }
  .aesirxui .flex-sm-1 {
    flex: 1;
  }
  .aesirxui .flex-sm-row {
    flex-direction: row;
  }
  .aesirxui .flex-sm-column {
    flex-direction: column;
  }
  .aesirxui .flex-sm-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxui .flex-sm-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxui .flex-sm-grow-0 {
    flex-grow: 0;
  }
  .aesirxui .flex-sm-grow-1 {
    flex-grow: 1;
  }
  .aesirxui .flex-sm-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxui .flex-sm-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxui .flex-sm-wrap {
    flex-wrap: wrap;
  }
  .aesirxui .flex-sm-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxui .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxui .justify-content-sm-start {
    justify-content: flex-start;
  }
  .aesirxui .justify-content-sm-end {
    justify-content: flex-end;
  }
  .aesirxui .justify-content-sm-center {
    justify-content: center;
  }
  .aesirxui .justify-content-sm-between {
    justify-content: space-between;
  }
  .aesirxui .justify-content-sm-around {
    justify-content: space-around;
  }
  .aesirxui .justify-content-sm-evenly {
    justify-content: space-evenly;
  }
  .aesirxui .align-items-sm-start {
    align-items: flex-start;
  }
  .aesirxui .align-items-sm-end {
    align-items: flex-end;
  }
  .aesirxui .align-items-sm-center {
    align-items: center;
  }
  .aesirxui .align-items-sm-baseline {
    align-items: baseline;
  }
  .aesirxui .align-items-sm-stretch {
    align-items: stretch;
  }
  .aesirxui .align-content-sm-start {
    align-content: flex-start;
  }
  .aesirxui .align-content-sm-end {
    align-content: flex-end;
  }
  .aesirxui .align-content-sm-center {
    align-content: center;
  }
  .aesirxui .align-content-sm-between {
    align-content: space-between;
  }
  .aesirxui .align-content-sm-around {
    align-content: space-around;
  }
  .aesirxui .align-content-sm-stretch {
    align-content: stretch;
  }
  .aesirxui .align-self-sm-auto {
    align-self: auto;
  }
  .aesirxui .align-self-sm-start {
    align-self: flex-start;
  }
  .aesirxui .align-self-sm-end {
    align-self: flex-end;
  }
  .aesirxui .align-self-sm-center {
    align-self: center;
  }
  .aesirxui .align-self-sm-baseline {
    align-self: baseline;
  }
  .aesirxui .align-self-sm-stretch {
    align-self: stretch;
  }
  .aesirxui .order-sm-first {
    order: -1;
  }
  .aesirxui .order-sm-0 {
    order: 0;
  }
  .aesirxui .order-sm-1 {
    order: 1;
  }
  .aesirxui .order-sm-2 {
    order: 2;
  }
  .aesirxui .order-sm-3 {
    order: 3;
  }
  .aesirxui .order-sm-4 {
    order: 4;
  }
  .aesirxui .order-sm-5 {
    order: 5;
  }
  .aesirxui .order-sm-last {
    order: 6;
  }
  .aesirxui .m-sm-0 {
    margin: 0;
  }
  .aesirxui .m-sm-1 {
    margin: 0.25rem;
  }
  .aesirxui .m-sm-2 {
    margin: 0.5rem;
  }
  .aesirxui .m-sm-3 {
    margin: 1rem;
  }
  .aesirxui .m-sm-4 {
    margin: 1.5rem;
  }
  .aesirxui .m-sm-5 {
    margin: 3rem;
  }
  .aesirxui .m-sm-sm {
    margin: 5px;
  }
  .aesirxui .m-sm-8px {
    margin: 8px;
  }
  .aesirxui .m-sm-15 {
    margin: 15px;
  }
  .aesirxui .m-sm-16 {
    margin: 16px;
  }
  .aesirxui .m-sm-20 {
    margin: 20px;
  }
  .aesirxui .m-sm-24 {
    margin: 24px;
  }
  .aesirxui .m-sm-6 {
    margin: 60px;
  }
  .aesirxui .m-sm-7 {
    margin: 70px;
  }
  .aesirxui .m-sm-8 {
    margin: 80px;
  }
  .aesirxui .m-sm-10 {
    margin: 10px;
  }
  .aesirxui .m-sm-13 {
    margin: 13px;
  }
  .aesirxui .m-sm-14 {
    margin: 14px;
  }
  .aesirxui .m-sm-40 {
    margin: 40px;
  }
  .aesirxui .m-sm-18px {
    margin: 18px;
  }
  .aesirxui .m-sm-32px {
    margin: 32px;
  }
  .aesirxui .m-sm-9px {
    margin: 9px;
  }
  .aesirxui .m-sm-12px {
    margin: 12px;
  }
  .aesirxui .m-sm-19px {
    margin: 19px;
  }
  .aesirxui .m-sm-auto {
    margin: auto;
  }
  .aesirxui .mx-sm-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxui .mx-sm-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxui .mx-sm-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxui .mx-sm-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxui .mx-sm-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxui .mx-sm-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxui .mx-sm-sm {
    margin-right: 5px;
    margin-left: 5px;
  }
  .aesirxui .mx-sm-8px {
    margin-right: 8px;
    margin-left: 8px;
  }
  .aesirxui .mx-sm-15 {
    margin-right: 15px;
    margin-left: 15px;
  }
  .aesirxui .mx-sm-16 {
    margin-right: 16px;
    margin-left: 16px;
  }
  .aesirxui .mx-sm-20 {
    margin-right: 20px;
    margin-left: 20px;
  }
  .aesirxui .mx-sm-24 {
    margin-right: 24px;
    margin-left: 24px;
  }
  .aesirxui .mx-sm-6 {
    margin-right: 60px;
    margin-left: 60px;
  }
  .aesirxui .mx-sm-7 {
    margin-right: 70px;
    margin-left: 70px;
  }
  .aesirxui .mx-sm-8 {
    margin-right: 80px;
    margin-left: 80px;
  }
  .aesirxui .mx-sm-10 {
    margin-right: 10px;
    margin-left: 10px;
  }
  .aesirxui .mx-sm-13 {
    margin-right: 13px;
    margin-left: 13px;
  }
  .aesirxui .mx-sm-14 {
    margin-right: 14px;
    margin-left: 14px;
  }
  .aesirxui .mx-sm-40 {
    margin-right: 40px;
    margin-left: 40px;
  }
  .aesirxui .mx-sm-18px {
    margin-right: 18px;
    margin-left: 18px;
  }
  .aesirxui .mx-sm-32px {
    margin-right: 32px;
    margin-left: 32px;
  }
  .aesirxui .mx-sm-9px {
    margin-right: 9px;
    margin-left: 9px;
  }
  .aesirxui .mx-sm-12px {
    margin-right: 12px;
    margin-left: 12px;
  }
  .aesirxui .mx-sm-19px {
    margin-right: 19px;
    margin-left: 19px;
  }
  .aesirxui .mx-sm-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxui .my-sm-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxui .my-sm-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxui .my-sm-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxui .my-sm-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxui .my-sm-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxui .my-sm-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxui .my-sm-sm {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .aesirxui .my-sm-8px {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .aesirxui .my-sm-15 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .aesirxui .my-sm-16 {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .aesirxui .my-sm-20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .aesirxui .my-sm-24 {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .aesirxui .my-sm-6 {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .aesirxui .my-sm-7 {
    margin-top: 70px;
    margin-bottom: 70px;
  }
  .aesirxui .my-sm-8 {
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .aesirxui .my-sm-10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .aesirxui .my-sm-13 {
    margin-top: 13px;
    margin-bottom: 13px;
  }
  .aesirxui .my-sm-14 {
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .aesirxui .my-sm-40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .aesirxui .my-sm-18px {
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .aesirxui .my-sm-32px {
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .aesirxui .my-sm-9px {
    margin-top: 9px;
    margin-bottom: 9px;
  }
  .aesirxui .my-sm-12px {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .aesirxui .my-sm-19px {
    margin-top: 19px;
    margin-bottom: 19px;
  }
  .aesirxui .my-sm-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxui .mt-sm-0 {
    margin-top: 0;
  }
  .aesirxui .mt-sm-1 {
    margin-top: 0.25rem;
  }
  .aesirxui .mt-sm-2 {
    margin-top: 0.5rem;
  }
  .aesirxui .mt-sm-3 {
    margin-top: 1rem;
  }
  .aesirxui .mt-sm-4 {
    margin-top: 1.5rem;
  }
  .aesirxui .mt-sm-5 {
    margin-top: 3rem;
  }
  .aesirxui .mt-sm-sm {
    margin-top: 5px;
  }
  .aesirxui .mt-sm-8px {
    margin-top: 8px;
  }
  .aesirxui .mt-sm-15 {
    margin-top: 15px;
  }
  .aesirxui .mt-sm-16 {
    margin-top: 16px;
  }
  .aesirxui .mt-sm-20 {
    margin-top: 20px;
  }
  .aesirxui .mt-sm-24 {
    margin-top: 24px;
  }
  .aesirxui .mt-sm-6 {
    margin-top: 60px;
  }
  .aesirxui .mt-sm-7 {
    margin-top: 70px;
  }
  .aesirxui .mt-sm-8 {
    margin-top: 80px;
  }
  .aesirxui .mt-sm-10 {
    margin-top: 10px;
  }
  .aesirxui .mt-sm-13 {
    margin-top: 13px;
  }
  .aesirxui .mt-sm-14 {
    margin-top: 14px;
  }
  .aesirxui .mt-sm-40 {
    margin-top: 40px;
  }
  .aesirxui .mt-sm-18px {
    margin-top: 18px;
  }
  .aesirxui .mt-sm-32px {
    margin-top: 32px;
  }
  .aesirxui .mt-sm-9px {
    margin-top: 9px;
  }
  .aesirxui .mt-sm-12px {
    margin-top: 12px;
  }
  .aesirxui .mt-sm-19px {
    margin-top: 19px;
  }
  .aesirxui .mt-sm-auto {
    margin-top: auto;
  }
  .aesirxui .me-sm-0 {
    margin-right: 0;
  }
  .aesirxui .me-sm-1 {
    margin-right: 0.25rem;
  }
  .aesirxui .me-sm-2 {
    margin-right: 0.5rem;
  }
  .aesirxui .me-sm-3 {
    margin-right: 1rem;
  }
  .aesirxui .me-sm-4 {
    margin-right: 1.5rem;
  }
  .aesirxui .me-sm-5 {
    margin-right: 3rem;
  }
  .aesirxui .me-sm-sm {
    margin-right: 5px;
  }
  .aesirxui .me-sm-8px {
    margin-right: 8px;
  }
  .aesirxui .me-sm-15 {
    margin-right: 15px;
  }
  .aesirxui .me-sm-16 {
    margin-right: 16px;
  }
  .aesirxui .me-sm-20 {
    margin-right: 20px;
  }
  .aesirxui .me-sm-24 {
    margin-right: 24px;
  }
  .aesirxui .me-sm-6 {
    margin-right: 60px;
  }
  .aesirxui .me-sm-7 {
    margin-right: 70px;
  }
  .aesirxui .me-sm-8 {
    margin-right: 80px;
  }
  .aesirxui .me-sm-10 {
    margin-right: 10px;
  }
  .aesirxui .me-sm-13 {
    margin-right: 13px;
  }
  .aesirxui .me-sm-14 {
    margin-right: 14px;
  }
  .aesirxui .me-sm-40 {
    margin-right: 40px;
  }
  .aesirxui .me-sm-18px {
    margin-right: 18px;
  }
  .aesirxui .me-sm-32px {
    margin-right: 32px;
  }
  .aesirxui .me-sm-9px {
    margin-right: 9px;
  }
  .aesirxui .me-sm-12px {
    margin-right: 12px;
  }
  .aesirxui .me-sm-19px {
    margin-right: 19px;
  }
  .aesirxui .me-sm-auto {
    margin-right: auto;
  }
  .aesirxui .mb-sm-0 {
    margin-bottom: 0;
  }
  .aesirxui .mb-sm-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxui .mb-sm-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxui .mb-sm-3 {
    margin-bottom: 1rem;
  }
  .aesirxui .mb-sm-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxui .mb-sm-5 {
    margin-bottom: 3rem;
  }
  .aesirxui .mb-sm-sm {
    margin-bottom: 5px;
  }
  .aesirxui .mb-sm-8px {
    margin-bottom: 8px;
  }
  .aesirxui .mb-sm-15 {
    margin-bottom: 15px;
  }
  .aesirxui .mb-sm-16 {
    margin-bottom: 16px;
  }
  .aesirxui .mb-sm-20 {
    margin-bottom: 20px;
  }
  .aesirxui .mb-sm-24 {
    margin-bottom: 24px;
  }
  .aesirxui .mb-sm-6 {
    margin-bottom: 60px;
  }
  .aesirxui .mb-sm-7 {
    margin-bottom: 70px;
  }
  .aesirxui .mb-sm-8 {
    margin-bottom: 80px;
  }
  .aesirxui .mb-sm-10 {
    margin-bottom: 10px;
  }
  .aesirxui .mb-sm-13 {
    margin-bottom: 13px;
  }
  .aesirxui .mb-sm-14 {
    margin-bottom: 14px;
  }
  .aesirxui .mb-sm-40 {
    margin-bottom: 40px;
  }
  .aesirxui .mb-sm-18px {
    margin-bottom: 18px;
  }
  .aesirxui .mb-sm-32px {
    margin-bottom: 32px;
  }
  .aesirxui .mb-sm-9px {
    margin-bottom: 9px;
  }
  .aesirxui .mb-sm-12px {
    margin-bottom: 12px;
  }
  .aesirxui .mb-sm-19px {
    margin-bottom: 19px;
  }
  .aesirxui .mb-sm-auto {
    margin-bottom: auto;
  }
  .aesirxui .ms-sm-0 {
    margin-left: 0;
  }
  .aesirxui .ms-sm-1 {
    margin-left: 0.25rem;
  }
  .aesirxui .ms-sm-2 {
    margin-left: 0.5rem;
  }
  .aesirxui .ms-sm-3 {
    margin-left: 1rem;
  }
  .aesirxui .ms-sm-4 {
    margin-left: 1.5rem;
  }
  .aesirxui .ms-sm-5 {
    margin-left: 3rem;
  }
  .aesirxui .ms-sm-sm {
    margin-left: 5px;
  }
  .aesirxui .ms-sm-8px {
    margin-left: 8px;
  }
  .aesirxui .ms-sm-15 {
    margin-left: 15px;
  }
  .aesirxui .ms-sm-16 {
    margin-left: 16px;
  }
  .aesirxui .ms-sm-20 {
    margin-left: 20px;
  }
  .aesirxui .ms-sm-24 {
    margin-left: 24px;
  }
  .aesirxui .ms-sm-6 {
    margin-left: 60px;
  }
  .aesirxui .ms-sm-7 {
    margin-left: 70px;
  }
  .aesirxui .ms-sm-8 {
    margin-left: 80px;
  }
  .aesirxui .ms-sm-10 {
    margin-left: 10px;
  }
  .aesirxui .ms-sm-13 {
    margin-left: 13px;
  }
  .aesirxui .ms-sm-14 {
    margin-left: 14px;
  }
  .aesirxui .ms-sm-40 {
    margin-left: 40px;
  }
  .aesirxui .ms-sm-18px {
    margin-left: 18px;
  }
  .aesirxui .ms-sm-32px {
    margin-left: 32px;
  }
  .aesirxui .ms-sm-9px {
    margin-left: 9px;
  }
  .aesirxui .ms-sm-12px {
    margin-left: 12px;
  }
  .aesirxui .ms-sm-19px {
    margin-left: 19px;
  }
  .aesirxui .ms-sm-auto {
    margin-left: auto;
  }
  .aesirxui .m-sm-n1 {
    margin: -0.25rem;
  }
  .aesirxui .m-sm-n2 {
    margin: -0.5rem;
  }
  .aesirxui .m-sm-n3 {
    margin: -1rem;
  }
  .aesirxui .m-sm-n4 {
    margin: -1.5rem;
  }
  .aesirxui .m-sm-n5 {
    margin: -3rem;
  }
  .aesirxui .m-sm-nsm {
    margin: -5px;
  }
  .aesirxui .m-sm-n8px {
    margin: -8px;
  }
  .aesirxui .m-sm-n15 {
    margin: -15px;
  }
  .aesirxui .m-sm-n16 {
    margin: -16px;
  }
  .aesirxui .m-sm-n20 {
    margin: -20px;
  }
  .aesirxui .m-sm-n24 {
    margin: -24px;
  }
  .aesirxui .m-sm-n6 {
    margin: -60px;
  }
  .aesirxui .m-sm-n7 {
    margin: -70px;
  }
  .aesirxui .m-sm-n8 {
    margin: -80px;
  }
  .aesirxui .m-sm-n10 {
    margin: -10px;
  }
  .aesirxui .m-sm-n13 {
    margin: -13px;
  }
  .aesirxui .m-sm-n14 {
    margin: -14px;
  }
  .aesirxui .m-sm-n40 {
    margin: -40px;
  }
  .aesirxui .m-sm-n18px {
    margin: -18px;
  }
  .aesirxui .m-sm-n32px {
    margin: -32px;
  }
  .aesirxui .m-sm-n9px {
    margin: -9px;
  }
  .aesirxui .m-sm-n12px {
    margin: -12px;
  }
  .aesirxui .m-sm-n19px {
    margin: -19px;
  }
  .aesirxui .mx-sm-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxui .mx-sm-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxui .mx-sm-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxui .mx-sm-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxui .mx-sm-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxui .mx-sm-nsm {
    margin-right: -5px;
    margin-left: -5px;
  }
  .aesirxui .mx-sm-n8px {
    margin-right: -8px;
    margin-left: -8px;
  }
  .aesirxui .mx-sm-n15 {
    margin-right: -15px;
    margin-left: -15px;
  }
  .aesirxui .mx-sm-n16 {
    margin-right: -16px;
    margin-left: -16px;
  }
  .aesirxui .mx-sm-n20 {
    margin-right: -20px;
    margin-left: -20px;
  }
  .aesirxui .mx-sm-n24 {
    margin-right: -24px;
    margin-left: -24px;
  }
  .aesirxui .mx-sm-n6 {
    margin-right: -60px;
    margin-left: -60px;
  }
  .aesirxui .mx-sm-n7 {
    margin-right: -70px;
    margin-left: -70px;
  }
  .aesirxui .mx-sm-n8 {
    margin-right: -80px;
    margin-left: -80px;
  }
  .aesirxui .mx-sm-n10 {
    margin-right: -10px;
    margin-left: -10px;
  }
  .aesirxui .mx-sm-n13 {
    margin-right: -13px;
    margin-left: -13px;
  }
  .aesirxui .mx-sm-n14 {
    margin-right: -14px;
    margin-left: -14px;
  }
  .aesirxui .mx-sm-n40 {
    margin-right: -40px;
    margin-left: -40px;
  }
  .aesirxui .mx-sm-n18px {
    margin-right: -18px;
    margin-left: -18px;
  }
  .aesirxui .mx-sm-n32px {
    margin-right: -32px;
    margin-left: -32px;
  }
  .aesirxui .mx-sm-n9px {
    margin-right: -9px;
    margin-left: -9px;
  }
  .aesirxui .mx-sm-n12px {
    margin-right: -12px;
    margin-left: -12px;
  }
  .aesirxui .mx-sm-n19px {
    margin-right: -19px;
    margin-left: -19px;
  }
  .aesirxui .my-sm-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxui .my-sm-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxui .my-sm-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxui .my-sm-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxui .my-sm-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxui .my-sm-nsm {
    margin-top: -5px;
    margin-bottom: -5px;
  }
  .aesirxui .my-sm-n8px {
    margin-top: -8px;
    margin-bottom: -8px;
  }
  .aesirxui .my-sm-n15 {
    margin-top: -15px;
    margin-bottom: -15px;
  }
  .aesirxui .my-sm-n16 {
    margin-top: -16px;
    margin-bottom: -16px;
  }
  .aesirxui .my-sm-n20 {
    margin-top: -20px;
    margin-bottom: -20px;
  }
  .aesirxui .my-sm-n24 {
    margin-top: -24px;
    margin-bottom: -24px;
  }
  .aesirxui .my-sm-n6 {
    margin-top: -60px;
    margin-bottom: -60px;
  }
  .aesirxui .my-sm-n7 {
    margin-top: -70px;
    margin-bottom: -70px;
  }
  .aesirxui .my-sm-n8 {
    margin-top: -80px;
    margin-bottom: -80px;
  }
  .aesirxui .my-sm-n10 {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .aesirxui .my-sm-n13 {
    margin-top: -13px;
    margin-bottom: -13px;
  }
  .aesirxui .my-sm-n14 {
    margin-top: -14px;
    margin-bottom: -14px;
  }
  .aesirxui .my-sm-n40 {
    margin-top: -40px;
    margin-bottom: -40px;
  }
  .aesirxui .my-sm-n18px {
    margin-top: -18px;
    margin-bottom: -18px;
  }
  .aesirxui .my-sm-n32px {
    margin-top: -32px;
    margin-bottom: -32px;
  }
  .aesirxui .my-sm-n9px {
    margin-top: -9px;
    margin-bottom: -9px;
  }
  .aesirxui .my-sm-n12px {
    margin-top: -12px;
    margin-bottom: -12px;
  }
  .aesirxui .my-sm-n19px {
    margin-top: -19px;
    margin-bottom: -19px;
  }
  .aesirxui .mt-sm-n1 {
    margin-top: -0.25rem;
  }
  .aesirxui .mt-sm-n2 {
    margin-top: -0.5rem;
  }
  .aesirxui .mt-sm-n3 {
    margin-top: -1rem;
  }
  .aesirxui .mt-sm-n4 {
    margin-top: -1.5rem;
  }
  .aesirxui .mt-sm-n5 {
    margin-top: -3rem;
  }
  .aesirxui .mt-sm-nsm {
    margin-top: -5px;
  }
  .aesirxui .mt-sm-n8px {
    margin-top: -8px;
  }
  .aesirxui .mt-sm-n15 {
    margin-top: -15px;
  }
  .aesirxui .mt-sm-n16 {
    margin-top: -16px;
  }
  .aesirxui .mt-sm-n20 {
    margin-top: -20px;
  }
  .aesirxui .mt-sm-n24 {
    margin-top: -24px;
  }
  .aesirxui .mt-sm-n6 {
    margin-top: -60px;
  }
  .aesirxui .mt-sm-n7 {
    margin-top: -70px;
  }
  .aesirxui .mt-sm-n8 {
    margin-top: -80px;
  }
  .aesirxui .mt-sm-n10 {
    margin-top: -10px;
  }
  .aesirxui .mt-sm-n13 {
    margin-top: -13px;
  }
  .aesirxui .mt-sm-n14 {
    margin-top: -14px;
  }
  .aesirxui .mt-sm-n40 {
    margin-top: -40px;
  }
  .aesirxui .mt-sm-n18px {
    margin-top: -18px;
  }
  .aesirxui .mt-sm-n32px {
    margin-top: -32px;
  }
  .aesirxui .mt-sm-n9px {
    margin-top: -9px;
  }
  .aesirxui .mt-sm-n12px {
    margin-top: -12px;
  }
  .aesirxui .mt-sm-n19px {
    margin-top: -19px;
  }
  .aesirxui .me-sm-n1 {
    margin-right: -0.25rem;
  }
  .aesirxui .me-sm-n2 {
    margin-right: -0.5rem;
  }
  .aesirxui .me-sm-n3 {
    margin-right: -1rem;
  }
  .aesirxui .me-sm-n4 {
    margin-right: -1.5rem;
  }
  .aesirxui .me-sm-n5 {
    margin-right: -3rem;
  }
  .aesirxui .me-sm-nsm {
    margin-right: -5px;
  }
  .aesirxui .me-sm-n8px {
    margin-right: -8px;
  }
  .aesirxui .me-sm-n15 {
    margin-right: -15px;
  }
  .aesirxui .me-sm-n16 {
    margin-right: -16px;
  }
  .aesirxui .me-sm-n20 {
    margin-right: -20px;
  }
  .aesirxui .me-sm-n24 {
    margin-right: -24px;
  }
  .aesirxui .me-sm-n6 {
    margin-right: -60px;
  }
  .aesirxui .me-sm-n7 {
    margin-right: -70px;
  }
  .aesirxui .me-sm-n8 {
    margin-right: -80px;
  }
  .aesirxui .me-sm-n10 {
    margin-right: -10px;
  }
  .aesirxui .me-sm-n13 {
    margin-right: -13px;
  }
  .aesirxui .me-sm-n14 {
    margin-right: -14px;
  }
  .aesirxui .me-sm-n40 {
    margin-right: -40px;
  }
  .aesirxui .me-sm-n18px {
    margin-right: -18px;
  }
  .aesirxui .me-sm-n32px {
    margin-right: -32px;
  }
  .aesirxui .me-sm-n9px {
    margin-right: -9px;
  }
  .aesirxui .me-sm-n12px {
    margin-right: -12px;
  }
  .aesirxui .me-sm-n19px {
    margin-right: -19px;
  }
  .aesirxui .mb-sm-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxui .mb-sm-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxui .mb-sm-n3 {
    margin-bottom: -1rem;
  }
  .aesirxui .mb-sm-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxui .mb-sm-n5 {
    margin-bottom: -3rem;
  }
  .aesirxui .mb-sm-nsm {
    margin-bottom: -5px;
  }
  .aesirxui .mb-sm-n8px {
    margin-bottom: -8px;
  }
  .aesirxui .mb-sm-n15 {
    margin-bottom: -15px;
  }
  .aesirxui .mb-sm-n16 {
    margin-bottom: -16px;
  }
  .aesirxui .mb-sm-n20 {
    margin-bottom: -20px;
  }
  .aesirxui .mb-sm-n24 {
    margin-bottom: -24px;
  }
  .aesirxui .mb-sm-n6 {
    margin-bottom: -60px;
  }
  .aesirxui .mb-sm-n7 {
    margin-bottom: -70px;
  }
  .aesirxui .mb-sm-n8 {
    margin-bottom: -80px;
  }
  .aesirxui .mb-sm-n10 {
    margin-bottom: -10px;
  }
  .aesirxui .mb-sm-n13 {
    margin-bottom: -13px;
  }
  .aesirxui .mb-sm-n14 {
    margin-bottom: -14px;
  }
  .aesirxui .mb-sm-n40 {
    margin-bottom: -40px;
  }
  .aesirxui .mb-sm-n18px {
    margin-bottom: -18px;
  }
  .aesirxui .mb-sm-n32px {
    margin-bottom: -32px;
  }
  .aesirxui .mb-sm-n9px {
    margin-bottom: -9px;
  }
  .aesirxui .mb-sm-n12px {
    margin-bottom: -12px;
  }
  .aesirxui .mb-sm-n19px {
    margin-bottom: -19px;
  }
  .aesirxui .ms-sm-n1 {
    margin-left: -0.25rem;
  }
  .aesirxui .ms-sm-n2 {
    margin-left: -0.5rem;
  }
  .aesirxui .ms-sm-n3 {
    margin-left: -1rem;
  }
  .aesirxui .ms-sm-n4 {
    margin-left: -1.5rem;
  }
  .aesirxui .ms-sm-n5 {
    margin-left: -3rem;
  }
  .aesirxui .ms-sm-nsm {
    margin-left: -5px;
  }
  .aesirxui .ms-sm-n8px {
    margin-left: -8px;
  }
  .aesirxui .ms-sm-n15 {
    margin-left: -15px;
  }
  .aesirxui .ms-sm-n16 {
    margin-left: -16px;
  }
  .aesirxui .ms-sm-n20 {
    margin-left: -20px;
  }
  .aesirxui .ms-sm-n24 {
    margin-left: -24px;
  }
  .aesirxui .ms-sm-n6 {
    margin-left: -60px;
  }
  .aesirxui .ms-sm-n7 {
    margin-left: -70px;
  }
  .aesirxui .ms-sm-n8 {
    margin-left: -80px;
  }
  .aesirxui .ms-sm-n10 {
    margin-left: -10px;
  }
  .aesirxui .ms-sm-n13 {
    margin-left: -13px;
  }
  .aesirxui .ms-sm-n14 {
    margin-left: -14px;
  }
  .aesirxui .ms-sm-n40 {
    margin-left: -40px;
  }
  .aesirxui .ms-sm-n18px {
    margin-left: -18px;
  }
  .aesirxui .ms-sm-n32px {
    margin-left: -32px;
  }
  .aesirxui .ms-sm-n9px {
    margin-left: -9px;
  }
  .aesirxui .ms-sm-n12px {
    margin-left: -12px;
  }
  .aesirxui .ms-sm-n19px {
    margin-left: -19px;
  }
  .aesirxui .p-sm-0 {
    padding: 0;
  }
  .aesirxui .p-sm-1 {
    padding: 0.25rem;
  }
  .aesirxui .p-sm-2 {
    padding: 0.5rem;
  }
  .aesirxui .p-sm-3 {
    padding: 1rem;
  }
  .aesirxui .p-sm-4 {
    padding: 1.5rem;
  }
  .aesirxui .p-sm-5 {
    padding: 3rem;
  }
  .aesirxui .p-sm-sm {
    padding: 5px;
  }
  .aesirxui .p-sm-8px {
    padding: 8px;
  }
  .aesirxui .p-sm-15 {
    padding: 15px;
  }
  .aesirxui .p-sm-16 {
    padding: 16px;
  }
  .aesirxui .p-sm-20 {
    padding: 20px;
  }
  .aesirxui .p-sm-24 {
    padding: 24px;
  }
  .aesirxui .p-sm-6 {
    padding: 60px;
  }
  .aesirxui .p-sm-7 {
    padding: 70px;
  }
  .aesirxui .p-sm-8 {
    padding: 80px;
  }
  .aesirxui .p-sm-10 {
    padding: 10px;
  }
  .aesirxui .p-sm-13 {
    padding: 13px;
  }
  .aesirxui .p-sm-14 {
    padding: 14px;
  }
  .aesirxui .p-sm-40 {
    padding: 40px;
  }
  .aesirxui .p-sm-18px {
    padding: 18px;
  }
  .aesirxui .p-sm-32px {
    padding: 32px;
  }
  .aesirxui .p-sm-9px {
    padding: 9px;
  }
  .aesirxui .p-sm-12px {
    padding: 12px;
  }
  .aesirxui .p-sm-19px {
    padding: 19px;
  }
  .aesirxui .px-sm-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxui .px-sm-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxui .px-sm-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxui .px-sm-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxui .px-sm-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxui .px-sm-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxui .px-sm-sm {
    padding-right: 5px;
    padding-left: 5px;
  }
  .aesirxui .px-sm-8px {
    padding-right: 8px;
    padding-left: 8px;
  }
  .aesirxui .px-sm-15 {
    padding-right: 15px;
    padding-left: 15px;
  }
  .aesirxui .px-sm-16 {
    padding-right: 16px;
    padding-left: 16px;
  }
  .aesirxui .px-sm-20 {
    padding-right: 20px;
    padding-left: 20px;
  }
  .aesirxui .px-sm-24 {
    padding-right: 24px;
    padding-left: 24px;
  }
  .aesirxui .px-sm-6 {
    padding-right: 60px;
    padding-left: 60px;
  }
  .aesirxui .px-sm-7 {
    padding-right: 70px;
    padding-left: 70px;
  }
  .aesirxui .px-sm-8 {
    padding-right: 80px;
    padding-left: 80px;
  }
  .aesirxui .px-sm-10 {
    padding-right: 10px;
    padding-left: 10px;
  }
  .aesirxui .px-sm-13 {
    padding-right: 13px;
    padding-left: 13px;
  }
  .aesirxui .px-sm-14 {
    padding-right: 14px;
    padding-left: 14px;
  }
  .aesirxui .px-sm-40 {
    padding-right: 40px;
    padding-left: 40px;
  }
  .aesirxui .px-sm-18px {
    padding-right: 18px;
    padding-left: 18px;
  }
  .aesirxui .px-sm-32px {
    padding-right: 32px;
    padding-left: 32px;
  }
  .aesirxui .px-sm-9px {
    padding-right: 9px;
    padding-left: 9px;
  }
  .aesirxui .px-sm-12px {
    padding-right: 12px;
    padding-left: 12px;
  }
  .aesirxui .px-sm-19px {
    padding-right: 19px;
    padding-left: 19px;
  }
  .aesirxui .py-sm-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxui .py-sm-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxui .py-sm-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxui .py-sm-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxui .py-sm-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxui .py-sm-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxui .py-sm-sm {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .aesirxui .py-sm-8px {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .aesirxui .py-sm-15 {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .aesirxui .py-sm-16 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .aesirxui .py-sm-20 {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .aesirxui .py-sm-24 {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .aesirxui .py-sm-6 {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .aesirxui .py-sm-7 {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .aesirxui .py-sm-8 {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .aesirxui .py-sm-10 {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .aesirxui .py-sm-13 {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .aesirxui .py-sm-14 {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .aesirxui .py-sm-40 {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .aesirxui .py-sm-18px {
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .aesirxui .py-sm-32px {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  .aesirxui .py-sm-9px {
    padding-top: 9px;
    padding-bottom: 9px;
  }
  .aesirxui .py-sm-12px {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .aesirxui .py-sm-19px {
    padding-top: 19px;
    padding-bottom: 19px;
  }
  .aesirxui .pt-sm-0 {
    padding-top: 0;
  }
  .aesirxui .pt-sm-1 {
    padding-top: 0.25rem;
  }
  .aesirxui .pt-sm-2 {
    padding-top: 0.5rem;
  }
  .aesirxui .pt-sm-3 {
    padding-top: 1rem;
  }
  .aesirxui .pt-sm-4 {
    padding-top: 1.5rem;
  }
  .aesirxui .pt-sm-5 {
    padding-top: 3rem;
  }
  .aesirxui .pt-sm-sm {
    padding-top: 5px;
  }
  .aesirxui .pt-sm-8px {
    padding-top: 8px;
  }
  .aesirxui .pt-sm-15 {
    padding-top: 15px;
  }
  .aesirxui .pt-sm-16 {
    padding-top: 16px;
  }
  .aesirxui .pt-sm-20 {
    padding-top: 20px;
  }
  .aesirxui .pt-sm-24 {
    padding-top: 24px;
  }
  .aesirxui .pt-sm-6 {
    padding-top: 60px;
  }
  .aesirxui .pt-sm-7 {
    padding-top: 70px;
  }
  .aesirxui .pt-sm-8 {
    padding-top: 80px;
  }
  .aesirxui .pt-sm-10 {
    padding-top: 10px;
  }
  .aesirxui .pt-sm-13 {
    padding-top: 13px;
  }
  .aesirxui .pt-sm-14 {
    padding-top: 14px;
  }
  .aesirxui .pt-sm-40 {
    padding-top: 40px;
  }
  .aesirxui .pt-sm-18px {
    padding-top: 18px;
  }
  .aesirxui .pt-sm-32px {
    padding-top: 32px;
  }
  .aesirxui .pt-sm-9px {
    padding-top: 9px;
  }
  .aesirxui .pt-sm-12px {
    padding-top: 12px;
  }
  .aesirxui .pt-sm-19px {
    padding-top: 19px;
  }
  .aesirxui .pe-sm-0 {
    padding-right: 0;
  }
  .aesirxui .pe-sm-1 {
    padding-right: 0.25rem;
  }
  .aesirxui .pe-sm-2 {
    padding-right: 0.5rem;
  }
  .aesirxui .pe-sm-3 {
    padding-right: 1rem;
  }
  .aesirxui .pe-sm-4 {
    padding-right: 1.5rem;
  }
  .aesirxui .pe-sm-5 {
    padding-right: 3rem;
  }
  .aesirxui .pe-sm-sm {
    padding-right: 5px;
  }
  .aesirxui .pe-sm-8px {
    padding-right: 8px;
  }
  .aesirxui .pe-sm-15 {
    padding-right: 15px;
  }
  .aesirxui .pe-sm-16 {
    padding-right: 16px;
  }
  .aesirxui .pe-sm-20 {
    padding-right: 20px;
  }
  .aesirxui .pe-sm-24 {
    padding-right: 24px;
  }
  .aesirxui .pe-sm-6 {
    padding-right: 60px;
  }
  .aesirxui .pe-sm-7 {
    padding-right: 70px;
  }
  .aesirxui .pe-sm-8 {
    padding-right: 80px;
  }
  .aesirxui .pe-sm-10 {
    padding-right: 10px;
  }
  .aesirxui .pe-sm-13 {
    padding-right: 13px;
  }
  .aesirxui .pe-sm-14 {
    padding-right: 14px;
  }
  .aesirxui .pe-sm-40 {
    padding-right: 40px;
  }
  .aesirxui .pe-sm-18px {
    padding-right: 18px;
  }
  .aesirxui .pe-sm-32px {
    padding-right: 32px;
  }
  .aesirxui .pe-sm-9px {
    padding-right: 9px;
  }
  .aesirxui .pe-sm-12px {
    padding-right: 12px;
  }
  .aesirxui .pe-sm-19px {
    padding-right: 19px;
  }
  .aesirxui .pb-sm-0 {
    padding-bottom: 0;
  }
  .aesirxui .pb-sm-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxui .pb-sm-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxui .pb-sm-3 {
    padding-bottom: 1rem;
  }
  .aesirxui .pb-sm-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxui .pb-sm-5 {
    padding-bottom: 3rem;
  }
  .aesirxui .pb-sm-sm {
    padding-bottom: 5px;
  }
  .aesirxui .pb-sm-8px {
    padding-bottom: 8px;
  }
  .aesirxui .pb-sm-15 {
    padding-bottom: 15px;
  }
  .aesirxui .pb-sm-16 {
    padding-bottom: 16px;
  }
  .aesirxui .pb-sm-20 {
    padding-bottom: 20px;
  }
  .aesirxui .pb-sm-24 {
    padding-bottom: 24px;
  }
  .aesirxui .pb-sm-6 {
    padding-bottom: 60px;
  }
  .aesirxui .pb-sm-7 {
    padding-bottom: 70px;
  }
  .aesirxui .pb-sm-8 {
    padding-bottom: 80px;
  }
  .aesirxui .pb-sm-10 {
    padding-bottom: 10px;
  }
  .aesirxui .pb-sm-13 {
    padding-bottom: 13px;
  }
  .aesirxui .pb-sm-14 {
    padding-bottom: 14px;
  }
  .aesirxui .pb-sm-40 {
    padding-bottom: 40px;
  }
  .aesirxui .pb-sm-18px {
    padding-bottom: 18px;
  }
  .aesirxui .pb-sm-32px {
    padding-bottom: 32px;
  }
  .aesirxui .pb-sm-9px {
    padding-bottom: 9px;
  }
  .aesirxui .pb-sm-12px {
    padding-bottom: 12px;
  }
  .aesirxui .pb-sm-19px {
    padding-bottom: 19px;
  }
  .aesirxui .ps-sm-0 {
    padding-left: 0;
  }
  .aesirxui .ps-sm-1 {
    padding-left: 0.25rem;
  }
  .aesirxui .ps-sm-2 {
    padding-left: 0.5rem;
  }
  .aesirxui .ps-sm-3 {
    padding-left: 1rem;
  }
  .aesirxui .ps-sm-4 {
    padding-left: 1.5rem;
  }
  .aesirxui .ps-sm-5 {
    padding-left: 3rem;
  }
  .aesirxui .ps-sm-sm {
    padding-left: 5px;
  }
  .aesirxui .ps-sm-8px {
    padding-left: 8px;
  }
  .aesirxui .ps-sm-15 {
    padding-left: 15px;
  }
  .aesirxui .ps-sm-16 {
    padding-left: 16px;
  }
  .aesirxui .ps-sm-20 {
    padding-left: 20px;
  }
  .aesirxui .ps-sm-24 {
    padding-left: 24px;
  }
  .aesirxui .ps-sm-6 {
    padding-left: 60px;
  }
  .aesirxui .ps-sm-7 {
    padding-left: 70px;
  }
  .aesirxui .ps-sm-8 {
    padding-left: 80px;
  }
  .aesirxui .ps-sm-10 {
    padding-left: 10px;
  }
  .aesirxui .ps-sm-13 {
    padding-left: 13px;
  }
  .aesirxui .ps-sm-14 {
    padding-left: 14px;
  }
  .aesirxui .ps-sm-40 {
    padding-left: 40px;
  }
  .aesirxui .ps-sm-18px {
    padding-left: 18px;
  }
  .aesirxui .ps-sm-32px {
    padding-left: 32px;
  }
  .aesirxui .ps-sm-9px {
    padding-left: 9px;
  }
  .aesirxui .ps-sm-12px {
    padding-left: 12px;
  }
  .aesirxui .ps-sm-19px {
    padding-left: 19px;
  }
  .aesirxui .gap-sm-0 {
    gap: 0;
  }
  .aesirxui .gap-sm-1 {
    gap: 0.25rem;
  }
  .aesirxui .gap-sm-2 {
    gap: 0.5rem;
  }
  .aesirxui .gap-sm-3 {
    gap: 1rem;
  }
  .aesirxui .gap-sm-4 {
    gap: 1.5rem;
  }
  .aesirxui .gap-sm-5 {
    gap: 3rem;
  }
  .aesirxui .gap-sm-sm {
    gap: 5px;
  }
  .aesirxui .gap-sm-8px {
    gap: 8px;
  }
  .aesirxui .gap-sm-15 {
    gap: 15px;
  }
  .aesirxui .gap-sm-16 {
    gap: 16px;
  }
  .aesirxui .gap-sm-20 {
    gap: 20px;
  }
  .aesirxui .gap-sm-24 {
    gap: 24px;
  }
  .aesirxui .gap-sm-6 {
    gap: 60px;
  }
  .aesirxui .gap-sm-7 {
    gap: 70px;
  }
  .aesirxui .gap-sm-8 {
    gap: 80px;
  }
  .aesirxui .gap-sm-10 {
    gap: 10px;
  }
  .aesirxui .gap-sm-13 {
    gap: 13px;
  }
  .aesirxui .gap-sm-14 {
    gap: 14px;
  }
  .aesirxui .gap-sm-40 {
    gap: 40px;
  }
  .aesirxui .gap-sm-18px {
    gap: 18px;
  }
  .aesirxui .gap-sm-32px {
    gap: 32px;
  }
  .aesirxui .gap-sm-9px {
    gap: 9px;
  }
  .aesirxui .gap-sm-12px {
    gap: 12px;
  }
  .aesirxui .gap-sm-19px {
    gap: 19px;
  }
  .aesirxui .row-gap-sm-0 {
    row-gap: 0;
  }
  .aesirxui .row-gap-sm-1 {
    row-gap: 0.25rem;
  }
  .aesirxui .row-gap-sm-2 {
    row-gap: 0.5rem;
  }
  .aesirxui .row-gap-sm-3 {
    row-gap: 1rem;
  }
  .aesirxui .row-gap-sm-4 {
    row-gap: 1.5rem;
  }
  .aesirxui .row-gap-sm-5 {
    row-gap: 3rem;
  }
  .aesirxui .row-gap-sm-sm {
    row-gap: 5px;
  }
  .aesirxui .row-gap-sm-8px {
    row-gap: 8px;
  }
  .aesirxui .row-gap-sm-15 {
    row-gap: 15px;
  }
  .aesirxui .row-gap-sm-16 {
    row-gap: 16px;
  }
  .aesirxui .row-gap-sm-20 {
    row-gap: 20px;
  }
  .aesirxui .row-gap-sm-24 {
    row-gap: 24px;
  }
  .aesirxui .row-gap-sm-6 {
    row-gap: 60px;
  }
  .aesirxui .row-gap-sm-7 {
    row-gap: 70px;
  }
  .aesirxui .row-gap-sm-8 {
    row-gap: 80px;
  }
  .aesirxui .row-gap-sm-10 {
    row-gap: 10px;
  }
  .aesirxui .row-gap-sm-13 {
    row-gap: 13px;
  }
  .aesirxui .row-gap-sm-14 {
    row-gap: 14px;
  }
  .aesirxui .row-gap-sm-40 {
    row-gap: 40px;
  }
  .aesirxui .row-gap-sm-18px {
    row-gap: 18px;
  }
  .aesirxui .row-gap-sm-32px {
    row-gap: 32px;
  }
  .aesirxui .row-gap-sm-9px {
    row-gap: 9px;
  }
  .aesirxui .row-gap-sm-12px {
    row-gap: 12px;
  }
  .aesirxui .row-gap-sm-19px {
    row-gap: 19px;
  }
  .aesirxui .column-gap-sm-0 {
    column-gap: 0;
  }
  .aesirxui .column-gap-sm-1 {
    column-gap: 0.25rem;
  }
  .aesirxui .column-gap-sm-2 {
    column-gap: 0.5rem;
  }
  .aesirxui .column-gap-sm-3 {
    column-gap: 1rem;
  }
  .aesirxui .column-gap-sm-4 {
    column-gap: 1.5rem;
  }
  .aesirxui .column-gap-sm-5 {
    column-gap: 3rem;
  }
  .aesirxui .column-gap-sm-sm {
    column-gap: 5px;
  }
  .aesirxui .column-gap-sm-8px {
    column-gap: 8px;
  }
  .aesirxui .column-gap-sm-15 {
    column-gap: 15px;
  }
  .aesirxui .column-gap-sm-16 {
    column-gap: 16px;
  }
  .aesirxui .column-gap-sm-20 {
    column-gap: 20px;
  }
  .aesirxui .column-gap-sm-24 {
    column-gap: 24px;
  }
  .aesirxui .column-gap-sm-6 {
    column-gap: 60px;
  }
  .aesirxui .column-gap-sm-7 {
    column-gap: 70px;
  }
  .aesirxui .column-gap-sm-8 {
    column-gap: 80px;
  }
  .aesirxui .column-gap-sm-10 {
    column-gap: 10px;
  }
  .aesirxui .column-gap-sm-13 {
    column-gap: 13px;
  }
  .aesirxui .column-gap-sm-14 {
    column-gap: 14px;
  }
  .aesirxui .column-gap-sm-40 {
    column-gap: 40px;
  }
  .aesirxui .column-gap-sm-18px {
    column-gap: 18px;
  }
  .aesirxui .column-gap-sm-32px {
    column-gap: 32px;
  }
  .aesirxui .column-gap-sm-9px {
    column-gap: 9px;
  }
  .aesirxui .column-gap-sm-12px {
    column-gap: 12px;
  }
  .aesirxui .column-gap-sm-19px {
    column-gap: 19px;
  }
  .aesirxui .text-sm-start {
    text-align: left;
  }
  .aesirxui .text-sm-end {
    text-align: right;
  }
  .aesirxui .text-sm-center {
    text-align: center;
  }
}
@media (min-width: 768px) {
  .aesirxui .float-md-start {
    float: left;
  }
  .aesirxui .float-md-end {
    float: right;
  }
  .aesirxui .float-md-none {
    float: none;
  }
  .aesirxui .d-md-inline {
    display: inline;
  }
  .aesirxui .d-md-inline-block {
    display: inline-block;
  }
  .aesirxui .d-md-block {
    display: block;
  }
  .aesirxui .d-md-grid {
    display: grid;
  }
  .aesirxui .d-md-inline-grid {
    display: inline-grid;
  }
  .aesirxui .d-md-table {
    display: table;
  }
  .aesirxui .d-md-table-row {
    display: table-row;
  }
  .aesirxui .d-md-table-cell {
    display: table-cell;
  }
  .aesirxui .d-md-flex {
    display: flex;
  }
  .aesirxui .d-md-inline-flex {
    display: inline-flex;
  }
  .aesirxui .d-md-none {
    display: none;
  }
  .aesirxui .w-md-25 {
    width: 25%;
  }
  .aesirxui .w-md-20 {
    width: 20%;
  }
  .aesirxui .w-md-40 {
    width: 40%;
  }
  .aesirxui .w-md-50 {
    width: 50%;
  }
  .aesirxui .w-md-75 {
    width: 75%;
  }
  .aesirxui .w-md-100 {
    width: 100%;
  }
  .aesirxui .w-md-fit {
    width: fit-content;
  }
  .aesirxui .w-md-max {
    width: max-content;
  }
  .aesirxui .w-md-auto {
    width: auto;
  }
  .aesirxui .w-md-150px {
    width: 150px;
  }
  .aesirxui .w-md-40px {
    width: 40px;
  }
  .aesirxui .w-md-145px {
    width: 145px;
  }
  .aesirxui .flex-md-fill {
    flex: 1 1 auto;
  }
  .aesirxui .flex-md-1 {
    flex: 1;
  }
  .aesirxui .flex-md-row {
    flex-direction: row;
  }
  .aesirxui .flex-md-column {
    flex-direction: column;
  }
  .aesirxui .flex-md-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxui .flex-md-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxui .flex-md-grow-0 {
    flex-grow: 0;
  }
  .aesirxui .flex-md-grow-1 {
    flex-grow: 1;
  }
  .aesirxui .flex-md-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxui .flex-md-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxui .flex-md-wrap {
    flex-wrap: wrap;
  }
  .aesirxui .flex-md-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxui .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxui .justify-content-md-start {
    justify-content: flex-start;
  }
  .aesirxui .justify-content-md-end {
    justify-content: flex-end;
  }
  .aesirxui .justify-content-md-center {
    justify-content: center;
  }
  .aesirxui .justify-content-md-between {
    justify-content: space-between;
  }
  .aesirxui .justify-content-md-around {
    justify-content: space-around;
  }
  .aesirxui .justify-content-md-evenly {
    justify-content: space-evenly;
  }
  .aesirxui .align-items-md-start {
    align-items: flex-start;
  }
  .aesirxui .align-items-md-end {
    align-items: flex-end;
  }
  .aesirxui .align-items-md-center {
    align-items: center;
  }
  .aesirxui .align-items-md-baseline {
    align-items: baseline;
  }
  .aesirxui .align-items-md-stretch {
    align-items: stretch;
  }
  .aesirxui .align-content-md-start {
    align-content: flex-start;
  }
  .aesirxui .align-content-md-end {
    align-content: flex-end;
  }
  .aesirxui .align-content-md-center {
    align-content: center;
  }
  .aesirxui .align-content-md-between {
    align-content: space-between;
  }
  .aesirxui .align-content-md-around {
    align-content: space-around;
  }
  .aesirxui .align-content-md-stretch {
    align-content: stretch;
  }
  .aesirxui .align-self-md-auto {
    align-self: auto;
  }
  .aesirxui .align-self-md-start {
    align-self: flex-start;
  }
  .aesirxui .align-self-md-end {
    align-self: flex-end;
  }
  .aesirxui .align-self-md-center {
    align-self: center;
  }
  .aesirxui .align-self-md-baseline {
    align-self: baseline;
  }
  .aesirxui .align-self-md-stretch {
    align-self: stretch;
  }
  .aesirxui .order-md-first {
    order: -1;
  }
  .aesirxui .order-md-0 {
    order: 0;
  }
  .aesirxui .order-md-1 {
    order: 1;
  }
  .aesirxui .order-md-2 {
    order: 2;
  }
  .aesirxui .order-md-3 {
    order: 3;
  }
  .aesirxui .order-md-4 {
    order: 4;
  }
  .aesirxui .order-md-5 {
    order: 5;
  }
  .aesirxui .order-md-last {
    order: 6;
  }
  .aesirxui .m-md-0 {
    margin: 0;
  }
  .aesirxui .m-md-1 {
    margin: 0.25rem;
  }
  .aesirxui .m-md-2 {
    margin: 0.5rem;
  }
  .aesirxui .m-md-3 {
    margin: 1rem;
  }
  .aesirxui .m-md-4 {
    margin: 1.5rem;
  }
  .aesirxui .m-md-5 {
    margin: 3rem;
  }
  .aesirxui .m-md-sm {
    margin: 5px;
  }
  .aesirxui .m-md-8px {
    margin: 8px;
  }
  .aesirxui .m-md-15 {
    margin: 15px;
  }
  .aesirxui .m-md-16 {
    margin: 16px;
  }
  .aesirxui .m-md-20 {
    margin: 20px;
  }
  .aesirxui .m-md-24 {
    margin: 24px;
  }
  .aesirxui .m-md-6 {
    margin: 60px;
  }
  .aesirxui .m-md-7 {
    margin: 70px;
  }
  .aesirxui .m-md-8 {
    margin: 80px;
  }
  .aesirxui .m-md-10 {
    margin: 10px;
  }
  .aesirxui .m-md-13 {
    margin: 13px;
  }
  .aesirxui .m-md-14 {
    margin: 14px;
  }
  .aesirxui .m-md-40 {
    margin: 40px;
  }
  .aesirxui .m-md-18px {
    margin: 18px;
  }
  .aesirxui .m-md-32px {
    margin: 32px;
  }
  .aesirxui .m-md-9px {
    margin: 9px;
  }
  .aesirxui .m-md-12px {
    margin: 12px;
  }
  .aesirxui .m-md-19px {
    margin: 19px;
  }
  .aesirxui .m-md-auto {
    margin: auto;
  }
  .aesirxui .mx-md-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxui .mx-md-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxui .mx-md-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxui .mx-md-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxui .mx-md-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxui .mx-md-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxui .mx-md-sm {
    margin-right: 5px;
    margin-left: 5px;
  }
  .aesirxui .mx-md-8px {
    margin-right: 8px;
    margin-left: 8px;
  }
  .aesirxui .mx-md-15 {
    margin-right: 15px;
    margin-left: 15px;
  }
  .aesirxui .mx-md-16 {
    margin-right: 16px;
    margin-left: 16px;
  }
  .aesirxui .mx-md-20 {
    margin-right: 20px;
    margin-left: 20px;
  }
  .aesirxui .mx-md-24 {
    margin-right: 24px;
    margin-left: 24px;
  }
  .aesirxui .mx-md-6 {
    margin-right: 60px;
    margin-left: 60px;
  }
  .aesirxui .mx-md-7 {
    margin-right: 70px;
    margin-left: 70px;
  }
  .aesirxui .mx-md-8 {
    margin-right: 80px;
    margin-left: 80px;
  }
  .aesirxui .mx-md-10 {
    margin-right: 10px;
    margin-left: 10px;
  }
  .aesirxui .mx-md-13 {
    margin-right: 13px;
    margin-left: 13px;
  }
  .aesirxui .mx-md-14 {
    margin-right: 14px;
    margin-left: 14px;
  }
  .aesirxui .mx-md-40 {
    margin-right: 40px;
    margin-left: 40px;
  }
  .aesirxui .mx-md-18px {
    margin-right: 18px;
    margin-left: 18px;
  }
  .aesirxui .mx-md-32px {
    margin-right: 32px;
    margin-left: 32px;
  }
  .aesirxui .mx-md-9px {
    margin-right: 9px;
    margin-left: 9px;
  }
  .aesirxui .mx-md-12px {
    margin-right: 12px;
    margin-left: 12px;
  }
  .aesirxui .mx-md-19px {
    margin-right: 19px;
    margin-left: 19px;
  }
  .aesirxui .mx-md-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxui .my-md-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxui .my-md-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxui .my-md-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxui .my-md-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxui .my-md-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxui .my-md-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxui .my-md-sm {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .aesirxui .my-md-8px {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .aesirxui .my-md-15 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .aesirxui .my-md-16 {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .aesirxui .my-md-20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .aesirxui .my-md-24 {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .aesirxui .my-md-6 {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .aesirxui .my-md-7 {
    margin-top: 70px;
    margin-bottom: 70px;
  }
  .aesirxui .my-md-8 {
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .aesirxui .my-md-10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .aesirxui .my-md-13 {
    margin-top: 13px;
    margin-bottom: 13px;
  }
  .aesirxui .my-md-14 {
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .aesirxui .my-md-40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .aesirxui .my-md-18px {
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .aesirxui .my-md-32px {
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .aesirxui .my-md-9px {
    margin-top: 9px;
    margin-bottom: 9px;
  }
  .aesirxui .my-md-12px {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .aesirxui .my-md-19px {
    margin-top: 19px;
    margin-bottom: 19px;
  }
  .aesirxui .my-md-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxui .mt-md-0 {
    margin-top: 0;
  }
  .aesirxui .mt-md-1 {
    margin-top: 0.25rem;
  }
  .aesirxui .mt-md-2 {
    margin-top: 0.5rem;
  }
  .aesirxui .mt-md-3 {
    margin-top: 1rem;
  }
  .aesirxui .mt-md-4 {
    margin-top: 1.5rem;
  }
  .aesirxui .mt-md-5 {
    margin-top: 3rem;
  }
  .aesirxui .mt-md-sm {
    margin-top: 5px;
  }
  .aesirxui .mt-md-8px {
    margin-top: 8px;
  }
  .aesirxui .mt-md-15 {
    margin-top: 15px;
  }
  .aesirxui .mt-md-16 {
    margin-top: 16px;
  }
  .aesirxui .mt-md-20 {
    margin-top: 20px;
  }
  .aesirxui .mt-md-24 {
    margin-top: 24px;
  }
  .aesirxui .mt-md-6 {
    margin-top: 60px;
  }
  .aesirxui .mt-md-7 {
    margin-top: 70px;
  }
  .aesirxui .mt-md-8 {
    margin-top: 80px;
  }
  .aesirxui .mt-md-10 {
    margin-top: 10px;
  }
  .aesirxui .mt-md-13 {
    margin-top: 13px;
  }
  .aesirxui .mt-md-14 {
    margin-top: 14px;
  }
  .aesirxui .mt-md-40 {
    margin-top: 40px;
  }
  .aesirxui .mt-md-18px {
    margin-top: 18px;
  }
  .aesirxui .mt-md-32px {
    margin-top: 32px;
  }
  .aesirxui .mt-md-9px {
    margin-top: 9px;
  }
  .aesirxui .mt-md-12px {
    margin-top: 12px;
  }
  .aesirxui .mt-md-19px {
    margin-top: 19px;
  }
  .aesirxui .mt-md-auto {
    margin-top: auto;
  }
  .aesirxui .me-md-0 {
    margin-right: 0;
  }
  .aesirxui .me-md-1 {
    margin-right: 0.25rem;
  }
  .aesirxui .me-md-2 {
    margin-right: 0.5rem;
  }
  .aesirxui .me-md-3 {
    margin-right: 1rem;
  }
  .aesirxui .me-md-4 {
    margin-right: 1.5rem;
  }
  .aesirxui .me-md-5 {
    margin-right: 3rem;
  }
  .aesirxui .me-md-sm {
    margin-right: 5px;
  }
  .aesirxui .me-md-8px {
    margin-right: 8px;
  }
  .aesirxui .me-md-15 {
    margin-right: 15px;
  }
  .aesirxui .me-md-16 {
    margin-right: 16px;
  }
  .aesirxui .me-md-20 {
    margin-right: 20px;
  }
  .aesirxui .me-md-24 {
    margin-right: 24px;
  }
  .aesirxui .me-md-6 {
    margin-right: 60px;
  }
  .aesirxui .me-md-7 {
    margin-right: 70px;
  }
  .aesirxui .me-md-8 {
    margin-right: 80px;
  }
  .aesirxui .me-md-10 {
    margin-right: 10px;
  }
  .aesirxui .me-md-13 {
    margin-right: 13px;
  }
  .aesirxui .me-md-14 {
    margin-right: 14px;
  }
  .aesirxui .me-md-40 {
    margin-right: 40px;
  }
  .aesirxui .me-md-18px {
    margin-right: 18px;
  }
  .aesirxui .me-md-32px {
    margin-right: 32px;
  }
  .aesirxui .me-md-9px {
    margin-right: 9px;
  }
  .aesirxui .me-md-12px {
    margin-right: 12px;
  }
  .aesirxui .me-md-19px {
    margin-right: 19px;
  }
  .aesirxui .me-md-auto {
    margin-right: auto;
  }
  .aesirxui .mb-md-0 {
    margin-bottom: 0;
  }
  .aesirxui .mb-md-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxui .mb-md-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxui .mb-md-3 {
    margin-bottom: 1rem;
  }
  .aesirxui .mb-md-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxui .mb-md-5 {
    margin-bottom: 3rem;
  }
  .aesirxui .mb-md-sm {
    margin-bottom: 5px;
  }
  .aesirxui .mb-md-8px {
    margin-bottom: 8px;
  }
  .aesirxui .mb-md-15 {
    margin-bottom: 15px;
  }
  .aesirxui .mb-md-16 {
    margin-bottom: 16px;
  }
  .aesirxui .mb-md-20 {
    margin-bottom: 20px;
  }
  .aesirxui .mb-md-24 {
    margin-bottom: 24px;
  }
  .aesirxui .mb-md-6 {
    margin-bottom: 60px;
  }
  .aesirxui .mb-md-7 {
    margin-bottom: 70px;
  }
  .aesirxui .mb-md-8 {
    margin-bottom: 80px;
  }
  .aesirxui .mb-md-10 {
    margin-bottom: 10px;
  }
  .aesirxui .mb-md-13 {
    margin-bottom: 13px;
  }
  .aesirxui .mb-md-14 {
    margin-bottom: 14px;
  }
  .aesirxui .mb-md-40 {
    margin-bottom: 40px;
  }
  .aesirxui .mb-md-18px {
    margin-bottom: 18px;
  }
  .aesirxui .mb-md-32px {
    margin-bottom: 32px;
  }
  .aesirxui .mb-md-9px {
    margin-bottom: 9px;
  }
  .aesirxui .mb-md-12px {
    margin-bottom: 12px;
  }
  .aesirxui .mb-md-19px {
    margin-bottom: 19px;
  }
  .aesirxui .mb-md-auto {
    margin-bottom: auto;
  }
  .aesirxui .ms-md-0 {
    margin-left: 0;
  }
  .aesirxui .ms-md-1 {
    margin-left: 0.25rem;
  }
  .aesirxui .ms-md-2 {
    margin-left: 0.5rem;
  }
  .aesirxui .ms-md-3 {
    margin-left: 1rem;
  }
  .aesirxui .ms-md-4 {
    margin-left: 1.5rem;
  }
  .aesirxui .ms-md-5 {
    margin-left: 3rem;
  }
  .aesirxui .ms-md-sm {
    margin-left: 5px;
  }
  .aesirxui .ms-md-8px {
    margin-left: 8px;
  }
  .aesirxui .ms-md-15 {
    margin-left: 15px;
  }
  .aesirxui .ms-md-16 {
    margin-left: 16px;
  }
  .aesirxui .ms-md-20 {
    margin-left: 20px;
  }
  .aesirxui .ms-md-24 {
    margin-left: 24px;
  }
  .aesirxui .ms-md-6 {
    margin-left: 60px;
  }
  .aesirxui .ms-md-7 {
    margin-left: 70px;
  }
  .aesirxui .ms-md-8 {
    margin-left: 80px;
  }
  .aesirxui .ms-md-10 {
    margin-left: 10px;
  }
  .aesirxui .ms-md-13 {
    margin-left: 13px;
  }
  .aesirxui .ms-md-14 {
    margin-left: 14px;
  }
  .aesirxui .ms-md-40 {
    margin-left: 40px;
  }
  .aesirxui .ms-md-18px {
    margin-left: 18px;
  }
  .aesirxui .ms-md-32px {
    margin-left: 32px;
  }
  .aesirxui .ms-md-9px {
    margin-left: 9px;
  }
  .aesirxui .ms-md-12px {
    margin-left: 12px;
  }
  .aesirxui .ms-md-19px {
    margin-left: 19px;
  }
  .aesirxui .ms-md-auto {
    margin-left: auto;
  }
  .aesirxui .m-md-n1 {
    margin: -0.25rem;
  }
  .aesirxui .m-md-n2 {
    margin: -0.5rem;
  }
  .aesirxui .m-md-n3 {
    margin: -1rem;
  }
  .aesirxui .m-md-n4 {
    margin: -1.5rem;
  }
  .aesirxui .m-md-n5 {
    margin: -3rem;
  }
  .aesirxui .m-md-nsm {
    margin: -5px;
  }
  .aesirxui .m-md-n8px {
    margin: -8px;
  }
  .aesirxui .m-md-n15 {
    margin: -15px;
  }
  .aesirxui .m-md-n16 {
    margin: -16px;
  }
  .aesirxui .m-md-n20 {
    margin: -20px;
  }
  .aesirxui .m-md-n24 {
    margin: -24px;
  }
  .aesirxui .m-md-n6 {
    margin: -60px;
  }
  .aesirxui .m-md-n7 {
    margin: -70px;
  }
  .aesirxui .m-md-n8 {
    margin: -80px;
  }
  .aesirxui .m-md-n10 {
    margin: -10px;
  }
  .aesirxui .m-md-n13 {
    margin: -13px;
  }
  .aesirxui .m-md-n14 {
    margin: -14px;
  }
  .aesirxui .m-md-n40 {
    margin: -40px;
  }
  .aesirxui .m-md-n18px {
    margin: -18px;
  }
  .aesirxui .m-md-n32px {
    margin: -32px;
  }
  .aesirxui .m-md-n9px {
    margin: -9px;
  }
  .aesirxui .m-md-n12px {
    margin: -12px;
  }
  .aesirxui .m-md-n19px {
    margin: -19px;
  }
  .aesirxui .mx-md-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxui .mx-md-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxui .mx-md-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxui .mx-md-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxui .mx-md-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxui .mx-md-nsm {
    margin-right: -5px;
    margin-left: -5px;
  }
  .aesirxui .mx-md-n8px {
    margin-right: -8px;
    margin-left: -8px;
  }
  .aesirxui .mx-md-n15 {
    margin-right: -15px;
    margin-left: -15px;
  }
  .aesirxui .mx-md-n16 {
    margin-right: -16px;
    margin-left: -16px;
  }
  .aesirxui .mx-md-n20 {
    margin-right: -20px;
    margin-left: -20px;
  }
  .aesirxui .mx-md-n24 {
    margin-right: -24px;
    margin-left: -24px;
  }
  .aesirxui .mx-md-n6 {
    margin-right: -60px;
    margin-left: -60px;
  }
  .aesirxui .mx-md-n7 {
    margin-right: -70px;
    margin-left: -70px;
  }
  .aesirxui .mx-md-n8 {
    margin-right: -80px;
    margin-left: -80px;
  }
  .aesirxui .mx-md-n10 {
    margin-right: -10px;
    margin-left: -10px;
  }
  .aesirxui .mx-md-n13 {
    margin-right: -13px;
    margin-left: -13px;
  }
  .aesirxui .mx-md-n14 {
    margin-right: -14px;
    margin-left: -14px;
  }
  .aesirxui .mx-md-n40 {
    margin-right: -40px;
    margin-left: -40px;
  }
  .aesirxui .mx-md-n18px {
    margin-right: -18px;
    margin-left: -18px;
  }
  .aesirxui .mx-md-n32px {
    margin-right: -32px;
    margin-left: -32px;
  }
  .aesirxui .mx-md-n9px {
    margin-right: -9px;
    margin-left: -9px;
  }
  .aesirxui .mx-md-n12px {
    margin-right: -12px;
    margin-left: -12px;
  }
  .aesirxui .mx-md-n19px {
    margin-right: -19px;
    margin-left: -19px;
  }
  .aesirxui .my-md-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxui .my-md-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxui .my-md-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxui .my-md-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxui .my-md-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxui .my-md-nsm {
    margin-top: -5px;
    margin-bottom: -5px;
  }
  .aesirxui .my-md-n8px {
    margin-top: -8px;
    margin-bottom: -8px;
  }
  .aesirxui .my-md-n15 {
    margin-top: -15px;
    margin-bottom: -15px;
  }
  .aesirxui .my-md-n16 {
    margin-top: -16px;
    margin-bottom: -16px;
  }
  .aesirxui .my-md-n20 {
    margin-top: -20px;
    margin-bottom: -20px;
  }
  .aesirxui .my-md-n24 {
    margin-top: -24px;
    margin-bottom: -24px;
  }
  .aesirxui .my-md-n6 {
    margin-top: -60px;
    margin-bottom: -60px;
  }
  .aesirxui .my-md-n7 {
    margin-top: -70px;
    margin-bottom: -70px;
  }
  .aesirxui .my-md-n8 {
    margin-top: -80px;
    margin-bottom: -80px;
  }
  .aesirxui .my-md-n10 {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .aesirxui .my-md-n13 {
    margin-top: -13px;
    margin-bottom: -13px;
  }
  .aesirxui .my-md-n14 {
    margin-top: -14px;
    margin-bottom: -14px;
  }
  .aesirxui .my-md-n40 {
    margin-top: -40px;
    margin-bottom: -40px;
  }
  .aesirxui .my-md-n18px {
    margin-top: -18px;
    margin-bottom: -18px;
  }
  .aesirxui .my-md-n32px {
    margin-top: -32px;
    margin-bottom: -32px;
  }
  .aesirxui .my-md-n9px {
    margin-top: -9px;
    margin-bottom: -9px;
  }
  .aesirxui .my-md-n12px {
    margin-top: -12px;
    margin-bottom: -12px;
  }
  .aesirxui .my-md-n19px {
    margin-top: -19px;
    margin-bottom: -19px;
  }
  .aesirxui .mt-md-n1 {
    margin-top: -0.25rem;
  }
  .aesirxui .mt-md-n2 {
    margin-top: -0.5rem;
  }
  .aesirxui .mt-md-n3 {
    margin-top: -1rem;
  }
  .aesirxui .mt-md-n4 {
    margin-top: -1.5rem;
  }
  .aesirxui .mt-md-n5 {
    margin-top: -3rem;
  }
  .aesirxui .mt-md-nsm {
    margin-top: -5px;
  }
  .aesirxui .mt-md-n8px {
    margin-top: -8px;
  }
  .aesirxui .mt-md-n15 {
    margin-top: -15px;
  }
  .aesirxui .mt-md-n16 {
    margin-top: -16px;
  }
  .aesirxui .mt-md-n20 {
    margin-top: -20px;
  }
  .aesirxui .mt-md-n24 {
    margin-top: -24px;
  }
  .aesirxui .mt-md-n6 {
    margin-top: -60px;
  }
  .aesirxui .mt-md-n7 {
    margin-top: -70px;
  }
  .aesirxui .mt-md-n8 {
    margin-top: -80px;
  }
  .aesirxui .mt-md-n10 {
    margin-top: -10px;
  }
  .aesirxui .mt-md-n13 {
    margin-top: -13px;
  }
  .aesirxui .mt-md-n14 {
    margin-top: -14px;
  }
  .aesirxui .mt-md-n40 {
    margin-top: -40px;
  }
  .aesirxui .mt-md-n18px {
    margin-top: -18px;
  }
  .aesirxui .mt-md-n32px {
    margin-top: -32px;
  }
  .aesirxui .mt-md-n9px {
    margin-top: -9px;
  }
  .aesirxui .mt-md-n12px {
    margin-top: -12px;
  }
  .aesirxui .mt-md-n19px {
    margin-top: -19px;
  }
  .aesirxui .me-md-n1 {
    margin-right: -0.25rem;
  }
  .aesirxui .me-md-n2 {
    margin-right: -0.5rem;
  }
  .aesirxui .me-md-n3 {
    margin-right: -1rem;
  }
  .aesirxui .me-md-n4 {
    margin-right: -1.5rem;
  }
  .aesirxui .me-md-n5 {
    margin-right: -3rem;
  }
  .aesirxui .me-md-nsm {
    margin-right: -5px;
  }
  .aesirxui .me-md-n8px {
    margin-right: -8px;
  }
  .aesirxui .me-md-n15 {
    margin-right: -15px;
  }
  .aesirxui .me-md-n16 {
    margin-right: -16px;
  }
  .aesirxui .me-md-n20 {
    margin-right: -20px;
  }
  .aesirxui .me-md-n24 {
    margin-right: -24px;
  }
  .aesirxui .me-md-n6 {
    margin-right: -60px;
  }
  .aesirxui .me-md-n7 {
    margin-right: -70px;
  }
  .aesirxui .me-md-n8 {
    margin-right: -80px;
  }
  .aesirxui .me-md-n10 {
    margin-right: -10px;
  }
  .aesirxui .me-md-n13 {
    margin-right: -13px;
  }
  .aesirxui .me-md-n14 {
    margin-right: -14px;
  }
  .aesirxui .me-md-n40 {
    margin-right: -40px;
  }
  .aesirxui .me-md-n18px {
    margin-right: -18px;
  }
  .aesirxui .me-md-n32px {
    margin-right: -32px;
  }
  .aesirxui .me-md-n9px {
    margin-right: -9px;
  }
  .aesirxui .me-md-n12px {
    margin-right: -12px;
  }
  .aesirxui .me-md-n19px {
    margin-right: -19px;
  }
  .aesirxui .mb-md-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxui .mb-md-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxui .mb-md-n3 {
    margin-bottom: -1rem;
  }
  .aesirxui .mb-md-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxui .mb-md-n5 {
    margin-bottom: -3rem;
  }
  .aesirxui .mb-md-nsm {
    margin-bottom: -5px;
  }
  .aesirxui .mb-md-n8px {
    margin-bottom: -8px;
  }
  .aesirxui .mb-md-n15 {
    margin-bottom: -15px;
  }
  .aesirxui .mb-md-n16 {
    margin-bottom: -16px;
  }
  .aesirxui .mb-md-n20 {
    margin-bottom: -20px;
  }
  .aesirxui .mb-md-n24 {
    margin-bottom: -24px;
  }
  .aesirxui .mb-md-n6 {
    margin-bottom: -60px;
  }
  .aesirxui .mb-md-n7 {
    margin-bottom: -70px;
  }
  .aesirxui .mb-md-n8 {
    margin-bottom: -80px;
  }
  .aesirxui .mb-md-n10 {
    margin-bottom: -10px;
  }
  .aesirxui .mb-md-n13 {
    margin-bottom: -13px;
  }
  .aesirxui .mb-md-n14 {
    margin-bottom: -14px;
  }
  .aesirxui .mb-md-n40 {
    margin-bottom: -40px;
  }
  .aesirxui .mb-md-n18px {
    margin-bottom: -18px;
  }
  .aesirxui .mb-md-n32px {
    margin-bottom: -32px;
  }
  .aesirxui .mb-md-n9px {
    margin-bottom: -9px;
  }
  .aesirxui .mb-md-n12px {
    margin-bottom: -12px;
  }
  .aesirxui .mb-md-n19px {
    margin-bottom: -19px;
  }
  .aesirxui .ms-md-n1 {
    margin-left: -0.25rem;
  }
  .aesirxui .ms-md-n2 {
    margin-left: -0.5rem;
  }
  .aesirxui .ms-md-n3 {
    margin-left: -1rem;
  }
  .aesirxui .ms-md-n4 {
    margin-left: -1.5rem;
  }
  .aesirxui .ms-md-n5 {
    margin-left: -3rem;
  }
  .aesirxui .ms-md-nsm {
    margin-left: -5px;
  }
  .aesirxui .ms-md-n8px {
    margin-left: -8px;
  }
  .aesirxui .ms-md-n15 {
    margin-left: -15px;
  }
  .aesirxui .ms-md-n16 {
    margin-left: -16px;
  }
  .aesirxui .ms-md-n20 {
    margin-left: -20px;
  }
  .aesirxui .ms-md-n24 {
    margin-left: -24px;
  }
  .aesirxui .ms-md-n6 {
    margin-left: -60px;
  }
  .aesirxui .ms-md-n7 {
    margin-left: -70px;
  }
  .aesirxui .ms-md-n8 {
    margin-left: -80px;
  }
  .aesirxui .ms-md-n10 {
    margin-left: -10px;
  }
  .aesirxui .ms-md-n13 {
    margin-left: -13px;
  }
  .aesirxui .ms-md-n14 {
    margin-left: -14px;
  }
  .aesirxui .ms-md-n40 {
    margin-left: -40px;
  }
  .aesirxui .ms-md-n18px {
    margin-left: -18px;
  }
  .aesirxui .ms-md-n32px {
    margin-left: -32px;
  }
  .aesirxui .ms-md-n9px {
    margin-left: -9px;
  }
  .aesirxui .ms-md-n12px {
    margin-left: -12px;
  }
  .aesirxui .ms-md-n19px {
    margin-left: -19px;
  }
  .aesirxui .p-md-0 {
    padding: 0;
  }
  .aesirxui .p-md-1 {
    padding: 0.25rem;
  }
  .aesirxui .p-md-2 {
    padding: 0.5rem;
  }
  .aesirxui .p-md-3 {
    padding: 1rem;
  }
  .aesirxui .p-md-4 {
    padding: 1.5rem;
  }
  .aesirxui .p-md-5 {
    padding: 3rem;
  }
  .aesirxui .p-md-sm {
    padding: 5px;
  }
  .aesirxui .p-md-8px {
    padding: 8px;
  }
  .aesirxui .p-md-15 {
    padding: 15px;
  }
  .aesirxui .p-md-16 {
    padding: 16px;
  }
  .aesirxui .p-md-20 {
    padding: 20px;
  }
  .aesirxui .p-md-24 {
    padding: 24px;
  }
  .aesirxui .p-md-6 {
    padding: 60px;
  }
  .aesirxui .p-md-7 {
    padding: 70px;
  }
  .aesirxui .p-md-8 {
    padding: 80px;
  }
  .aesirxui .p-md-10 {
    padding: 10px;
  }
  .aesirxui .p-md-13 {
    padding: 13px;
  }
  .aesirxui .p-md-14 {
    padding: 14px;
  }
  .aesirxui .p-md-40 {
    padding: 40px;
  }
  .aesirxui .p-md-18px {
    padding: 18px;
  }
  .aesirxui .p-md-32px {
    padding: 32px;
  }
  .aesirxui .p-md-9px {
    padding: 9px;
  }
  .aesirxui .p-md-12px {
    padding: 12px;
  }
  .aesirxui .p-md-19px {
    padding: 19px;
  }
  .aesirxui .px-md-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxui .px-md-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxui .px-md-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxui .px-md-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxui .px-md-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxui .px-md-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxui .px-md-sm {
    padding-right: 5px;
    padding-left: 5px;
  }
  .aesirxui .px-md-8px {
    padding-right: 8px;
    padding-left: 8px;
  }
  .aesirxui .px-md-15 {
    padding-right: 15px;
    padding-left: 15px;
  }
  .aesirxui .px-md-16 {
    padding-right: 16px;
    padding-left: 16px;
  }
  .aesirxui .px-md-20 {
    padding-right: 20px;
    padding-left: 20px;
  }
  .aesirxui .px-md-24 {
    padding-right: 24px;
    padding-left: 24px;
  }
  .aesirxui .px-md-6 {
    padding-right: 60px;
    padding-left: 60px;
  }
  .aesirxui .px-md-7 {
    padding-right: 70px;
    padding-left: 70px;
  }
  .aesirxui .px-md-8 {
    padding-right: 80px;
    padding-left: 80px;
  }
  .aesirxui .px-md-10 {
    padding-right: 10px;
    padding-left: 10px;
  }
  .aesirxui .px-md-13 {
    padding-right: 13px;
    padding-left: 13px;
  }
  .aesirxui .px-md-14 {
    padding-right: 14px;
    padding-left: 14px;
  }
  .aesirxui .px-md-40 {
    padding-right: 40px;
    padding-left: 40px;
  }
  .aesirxui .px-md-18px {
    padding-right: 18px;
    padding-left: 18px;
  }
  .aesirxui .px-md-32px {
    padding-right: 32px;
    padding-left: 32px;
  }
  .aesirxui .px-md-9px {
    padding-right: 9px;
    padding-left: 9px;
  }
  .aesirxui .px-md-12px {
    padding-right: 12px;
    padding-left: 12px;
  }
  .aesirxui .px-md-19px {
    padding-right: 19px;
    padding-left: 19px;
  }
  .aesirxui .py-md-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxui .py-md-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxui .py-md-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxui .py-md-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxui .py-md-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxui .py-md-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxui .py-md-sm {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .aesirxui .py-md-8px {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .aesirxui .py-md-15 {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .aesirxui .py-md-16 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .aesirxui .py-md-20 {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .aesirxui .py-md-24 {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .aesirxui .py-md-6 {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .aesirxui .py-md-7 {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .aesirxui .py-md-8 {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .aesirxui .py-md-10 {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .aesirxui .py-md-13 {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .aesirxui .py-md-14 {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .aesirxui .py-md-40 {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .aesirxui .py-md-18px {
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .aesirxui .py-md-32px {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  .aesirxui .py-md-9px {
    padding-top: 9px;
    padding-bottom: 9px;
  }
  .aesirxui .py-md-12px {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .aesirxui .py-md-19px {
    padding-top: 19px;
    padding-bottom: 19px;
  }
  .aesirxui .pt-md-0 {
    padding-top: 0;
  }
  .aesirxui .pt-md-1 {
    padding-top: 0.25rem;
  }
  .aesirxui .pt-md-2 {
    padding-top: 0.5rem;
  }
  .aesirxui .pt-md-3 {
    padding-top: 1rem;
  }
  .aesirxui .pt-md-4 {
    padding-top: 1.5rem;
  }
  .aesirxui .pt-md-5 {
    padding-top: 3rem;
  }
  .aesirxui .pt-md-sm {
    padding-top: 5px;
  }
  .aesirxui .pt-md-8px {
    padding-top: 8px;
  }
  .aesirxui .pt-md-15 {
    padding-top: 15px;
  }
  .aesirxui .pt-md-16 {
    padding-top: 16px;
  }
  .aesirxui .pt-md-20 {
    padding-top: 20px;
  }
  .aesirxui .pt-md-24 {
    padding-top: 24px;
  }
  .aesirxui .pt-md-6 {
    padding-top: 60px;
  }
  .aesirxui .pt-md-7 {
    padding-top: 70px;
  }
  .aesirxui .pt-md-8 {
    padding-top: 80px;
  }
  .aesirxui .pt-md-10 {
    padding-top: 10px;
  }
  .aesirxui .pt-md-13 {
    padding-top: 13px;
  }
  .aesirxui .pt-md-14 {
    padding-top: 14px;
  }
  .aesirxui .pt-md-40 {
    padding-top: 40px;
  }
  .aesirxui .pt-md-18px {
    padding-top: 18px;
  }
  .aesirxui .pt-md-32px {
    padding-top: 32px;
  }
  .aesirxui .pt-md-9px {
    padding-top: 9px;
  }
  .aesirxui .pt-md-12px {
    padding-top: 12px;
  }
  .aesirxui .pt-md-19px {
    padding-top: 19px;
  }
  .aesirxui .pe-md-0 {
    padding-right: 0;
  }
  .aesirxui .pe-md-1 {
    padding-right: 0.25rem;
  }
  .aesirxui .pe-md-2 {
    padding-right: 0.5rem;
  }
  .aesirxui .pe-md-3 {
    padding-right: 1rem;
  }
  .aesirxui .pe-md-4 {
    padding-right: 1.5rem;
  }
  .aesirxui .pe-md-5 {
    padding-right: 3rem;
  }
  .aesirxui .pe-md-sm {
    padding-right: 5px;
  }
  .aesirxui .pe-md-8px {
    padding-right: 8px;
  }
  .aesirxui .pe-md-15 {
    padding-right: 15px;
  }
  .aesirxui .pe-md-16 {
    padding-right: 16px;
  }
  .aesirxui .pe-md-20 {
    padding-right: 20px;
  }
  .aesirxui .pe-md-24 {
    padding-right: 24px;
  }
  .aesirxui .pe-md-6 {
    padding-right: 60px;
  }
  .aesirxui .pe-md-7 {
    padding-right: 70px;
  }
  .aesirxui .pe-md-8 {
    padding-right: 80px;
  }
  .aesirxui .pe-md-10 {
    padding-right: 10px;
  }
  .aesirxui .pe-md-13 {
    padding-right: 13px;
  }
  .aesirxui .pe-md-14 {
    padding-right: 14px;
  }
  .aesirxui .pe-md-40 {
    padding-right: 40px;
  }
  .aesirxui .pe-md-18px {
    padding-right: 18px;
  }
  .aesirxui .pe-md-32px {
    padding-right: 32px;
  }
  .aesirxui .pe-md-9px {
    padding-right: 9px;
  }
  .aesirxui .pe-md-12px {
    padding-right: 12px;
  }
  .aesirxui .pe-md-19px {
    padding-right: 19px;
  }
  .aesirxui .pb-md-0 {
    padding-bottom: 0;
  }
  .aesirxui .pb-md-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxui .pb-md-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxui .pb-md-3 {
    padding-bottom: 1rem;
  }
  .aesirxui .pb-md-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxui .pb-md-5 {
    padding-bottom: 3rem;
  }
  .aesirxui .pb-md-sm {
    padding-bottom: 5px;
  }
  .aesirxui .pb-md-8px {
    padding-bottom: 8px;
  }
  .aesirxui .pb-md-15 {
    padding-bottom: 15px;
  }
  .aesirxui .pb-md-16 {
    padding-bottom: 16px;
  }
  .aesirxui .pb-md-20 {
    padding-bottom: 20px;
  }
  .aesirxui .pb-md-24 {
    padding-bottom: 24px;
  }
  .aesirxui .pb-md-6 {
    padding-bottom: 60px;
  }
  .aesirxui .pb-md-7 {
    padding-bottom: 70px;
  }
  .aesirxui .pb-md-8 {
    padding-bottom: 80px;
  }
  .aesirxui .pb-md-10 {
    padding-bottom: 10px;
  }
  .aesirxui .pb-md-13 {
    padding-bottom: 13px;
  }
  .aesirxui .pb-md-14 {
    padding-bottom: 14px;
  }
  .aesirxui .pb-md-40 {
    padding-bottom: 40px;
  }
  .aesirxui .pb-md-18px {
    padding-bottom: 18px;
  }
  .aesirxui .pb-md-32px {
    padding-bottom: 32px;
  }
  .aesirxui .pb-md-9px {
    padding-bottom: 9px;
  }
  .aesirxui .pb-md-12px {
    padding-bottom: 12px;
  }
  .aesirxui .pb-md-19px {
    padding-bottom: 19px;
  }
  .aesirxui .ps-md-0 {
    padding-left: 0;
  }
  .aesirxui .ps-md-1 {
    padding-left: 0.25rem;
  }
  .aesirxui .ps-md-2 {
    padding-left: 0.5rem;
  }
  .aesirxui .ps-md-3 {
    padding-left: 1rem;
  }
  .aesirxui .ps-md-4 {
    padding-left: 1.5rem;
  }
  .aesirxui .ps-md-5 {
    padding-left: 3rem;
  }
  .aesirxui .ps-md-sm {
    padding-left: 5px;
  }
  .aesirxui .ps-md-8px {
    padding-left: 8px;
  }
  .aesirxui .ps-md-15 {
    padding-left: 15px;
  }
  .aesirxui .ps-md-16 {
    padding-left: 16px;
  }
  .aesirxui .ps-md-20 {
    padding-left: 20px;
  }
  .aesirxui .ps-md-24 {
    padding-left: 24px;
  }
  .aesirxui .ps-md-6 {
    padding-left: 60px;
  }
  .aesirxui .ps-md-7 {
    padding-left: 70px;
  }
  .aesirxui .ps-md-8 {
    padding-left: 80px;
  }
  .aesirxui .ps-md-10 {
    padding-left: 10px;
  }
  .aesirxui .ps-md-13 {
    padding-left: 13px;
  }
  .aesirxui .ps-md-14 {
    padding-left: 14px;
  }
  .aesirxui .ps-md-40 {
    padding-left: 40px;
  }
  .aesirxui .ps-md-18px {
    padding-left: 18px;
  }
  .aesirxui .ps-md-32px {
    padding-left: 32px;
  }
  .aesirxui .ps-md-9px {
    padding-left: 9px;
  }
  .aesirxui .ps-md-12px {
    padding-left: 12px;
  }
  .aesirxui .ps-md-19px {
    padding-left: 19px;
  }
  .aesirxui .gap-md-0 {
    gap: 0;
  }
  .aesirxui .gap-md-1 {
    gap: 0.25rem;
  }
  .aesirxui .gap-md-2 {
    gap: 0.5rem;
  }
  .aesirxui .gap-md-3 {
    gap: 1rem;
  }
  .aesirxui .gap-md-4 {
    gap: 1.5rem;
  }
  .aesirxui .gap-md-5 {
    gap: 3rem;
  }
  .aesirxui .gap-md-sm {
    gap: 5px;
  }
  .aesirxui .gap-md-8px {
    gap: 8px;
  }
  .aesirxui .gap-md-15 {
    gap: 15px;
  }
  .aesirxui .gap-md-16 {
    gap: 16px;
  }
  .aesirxui .gap-md-20 {
    gap: 20px;
  }
  .aesirxui .gap-md-24 {
    gap: 24px;
  }
  .aesirxui .gap-md-6 {
    gap: 60px;
  }
  .aesirxui .gap-md-7 {
    gap: 70px;
  }
  .aesirxui .gap-md-8 {
    gap: 80px;
  }
  .aesirxui .gap-md-10 {
    gap: 10px;
  }
  .aesirxui .gap-md-13 {
    gap: 13px;
  }
  .aesirxui .gap-md-14 {
    gap: 14px;
  }
  .aesirxui .gap-md-40 {
    gap: 40px;
  }
  .aesirxui .gap-md-18px {
    gap: 18px;
  }
  .aesirxui .gap-md-32px {
    gap: 32px;
  }
  .aesirxui .gap-md-9px {
    gap: 9px;
  }
  .aesirxui .gap-md-12px {
    gap: 12px;
  }
  .aesirxui .gap-md-19px {
    gap: 19px;
  }
  .aesirxui .row-gap-md-0 {
    row-gap: 0;
  }
  .aesirxui .row-gap-md-1 {
    row-gap: 0.25rem;
  }
  .aesirxui .row-gap-md-2 {
    row-gap: 0.5rem;
  }
  .aesirxui .row-gap-md-3 {
    row-gap: 1rem;
  }
  .aesirxui .row-gap-md-4 {
    row-gap: 1.5rem;
  }
  .aesirxui .row-gap-md-5 {
    row-gap: 3rem;
  }
  .aesirxui .row-gap-md-sm {
    row-gap: 5px;
  }
  .aesirxui .row-gap-md-8px {
    row-gap: 8px;
  }
  .aesirxui .row-gap-md-15 {
    row-gap: 15px;
  }
  .aesirxui .row-gap-md-16 {
    row-gap: 16px;
  }
  .aesirxui .row-gap-md-20 {
    row-gap: 20px;
  }
  .aesirxui .row-gap-md-24 {
    row-gap: 24px;
  }
  .aesirxui .row-gap-md-6 {
    row-gap: 60px;
  }
  .aesirxui .row-gap-md-7 {
    row-gap: 70px;
  }
  .aesirxui .row-gap-md-8 {
    row-gap: 80px;
  }
  .aesirxui .row-gap-md-10 {
    row-gap: 10px;
  }
  .aesirxui .row-gap-md-13 {
    row-gap: 13px;
  }
  .aesirxui .row-gap-md-14 {
    row-gap: 14px;
  }
  .aesirxui .row-gap-md-40 {
    row-gap: 40px;
  }
  .aesirxui .row-gap-md-18px {
    row-gap: 18px;
  }
  .aesirxui .row-gap-md-32px {
    row-gap: 32px;
  }
  .aesirxui .row-gap-md-9px {
    row-gap: 9px;
  }
  .aesirxui .row-gap-md-12px {
    row-gap: 12px;
  }
  .aesirxui .row-gap-md-19px {
    row-gap: 19px;
  }
  .aesirxui .column-gap-md-0 {
    column-gap: 0;
  }
  .aesirxui .column-gap-md-1 {
    column-gap: 0.25rem;
  }
  .aesirxui .column-gap-md-2 {
    column-gap: 0.5rem;
  }
  .aesirxui .column-gap-md-3 {
    column-gap: 1rem;
  }
  .aesirxui .column-gap-md-4 {
    column-gap: 1.5rem;
  }
  .aesirxui .column-gap-md-5 {
    column-gap: 3rem;
  }
  .aesirxui .column-gap-md-sm {
    column-gap: 5px;
  }
  .aesirxui .column-gap-md-8px {
    column-gap: 8px;
  }
  .aesirxui .column-gap-md-15 {
    column-gap: 15px;
  }
  .aesirxui .column-gap-md-16 {
    column-gap: 16px;
  }
  .aesirxui .column-gap-md-20 {
    column-gap: 20px;
  }
  .aesirxui .column-gap-md-24 {
    column-gap: 24px;
  }
  .aesirxui .column-gap-md-6 {
    column-gap: 60px;
  }
  .aesirxui .column-gap-md-7 {
    column-gap: 70px;
  }
  .aesirxui .column-gap-md-8 {
    column-gap: 80px;
  }
  .aesirxui .column-gap-md-10 {
    column-gap: 10px;
  }
  .aesirxui .column-gap-md-13 {
    column-gap: 13px;
  }
  .aesirxui .column-gap-md-14 {
    column-gap: 14px;
  }
  .aesirxui .column-gap-md-40 {
    column-gap: 40px;
  }
  .aesirxui .column-gap-md-18px {
    column-gap: 18px;
  }
  .aesirxui .column-gap-md-32px {
    column-gap: 32px;
  }
  .aesirxui .column-gap-md-9px {
    column-gap: 9px;
  }
  .aesirxui .column-gap-md-12px {
    column-gap: 12px;
  }
  .aesirxui .column-gap-md-19px {
    column-gap: 19px;
  }
  .aesirxui .text-md-start {
    text-align: left;
  }
  .aesirxui .text-md-end {
    text-align: right;
  }
  .aesirxui .text-md-center {
    text-align: center;
  }
}
@media (min-width: 992px) {
  .aesirxui .float-lg-start {
    float: left;
  }
  .aesirxui .float-lg-end {
    float: right;
  }
  .aesirxui .float-lg-none {
    float: none;
  }
  .aesirxui .d-lg-inline {
    display: inline;
  }
  .aesirxui .d-lg-inline-block {
    display: inline-block;
  }
  .aesirxui .d-lg-block {
    display: block;
  }
  .aesirxui .d-lg-grid {
    display: grid;
  }
  .aesirxui .d-lg-inline-grid {
    display: inline-grid;
  }
  .aesirxui .d-lg-table {
    display: table;
  }
  .aesirxui .d-lg-table-row {
    display: table-row;
  }
  .aesirxui .d-lg-table-cell {
    display: table-cell;
  }
  .aesirxui .d-lg-flex {
    display: flex;
  }
  .aesirxui .d-lg-inline-flex {
    display: inline-flex;
  }
  .aesirxui .d-lg-none {
    display: none;
  }
  .aesirxui .w-lg-25 {
    width: 25%;
  }
  .aesirxui .w-lg-20 {
    width: 20%;
  }
  .aesirxui .w-lg-40 {
    width: 40%;
  }
  .aesirxui .w-lg-50 {
    width: 50%;
  }
  .aesirxui .w-lg-75 {
    width: 75%;
  }
  .aesirxui .w-lg-100 {
    width: 100%;
  }
  .aesirxui .w-lg-fit {
    width: fit-content;
  }
  .aesirxui .w-lg-max {
    width: max-content;
  }
  .aesirxui .w-lg-auto {
    width: auto;
  }
  .aesirxui .w-lg-150px {
    width: 150px;
  }
  .aesirxui .w-lg-40px {
    width: 40px;
  }
  .aesirxui .w-lg-145px {
    width: 145px;
  }
  .aesirxui .flex-lg-fill {
    flex: 1 1 auto;
  }
  .aesirxui .flex-lg-1 {
    flex: 1;
  }
  .aesirxui .flex-lg-row {
    flex-direction: row;
  }
  .aesirxui .flex-lg-column {
    flex-direction: column;
  }
  .aesirxui .flex-lg-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxui .flex-lg-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxui .flex-lg-grow-0 {
    flex-grow: 0;
  }
  .aesirxui .flex-lg-grow-1 {
    flex-grow: 1;
  }
  .aesirxui .flex-lg-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxui .flex-lg-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxui .flex-lg-wrap {
    flex-wrap: wrap;
  }
  .aesirxui .flex-lg-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxui .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxui .justify-content-lg-start {
    justify-content: flex-start;
  }
  .aesirxui .justify-content-lg-end {
    justify-content: flex-end;
  }
  .aesirxui .justify-content-lg-center {
    justify-content: center;
  }
  .aesirxui .justify-content-lg-between {
    justify-content: space-between;
  }
  .aesirxui .justify-content-lg-around {
    justify-content: space-around;
  }
  .aesirxui .justify-content-lg-evenly {
    justify-content: space-evenly;
  }
  .aesirxui .align-items-lg-start {
    align-items: flex-start;
  }
  .aesirxui .align-items-lg-end {
    align-items: flex-end;
  }
  .aesirxui .align-items-lg-center {
    align-items: center;
  }
  .aesirxui .align-items-lg-baseline {
    align-items: baseline;
  }
  .aesirxui .align-items-lg-stretch {
    align-items: stretch;
  }
  .aesirxui .align-content-lg-start {
    align-content: flex-start;
  }
  .aesirxui .align-content-lg-end {
    align-content: flex-end;
  }
  .aesirxui .align-content-lg-center {
    align-content: center;
  }
  .aesirxui .align-content-lg-between {
    align-content: space-between;
  }
  .aesirxui .align-content-lg-around {
    align-content: space-around;
  }
  .aesirxui .align-content-lg-stretch {
    align-content: stretch;
  }
  .aesirxui .align-self-lg-auto {
    align-self: auto;
  }
  .aesirxui .align-self-lg-start {
    align-self: flex-start;
  }
  .aesirxui .align-self-lg-end {
    align-self: flex-end;
  }
  .aesirxui .align-self-lg-center {
    align-self: center;
  }
  .aesirxui .align-self-lg-baseline {
    align-self: baseline;
  }
  .aesirxui .align-self-lg-stretch {
    align-self: stretch;
  }
  .aesirxui .order-lg-first {
    order: -1;
  }
  .aesirxui .order-lg-0 {
    order: 0;
  }
  .aesirxui .order-lg-1 {
    order: 1;
  }
  .aesirxui .order-lg-2 {
    order: 2;
  }
  .aesirxui .order-lg-3 {
    order: 3;
  }
  .aesirxui .order-lg-4 {
    order: 4;
  }
  .aesirxui .order-lg-5 {
    order: 5;
  }
  .aesirxui .order-lg-last {
    order: 6;
  }
  .aesirxui .m-lg-0 {
    margin: 0;
  }
  .aesirxui .m-lg-1 {
    margin: 0.25rem;
  }
  .aesirxui .m-lg-2 {
    margin: 0.5rem;
  }
  .aesirxui .m-lg-3 {
    margin: 1rem;
  }
  .aesirxui .m-lg-4 {
    margin: 1.5rem;
  }
  .aesirxui .m-lg-5 {
    margin: 3rem;
  }
  .aesirxui .m-lg-sm {
    margin: 5px;
  }
  .aesirxui .m-lg-8px {
    margin: 8px;
  }
  .aesirxui .m-lg-15 {
    margin: 15px;
  }
  .aesirxui .m-lg-16 {
    margin: 16px;
  }
  .aesirxui .m-lg-20 {
    margin: 20px;
  }
  .aesirxui .m-lg-24 {
    margin: 24px;
  }
  .aesirxui .m-lg-6 {
    margin: 60px;
  }
  .aesirxui .m-lg-7 {
    margin: 70px;
  }
  .aesirxui .m-lg-8 {
    margin: 80px;
  }
  .aesirxui .m-lg-10 {
    margin: 10px;
  }
  .aesirxui .m-lg-13 {
    margin: 13px;
  }
  .aesirxui .m-lg-14 {
    margin: 14px;
  }
  .aesirxui .m-lg-40 {
    margin: 40px;
  }
  .aesirxui .m-lg-18px {
    margin: 18px;
  }
  .aesirxui .m-lg-32px {
    margin: 32px;
  }
  .aesirxui .m-lg-9px {
    margin: 9px;
  }
  .aesirxui .m-lg-12px {
    margin: 12px;
  }
  .aesirxui .m-lg-19px {
    margin: 19px;
  }
  .aesirxui .m-lg-auto {
    margin: auto;
  }
  .aesirxui .mx-lg-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxui .mx-lg-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxui .mx-lg-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxui .mx-lg-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxui .mx-lg-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxui .mx-lg-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxui .mx-lg-sm {
    margin-right: 5px;
    margin-left: 5px;
  }
  .aesirxui .mx-lg-8px {
    margin-right: 8px;
    margin-left: 8px;
  }
  .aesirxui .mx-lg-15 {
    margin-right: 15px;
    margin-left: 15px;
  }
  .aesirxui .mx-lg-16 {
    margin-right: 16px;
    margin-left: 16px;
  }
  .aesirxui .mx-lg-20 {
    margin-right: 20px;
    margin-left: 20px;
  }
  .aesirxui .mx-lg-24 {
    margin-right: 24px;
    margin-left: 24px;
  }
  .aesirxui .mx-lg-6 {
    margin-right: 60px;
    margin-left: 60px;
  }
  .aesirxui .mx-lg-7 {
    margin-right: 70px;
    margin-left: 70px;
  }
  .aesirxui .mx-lg-8 {
    margin-right: 80px;
    margin-left: 80px;
  }
  .aesirxui .mx-lg-10 {
    margin-right: 10px;
    margin-left: 10px;
  }
  .aesirxui .mx-lg-13 {
    margin-right: 13px;
    margin-left: 13px;
  }
  .aesirxui .mx-lg-14 {
    margin-right: 14px;
    margin-left: 14px;
  }
  .aesirxui .mx-lg-40 {
    margin-right: 40px;
    margin-left: 40px;
  }
  .aesirxui .mx-lg-18px {
    margin-right: 18px;
    margin-left: 18px;
  }
  .aesirxui .mx-lg-32px {
    margin-right: 32px;
    margin-left: 32px;
  }
  .aesirxui .mx-lg-9px {
    margin-right: 9px;
    margin-left: 9px;
  }
  .aesirxui .mx-lg-12px {
    margin-right: 12px;
    margin-left: 12px;
  }
  .aesirxui .mx-lg-19px {
    margin-right: 19px;
    margin-left: 19px;
  }
  .aesirxui .mx-lg-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxui .my-lg-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxui .my-lg-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxui .my-lg-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxui .my-lg-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxui .my-lg-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxui .my-lg-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxui .my-lg-sm {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .aesirxui .my-lg-8px {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .aesirxui .my-lg-15 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .aesirxui .my-lg-16 {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .aesirxui .my-lg-20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .aesirxui .my-lg-24 {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .aesirxui .my-lg-6 {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .aesirxui .my-lg-7 {
    margin-top: 70px;
    margin-bottom: 70px;
  }
  .aesirxui .my-lg-8 {
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .aesirxui .my-lg-10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .aesirxui .my-lg-13 {
    margin-top: 13px;
    margin-bottom: 13px;
  }
  .aesirxui .my-lg-14 {
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .aesirxui .my-lg-40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .aesirxui .my-lg-18px {
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .aesirxui .my-lg-32px {
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .aesirxui .my-lg-9px {
    margin-top: 9px;
    margin-bottom: 9px;
  }
  .aesirxui .my-lg-12px {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .aesirxui .my-lg-19px {
    margin-top: 19px;
    margin-bottom: 19px;
  }
  .aesirxui .my-lg-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxui .mt-lg-0 {
    margin-top: 0;
  }
  .aesirxui .mt-lg-1 {
    margin-top: 0.25rem;
  }
  .aesirxui .mt-lg-2 {
    margin-top: 0.5rem;
  }
  .aesirxui .mt-lg-3 {
    margin-top: 1rem;
  }
  .aesirxui .mt-lg-4 {
    margin-top: 1.5rem;
  }
  .aesirxui .mt-lg-5 {
    margin-top: 3rem;
  }
  .aesirxui .mt-lg-sm {
    margin-top: 5px;
  }
  .aesirxui .mt-lg-8px {
    margin-top: 8px;
  }
  .aesirxui .mt-lg-15 {
    margin-top: 15px;
  }
  .aesirxui .mt-lg-16 {
    margin-top: 16px;
  }
  .aesirxui .mt-lg-20 {
    margin-top: 20px;
  }
  .aesirxui .mt-lg-24 {
    margin-top: 24px;
  }
  .aesirxui .mt-lg-6 {
    margin-top: 60px;
  }
  .aesirxui .mt-lg-7 {
    margin-top: 70px;
  }
  .aesirxui .mt-lg-8 {
    margin-top: 80px;
  }
  .aesirxui .mt-lg-10 {
    margin-top: 10px;
  }
  .aesirxui .mt-lg-13 {
    margin-top: 13px;
  }
  .aesirxui .mt-lg-14 {
    margin-top: 14px;
  }
  .aesirxui .mt-lg-40 {
    margin-top: 40px;
  }
  .aesirxui .mt-lg-18px {
    margin-top: 18px;
  }
  .aesirxui .mt-lg-32px {
    margin-top: 32px;
  }
  .aesirxui .mt-lg-9px {
    margin-top: 9px;
  }
  .aesirxui .mt-lg-12px {
    margin-top: 12px;
  }
  .aesirxui .mt-lg-19px {
    margin-top: 19px;
  }
  .aesirxui .mt-lg-auto {
    margin-top: auto;
  }
  .aesirxui .me-lg-0 {
    margin-right: 0;
  }
  .aesirxui .me-lg-1 {
    margin-right: 0.25rem;
  }
  .aesirxui .me-lg-2 {
    margin-right: 0.5rem;
  }
  .aesirxui .me-lg-3 {
    margin-right: 1rem;
  }
  .aesirxui .me-lg-4 {
    margin-right: 1.5rem;
  }
  .aesirxui .me-lg-5 {
    margin-right: 3rem;
  }
  .aesirxui .me-lg-sm {
    margin-right: 5px;
  }
  .aesirxui .me-lg-8px {
    margin-right: 8px;
  }
  .aesirxui .me-lg-15 {
    margin-right: 15px;
  }
  .aesirxui .me-lg-16 {
    margin-right: 16px;
  }
  .aesirxui .me-lg-20 {
    margin-right: 20px;
  }
  .aesirxui .me-lg-24 {
    margin-right: 24px;
  }
  .aesirxui .me-lg-6 {
    margin-right: 60px;
  }
  .aesirxui .me-lg-7 {
    margin-right: 70px;
  }
  .aesirxui .me-lg-8 {
    margin-right: 80px;
  }
  .aesirxui .me-lg-10 {
    margin-right: 10px;
  }
  .aesirxui .me-lg-13 {
    margin-right: 13px;
  }
  .aesirxui .me-lg-14 {
    margin-right: 14px;
  }
  .aesirxui .me-lg-40 {
    margin-right: 40px;
  }
  .aesirxui .me-lg-18px {
    margin-right: 18px;
  }
  .aesirxui .me-lg-32px {
    margin-right: 32px;
  }
  .aesirxui .me-lg-9px {
    margin-right: 9px;
  }
  .aesirxui .me-lg-12px {
    margin-right: 12px;
  }
  .aesirxui .me-lg-19px {
    margin-right: 19px;
  }
  .aesirxui .me-lg-auto {
    margin-right: auto;
  }
  .aesirxui .mb-lg-0 {
    margin-bottom: 0;
  }
  .aesirxui .mb-lg-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxui .mb-lg-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxui .mb-lg-3 {
    margin-bottom: 1rem;
  }
  .aesirxui .mb-lg-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxui .mb-lg-5 {
    margin-bottom: 3rem;
  }
  .aesirxui .mb-lg-sm {
    margin-bottom: 5px;
  }
  .aesirxui .mb-lg-8px {
    margin-bottom: 8px;
  }
  .aesirxui .mb-lg-15 {
    margin-bottom: 15px;
  }
  .aesirxui .mb-lg-16 {
    margin-bottom: 16px;
  }
  .aesirxui .mb-lg-20 {
    margin-bottom: 20px;
  }
  .aesirxui .mb-lg-24 {
    margin-bottom: 24px;
  }
  .aesirxui .mb-lg-6 {
    margin-bottom: 60px;
  }
  .aesirxui .mb-lg-7 {
    margin-bottom: 70px;
  }
  .aesirxui .mb-lg-8 {
    margin-bottom: 80px;
  }
  .aesirxui .mb-lg-10 {
    margin-bottom: 10px;
  }
  .aesirxui .mb-lg-13 {
    margin-bottom: 13px;
  }
  .aesirxui .mb-lg-14 {
    margin-bottom: 14px;
  }
  .aesirxui .mb-lg-40 {
    margin-bottom: 40px;
  }
  .aesirxui .mb-lg-18px {
    margin-bottom: 18px;
  }
  .aesirxui .mb-lg-32px {
    margin-bottom: 32px;
  }
  .aesirxui .mb-lg-9px {
    margin-bottom: 9px;
  }
  .aesirxui .mb-lg-12px {
    margin-bottom: 12px;
  }
  .aesirxui .mb-lg-19px {
    margin-bottom: 19px;
  }
  .aesirxui .mb-lg-auto {
    margin-bottom: auto;
  }
  .aesirxui .ms-lg-0 {
    margin-left: 0;
  }
  .aesirxui .ms-lg-1 {
    margin-left: 0.25rem;
  }
  .aesirxui .ms-lg-2 {
    margin-left: 0.5rem;
  }
  .aesirxui .ms-lg-3 {
    margin-left: 1rem;
  }
  .aesirxui .ms-lg-4 {
    margin-left: 1.5rem;
  }
  .aesirxui .ms-lg-5 {
    margin-left: 3rem;
  }
  .aesirxui .ms-lg-sm {
    margin-left: 5px;
  }
  .aesirxui .ms-lg-8px {
    margin-left: 8px;
  }
  .aesirxui .ms-lg-15 {
    margin-left: 15px;
  }
  .aesirxui .ms-lg-16 {
    margin-left: 16px;
  }
  .aesirxui .ms-lg-20 {
    margin-left: 20px;
  }
  .aesirxui .ms-lg-24 {
    margin-left: 24px;
  }
  .aesirxui .ms-lg-6 {
    margin-left: 60px;
  }
  .aesirxui .ms-lg-7 {
    margin-left: 70px;
  }
  .aesirxui .ms-lg-8 {
    margin-left: 80px;
  }
  .aesirxui .ms-lg-10 {
    margin-left: 10px;
  }
  .aesirxui .ms-lg-13 {
    margin-left: 13px;
  }
  .aesirxui .ms-lg-14 {
    margin-left: 14px;
  }
  .aesirxui .ms-lg-40 {
    margin-left: 40px;
  }
  .aesirxui .ms-lg-18px {
    margin-left: 18px;
  }
  .aesirxui .ms-lg-32px {
    margin-left: 32px;
  }
  .aesirxui .ms-lg-9px {
    margin-left: 9px;
  }
  .aesirxui .ms-lg-12px {
    margin-left: 12px;
  }
  .aesirxui .ms-lg-19px {
    margin-left: 19px;
  }
  .aesirxui .ms-lg-auto {
    margin-left: auto;
  }
  .aesirxui .m-lg-n1 {
    margin: -0.25rem;
  }
  .aesirxui .m-lg-n2 {
    margin: -0.5rem;
  }
  .aesirxui .m-lg-n3 {
    margin: -1rem;
  }
  .aesirxui .m-lg-n4 {
    margin: -1.5rem;
  }
  .aesirxui .m-lg-n5 {
    margin: -3rem;
  }
  .aesirxui .m-lg-nsm {
    margin: -5px;
  }
  .aesirxui .m-lg-n8px {
    margin: -8px;
  }
  .aesirxui .m-lg-n15 {
    margin: -15px;
  }
  .aesirxui .m-lg-n16 {
    margin: -16px;
  }
  .aesirxui .m-lg-n20 {
    margin: -20px;
  }
  .aesirxui .m-lg-n24 {
    margin: -24px;
  }
  .aesirxui .m-lg-n6 {
    margin: -60px;
  }
  .aesirxui .m-lg-n7 {
    margin: -70px;
  }
  .aesirxui .m-lg-n8 {
    margin: -80px;
  }
  .aesirxui .m-lg-n10 {
    margin: -10px;
  }
  .aesirxui .m-lg-n13 {
    margin: -13px;
  }
  .aesirxui .m-lg-n14 {
    margin: -14px;
  }
  .aesirxui .m-lg-n40 {
    margin: -40px;
  }
  .aesirxui .m-lg-n18px {
    margin: -18px;
  }
  .aesirxui .m-lg-n32px {
    margin: -32px;
  }
  .aesirxui .m-lg-n9px {
    margin: -9px;
  }
  .aesirxui .m-lg-n12px {
    margin: -12px;
  }
  .aesirxui .m-lg-n19px {
    margin: -19px;
  }
  .aesirxui .mx-lg-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxui .mx-lg-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxui .mx-lg-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxui .mx-lg-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxui .mx-lg-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxui .mx-lg-nsm {
    margin-right: -5px;
    margin-left: -5px;
  }
  .aesirxui .mx-lg-n8px {
    margin-right: -8px;
    margin-left: -8px;
  }
  .aesirxui .mx-lg-n15 {
    margin-right: -15px;
    margin-left: -15px;
  }
  .aesirxui .mx-lg-n16 {
    margin-right: -16px;
    margin-left: -16px;
  }
  .aesirxui .mx-lg-n20 {
    margin-right: -20px;
    margin-left: -20px;
  }
  .aesirxui .mx-lg-n24 {
    margin-right: -24px;
    margin-left: -24px;
  }
  .aesirxui .mx-lg-n6 {
    margin-right: -60px;
    margin-left: -60px;
  }
  .aesirxui .mx-lg-n7 {
    margin-right: -70px;
    margin-left: -70px;
  }
  .aesirxui .mx-lg-n8 {
    margin-right: -80px;
    margin-left: -80px;
  }
  .aesirxui .mx-lg-n10 {
    margin-right: -10px;
    margin-left: -10px;
  }
  .aesirxui .mx-lg-n13 {
    margin-right: -13px;
    margin-left: -13px;
  }
  .aesirxui .mx-lg-n14 {
    margin-right: -14px;
    margin-left: -14px;
  }
  .aesirxui .mx-lg-n40 {
    margin-right: -40px;
    margin-left: -40px;
  }
  .aesirxui .mx-lg-n18px {
    margin-right: -18px;
    margin-left: -18px;
  }
  .aesirxui .mx-lg-n32px {
    margin-right: -32px;
    margin-left: -32px;
  }
  .aesirxui .mx-lg-n9px {
    margin-right: -9px;
    margin-left: -9px;
  }
  .aesirxui .mx-lg-n12px {
    margin-right: -12px;
    margin-left: -12px;
  }
  .aesirxui .mx-lg-n19px {
    margin-right: -19px;
    margin-left: -19px;
  }
  .aesirxui .my-lg-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxui .my-lg-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxui .my-lg-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxui .my-lg-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxui .my-lg-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxui .my-lg-nsm {
    margin-top: -5px;
    margin-bottom: -5px;
  }
  .aesirxui .my-lg-n8px {
    margin-top: -8px;
    margin-bottom: -8px;
  }
  .aesirxui .my-lg-n15 {
    margin-top: -15px;
    margin-bottom: -15px;
  }
  .aesirxui .my-lg-n16 {
    margin-top: -16px;
    margin-bottom: -16px;
  }
  .aesirxui .my-lg-n20 {
    margin-top: -20px;
    margin-bottom: -20px;
  }
  .aesirxui .my-lg-n24 {
    margin-top: -24px;
    margin-bottom: -24px;
  }
  .aesirxui .my-lg-n6 {
    margin-top: -60px;
    margin-bottom: -60px;
  }
  .aesirxui .my-lg-n7 {
    margin-top: -70px;
    margin-bottom: -70px;
  }
  .aesirxui .my-lg-n8 {
    margin-top: -80px;
    margin-bottom: -80px;
  }
  .aesirxui .my-lg-n10 {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .aesirxui .my-lg-n13 {
    margin-top: -13px;
    margin-bottom: -13px;
  }
  .aesirxui .my-lg-n14 {
    margin-top: -14px;
    margin-bottom: -14px;
  }
  .aesirxui .my-lg-n40 {
    margin-top: -40px;
    margin-bottom: -40px;
  }
  .aesirxui .my-lg-n18px {
    margin-top: -18px;
    margin-bottom: -18px;
  }
  .aesirxui .my-lg-n32px {
    margin-top: -32px;
    margin-bottom: -32px;
  }
  .aesirxui .my-lg-n9px {
    margin-top: -9px;
    margin-bottom: -9px;
  }
  .aesirxui .my-lg-n12px {
    margin-top: -12px;
    margin-bottom: -12px;
  }
  .aesirxui .my-lg-n19px {
    margin-top: -19px;
    margin-bottom: -19px;
  }
  .aesirxui .mt-lg-n1 {
    margin-top: -0.25rem;
  }
  .aesirxui .mt-lg-n2 {
    margin-top: -0.5rem;
  }
  .aesirxui .mt-lg-n3 {
    margin-top: -1rem;
  }
  .aesirxui .mt-lg-n4 {
    margin-top: -1.5rem;
  }
  .aesirxui .mt-lg-n5 {
    margin-top: -3rem;
  }
  .aesirxui .mt-lg-nsm {
    margin-top: -5px;
  }
  .aesirxui .mt-lg-n8px {
    margin-top: -8px;
  }
  .aesirxui .mt-lg-n15 {
    margin-top: -15px;
  }
  .aesirxui .mt-lg-n16 {
    margin-top: -16px;
  }
  .aesirxui .mt-lg-n20 {
    margin-top: -20px;
  }
  .aesirxui .mt-lg-n24 {
    margin-top: -24px;
  }
  .aesirxui .mt-lg-n6 {
    margin-top: -60px;
  }
  .aesirxui .mt-lg-n7 {
    margin-top: -70px;
  }
  .aesirxui .mt-lg-n8 {
    margin-top: -80px;
  }
  .aesirxui .mt-lg-n10 {
    margin-top: -10px;
  }
  .aesirxui .mt-lg-n13 {
    margin-top: -13px;
  }
  .aesirxui .mt-lg-n14 {
    margin-top: -14px;
  }
  .aesirxui .mt-lg-n40 {
    margin-top: -40px;
  }
  .aesirxui .mt-lg-n18px {
    margin-top: -18px;
  }
  .aesirxui .mt-lg-n32px {
    margin-top: -32px;
  }
  .aesirxui .mt-lg-n9px {
    margin-top: -9px;
  }
  .aesirxui .mt-lg-n12px {
    margin-top: -12px;
  }
  .aesirxui .mt-lg-n19px {
    margin-top: -19px;
  }
  .aesirxui .me-lg-n1 {
    margin-right: -0.25rem;
  }
  .aesirxui .me-lg-n2 {
    margin-right: -0.5rem;
  }
  .aesirxui .me-lg-n3 {
    margin-right: -1rem;
  }
  .aesirxui .me-lg-n4 {
    margin-right: -1.5rem;
  }
  .aesirxui .me-lg-n5 {
    margin-right: -3rem;
  }
  .aesirxui .me-lg-nsm {
    margin-right: -5px;
  }
  .aesirxui .me-lg-n8px {
    margin-right: -8px;
  }
  .aesirxui .me-lg-n15 {
    margin-right: -15px;
  }
  .aesirxui .me-lg-n16 {
    margin-right: -16px;
  }
  .aesirxui .me-lg-n20 {
    margin-right: -20px;
  }
  .aesirxui .me-lg-n24 {
    margin-right: -24px;
  }
  .aesirxui .me-lg-n6 {
    margin-right: -60px;
  }
  .aesirxui .me-lg-n7 {
    margin-right: -70px;
  }
  .aesirxui .me-lg-n8 {
    margin-right: -80px;
  }
  .aesirxui .me-lg-n10 {
    margin-right: -10px;
  }
  .aesirxui .me-lg-n13 {
    margin-right: -13px;
  }
  .aesirxui .me-lg-n14 {
    margin-right: -14px;
  }
  .aesirxui .me-lg-n40 {
    margin-right: -40px;
  }
  .aesirxui .me-lg-n18px {
    margin-right: -18px;
  }
  .aesirxui .me-lg-n32px {
    margin-right: -32px;
  }
  .aesirxui .me-lg-n9px {
    margin-right: -9px;
  }
  .aesirxui .me-lg-n12px {
    margin-right: -12px;
  }
  .aesirxui .me-lg-n19px {
    margin-right: -19px;
  }
  .aesirxui .mb-lg-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxui .mb-lg-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxui .mb-lg-n3 {
    margin-bottom: -1rem;
  }
  .aesirxui .mb-lg-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxui .mb-lg-n5 {
    margin-bottom: -3rem;
  }
  .aesirxui .mb-lg-nsm {
    margin-bottom: -5px;
  }
  .aesirxui .mb-lg-n8px {
    margin-bottom: -8px;
  }
  .aesirxui .mb-lg-n15 {
    margin-bottom: -15px;
  }
  .aesirxui .mb-lg-n16 {
    margin-bottom: -16px;
  }
  .aesirxui .mb-lg-n20 {
    margin-bottom: -20px;
  }
  .aesirxui .mb-lg-n24 {
    margin-bottom: -24px;
  }
  .aesirxui .mb-lg-n6 {
    margin-bottom: -60px;
  }
  .aesirxui .mb-lg-n7 {
    margin-bottom: -70px;
  }
  .aesirxui .mb-lg-n8 {
    margin-bottom: -80px;
  }
  .aesirxui .mb-lg-n10 {
    margin-bottom: -10px;
  }
  .aesirxui .mb-lg-n13 {
    margin-bottom: -13px;
  }
  .aesirxui .mb-lg-n14 {
    margin-bottom: -14px;
  }
  .aesirxui .mb-lg-n40 {
    margin-bottom: -40px;
  }
  .aesirxui .mb-lg-n18px {
    margin-bottom: -18px;
  }
  .aesirxui .mb-lg-n32px {
    margin-bottom: -32px;
  }
  .aesirxui .mb-lg-n9px {
    margin-bottom: -9px;
  }
  .aesirxui .mb-lg-n12px {
    margin-bottom: -12px;
  }
  .aesirxui .mb-lg-n19px {
    margin-bottom: -19px;
  }
  .aesirxui .ms-lg-n1 {
    margin-left: -0.25rem;
  }
  .aesirxui .ms-lg-n2 {
    margin-left: -0.5rem;
  }
  .aesirxui .ms-lg-n3 {
    margin-left: -1rem;
  }
  .aesirxui .ms-lg-n4 {
    margin-left: -1.5rem;
  }
  .aesirxui .ms-lg-n5 {
    margin-left: -3rem;
  }
  .aesirxui .ms-lg-nsm {
    margin-left: -5px;
  }
  .aesirxui .ms-lg-n8px {
    margin-left: -8px;
  }
  .aesirxui .ms-lg-n15 {
    margin-left: -15px;
  }
  .aesirxui .ms-lg-n16 {
    margin-left: -16px;
  }
  .aesirxui .ms-lg-n20 {
    margin-left: -20px;
  }
  .aesirxui .ms-lg-n24 {
    margin-left: -24px;
  }
  .aesirxui .ms-lg-n6 {
    margin-left: -60px;
  }
  .aesirxui .ms-lg-n7 {
    margin-left: -70px;
  }
  .aesirxui .ms-lg-n8 {
    margin-left: -80px;
  }
  .aesirxui .ms-lg-n10 {
    margin-left: -10px;
  }
  .aesirxui .ms-lg-n13 {
    margin-left: -13px;
  }
  .aesirxui .ms-lg-n14 {
    margin-left: -14px;
  }
  .aesirxui .ms-lg-n40 {
    margin-left: -40px;
  }
  .aesirxui .ms-lg-n18px {
    margin-left: -18px;
  }
  .aesirxui .ms-lg-n32px {
    margin-left: -32px;
  }
  .aesirxui .ms-lg-n9px {
    margin-left: -9px;
  }
  .aesirxui .ms-lg-n12px {
    margin-left: -12px;
  }
  .aesirxui .ms-lg-n19px {
    margin-left: -19px;
  }
  .aesirxui .p-lg-0 {
    padding: 0;
  }
  .aesirxui .p-lg-1 {
    padding: 0.25rem;
  }
  .aesirxui .p-lg-2 {
    padding: 0.5rem;
  }
  .aesirxui .p-lg-3 {
    padding: 1rem;
  }
  .aesirxui .p-lg-4 {
    padding: 1.5rem;
  }
  .aesirxui .p-lg-5 {
    padding: 3rem;
  }
  .aesirxui .p-lg-sm {
    padding: 5px;
  }
  .aesirxui .p-lg-8px {
    padding: 8px;
  }
  .aesirxui .p-lg-15 {
    padding: 15px;
  }
  .aesirxui .p-lg-16 {
    padding: 16px;
  }
  .aesirxui .p-lg-20 {
    padding: 20px;
  }
  .aesirxui .p-lg-24 {
    padding: 24px;
  }
  .aesirxui .p-lg-6 {
    padding: 60px;
  }
  .aesirxui .p-lg-7 {
    padding: 70px;
  }
  .aesirxui .p-lg-8 {
    padding: 80px;
  }
  .aesirxui .p-lg-10 {
    padding: 10px;
  }
  .aesirxui .p-lg-13 {
    padding: 13px;
  }
  .aesirxui .p-lg-14 {
    padding: 14px;
  }
  .aesirxui .p-lg-40 {
    padding: 40px;
  }
  .aesirxui .p-lg-18px {
    padding: 18px;
  }
  .aesirxui .p-lg-32px {
    padding: 32px;
  }
  .aesirxui .p-lg-9px {
    padding: 9px;
  }
  .aesirxui .p-lg-12px {
    padding: 12px;
  }
  .aesirxui .p-lg-19px {
    padding: 19px;
  }
  .aesirxui .px-lg-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxui .px-lg-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxui .px-lg-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxui .px-lg-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxui .px-lg-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxui .px-lg-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxui .px-lg-sm {
    padding-right: 5px;
    padding-left: 5px;
  }
  .aesirxui .px-lg-8px {
    padding-right: 8px;
    padding-left: 8px;
  }
  .aesirxui .px-lg-15 {
    padding-right: 15px;
    padding-left: 15px;
  }
  .aesirxui .px-lg-16 {
    padding-right: 16px;
    padding-left: 16px;
  }
  .aesirxui .px-lg-20 {
    padding-right: 20px;
    padding-left: 20px;
  }
  .aesirxui .px-lg-24 {
    padding-right: 24px;
    padding-left: 24px;
  }
  .aesirxui .px-lg-6 {
    padding-right: 60px;
    padding-left: 60px;
  }
  .aesirxui .px-lg-7 {
    padding-right: 70px;
    padding-left: 70px;
  }
  .aesirxui .px-lg-8 {
    padding-right: 80px;
    padding-left: 80px;
  }
  .aesirxui .px-lg-10 {
    padding-right: 10px;
    padding-left: 10px;
  }
  .aesirxui .px-lg-13 {
    padding-right: 13px;
    padding-left: 13px;
  }
  .aesirxui .px-lg-14 {
    padding-right: 14px;
    padding-left: 14px;
  }
  .aesirxui .px-lg-40 {
    padding-right: 40px;
    padding-left: 40px;
  }
  .aesirxui .px-lg-18px {
    padding-right: 18px;
    padding-left: 18px;
  }
  .aesirxui .px-lg-32px {
    padding-right: 32px;
    padding-left: 32px;
  }
  .aesirxui .px-lg-9px {
    padding-right: 9px;
    padding-left: 9px;
  }
  .aesirxui .px-lg-12px {
    padding-right: 12px;
    padding-left: 12px;
  }
  .aesirxui .px-lg-19px {
    padding-right: 19px;
    padding-left: 19px;
  }
  .aesirxui .py-lg-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxui .py-lg-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxui .py-lg-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxui .py-lg-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxui .py-lg-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxui .py-lg-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxui .py-lg-sm {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .aesirxui .py-lg-8px {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .aesirxui .py-lg-15 {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .aesirxui .py-lg-16 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .aesirxui .py-lg-20 {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .aesirxui .py-lg-24 {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .aesirxui .py-lg-6 {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .aesirxui .py-lg-7 {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .aesirxui .py-lg-8 {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .aesirxui .py-lg-10 {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .aesirxui .py-lg-13 {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .aesirxui .py-lg-14 {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .aesirxui .py-lg-40 {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .aesirxui .py-lg-18px {
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .aesirxui .py-lg-32px {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  .aesirxui .py-lg-9px {
    padding-top: 9px;
    padding-bottom: 9px;
  }
  .aesirxui .py-lg-12px {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .aesirxui .py-lg-19px {
    padding-top: 19px;
    padding-bottom: 19px;
  }
  .aesirxui .pt-lg-0 {
    padding-top: 0;
  }
  .aesirxui .pt-lg-1 {
    padding-top: 0.25rem;
  }
  .aesirxui .pt-lg-2 {
    padding-top: 0.5rem;
  }
  .aesirxui .pt-lg-3 {
    padding-top: 1rem;
  }
  .aesirxui .pt-lg-4 {
    padding-top: 1.5rem;
  }
  .aesirxui .pt-lg-5 {
    padding-top: 3rem;
  }
  .aesirxui .pt-lg-sm {
    padding-top: 5px;
  }
  .aesirxui .pt-lg-8px {
    padding-top: 8px;
  }
  .aesirxui .pt-lg-15 {
    padding-top: 15px;
  }
  .aesirxui .pt-lg-16 {
    padding-top: 16px;
  }
  .aesirxui .pt-lg-20 {
    padding-top: 20px;
  }
  .aesirxui .pt-lg-24 {
    padding-top: 24px;
  }
  .aesirxui .pt-lg-6 {
    padding-top: 60px;
  }
  .aesirxui .pt-lg-7 {
    padding-top: 70px;
  }
  .aesirxui .pt-lg-8 {
    padding-top: 80px;
  }
  .aesirxui .pt-lg-10 {
    padding-top: 10px;
  }
  .aesirxui .pt-lg-13 {
    padding-top: 13px;
  }
  .aesirxui .pt-lg-14 {
    padding-top: 14px;
  }
  .aesirxui .pt-lg-40 {
    padding-top: 40px;
  }
  .aesirxui .pt-lg-18px {
    padding-top: 18px;
  }
  .aesirxui .pt-lg-32px {
    padding-top: 32px;
  }
  .aesirxui .pt-lg-9px {
    padding-top: 9px;
  }
  .aesirxui .pt-lg-12px {
    padding-top: 12px;
  }
  .aesirxui .pt-lg-19px {
    padding-top: 19px;
  }
  .aesirxui .pe-lg-0 {
    padding-right: 0;
  }
  .aesirxui .pe-lg-1 {
    padding-right: 0.25rem;
  }
  .aesirxui .pe-lg-2 {
    padding-right: 0.5rem;
  }
  .aesirxui .pe-lg-3 {
    padding-right: 1rem;
  }
  .aesirxui .pe-lg-4 {
    padding-right: 1.5rem;
  }
  .aesirxui .pe-lg-5 {
    padding-right: 3rem;
  }
  .aesirxui .pe-lg-sm {
    padding-right: 5px;
  }
  .aesirxui .pe-lg-8px {
    padding-right: 8px;
  }
  .aesirxui .pe-lg-15 {
    padding-right: 15px;
  }
  .aesirxui .pe-lg-16 {
    padding-right: 16px;
  }
  .aesirxui .pe-lg-20 {
    padding-right: 20px;
  }
  .aesirxui .pe-lg-24 {
    padding-right: 24px;
  }
  .aesirxui .pe-lg-6 {
    padding-right: 60px;
  }
  .aesirxui .pe-lg-7 {
    padding-right: 70px;
  }
  .aesirxui .pe-lg-8 {
    padding-right: 80px;
  }
  .aesirxui .pe-lg-10 {
    padding-right: 10px;
  }
  .aesirxui .pe-lg-13 {
    padding-right: 13px;
  }
  .aesirxui .pe-lg-14 {
    padding-right: 14px;
  }
  .aesirxui .pe-lg-40 {
    padding-right: 40px;
  }
  .aesirxui .pe-lg-18px {
    padding-right: 18px;
  }
  .aesirxui .pe-lg-32px {
    padding-right: 32px;
  }
  .aesirxui .pe-lg-9px {
    padding-right: 9px;
  }
  .aesirxui .pe-lg-12px {
    padding-right: 12px;
  }
  .aesirxui .pe-lg-19px {
    padding-right: 19px;
  }
  .aesirxui .pb-lg-0 {
    padding-bottom: 0;
  }
  .aesirxui .pb-lg-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxui .pb-lg-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxui .pb-lg-3 {
    padding-bottom: 1rem;
  }
  .aesirxui .pb-lg-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxui .pb-lg-5 {
    padding-bottom: 3rem;
  }
  .aesirxui .pb-lg-sm {
    padding-bottom: 5px;
  }
  .aesirxui .pb-lg-8px {
    padding-bottom: 8px;
  }
  .aesirxui .pb-lg-15 {
    padding-bottom: 15px;
  }
  .aesirxui .pb-lg-16 {
    padding-bottom: 16px;
  }
  .aesirxui .pb-lg-20 {
    padding-bottom: 20px;
  }
  .aesirxui .pb-lg-24 {
    padding-bottom: 24px;
  }
  .aesirxui .pb-lg-6 {
    padding-bottom: 60px;
  }
  .aesirxui .pb-lg-7 {
    padding-bottom: 70px;
  }
  .aesirxui .pb-lg-8 {
    padding-bottom: 80px;
  }
  .aesirxui .pb-lg-10 {
    padding-bottom: 10px;
  }
  .aesirxui .pb-lg-13 {
    padding-bottom: 13px;
  }
  .aesirxui .pb-lg-14 {
    padding-bottom: 14px;
  }
  .aesirxui .pb-lg-40 {
    padding-bottom: 40px;
  }
  .aesirxui .pb-lg-18px {
    padding-bottom: 18px;
  }
  .aesirxui .pb-lg-32px {
    padding-bottom: 32px;
  }
  .aesirxui .pb-lg-9px {
    padding-bottom: 9px;
  }
  .aesirxui .pb-lg-12px {
    padding-bottom: 12px;
  }
  .aesirxui .pb-lg-19px {
    padding-bottom: 19px;
  }
  .aesirxui .ps-lg-0 {
    padding-left: 0;
  }
  .aesirxui .ps-lg-1 {
    padding-left: 0.25rem;
  }
  .aesirxui .ps-lg-2 {
    padding-left: 0.5rem;
  }
  .aesirxui .ps-lg-3 {
    padding-left: 1rem;
  }
  .aesirxui .ps-lg-4 {
    padding-left: 1.5rem;
  }
  .aesirxui .ps-lg-5 {
    padding-left: 3rem;
  }
  .aesirxui .ps-lg-sm {
    padding-left: 5px;
  }
  .aesirxui .ps-lg-8px {
    padding-left: 8px;
  }
  .aesirxui .ps-lg-15 {
    padding-left: 15px;
  }
  .aesirxui .ps-lg-16 {
    padding-left: 16px;
  }
  .aesirxui .ps-lg-20 {
    padding-left: 20px;
  }
  .aesirxui .ps-lg-24 {
    padding-left: 24px;
  }
  .aesirxui .ps-lg-6 {
    padding-left: 60px;
  }
  .aesirxui .ps-lg-7 {
    padding-left: 70px;
  }
  .aesirxui .ps-lg-8 {
    padding-left: 80px;
  }
  .aesirxui .ps-lg-10 {
    padding-left: 10px;
  }
  .aesirxui .ps-lg-13 {
    padding-left: 13px;
  }
  .aesirxui .ps-lg-14 {
    padding-left: 14px;
  }
  .aesirxui .ps-lg-40 {
    padding-left: 40px;
  }
  .aesirxui .ps-lg-18px {
    padding-left: 18px;
  }
  .aesirxui .ps-lg-32px {
    padding-left: 32px;
  }
  .aesirxui .ps-lg-9px {
    padding-left: 9px;
  }
  .aesirxui .ps-lg-12px {
    padding-left: 12px;
  }
  .aesirxui .ps-lg-19px {
    padding-left: 19px;
  }
  .aesirxui .gap-lg-0 {
    gap: 0;
  }
  .aesirxui .gap-lg-1 {
    gap: 0.25rem;
  }
  .aesirxui .gap-lg-2 {
    gap: 0.5rem;
  }
  .aesirxui .gap-lg-3 {
    gap: 1rem;
  }
  .aesirxui .gap-lg-4 {
    gap: 1.5rem;
  }
  .aesirxui .gap-lg-5 {
    gap: 3rem;
  }
  .aesirxui .gap-lg-sm {
    gap: 5px;
  }
  .aesirxui .gap-lg-8px {
    gap: 8px;
  }
  .aesirxui .gap-lg-15 {
    gap: 15px;
  }
  .aesirxui .gap-lg-16 {
    gap: 16px;
  }
  .aesirxui .gap-lg-20 {
    gap: 20px;
  }
  .aesirxui .gap-lg-24 {
    gap: 24px;
  }
  .aesirxui .gap-lg-6 {
    gap: 60px;
  }
  .aesirxui .gap-lg-7 {
    gap: 70px;
  }
  .aesirxui .gap-lg-8 {
    gap: 80px;
  }
  .aesirxui .gap-lg-10 {
    gap: 10px;
  }
  .aesirxui .gap-lg-13 {
    gap: 13px;
  }
  .aesirxui .gap-lg-14 {
    gap: 14px;
  }
  .aesirxui .gap-lg-40 {
    gap: 40px;
  }
  .aesirxui .gap-lg-18px {
    gap: 18px;
  }
  .aesirxui .gap-lg-32px {
    gap: 32px;
  }
  .aesirxui .gap-lg-9px {
    gap: 9px;
  }
  .aesirxui .gap-lg-12px {
    gap: 12px;
  }
  .aesirxui .gap-lg-19px {
    gap: 19px;
  }
  .aesirxui .row-gap-lg-0 {
    row-gap: 0;
  }
  .aesirxui .row-gap-lg-1 {
    row-gap: 0.25rem;
  }
  .aesirxui .row-gap-lg-2 {
    row-gap: 0.5rem;
  }
  .aesirxui .row-gap-lg-3 {
    row-gap: 1rem;
  }
  .aesirxui .row-gap-lg-4 {
    row-gap: 1.5rem;
  }
  .aesirxui .row-gap-lg-5 {
    row-gap: 3rem;
  }
  .aesirxui .row-gap-lg-sm {
    row-gap: 5px;
  }
  .aesirxui .row-gap-lg-8px {
    row-gap: 8px;
  }
  .aesirxui .row-gap-lg-15 {
    row-gap: 15px;
  }
  .aesirxui .row-gap-lg-16 {
    row-gap: 16px;
  }
  .aesirxui .row-gap-lg-20 {
    row-gap: 20px;
  }
  .aesirxui .row-gap-lg-24 {
    row-gap: 24px;
  }
  .aesirxui .row-gap-lg-6 {
    row-gap: 60px;
  }
  .aesirxui .row-gap-lg-7 {
    row-gap: 70px;
  }
  .aesirxui .row-gap-lg-8 {
    row-gap: 80px;
  }
  .aesirxui .row-gap-lg-10 {
    row-gap: 10px;
  }
  .aesirxui .row-gap-lg-13 {
    row-gap: 13px;
  }
  .aesirxui .row-gap-lg-14 {
    row-gap: 14px;
  }
  .aesirxui .row-gap-lg-40 {
    row-gap: 40px;
  }
  .aesirxui .row-gap-lg-18px {
    row-gap: 18px;
  }
  .aesirxui .row-gap-lg-32px {
    row-gap: 32px;
  }
  .aesirxui .row-gap-lg-9px {
    row-gap: 9px;
  }
  .aesirxui .row-gap-lg-12px {
    row-gap: 12px;
  }
  .aesirxui .row-gap-lg-19px {
    row-gap: 19px;
  }
  .aesirxui .column-gap-lg-0 {
    column-gap: 0;
  }
  .aesirxui .column-gap-lg-1 {
    column-gap: 0.25rem;
  }
  .aesirxui .column-gap-lg-2 {
    column-gap: 0.5rem;
  }
  .aesirxui .column-gap-lg-3 {
    column-gap: 1rem;
  }
  .aesirxui .column-gap-lg-4 {
    column-gap: 1.5rem;
  }
  .aesirxui .column-gap-lg-5 {
    column-gap: 3rem;
  }
  .aesirxui .column-gap-lg-sm {
    column-gap: 5px;
  }
  .aesirxui .column-gap-lg-8px {
    column-gap: 8px;
  }
  .aesirxui .column-gap-lg-15 {
    column-gap: 15px;
  }
  .aesirxui .column-gap-lg-16 {
    column-gap: 16px;
  }
  .aesirxui .column-gap-lg-20 {
    column-gap: 20px;
  }
  .aesirxui .column-gap-lg-24 {
    column-gap: 24px;
  }
  .aesirxui .column-gap-lg-6 {
    column-gap: 60px;
  }
  .aesirxui .column-gap-lg-7 {
    column-gap: 70px;
  }
  .aesirxui .column-gap-lg-8 {
    column-gap: 80px;
  }
  .aesirxui .column-gap-lg-10 {
    column-gap: 10px;
  }
  .aesirxui .column-gap-lg-13 {
    column-gap: 13px;
  }
  .aesirxui .column-gap-lg-14 {
    column-gap: 14px;
  }
  .aesirxui .column-gap-lg-40 {
    column-gap: 40px;
  }
  .aesirxui .column-gap-lg-18px {
    column-gap: 18px;
  }
  .aesirxui .column-gap-lg-32px {
    column-gap: 32px;
  }
  .aesirxui .column-gap-lg-9px {
    column-gap: 9px;
  }
  .aesirxui .column-gap-lg-12px {
    column-gap: 12px;
  }
  .aesirxui .column-gap-lg-19px {
    column-gap: 19px;
  }
  .aesirxui .text-lg-start {
    text-align: left;
  }
  .aesirxui .text-lg-end {
    text-align: right;
  }
  .aesirxui .text-lg-center {
    text-align: center;
  }
}
@media (min-width: 1200px) {
  .aesirxui .float-xl-start {
    float: left;
  }
  .aesirxui .float-xl-end {
    float: right;
  }
  .aesirxui .float-xl-none {
    float: none;
  }
  .aesirxui .d-xl-inline {
    display: inline;
  }
  .aesirxui .d-xl-inline-block {
    display: inline-block;
  }
  .aesirxui .d-xl-block {
    display: block;
  }
  .aesirxui .d-xl-grid {
    display: grid;
  }
  .aesirxui .d-xl-inline-grid {
    display: inline-grid;
  }
  .aesirxui .d-xl-table {
    display: table;
  }
  .aesirxui .d-xl-table-row {
    display: table-row;
  }
  .aesirxui .d-xl-table-cell {
    display: table-cell;
  }
  .aesirxui .d-xl-flex {
    display: flex;
  }
  .aesirxui .d-xl-inline-flex {
    display: inline-flex;
  }
  .aesirxui .d-xl-none {
    display: none;
  }
  .aesirxui .w-xl-25 {
    width: 25%;
  }
  .aesirxui .w-xl-20 {
    width: 20%;
  }
  .aesirxui .w-xl-40 {
    width: 40%;
  }
  .aesirxui .w-xl-50 {
    width: 50%;
  }
  .aesirxui .w-xl-75 {
    width: 75%;
  }
  .aesirxui .w-xl-100 {
    width: 100%;
  }
  .aesirxui .w-xl-fit {
    width: fit-content;
  }
  .aesirxui .w-xl-max {
    width: max-content;
  }
  .aesirxui .w-xl-auto {
    width: auto;
  }
  .aesirxui .w-xl-150px {
    width: 150px;
  }
  .aesirxui .w-xl-40px {
    width: 40px;
  }
  .aesirxui .w-xl-145px {
    width: 145px;
  }
  .aesirxui .flex-xl-fill {
    flex: 1 1 auto;
  }
  .aesirxui .flex-xl-1 {
    flex: 1;
  }
  .aesirxui .flex-xl-row {
    flex-direction: row;
  }
  .aesirxui .flex-xl-column {
    flex-direction: column;
  }
  .aesirxui .flex-xl-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxui .flex-xl-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxui .flex-xl-grow-0 {
    flex-grow: 0;
  }
  .aesirxui .flex-xl-grow-1 {
    flex-grow: 1;
  }
  .aesirxui .flex-xl-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxui .flex-xl-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxui .flex-xl-wrap {
    flex-wrap: wrap;
  }
  .aesirxui .flex-xl-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxui .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxui .justify-content-xl-start {
    justify-content: flex-start;
  }
  .aesirxui .justify-content-xl-end {
    justify-content: flex-end;
  }
  .aesirxui .justify-content-xl-center {
    justify-content: center;
  }
  .aesirxui .justify-content-xl-between {
    justify-content: space-between;
  }
  .aesirxui .justify-content-xl-around {
    justify-content: space-around;
  }
  .aesirxui .justify-content-xl-evenly {
    justify-content: space-evenly;
  }
  .aesirxui .align-items-xl-start {
    align-items: flex-start;
  }
  .aesirxui .align-items-xl-end {
    align-items: flex-end;
  }
  .aesirxui .align-items-xl-center {
    align-items: center;
  }
  .aesirxui .align-items-xl-baseline {
    align-items: baseline;
  }
  .aesirxui .align-items-xl-stretch {
    align-items: stretch;
  }
  .aesirxui .align-content-xl-start {
    align-content: flex-start;
  }
  .aesirxui .align-content-xl-end {
    align-content: flex-end;
  }
  .aesirxui .align-content-xl-center {
    align-content: center;
  }
  .aesirxui .align-content-xl-between {
    align-content: space-between;
  }
  .aesirxui .align-content-xl-around {
    align-content: space-around;
  }
  .aesirxui .align-content-xl-stretch {
    align-content: stretch;
  }
  .aesirxui .align-self-xl-auto {
    align-self: auto;
  }
  .aesirxui .align-self-xl-start {
    align-self: flex-start;
  }
  .aesirxui .align-self-xl-end {
    align-self: flex-end;
  }
  .aesirxui .align-self-xl-center {
    align-self: center;
  }
  .aesirxui .align-self-xl-baseline {
    align-self: baseline;
  }
  .aesirxui .align-self-xl-stretch {
    align-self: stretch;
  }
  .aesirxui .order-xl-first {
    order: -1;
  }
  .aesirxui .order-xl-0 {
    order: 0;
  }
  .aesirxui .order-xl-1 {
    order: 1;
  }
  .aesirxui .order-xl-2 {
    order: 2;
  }
  .aesirxui .order-xl-3 {
    order: 3;
  }
  .aesirxui .order-xl-4 {
    order: 4;
  }
  .aesirxui .order-xl-5 {
    order: 5;
  }
  .aesirxui .order-xl-last {
    order: 6;
  }
  .aesirxui .m-xl-0 {
    margin: 0;
  }
  .aesirxui .m-xl-1 {
    margin: 0.25rem;
  }
  .aesirxui .m-xl-2 {
    margin: 0.5rem;
  }
  .aesirxui .m-xl-3 {
    margin: 1rem;
  }
  .aesirxui .m-xl-4 {
    margin: 1.5rem;
  }
  .aesirxui .m-xl-5 {
    margin: 3rem;
  }
  .aesirxui .m-xl-sm {
    margin: 5px;
  }
  .aesirxui .m-xl-8px {
    margin: 8px;
  }
  .aesirxui .m-xl-15 {
    margin: 15px;
  }
  .aesirxui .m-xl-16 {
    margin: 16px;
  }
  .aesirxui .m-xl-20 {
    margin: 20px;
  }
  .aesirxui .m-xl-24 {
    margin: 24px;
  }
  .aesirxui .m-xl-6 {
    margin: 60px;
  }
  .aesirxui .m-xl-7 {
    margin: 70px;
  }
  .aesirxui .m-xl-8 {
    margin: 80px;
  }
  .aesirxui .m-xl-10 {
    margin: 10px;
  }
  .aesirxui .m-xl-13 {
    margin: 13px;
  }
  .aesirxui .m-xl-14 {
    margin: 14px;
  }
  .aesirxui .m-xl-40 {
    margin: 40px;
  }
  .aesirxui .m-xl-18px {
    margin: 18px;
  }
  .aesirxui .m-xl-32px {
    margin: 32px;
  }
  .aesirxui .m-xl-9px {
    margin: 9px;
  }
  .aesirxui .m-xl-12px {
    margin: 12px;
  }
  .aesirxui .m-xl-19px {
    margin: 19px;
  }
  .aesirxui .m-xl-auto {
    margin: auto;
  }
  .aesirxui .mx-xl-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxui .mx-xl-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxui .mx-xl-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxui .mx-xl-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxui .mx-xl-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxui .mx-xl-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxui .mx-xl-sm {
    margin-right: 5px;
    margin-left: 5px;
  }
  .aesirxui .mx-xl-8px {
    margin-right: 8px;
    margin-left: 8px;
  }
  .aesirxui .mx-xl-15 {
    margin-right: 15px;
    margin-left: 15px;
  }
  .aesirxui .mx-xl-16 {
    margin-right: 16px;
    margin-left: 16px;
  }
  .aesirxui .mx-xl-20 {
    margin-right: 20px;
    margin-left: 20px;
  }
  .aesirxui .mx-xl-24 {
    margin-right: 24px;
    margin-left: 24px;
  }
  .aesirxui .mx-xl-6 {
    margin-right: 60px;
    margin-left: 60px;
  }
  .aesirxui .mx-xl-7 {
    margin-right: 70px;
    margin-left: 70px;
  }
  .aesirxui .mx-xl-8 {
    margin-right: 80px;
    margin-left: 80px;
  }
  .aesirxui .mx-xl-10 {
    margin-right: 10px;
    margin-left: 10px;
  }
  .aesirxui .mx-xl-13 {
    margin-right: 13px;
    margin-left: 13px;
  }
  .aesirxui .mx-xl-14 {
    margin-right: 14px;
    margin-left: 14px;
  }
  .aesirxui .mx-xl-40 {
    margin-right: 40px;
    margin-left: 40px;
  }
  .aesirxui .mx-xl-18px {
    margin-right: 18px;
    margin-left: 18px;
  }
  .aesirxui .mx-xl-32px {
    margin-right: 32px;
    margin-left: 32px;
  }
  .aesirxui .mx-xl-9px {
    margin-right: 9px;
    margin-left: 9px;
  }
  .aesirxui .mx-xl-12px {
    margin-right: 12px;
    margin-left: 12px;
  }
  .aesirxui .mx-xl-19px {
    margin-right: 19px;
    margin-left: 19px;
  }
  .aesirxui .mx-xl-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxui .my-xl-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxui .my-xl-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxui .my-xl-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxui .my-xl-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxui .my-xl-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxui .my-xl-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxui .my-xl-sm {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .aesirxui .my-xl-8px {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .aesirxui .my-xl-15 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .aesirxui .my-xl-16 {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .aesirxui .my-xl-20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .aesirxui .my-xl-24 {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .aesirxui .my-xl-6 {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .aesirxui .my-xl-7 {
    margin-top: 70px;
    margin-bottom: 70px;
  }
  .aesirxui .my-xl-8 {
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .aesirxui .my-xl-10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .aesirxui .my-xl-13 {
    margin-top: 13px;
    margin-bottom: 13px;
  }
  .aesirxui .my-xl-14 {
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .aesirxui .my-xl-40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .aesirxui .my-xl-18px {
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .aesirxui .my-xl-32px {
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .aesirxui .my-xl-9px {
    margin-top: 9px;
    margin-bottom: 9px;
  }
  .aesirxui .my-xl-12px {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .aesirxui .my-xl-19px {
    margin-top: 19px;
    margin-bottom: 19px;
  }
  .aesirxui .my-xl-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxui .mt-xl-0 {
    margin-top: 0;
  }
  .aesirxui .mt-xl-1 {
    margin-top: 0.25rem;
  }
  .aesirxui .mt-xl-2 {
    margin-top: 0.5rem;
  }
  .aesirxui .mt-xl-3 {
    margin-top: 1rem;
  }
  .aesirxui .mt-xl-4 {
    margin-top: 1.5rem;
  }
  .aesirxui .mt-xl-5 {
    margin-top: 3rem;
  }
  .aesirxui .mt-xl-sm {
    margin-top: 5px;
  }
  .aesirxui .mt-xl-8px {
    margin-top: 8px;
  }
  .aesirxui .mt-xl-15 {
    margin-top: 15px;
  }
  .aesirxui .mt-xl-16 {
    margin-top: 16px;
  }
  .aesirxui .mt-xl-20 {
    margin-top: 20px;
  }
  .aesirxui .mt-xl-24 {
    margin-top: 24px;
  }
  .aesirxui .mt-xl-6 {
    margin-top: 60px;
  }
  .aesirxui .mt-xl-7 {
    margin-top: 70px;
  }
  .aesirxui .mt-xl-8 {
    margin-top: 80px;
  }
  .aesirxui .mt-xl-10 {
    margin-top: 10px;
  }
  .aesirxui .mt-xl-13 {
    margin-top: 13px;
  }
  .aesirxui .mt-xl-14 {
    margin-top: 14px;
  }
  .aesirxui .mt-xl-40 {
    margin-top: 40px;
  }
  .aesirxui .mt-xl-18px {
    margin-top: 18px;
  }
  .aesirxui .mt-xl-32px {
    margin-top: 32px;
  }
  .aesirxui .mt-xl-9px {
    margin-top: 9px;
  }
  .aesirxui .mt-xl-12px {
    margin-top: 12px;
  }
  .aesirxui .mt-xl-19px {
    margin-top: 19px;
  }
  .aesirxui .mt-xl-auto {
    margin-top: auto;
  }
  .aesirxui .me-xl-0 {
    margin-right: 0;
  }
  .aesirxui .me-xl-1 {
    margin-right: 0.25rem;
  }
  .aesirxui .me-xl-2 {
    margin-right: 0.5rem;
  }
  .aesirxui .me-xl-3 {
    margin-right: 1rem;
  }
  .aesirxui .me-xl-4 {
    margin-right: 1.5rem;
  }
  .aesirxui .me-xl-5 {
    margin-right: 3rem;
  }
  .aesirxui .me-xl-sm {
    margin-right: 5px;
  }
  .aesirxui .me-xl-8px {
    margin-right: 8px;
  }
  .aesirxui .me-xl-15 {
    margin-right: 15px;
  }
  .aesirxui .me-xl-16 {
    margin-right: 16px;
  }
  .aesirxui .me-xl-20 {
    margin-right: 20px;
  }
  .aesirxui .me-xl-24 {
    margin-right: 24px;
  }
  .aesirxui .me-xl-6 {
    margin-right: 60px;
  }
  .aesirxui .me-xl-7 {
    margin-right: 70px;
  }
  .aesirxui .me-xl-8 {
    margin-right: 80px;
  }
  .aesirxui .me-xl-10 {
    margin-right: 10px;
  }
  .aesirxui .me-xl-13 {
    margin-right: 13px;
  }
  .aesirxui .me-xl-14 {
    margin-right: 14px;
  }
  .aesirxui .me-xl-40 {
    margin-right: 40px;
  }
  .aesirxui .me-xl-18px {
    margin-right: 18px;
  }
  .aesirxui .me-xl-32px {
    margin-right: 32px;
  }
  .aesirxui .me-xl-9px {
    margin-right: 9px;
  }
  .aesirxui .me-xl-12px {
    margin-right: 12px;
  }
  .aesirxui .me-xl-19px {
    margin-right: 19px;
  }
  .aesirxui .me-xl-auto {
    margin-right: auto;
  }
  .aesirxui .mb-xl-0 {
    margin-bottom: 0;
  }
  .aesirxui .mb-xl-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxui .mb-xl-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxui .mb-xl-3 {
    margin-bottom: 1rem;
  }
  .aesirxui .mb-xl-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxui .mb-xl-5 {
    margin-bottom: 3rem;
  }
  .aesirxui .mb-xl-sm {
    margin-bottom: 5px;
  }
  .aesirxui .mb-xl-8px {
    margin-bottom: 8px;
  }
  .aesirxui .mb-xl-15 {
    margin-bottom: 15px;
  }
  .aesirxui .mb-xl-16 {
    margin-bottom: 16px;
  }
  .aesirxui .mb-xl-20 {
    margin-bottom: 20px;
  }
  .aesirxui .mb-xl-24 {
    margin-bottom: 24px;
  }
  .aesirxui .mb-xl-6 {
    margin-bottom: 60px;
  }
  .aesirxui .mb-xl-7 {
    margin-bottom: 70px;
  }
  .aesirxui .mb-xl-8 {
    margin-bottom: 80px;
  }
  .aesirxui .mb-xl-10 {
    margin-bottom: 10px;
  }
  .aesirxui .mb-xl-13 {
    margin-bottom: 13px;
  }
  .aesirxui .mb-xl-14 {
    margin-bottom: 14px;
  }
  .aesirxui .mb-xl-40 {
    margin-bottom: 40px;
  }
  .aesirxui .mb-xl-18px {
    margin-bottom: 18px;
  }
  .aesirxui .mb-xl-32px {
    margin-bottom: 32px;
  }
  .aesirxui .mb-xl-9px {
    margin-bottom: 9px;
  }
  .aesirxui .mb-xl-12px {
    margin-bottom: 12px;
  }
  .aesirxui .mb-xl-19px {
    margin-bottom: 19px;
  }
  .aesirxui .mb-xl-auto {
    margin-bottom: auto;
  }
  .aesirxui .ms-xl-0 {
    margin-left: 0;
  }
  .aesirxui .ms-xl-1 {
    margin-left: 0.25rem;
  }
  .aesirxui .ms-xl-2 {
    margin-left: 0.5rem;
  }
  .aesirxui .ms-xl-3 {
    margin-left: 1rem;
  }
  .aesirxui .ms-xl-4 {
    margin-left: 1.5rem;
  }
  .aesirxui .ms-xl-5 {
    margin-left: 3rem;
  }
  .aesirxui .ms-xl-sm {
    margin-left: 5px;
  }
  .aesirxui .ms-xl-8px {
    margin-left: 8px;
  }
  .aesirxui .ms-xl-15 {
    margin-left: 15px;
  }
  .aesirxui .ms-xl-16 {
    margin-left: 16px;
  }
  .aesirxui .ms-xl-20 {
    margin-left: 20px;
  }
  .aesirxui .ms-xl-24 {
    margin-left: 24px;
  }
  .aesirxui .ms-xl-6 {
    margin-left: 60px;
  }
  .aesirxui .ms-xl-7 {
    margin-left: 70px;
  }
  .aesirxui .ms-xl-8 {
    margin-left: 80px;
  }
  .aesirxui .ms-xl-10 {
    margin-left: 10px;
  }
  .aesirxui .ms-xl-13 {
    margin-left: 13px;
  }
  .aesirxui .ms-xl-14 {
    margin-left: 14px;
  }
  .aesirxui .ms-xl-40 {
    margin-left: 40px;
  }
  .aesirxui .ms-xl-18px {
    margin-left: 18px;
  }
  .aesirxui .ms-xl-32px {
    margin-left: 32px;
  }
  .aesirxui .ms-xl-9px {
    margin-left: 9px;
  }
  .aesirxui .ms-xl-12px {
    margin-left: 12px;
  }
  .aesirxui .ms-xl-19px {
    margin-left: 19px;
  }
  .aesirxui .ms-xl-auto {
    margin-left: auto;
  }
  .aesirxui .m-xl-n1 {
    margin: -0.25rem;
  }
  .aesirxui .m-xl-n2 {
    margin: -0.5rem;
  }
  .aesirxui .m-xl-n3 {
    margin: -1rem;
  }
  .aesirxui .m-xl-n4 {
    margin: -1.5rem;
  }
  .aesirxui .m-xl-n5 {
    margin: -3rem;
  }
  .aesirxui .m-xl-nsm {
    margin: -5px;
  }
  .aesirxui .m-xl-n8px {
    margin: -8px;
  }
  .aesirxui .m-xl-n15 {
    margin: -15px;
  }
  .aesirxui .m-xl-n16 {
    margin: -16px;
  }
  .aesirxui .m-xl-n20 {
    margin: -20px;
  }
  .aesirxui .m-xl-n24 {
    margin: -24px;
  }
  .aesirxui .m-xl-n6 {
    margin: -60px;
  }
  .aesirxui .m-xl-n7 {
    margin: -70px;
  }
  .aesirxui .m-xl-n8 {
    margin: -80px;
  }
  .aesirxui .m-xl-n10 {
    margin: -10px;
  }
  .aesirxui .m-xl-n13 {
    margin: -13px;
  }
  .aesirxui .m-xl-n14 {
    margin: -14px;
  }
  .aesirxui .m-xl-n40 {
    margin: -40px;
  }
  .aesirxui .m-xl-n18px {
    margin: -18px;
  }
  .aesirxui .m-xl-n32px {
    margin: -32px;
  }
  .aesirxui .m-xl-n9px {
    margin: -9px;
  }
  .aesirxui .m-xl-n12px {
    margin: -12px;
  }
  .aesirxui .m-xl-n19px {
    margin: -19px;
  }
  .aesirxui .mx-xl-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxui .mx-xl-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxui .mx-xl-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxui .mx-xl-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxui .mx-xl-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxui .mx-xl-nsm {
    margin-right: -5px;
    margin-left: -5px;
  }
  .aesirxui .mx-xl-n8px {
    margin-right: -8px;
    margin-left: -8px;
  }
  .aesirxui .mx-xl-n15 {
    margin-right: -15px;
    margin-left: -15px;
  }
  .aesirxui .mx-xl-n16 {
    margin-right: -16px;
    margin-left: -16px;
  }
  .aesirxui .mx-xl-n20 {
    margin-right: -20px;
    margin-left: -20px;
  }
  .aesirxui .mx-xl-n24 {
    margin-right: -24px;
    margin-left: -24px;
  }
  .aesirxui .mx-xl-n6 {
    margin-right: -60px;
    margin-left: -60px;
  }
  .aesirxui .mx-xl-n7 {
    margin-right: -70px;
    margin-left: -70px;
  }
  .aesirxui .mx-xl-n8 {
    margin-right: -80px;
    margin-left: -80px;
  }
  .aesirxui .mx-xl-n10 {
    margin-right: -10px;
    margin-left: -10px;
  }
  .aesirxui .mx-xl-n13 {
    margin-right: -13px;
    margin-left: -13px;
  }
  .aesirxui .mx-xl-n14 {
    margin-right: -14px;
    margin-left: -14px;
  }
  .aesirxui .mx-xl-n40 {
    margin-right: -40px;
    margin-left: -40px;
  }
  .aesirxui .mx-xl-n18px {
    margin-right: -18px;
    margin-left: -18px;
  }
  .aesirxui .mx-xl-n32px {
    margin-right: -32px;
    margin-left: -32px;
  }
  .aesirxui .mx-xl-n9px {
    margin-right: -9px;
    margin-left: -9px;
  }
  .aesirxui .mx-xl-n12px {
    margin-right: -12px;
    margin-left: -12px;
  }
  .aesirxui .mx-xl-n19px {
    margin-right: -19px;
    margin-left: -19px;
  }
  .aesirxui .my-xl-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxui .my-xl-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxui .my-xl-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxui .my-xl-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxui .my-xl-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxui .my-xl-nsm {
    margin-top: -5px;
    margin-bottom: -5px;
  }
  .aesirxui .my-xl-n8px {
    margin-top: -8px;
    margin-bottom: -8px;
  }
  .aesirxui .my-xl-n15 {
    margin-top: -15px;
    margin-bottom: -15px;
  }
  .aesirxui .my-xl-n16 {
    margin-top: -16px;
    margin-bottom: -16px;
  }
  .aesirxui .my-xl-n20 {
    margin-top: -20px;
    margin-bottom: -20px;
  }
  .aesirxui .my-xl-n24 {
    margin-top: -24px;
    margin-bottom: -24px;
  }
  .aesirxui .my-xl-n6 {
    margin-top: -60px;
    margin-bottom: -60px;
  }
  .aesirxui .my-xl-n7 {
    margin-top: -70px;
    margin-bottom: -70px;
  }
  .aesirxui .my-xl-n8 {
    margin-top: -80px;
    margin-bottom: -80px;
  }
  .aesirxui .my-xl-n10 {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .aesirxui .my-xl-n13 {
    margin-top: -13px;
    margin-bottom: -13px;
  }
  .aesirxui .my-xl-n14 {
    margin-top: -14px;
    margin-bottom: -14px;
  }
  .aesirxui .my-xl-n40 {
    margin-top: -40px;
    margin-bottom: -40px;
  }
  .aesirxui .my-xl-n18px {
    margin-top: -18px;
    margin-bottom: -18px;
  }
  .aesirxui .my-xl-n32px {
    margin-top: -32px;
    margin-bottom: -32px;
  }
  .aesirxui .my-xl-n9px {
    margin-top: -9px;
    margin-bottom: -9px;
  }
  .aesirxui .my-xl-n12px {
    margin-top: -12px;
    margin-bottom: -12px;
  }
  .aesirxui .my-xl-n19px {
    margin-top: -19px;
    margin-bottom: -19px;
  }
  .aesirxui .mt-xl-n1 {
    margin-top: -0.25rem;
  }
  .aesirxui .mt-xl-n2 {
    margin-top: -0.5rem;
  }
  .aesirxui .mt-xl-n3 {
    margin-top: -1rem;
  }
  .aesirxui .mt-xl-n4 {
    margin-top: -1.5rem;
  }
  .aesirxui .mt-xl-n5 {
    margin-top: -3rem;
  }
  .aesirxui .mt-xl-nsm {
    margin-top: -5px;
  }
  .aesirxui .mt-xl-n8px {
    margin-top: -8px;
  }
  .aesirxui .mt-xl-n15 {
    margin-top: -15px;
  }
  .aesirxui .mt-xl-n16 {
    margin-top: -16px;
  }
  .aesirxui .mt-xl-n20 {
    margin-top: -20px;
  }
  .aesirxui .mt-xl-n24 {
    margin-top: -24px;
  }
  .aesirxui .mt-xl-n6 {
    margin-top: -60px;
  }
  .aesirxui .mt-xl-n7 {
    margin-top: -70px;
  }
  .aesirxui .mt-xl-n8 {
    margin-top: -80px;
  }
  .aesirxui .mt-xl-n10 {
    margin-top: -10px;
  }
  .aesirxui .mt-xl-n13 {
    margin-top: -13px;
  }
  .aesirxui .mt-xl-n14 {
    margin-top: -14px;
  }
  .aesirxui .mt-xl-n40 {
    margin-top: -40px;
  }
  .aesirxui .mt-xl-n18px {
    margin-top: -18px;
  }
  .aesirxui .mt-xl-n32px {
    margin-top: -32px;
  }
  .aesirxui .mt-xl-n9px {
    margin-top: -9px;
  }
  .aesirxui .mt-xl-n12px {
    margin-top: -12px;
  }
  .aesirxui .mt-xl-n19px {
    margin-top: -19px;
  }
  .aesirxui .me-xl-n1 {
    margin-right: -0.25rem;
  }
  .aesirxui .me-xl-n2 {
    margin-right: -0.5rem;
  }
  .aesirxui .me-xl-n3 {
    margin-right: -1rem;
  }
  .aesirxui .me-xl-n4 {
    margin-right: -1.5rem;
  }
  .aesirxui .me-xl-n5 {
    margin-right: -3rem;
  }
  .aesirxui .me-xl-nsm {
    margin-right: -5px;
  }
  .aesirxui .me-xl-n8px {
    margin-right: -8px;
  }
  .aesirxui .me-xl-n15 {
    margin-right: -15px;
  }
  .aesirxui .me-xl-n16 {
    margin-right: -16px;
  }
  .aesirxui .me-xl-n20 {
    margin-right: -20px;
  }
  .aesirxui .me-xl-n24 {
    margin-right: -24px;
  }
  .aesirxui .me-xl-n6 {
    margin-right: -60px;
  }
  .aesirxui .me-xl-n7 {
    margin-right: -70px;
  }
  .aesirxui .me-xl-n8 {
    margin-right: -80px;
  }
  .aesirxui .me-xl-n10 {
    margin-right: -10px;
  }
  .aesirxui .me-xl-n13 {
    margin-right: -13px;
  }
  .aesirxui .me-xl-n14 {
    margin-right: -14px;
  }
  .aesirxui .me-xl-n40 {
    margin-right: -40px;
  }
  .aesirxui .me-xl-n18px {
    margin-right: -18px;
  }
  .aesirxui .me-xl-n32px {
    margin-right: -32px;
  }
  .aesirxui .me-xl-n9px {
    margin-right: -9px;
  }
  .aesirxui .me-xl-n12px {
    margin-right: -12px;
  }
  .aesirxui .me-xl-n19px {
    margin-right: -19px;
  }
  .aesirxui .mb-xl-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxui .mb-xl-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxui .mb-xl-n3 {
    margin-bottom: -1rem;
  }
  .aesirxui .mb-xl-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxui .mb-xl-n5 {
    margin-bottom: -3rem;
  }
  .aesirxui .mb-xl-nsm {
    margin-bottom: -5px;
  }
  .aesirxui .mb-xl-n8px {
    margin-bottom: -8px;
  }
  .aesirxui .mb-xl-n15 {
    margin-bottom: -15px;
  }
  .aesirxui .mb-xl-n16 {
    margin-bottom: -16px;
  }
  .aesirxui .mb-xl-n20 {
    margin-bottom: -20px;
  }
  .aesirxui .mb-xl-n24 {
    margin-bottom: -24px;
  }
  .aesirxui .mb-xl-n6 {
    margin-bottom: -60px;
  }
  .aesirxui .mb-xl-n7 {
    margin-bottom: -70px;
  }
  .aesirxui .mb-xl-n8 {
    margin-bottom: -80px;
  }
  .aesirxui .mb-xl-n10 {
    margin-bottom: -10px;
  }
  .aesirxui .mb-xl-n13 {
    margin-bottom: -13px;
  }
  .aesirxui .mb-xl-n14 {
    margin-bottom: -14px;
  }
  .aesirxui .mb-xl-n40 {
    margin-bottom: -40px;
  }
  .aesirxui .mb-xl-n18px {
    margin-bottom: -18px;
  }
  .aesirxui .mb-xl-n32px {
    margin-bottom: -32px;
  }
  .aesirxui .mb-xl-n9px {
    margin-bottom: -9px;
  }
  .aesirxui .mb-xl-n12px {
    margin-bottom: -12px;
  }
  .aesirxui .mb-xl-n19px {
    margin-bottom: -19px;
  }
  .aesirxui .ms-xl-n1 {
    margin-left: -0.25rem;
  }
  .aesirxui .ms-xl-n2 {
    margin-left: -0.5rem;
  }
  .aesirxui .ms-xl-n3 {
    margin-left: -1rem;
  }
  .aesirxui .ms-xl-n4 {
    margin-left: -1.5rem;
  }
  .aesirxui .ms-xl-n5 {
    margin-left: -3rem;
  }
  .aesirxui .ms-xl-nsm {
    margin-left: -5px;
  }
  .aesirxui .ms-xl-n8px {
    margin-left: -8px;
  }
  .aesirxui .ms-xl-n15 {
    margin-left: -15px;
  }
  .aesirxui .ms-xl-n16 {
    margin-left: -16px;
  }
  .aesirxui .ms-xl-n20 {
    margin-left: -20px;
  }
  .aesirxui .ms-xl-n24 {
    margin-left: -24px;
  }
  .aesirxui .ms-xl-n6 {
    margin-left: -60px;
  }
  .aesirxui .ms-xl-n7 {
    margin-left: -70px;
  }
  .aesirxui .ms-xl-n8 {
    margin-left: -80px;
  }
  .aesirxui .ms-xl-n10 {
    margin-left: -10px;
  }
  .aesirxui .ms-xl-n13 {
    margin-left: -13px;
  }
  .aesirxui .ms-xl-n14 {
    margin-left: -14px;
  }
  .aesirxui .ms-xl-n40 {
    margin-left: -40px;
  }
  .aesirxui .ms-xl-n18px {
    margin-left: -18px;
  }
  .aesirxui .ms-xl-n32px {
    margin-left: -32px;
  }
  .aesirxui .ms-xl-n9px {
    margin-left: -9px;
  }
  .aesirxui .ms-xl-n12px {
    margin-left: -12px;
  }
  .aesirxui .ms-xl-n19px {
    margin-left: -19px;
  }
  .aesirxui .p-xl-0 {
    padding: 0;
  }
  .aesirxui .p-xl-1 {
    padding: 0.25rem;
  }
  .aesirxui .p-xl-2 {
    padding: 0.5rem;
  }
  .aesirxui .p-xl-3 {
    padding: 1rem;
  }
  .aesirxui .p-xl-4 {
    padding: 1.5rem;
  }
  .aesirxui .p-xl-5 {
    padding: 3rem;
  }
  .aesirxui .p-xl-sm {
    padding: 5px;
  }
  .aesirxui .p-xl-8px {
    padding: 8px;
  }
  .aesirxui .p-xl-15 {
    padding: 15px;
  }
  .aesirxui .p-xl-16 {
    padding: 16px;
  }
  .aesirxui .p-xl-20 {
    padding: 20px;
  }
  .aesirxui .p-xl-24 {
    padding: 24px;
  }
  .aesirxui .p-xl-6 {
    padding: 60px;
  }
  .aesirxui .p-xl-7 {
    padding: 70px;
  }
  .aesirxui .p-xl-8 {
    padding: 80px;
  }
  .aesirxui .p-xl-10 {
    padding: 10px;
  }
  .aesirxui .p-xl-13 {
    padding: 13px;
  }
  .aesirxui .p-xl-14 {
    padding: 14px;
  }
  .aesirxui .p-xl-40 {
    padding: 40px;
  }
  .aesirxui .p-xl-18px {
    padding: 18px;
  }
  .aesirxui .p-xl-32px {
    padding: 32px;
  }
  .aesirxui .p-xl-9px {
    padding: 9px;
  }
  .aesirxui .p-xl-12px {
    padding: 12px;
  }
  .aesirxui .p-xl-19px {
    padding: 19px;
  }
  .aesirxui .px-xl-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxui .px-xl-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxui .px-xl-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxui .px-xl-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxui .px-xl-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxui .px-xl-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxui .px-xl-sm {
    padding-right: 5px;
    padding-left: 5px;
  }
  .aesirxui .px-xl-8px {
    padding-right: 8px;
    padding-left: 8px;
  }
  .aesirxui .px-xl-15 {
    padding-right: 15px;
    padding-left: 15px;
  }
  .aesirxui .px-xl-16 {
    padding-right: 16px;
    padding-left: 16px;
  }
  .aesirxui .px-xl-20 {
    padding-right: 20px;
    padding-left: 20px;
  }
  .aesirxui .px-xl-24 {
    padding-right: 24px;
    padding-left: 24px;
  }
  .aesirxui .px-xl-6 {
    padding-right: 60px;
    padding-left: 60px;
  }
  .aesirxui .px-xl-7 {
    padding-right: 70px;
    padding-left: 70px;
  }
  .aesirxui .px-xl-8 {
    padding-right: 80px;
    padding-left: 80px;
  }
  .aesirxui .px-xl-10 {
    padding-right: 10px;
    padding-left: 10px;
  }
  .aesirxui .px-xl-13 {
    padding-right: 13px;
    padding-left: 13px;
  }
  .aesirxui .px-xl-14 {
    padding-right: 14px;
    padding-left: 14px;
  }
  .aesirxui .px-xl-40 {
    padding-right: 40px;
    padding-left: 40px;
  }
  .aesirxui .px-xl-18px {
    padding-right: 18px;
    padding-left: 18px;
  }
  .aesirxui .px-xl-32px {
    padding-right: 32px;
    padding-left: 32px;
  }
  .aesirxui .px-xl-9px {
    padding-right: 9px;
    padding-left: 9px;
  }
  .aesirxui .px-xl-12px {
    padding-right: 12px;
    padding-left: 12px;
  }
  .aesirxui .px-xl-19px {
    padding-right: 19px;
    padding-left: 19px;
  }
  .aesirxui .py-xl-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxui .py-xl-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxui .py-xl-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxui .py-xl-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxui .py-xl-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxui .py-xl-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxui .py-xl-sm {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .aesirxui .py-xl-8px {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .aesirxui .py-xl-15 {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .aesirxui .py-xl-16 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .aesirxui .py-xl-20 {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .aesirxui .py-xl-24 {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .aesirxui .py-xl-6 {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .aesirxui .py-xl-7 {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .aesirxui .py-xl-8 {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .aesirxui .py-xl-10 {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .aesirxui .py-xl-13 {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .aesirxui .py-xl-14 {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .aesirxui .py-xl-40 {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .aesirxui .py-xl-18px {
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .aesirxui .py-xl-32px {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  .aesirxui .py-xl-9px {
    padding-top: 9px;
    padding-bottom: 9px;
  }
  .aesirxui .py-xl-12px {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .aesirxui .py-xl-19px {
    padding-top: 19px;
    padding-bottom: 19px;
  }
  .aesirxui .pt-xl-0 {
    padding-top: 0;
  }
  .aesirxui .pt-xl-1 {
    padding-top: 0.25rem;
  }
  .aesirxui .pt-xl-2 {
    padding-top: 0.5rem;
  }
  .aesirxui .pt-xl-3 {
    padding-top: 1rem;
  }
  .aesirxui .pt-xl-4 {
    padding-top: 1.5rem;
  }
  .aesirxui .pt-xl-5 {
    padding-top: 3rem;
  }
  .aesirxui .pt-xl-sm {
    padding-top: 5px;
  }
  .aesirxui .pt-xl-8px {
    padding-top: 8px;
  }
  .aesirxui .pt-xl-15 {
    padding-top: 15px;
  }
  .aesirxui .pt-xl-16 {
    padding-top: 16px;
  }
  .aesirxui .pt-xl-20 {
    padding-top: 20px;
  }
  .aesirxui .pt-xl-24 {
    padding-top: 24px;
  }
  .aesirxui .pt-xl-6 {
    padding-top: 60px;
  }
  .aesirxui .pt-xl-7 {
    padding-top: 70px;
  }
  .aesirxui .pt-xl-8 {
    padding-top: 80px;
  }
  .aesirxui .pt-xl-10 {
    padding-top: 10px;
  }
  .aesirxui .pt-xl-13 {
    padding-top: 13px;
  }
  .aesirxui .pt-xl-14 {
    padding-top: 14px;
  }
  .aesirxui .pt-xl-40 {
    padding-top: 40px;
  }
  .aesirxui .pt-xl-18px {
    padding-top: 18px;
  }
  .aesirxui .pt-xl-32px {
    padding-top: 32px;
  }
  .aesirxui .pt-xl-9px {
    padding-top: 9px;
  }
  .aesirxui .pt-xl-12px {
    padding-top: 12px;
  }
  .aesirxui .pt-xl-19px {
    padding-top: 19px;
  }
  .aesirxui .pe-xl-0 {
    padding-right: 0;
  }
  .aesirxui .pe-xl-1 {
    padding-right: 0.25rem;
  }
  .aesirxui .pe-xl-2 {
    padding-right: 0.5rem;
  }
  .aesirxui .pe-xl-3 {
    padding-right: 1rem;
  }
  .aesirxui .pe-xl-4 {
    padding-right: 1.5rem;
  }
  .aesirxui .pe-xl-5 {
    padding-right: 3rem;
  }
  .aesirxui .pe-xl-sm {
    padding-right: 5px;
  }
  .aesirxui .pe-xl-8px {
    padding-right: 8px;
  }
  .aesirxui .pe-xl-15 {
    padding-right: 15px;
  }
  .aesirxui .pe-xl-16 {
    padding-right: 16px;
  }
  .aesirxui .pe-xl-20 {
    padding-right: 20px;
  }
  .aesirxui .pe-xl-24 {
    padding-right: 24px;
  }
  .aesirxui .pe-xl-6 {
    padding-right: 60px;
  }
  .aesirxui .pe-xl-7 {
    padding-right: 70px;
  }
  .aesirxui .pe-xl-8 {
    padding-right: 80px;
  }
  .aesirxui .pe-xl-10 {
    padding-right: 10px;
  }
  .aesirxui .pe-xl-13 {
    padding-right: 13px;
  }
  .aesirxui .pe-xl-14 {
    padding-right: 14px;
  }
  .aesirxui .pe-xl-40 {
    padding-right: 40px;
  }
  .aesirxui .pe-xl-18px {
    padding-right: 18px;
  }
  .aesirxui .pe-xl-32px {
    padding-right: 32px;
  }
  .aesirxui .pe-xl-9px {
    padding-right: 9px;
  }
  .aesirxui .pe-xl-12px {
    padding-right: 12px;
  }
  .aesirxui .pe-xl-19px {
    padding-right: 19px;
  }
  .aesirxui .pb-xl-0 {
    padding-bottom: 0;
  }
  .aesirxui .pb-xl-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxui .pb-xl-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxui .pb-xl-3 {
    padding-bottom: 1rem;
  }
  .aesirxui .pb-xl-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxui .pb-xl-5 {
    padding-bottom: 3rem;
  }
  .aesirxui .pb-xl-sm {
    padding-bottom: 5px;
  }
  .aesirxui .pb-xl-8px {
    padding-bottom: 8px;
  }
  .aesirxui .pb-xl-15 {
    padding-bottom: 15px;
  }
  .aesirxui .pb-xl-16 {
    padding-bottom: 16px;
  }
  .aesirxui .pb-xl-20 {
    padding-bottom: 20px;
  }
  .aesirxui .pb-xl-24 {
    padding-bottom: 24px;
  }
  .aesirxui .pb-xl-6 {
    padding-bottom: 60px;
  }
  .aesirxui .pb-xl-7 {
    padding-bottom: 70px;
  }
  .aesirxui .pb-xl-8 {
    padding-bottom: 80px;
  }
  .aesirxui .pb-xl-10 {
    padding-bottom: 10px;
  }
  .aesirxui .pb-xl-13 {
    padding-bottom: 13px;
  }
  .aesirxui .pb-xl-14 {
    padding-bottom: 14px;
  }
  .aesirxui .pb-xl-40 {
    padding-bottom: 40px;
  }
  .aesirxui .pb-xl-18px {
    padding-bottom: 18px;
  }
  .aesirxui .pb-xl-32px {
    padding-bottom: 32px;
  }
  .aesirxui .pb-xl-9px {
    padding-bottom: 9px;
  }
  .aesirxui .pb-xl-12px {
    padding-bottom: 12px;
  }
  .aesirxui .pb-xl-19px {
    padding-bottom: 19px;
  }
  .aesirxui .ps-xl-0 {
    padding-left: 0;
  }
  .aesirxui .ps-xl-1 {
    padding-left: 0.25rem;
  }
  .aesirxui .ps-xl-2 {
    padding-left: 0.5rem;
  }
  .aesirxui .ps-xl-3 {
    padding-left: 1rem;
  }
  .aesirxui .ps-xl-4 {
    padding-left: 1.5rem;
  }
  .aesirxui .ps-xl-5 {
    padding-left: 3rem;
  }
  .aesirxui .ps-xl-sm {
    padding-left: 5px;
  }
  .aesirxui .ps-xl-8px {
    padding-left: 8px;
  }
  .aesirxui .ps-xl-15 {
    padding-left: 15px;
  }
  .aesirxui .ps-xl-16 {
    padding-left: 16px;
  }
  .aesirxui .ps-xl-20 {
    padding-left: 20px;
  }
  .aesirxui .ps-xl-24 {
    padding-left: 24px;
  }
  .aesirxui .ps-xl-6 {
    padding-left: 60px;
  }
  .aesirxui .ps-xl-7 {
    padding-left: 70px;
  }
  .aesirxui .ps-xl-8 {
    padding-left: 80px;
  }
  .aesirxui .ps-xl-10 {
    padding-left: 10px;
  }
  .aesirxui .ps-xl-13 {
    padding-left: 13px;
  }
  .aesirxui .ps-xl-14 {
    padding-left: 14px;
  }
  .aesirxui .ps-xl-40 {
    padding-left: 40px;
  }
  .aesirxui .ps-xl-18px {
    padding-left: 18px;
  }
  .aesirxui .ps-xl-32px {
    padding-left: 32px;
  }
  .aesirxui .ps-xl-9px {
    padding-left: 9px;
  }
  .aesirxui .ps-xl-12px {
    padding-left: 12px;
  }
  .aesirxui .ps-xl-19px {
    padding-left: 19px;
  }
  .aesirxui .gap-xl-0 {
    gap: 0;
  }
  .aesirxui .gap-xl-1 {
    gap: 0.25rem;
  }
  .aesirxui .gap-xl-2 {
    gap: 0.5rem;
  }
  .aesirxui .gap-xl-3 {
    gap: 1rem;
  }
  .aesirxui .gap-xl-4 {
    gap: 1.5rem;
  }
  .aesirxui .gap-xl-5 {
    gap: 3rem;
  }
  .aesirxui .gap-xl-sm {
    gap: 5px;
  }
  .aesirxui .gap-xl-8px {
    gap: 8px;
  }
  .aesirxui .gap-xl-15 {
    gap: 15px;
  }
  .aesirxui .gap-xl-16 {
    gap: 16px;
  }
  .aesirxui .gap-xl-20 {
    gap: 20px;
  }
  .aesirxui .gap-xl-24 {
    gap: 24px;
  }
  .aesirxui .gap-xl-6 {
    gap: 60px;
  }
  .aesirxui .gap-xl-7 {
    gap: 70px;
  }
  .aesirxui .gap-xl-8 {
    gap: 80px;
  }
  .aesirxui .gap-xl-10 {
    gap: 10px;
  }
  .aesirxui .gap-xl-13 {
    gap: 13px;
  }
  .aesirxui .gap-xl-14 {
    gap: 14px;
  }
  .aesirxui .gap-xl-40 {
    gap: 40px;
  }
  .aesirxui .gap-xl-18px {
    gap: 18px;
  }
  .aesirxui .gap-xl-32px {
    gap: 32px;
  }
  .aesirxui .gap-xl-9px {
    gap: 9px;
  }
  .aesirxui .gap-xl-12px {
    gap: 12px;
  }
  .aesirxui .gap-xl-19px {
    gap: 19px;
  }
  .aesirxui .row-gap-xl-0 {
    row-gap: 0;
  }
  .aesirxui .row-gap-xl-1 {
    row-gap: 0.25rem;
  }
  .aesirxui .row-gap-xl-2 {
    row-gap: 0.5rem;
  }
  .aesirxui .row-gap-xl-3 {
    row-gap: 1rem;
  }
  .aesirxui .row-gap-xl-4 {
    row-gap: 1.5rem;
  }
  .aesirxui .row-gap-xl-5 {
    row-gap: 3rem;
  }
  .aesirxui .row-gap-xl-sm {
    row-gap: 5px;
  }
  .aesirxui .row-gap-xl-8px {
    row-gap: 8px;
  }
  .aesirxui .row-gap-xl-15 {
    row-gap: 15px;
  }
  .aesirxui .row-gap-xl-16 {
    row-gap: 16px;
  }
  .aesirxui .row-gap-xl-20 {
    row-gap: 20px;
  }
  .aesirxui .row-gap-xl-24 {
    row-gap: 24px;
  }
  .aesirxui .row-gap-xl-6 {
    row-gap: 60px;
  }
  .aesirxui .row-gap-xl-7 {
    row-gap: 70px;
  }
  .aesirxui .row-gap-xl-8 {
    row-gap: 80px;
  }
  .aesirxui .row-gap-xl-10 {
    row-gap: 10px;
  }
  .aesirxui .row-gap-xl-13 {
    row-gap: 13px;
  }
  .aesirxui .row-gap-xl-14 {
    row-gap: 14px;
  }
  .aesirxui .row-gap-xl-40 {
    row-gap: 40px;
  }
  .aesirxui .row-gap-xl-18px {
    row-gap: 18px;
  }
  .aesirxui .row-gap-xl-32px {
    row-gap: 32px;
  }
  .aesirxui .row-gap-xl-9px {
    row-gap: 9px;
  }
  .aesirxui .row-gap-xl-12px {
    row-gap: 12px;
  }
  .aesirxui .row-gap-xl-19px {
    row-gap: 19px;
  }
  .aesirxui .column-gap-xl-0 {
    column-gap: 0;
  }
  .aesirxui .column-gap-xl-1 {
    column-gap: 0.25rem;
  }
  .aesirxui .column-gap-xl-2 {
    column-gap: 0.5rem;
  }
  .aesirxui .column-gap-xl-3 {
    column-gap: 1rem;
  }
  .aesirxui .column-gap-xl-4 {
    column-gap: 1.5rem;
  }
  .aesirxui .column-gap-xl-5 {
    column-gap: 3rem;
  }
  .aesirxui .column-gap-xl-sm {
    column-gap: 5px;
  }
  .aesirxui .column-gap-xl-8px {
    column-gap: 8px;
  }
  .aesirxui .column-gap-xl-15 {
    column-gap: 15px;
  }
  .aesirxui .column-gap-xl-16 {
    column-gap: 16px;
  }
  .aesirxui .column-gap-xl-20 {
    column-gap: 20px;
  }
  .aesirxui .column-gap-xl-24 {
    column-gap: 24px;
  }
  .aesirxui .column-gap-xl-6 {
    column-gap: 60px;
  }
  .aesirxui .column-gap-xl-7 {
    column-gap: 70px;
  }
  .aesirxui .column-gap-xl-8 {
    column-gap: 80px;
  }
  .aesirxui .column-gap-xl-10 {
    column-gap: 10px;
  }
  .aesirxui .column-gap-xl-13 {
    column-gap: 13px;
  }
  .aesirxui .column-gap-xl-14 {
    column-gap: 14px;
  }
  .aesirxui .column-gap-xl-40 {
    column-gap: 40px;
  }
  .aesirxui .column-gap-xl-18px {
    column-gap: 18px;
  }
  .aesirxui .column-gap-xl-32px {
    column-gap: 32px;
  }
  .aesirxui .column-gap-xl-9px {
    column-gap: 9px;
  }
  .aesirxui .column-gap-xl-12px {
    column-gap: 12px;
  }
  .aesirxui .column-gap-xl-19px {
    column-gap: 19px;
  }
  .aesirxui .text-xl-start {
    text-align: left;
  }
  .aesirxui .text-xl-end {
    text-align: right;
  }
  .aesirxui .text-xl-center {
    text-align: center;
  }
}
@media (min-width: 1400px) {
  .aesirxui .float-xxl-start {
    float: left;
  }
  .aesirxui .float-xxl-end {
    float: right;
  }
  .aesirxui .float-xxl-none {
    float: none;
  }
  .aesirxui .d-xxl-inline {
    display: inline;
  }
  .aesirxui .d-xxl-inline-block {
    display: inline-block;
  }
  .aesirxui .d-xxl-block {
    display: block;
  }
  .aesirxui .d-xxl-grid {
    display: grid;
  }
  .aesirxui .d-xxl-inline-grid {
    display: inline-grid;
  }
  .aesirxui .d-xxl-table {
    display: table;
  }
  .aesirxui .d-xxl-table-row {
    display: table-row;
  }
  .aesirxui .d-xxl-table-cell {
    display: table-cell;
  }
  .aesirxui .d-xxl-flex {
    display: flex;
  }
  .aesirxui .d-xxl-inline-flex {
    display: inline-flex;
  }
  .aesirxui .d-xxl-none {
    display: none;
  }
  .aesirxui .w-xxl-25 {
    width: 25%;
  }
  .aesirxui .w-xxl-20 {
    width: 20%;
  }
  .aesirxui .w-xxl-40 {
    width: 40%;
  }
  .aesirxui .w-xxl-50 {
    width: 50%;
  }
  .aesirxui .w-xxl-75 {
    width: 75%;
  }
  .aesirxui .w-xxl-100 {
    width: 100%;
  }
  .aesirxui .w-xxl-fit {
    width: fit-content;
  }
  .aesirxui .w-xxl-max {
    width: max-content;
  }
  .aesirxui .w-xxl-auto {
    width: auto;
  }
  .aesirxui .w-xxl-150px {
    width: 150px;
  }
  .aesirxui .w-xxl-40px {
    width: 40px;
  }
  .aesirxui .w-xxl-145px {
    width: 145px;
  }
  .aesirxui .flex-xxl-fill {
    flex: 1 1 auto;
  }
  .aesirxui .flex-xxl-1 {
    flex: 1;
  }
  .aesirxui .flex-xxl-row {
    flex-direction: row;
  }
  .aesirxui .flex-xxl-column {
    flex-direction: column;
  }
  .aesirxui .flex-xxl-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxui .flex-xxl-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxui .flex-xxl-grow-0 {
    flex-grow: 0;
  }
  .aesirxui .flex-xxl-grow-1 {
    flex-grow: 1;
  }
  .aesirxui .flex-xxl-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxui .flex-xxl-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxui .flex-xxl-wrap {
    flex-wrap: wrap;
  }
  .aesirxui .flex-xxl-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxui .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxui .justify-content-xxl-start {
    justify-content: flex-start;
  }
  .aesirxui .justify-content-xxl-end {
    justify-content: flex-end;
  }
  .aesirxui .justify-content-xxl-center {
    justify-content: center;
  }
  .aesirxui .justify-content-xxl-between {
    justify-content: space-between;
  }
  .aesirxui .justify-content-xxl-around {
    justify-content: space-around;
  }
  .aesirxui .justify-content-xxl-evenly {
    justify-content: space-evenly;
  }
  .aesirxui .align-items-xxl-start {
    align-items: flex-start;
  }
  .aesirxui .align-items-xxl-end {
    align-items: flex-end;
  }
  .aesirxui .align-items-xxl-center {
    align-items: center;
  }
  .aesirxui .align-items-xxl-baseline {
    align-items: baseline;
  }
  .aesirxui .align-items-xxl-stretch {
    align-items: stretch;
  }
  .aesirxui .align-content-xxl-start {
    align-content: flex-start;
  }
  .aesirxui .align-content-xxl-end {
    align-content: flex-end;
  }
  .aesirxui .align-content-xxl-center {
    align-content: center;
  }
  .aesirxui .align-content-xxl-between {
    align-content: space-between;
  }
  .aesirxui .align-content-xxl-around {
    align-content: space-around;
  }
  .aesirxui .align-content-xxl-stretch {
    align-content: stretch;
  }
  .aesirxui .align-self-xxl-auto {
    align-self: auto;
  }
  .aesirxui .align-self-xxl-start {
    align-self: flex-start;
  }
  .aesirxui .align-self-xxl-end {
    align-self: flex-end;
  }
  .aesirxui .align-self-xxl-center {
    align-self: center;
  }
  .aesirxui .align-self-xxl-baseline {
    align-self: baseline;
  }
  .aesirxui .align-self-xxl-stretch {
    align-self: stretch;
  }
  .aesirxui .order-xxl-first {
    order: -1;
  }
  .aesirxui .order-xxl-0 {
    order: 0;
  }
  .aesirxui .order-xxl-1 {
    order: 1;
  }
  .aesirxui .order-xxl-2 {
    order: 2;
  }
  .aesirxui .order-xxl-3 {
    order: 3;
  }
  .aesirxui .order-xxl-4 {
    order: 4;
  }
  .aesirxui .order-xxl-5 {
    order: 5;
  }
  .aesirxui .order-xxl-last {
    order: 6;
  }
  .aesirxui .m-xxl-0 {
    margin: 0;
  }
  .aesirxui .m-xxl-1 {
    margin: 0.25rem;
  }
  .aesirxui .m-xxl-2 {
    margin: 0.5rem;
  }
  .aesirxui .m-xxl-3 {
    margin: 1rem;
  }
  .aesirxui .m-xxl-4 {
    margin: 1.5rem;
  }
  .aesirxui .m-xxl-5 {
    margin: 3rem;
  }
  .aesirxui .m-xxl-sm {
    margin: 5px;
  }
  .aesirxui .m-xxl-8px {
    margin: 8px;
  }
  .aesirxui .m-xxl-15 {
    margin: 15px;
  }
  .aesirxui .m-xxl-16 {
    margin: 16px;
  }
  .aesirxui .m-xxl-20 {
    margin: 20px;
  }
  .aesirxui .m-xxl-24 {
    margin: 24px;
  }
  .aesirxui .m-xxl-6 {
    margin: 60px;
  }
  .aesirxui .m-xxl-7 {
    margin: 70px;
  }
  .aesirxui .m-xxl-8 {
    margin: 80px;
  }
  .aesirxui .m-xxl-10 {
    margin: 10px;
  }
  .aesirxui .m-xxl-13 {
    margin: 13px;
  }
  .aesirxui .m-xxl-14 {
    margin: 14px;
  }
  .aesirxui .m-xxl-40 {
    margin: 40px;
  }
  .aesirxui .m-xxl-18px {
    margin: 18px;
  }
  .aesirxui .m-xxl-32px {
    margin: 32px;
  }
  .aesirxui .m-xxl-9px {
    margin: 9px;
  }
  .aesirxui .m-xxl-12px {
    margin: 12px;
  }
  .aesirxui .m-xxl-19px {
    margin: 19px;
  }
  .aesirxui .m-xxl-auto {
    margin: auto;
  }
  .aesirxui .mx-xxl-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxui .mx-xxl-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxui .mx-xxl-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxui .mx-xxl-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxui .mx-xxl-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxui .mx-xxl-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxui .mx-xxl-sm {
    margin-right: 5px;
    margin-left: 5px;
  }
  .aesirxui .mx-xxl-8px {
    margin-right: 8px;
    margin-left: 8px;
  }
  .aesirxui .mx-xxl-15 {
    margin-right: 15px;
    margin-left: 15px;
  }
  .aesirxui .mx-xxl-16 {
    margin-right: 16px;
    margin-left: 16px;
  }
  .aesirxui .mx-xxl-20 {
    margin-right: 20px;
    margin-left: 20px;
  }
  .aesirxui .mx-xxl-24 {
    margin-right: 24px;
    margin-left: 24px;
  }
  .aesirxui .mx-xxl-6 {
    margin-right: 60px;
    margin-left: 60px;
  }
  .aesirxui .mx-xxl-7 {
    margin-right: 70px;
    margin-left: 70px;
  }
  .aesirxui .mx-xxl-8 {
    margin-right: 80px;
    margin-left: 80px;
  }
  .aesirxui .mx-xxl-10 {
    margin-right: 10px;
    margin-left: 10px;
  }
  .aesirxui .mx-xxl-13 {
    margin-right: 13px;
    margin-left: 13px;
  }
  .aesirxui .mx-xxl-14 {
    margin-right: 14px;
    margin-left: 14px;
  }
  .aesirxui .mx-xxl-40 {
    margin-right: 40px;
    margin-left: 40px;
  }
  .aesirxui .mx-xxl-18px {
    margin-right: 18px;
    margin-left: 18px;
  }
  .aesirxui .mx-xxl-32px {
    margin-right: 32px;
    margin-left: 32px;
  }
  .aesirxui .mx-xxl-9px {
    margin-right: 9px;
    margin-left: 9px;
  }
  .aesirxui .mx-xxl-12px {
    margin-right: 12px;
    margin-left: 12px;
  }
  .aesirxui .mx-xxl-19px {
    margin-right: 19px;
    margin-left: 19px;
  }
  .aesirxui .mx-xxl-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxui .my-xxl-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxui .my-xxl-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxui .my-xxl-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxui .my-xxl-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxui .my-xxl-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxui .my-xxl-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxui .my-xxl-sm {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .aesirxui .my-xxl-8px {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .aesirxui .my-xxl-15 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .aesirxui .my-xxl-16 {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .aesirxui .my-xxl-20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .aesirxui .my-xxl-24 {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .aesirxui .my-xxl-6 {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .aesirxui .my-xxl-7 {
    margin-top: 70px;
    margin-bottom: 70px;
  }
  .aesirxui .my-xxl-8 {
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .aesirxui .my-xxl-10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .aesirxui .my-xxl-13 {
    margin-top: 13px;
    margin-bottom: 13px;
  }
  .aesirxui .my-xxl-14 {
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .aesirxui .my-xxl-40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .aesirxui .my-xxl-18px {
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .aesirxui .my-xxl-32px {
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .aesirxui .my-xxl-9px {
    margin-top: 9px;
    margin-bottom: 9px;
  }
  .aesirxui .my-xxl-12px {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .aesirxui .my-xxl-19px {
    margin-top: 19px;
    margin-bottom: 19px;
  }
  .aesirxui .my-xxl-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxui .mt-xxl-0 {
    margin-top: 0;
  }
  .aesirxui .mt-xxl-1 {
    margin-top: 0.25rem;
  }
  .aesirxui .mt-xxl-2 {
    margin-top: 0.5rem;
  }
  .aesirxui .mt-xxl-3 {
    margin-top: 1rem;
  }
  .aesirxui .mt-xxl-4 {
    margin-top: 1.5rem;
  }
  .aesirxui .mt-xxl-5 {
    margin-top: 3rem;
  }
  .aesirxui .mt-xxl-sm {
    margin-top: 5px;
  }
  .aesirxui .mt-xxl-8px {
    margin-top: 8px;
  }
  .aesirxui .mt-xxl-15 {
    margin-top: 15px;
  }
  .aesirxui .mt-xxl-16 {
    margin-top: 16px;
  }
  .aesirxui .mt-xxl-20 {
    margin-top: 20px;
  }
  .aesirxui .mt-xxl-24 {
    margin-top: 24px;
  }
  .aesirxui .mt-xxl-6 {
    margin-top: 60px;
  }
  .aesirxui .mt-xxl-7 {
    margin-top: 70px;
  }
  .aesirxui .mt-xxl-8 {
    margin-top: 80px;
  }
  .aesirxui .mt-xxl-10 {
    margin-top: 10px;
  }
  .aesirxui .mt-xxl-13 {
    margin-top: 13px;
  }
  .aesirxui .mt-xxl-14 {
    margin-top: 14px;
  }
  .aesirxui .mt-xxl-40 {
    margin-top: 40px;
  }
  .aesirxui .mt-xxl-18px {
    margin-top: 18px;
  }
  .aesirxui .mt-xxl-32px {
    margin-top: 32px;
  }
  .aesirxui .mt-xxl-9px {
    margin-top: 9px;
  }
  .aesirxui .mt-xxl-12px {
    margin-top: 12px;
  }
  .aesirxui .mt-xxl-19px {
    margin-top: 19px;
  }
  .aesirxui .mt-xxl-auto {
    margin-top: auto;
  }
  .aesirxui .me-xxl-0 {
    margin-right: 0;
  }
  .aesirxui .me-xxl-1 {
    margin-right: 0.25rem;
  }
  .aesirxui .me-xxl-2 {
    margin-right: 0.5rem;
  }
  .aesirxui .me-xxl-3 {
    margin-right: 1rem;
  }
  .aesirxui .me-xxl-4 {
    margin-right: 1.5rem;
  }
  .aesirxui .me-xxl-5 {
    margin-right: 3rem;
  }
  .aesirxui .me-xxl-sm {
    margin-right: 5px;
  }
  .aesirxui .me-xxl-8px {
    margin-right: 8px;
  }
  .aesirxui .me-xxl-15 {
    margin-right: 15px;
  }
  .aesirxui .me-xxl-16 {
    margin-right: 16px;
  }
  .aesirxui .me-xxl-20 {
    margin-right: 20px;
  }
  .aesirxui .me-xxl-24 {
    margin-right: 24px;
  }
  .aesirxui .me-xxl-6 {
    margin-right: 60px;
  }
  .aesirxui .me-xxl-7 {
    margin-right: 70px;
  }
  .aesirxui .me-xxl-8 {
    margin-right: 80px;
  }
  .aesirxui .me-xxl-10 {
    margin-right: 10px;
  }
  .aesirxui .me-xxl-13 {
    margin-right: 13px;
  }
  .aesirxui .me-xxl-14 {
    margin-right: 14px;
  }
  .aesirxui .me-xxl-40 {
    margin-right: 40px;
  }
  .aesirxui .me-xxl-18px {
    margin-right: 18px;
  }
  .aesirxui .me-xxl-32px {
    margin-right: 32px;
  }
  .aesirxui .me-xxl-9px {
    margin-right: 9px;
  }
  .aesirxui .me-xxl-12px {
    margin-right: 12px;
  }
  .aesirxui .me-xxl-19px {
    margin-right: 19px;
  }
  .aesirxui .me-xxl-auto {
    margin-right: auto;
  }
  .aesirxui .mb-xxl-0 {
    margin-bottom: 0;
  }
  .aesirxui .mb-xxl-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxui .mb-xxl-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxui .mb-xxl-3 {
    margin-bottom: 1rem;
  }
  .aesirxui .mb-xxl-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxui .mb-xxl-5 {
    margin-bottom: 3rem;
  }
  .aesirxui .mb-xxl-sm {
    margin-bottom: 5px;
  }
  .aesirxui .mb-xxl-8px {
    margin-bottom: 8px;
  }
  .aesirxui .mb-xxl-15 {
    margin-bottom: 15px;
  }
  .aesirxui .mb-xxl-16 {
    margin-bottom: 16px;
  }
  .aesirxui .mb-xxl-20 {
    margin-bottom: 20px;
  }
  .aesirxui .mb-xxl-24 {
    margin-bottom: 24px;
  }
  .aesirxui .mb-xxl-6 {
    margin-bottom: 60px;
  }
  .aesirxui .mb-xxl-7 {
    margin-bottom: 70px;
  }
  .aesirxui .mb-xxl-8 {
    margin-bottom: 80px;
  }
  .aesirxui .mb-xxl-10 {
    margin-bottom: 10px;
  }
  .aesirxui .mb-xxl-13 {
    margin-bottom: 13px;
  }
  .aesirxui .mb-xxl-14 {
    margin-bottom: 14px;
  }
  .aesirxui .mb-xxl-40 {
    margin-bottom: 40px;
  }
  .aesirxui .mb-xxl-18px {
    margin-bottom: 18px;
  }
  .aesirxui .mb-xxl-32px {
    margin-bottom: 32px;
  }
  .aesirxui .mb-xxl-9px {
    margin-bottom: 9px;
  }
  .aesirxui .mb-xxl-12px {
    margin-bottom: 12px;
  }
  .aesirxui .mb-xxl-19px {
    margin-bottom: 19px;
  }
  .aesirxui .mb-xxl-auto {
    margin-bottom: auto;
  }
  .aesirxui .ms-xxl-0 {
    margin-left: 0;
  }
  .aesirxui .ms-xxl-1 {
    margin-left: 0.25rem;
  }
  .aesirxui .ms-xxl-2 {
    margin-left: 0.5rem;
  }
  .aesirxui .ms-xxl-3 {
    margin-left: 1rem;
  }
  .aesirxui .ms-xxl-4 {
    margin-left: 1.5rem;
  }
  .aesirxui .ms-xxl-5 {
    margin-left: 3rem;
  }
  .aesirxui .ms-xxl-sm {
    margin-left: 5px;
  }
  .aesirxui .ms-xxl-8px {
    margin-left: 8px;
  }
  .aesirxui .ms-xxl-15 {
    margin-left: 15px;
  }
  .aesirxui .ms-xxl-16 {
    margin-left: 16px;
  }
  .aesirxui .ms-xxl-20 {
    margin-left: 20px;
  }
  .aesirxui .ms-xxl-24 {
    margin-left: 24px;
  }
  .aesirxui .ms-xxl-6 {
    margin-left: 60px;
  }
  .aesirxui .ms-xxl-7 {
    margin-left: 70px;
  }
  .aesirxui .ms-xxl-8 {
    margin-left: 80px;
  }
  .aesirxui .ms-xxl-10 {
    margin-left: 10px;
  }
  .aesirxui .ms-xxl-13 {
    margin-left: 13px;
  }
  .aesirxui .ms-xxl-14 {
    margin-left: 14px;
  }
  .aesirxui .ms-xxl-40 {
    margin-left: 40px;
  }
  .aesirxui .ms-xxl-18px {
    margin-left: 18px;
  }
  .aesirxui .ms-xxl-32px {
    margin-left: 32px;
  }
  .aesirxui .ms-xxl-9px {
    margin-left: 9px;
  }
  .aesirxui .ms-xxl-12px {
    margin-left: 12px;
  }
  .aesirxui .ms-xxl-19px {
    margin-left: 19px;
  }
  .aesirxui .ms-xxl-auto {
    margin-left: auto;
  }
  .aesirxui .m-xxl-n1 {
    margin: -0.25rem;
  }
  .aesirxui .m-xxl-n2 {
    margin: -0.5rem;
  }
  .aesirxui .m-xxl-n3 {
    margin: -1rem;
  }
  .aesirxui .m-xxl-n4 {
    margin: -1.5rem;
  }
  .aesirxui .m-xxl-n5 {
    margin: -3rem;
  }
  .aesirxui .m-xxl-nsm {
    margin: -5px;
  }
  .aesirxui .m-xxl-n8px {
    margin: -8px;
  }
  .aesirxui .m-xxl-n15 {
    margin: -15px;
  }
  .aesirxui .m-xxl-n16 {
    margin: -16px;
  }
  .aesirxui .m-xxl-n20 {
    margin: -20px;
  }
  .aesirxui .m-xxl-n24 {
    margin: -24px;
  }
  .aesirxui .m-xxl-n6 {
    margin: -60px;
  }
  .aesirxui .m-xxl-n7 {
    margin: -70px;
  }
  .aesirxui .m-xxl-n8 {
    margin: -80px;
  }
  .aesirxui .m-xxl-n10 {
    margin: -10px;
  }
  .aesirxui .m-xxl-n13 {
    margin: -13px;
  }
  .aesirxui .m-xxl-n14 {
    margin: -14px;
  }
  .aesirxui .m-xxl-n40 {
    margin: -40px;
  }
  .aesirxui .m-xxl-n18px {
    margin: -18px;
  }
  .aesirxui .m-xxl-n32px {
    margin: -32px;
  }
  .aesirxui .m-xxl-n9px {
    margin: -9px;
  }
  .aesirxui .m-xxl-n12px {
    margin: -12px;
  }
  .aesirxui .m-xxl-n19px {
    margin: -19px;
  }
  .aesirxui .mx-xxl-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxui .mx-xxl-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxui .mx-xxl-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxui .mx-xxl-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxui .mx-xxl-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxui .mx-xxl-nsm {
    margin-right: -5px;
    margin-left: -5px;
  }
  .aesirxui .mx-xxl-n8px {
    margin-right: -8px;
    margin-left: -8px;
  }
  .aesirxui .mx-xxl-n15 {
    margin-right: -15px;
    margin-left: -15px;
  }
  .aesirxui .mx-xxl-n16 {
    margin-right: -16px;
    margin-left: -16px;
  }
  .aesirxui .mx-xxl-n20 {
    margin-right: -20px;
    margin-left: -20px;
  }
  .aesirxui .mx-xxl-n24 {
    margin-right: -24px;
    margin-left: -24px;
  }
  .aesirxui .mx-xxl-n6 {
    margin-right: -60px;
    margin-left: -60px;
  }
  .aesirxui .mx-xxl-n7 {
    margin-right: -70px;
    margin-left: -70px;
  }
  .aesirxui .mx-xxl-n8 {
    margin-right: -80px;
    margin-left: -80px;
  }
  .aesirxui .mx-xxl-n10 {
    margin-right: -10px;
    margin-left: -10px;
  }
  .aesirxui .mx-xxl-n13 {
    margin-right: -13px;
    margin-left: -13px;
  }
  .aesirxui .mx-xxl-n14 {
    margin-right: -14px;
    margin-left: -14px;
  }
  .aesirxui .mx-xxl-n40 {
    margin-right: -40px;
    margin-left: -40px;
  }
  .aesirxui .mx-xxl-n18px {
    margin-right: -18px;
    margin-left: -18px;
  }
  .aesirxui .mx-xxl-n32px {
    margin-right: -32px;
    margin-left: -32px;
  }
  .aesirxui .mx-xxl-n9px {
    margin-right: -9px;
    margin-left: -9px;
  }
  .aesirxui .mx-xxl-n12px {
    margin-right: -12px;
    margin-left: -12px;
  }
  .aesirxui .mx-xxl-n19px {
    margin-right: -19px;
    margin-left: -19px;
  }
  .aesirxui .my-xxl-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxui .my-xxl-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxui .my-xxl-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxui .my-xxl-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxui .my-xxl-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxui .my-xxl-nsm {
    margin-top: -5px;
    margin-bottom: -5px;
  }
  .aesirxui .my-xxl-n8px {
    margin-top: -8px;
    margin-bottom: -8px;
  }
  .aesirxui .my-xxl-n15 {
    margin-top: -15px;
    margin-bottom: -15px;
  }
  .aesirxui .my-xxl-n16 {
    margin-top: -16px;
    margin-bottom: -16px;
  }
  .aesirxui .my-xxl-n20 {
    margin-top: -20px;
    margin-bottom: -20px;
  }
  .aesirxui .my-xxl-n24 {
    margin-top: -24px;
    margin-bottom: -24px;
  }
  .aesirxui .my-xxl-n6 {
    margin-top: -60px;
    margin-bottom: -60px;
  }
  .aesirxui .my-xxl-n7 {
    margin-top: -70px;
    margin-bottom: -70px;
  }
  .aesirxui .my-xxl-n8 {
    margin-top: -80px;
    margin-bottom: -80px;
  }
  .aesirxui .my-xxl-n10 {
    margin-top: -10px;
    margin-bottom: -10px;
  }
  .aesirxui .my-xxl-n13 {
    margin-top: -13px;
    margin-bottom: -13px;
  }
  .aesirxui .my-xxl-n14 {
    margin-top: -14px;
    margin-bottom: -14px;
  }
  .aesirxui .my-xxl-n40 {
    margin-top: -40px;
    margin-bottom: -40px;
  }
  .aesirxui .my-xxl-n18px {
    margin-top: -18px;
    margin-bottom: -18px;
  }
  .aesirxui .my-xxl-n32px {
    margin-top: -32px;
    margin-bottom: -32px;
  }
  .aesirxui .my-xxl-n9px {
    margin-top: -9px;
    margin-bottom: -9px;
  }
  .aesirxui .my-xxl-n12px {
    margin-top: -12px;
    margin-bottom: -12px;
  }
  .aesirxui .my-xxl-n19px {
    margin-top: -19px;
    margin-bottom: -19px;
  }
  .aesirxui .mt-xxl-n1 {
    margin-top: -0.25rem;
  }
  .aesirxui .mt-xxl-n2 {
    margin-top: -0.5rem;
  }
  .aesirxui .mt-xxl-n3 {
    margin-top: -1rem;
  }
  .aesirxui .mt-xxl-n4 {
    margin-top: -1.5rem;
  }
  .aesirxui .mt-xxl-n5 {
    margin-top: -3rem;
  }
  .aesirxui .mt-xxl-nsm {
    margin-top: -5px;
  }
  .aesirxui .mt-xxl-n8px {
    margin-top: -8px;
  }
  .aesirxui .mt-xxl-n15 {
    margin-top: -15px;
  }
  .aesirxui .mt-xxl-n16 {
    margin-top: -16px;
  }
  .aesirxui .mt-xxl-n20 {
    margin-top: -20px;
  }
  .aesirxui .mt-xxl-n24 {
    margin-top: -24px;
  }
  .aesirxui .mt-xxl-n6 {
    margin-top: -60px;
  }
  .aesirxui .mt-xxl-n7 {
    margin-top: -70px;
  }
  .aesirxui .mt-xxl-n8 {
    margin-top: -80px;
  }
  .aesirxui .mt-xxl-n10 {
    margin-top: -10px;
  }
  .aesirxui .mt-xxl-n13 {
    margin-top: -13px;
  }
  .aesirxui .mt-xxl-n14 {
    margin-top: -14px;
  }
  .aesirxui .mt-xxl-n40 {
    margin-top: -40px;
  }
  .aesirxui .mt-xxl-n18px {
    margin-top: -18px;
  }
  .aesirxui .mt-xxl-n32px {
    margin-top: -32px;
  }
  .aesirxui .mt-xxl-n9px {
    margin-top: -9px;
  }
  .aesirxui .mt-xxl-n12px {
    margin-top: -12px;
  }
  .aesirxui .mt-xxl-n19px {
    margin-top: -19px;
  }
  .aesirxui .me-xxl-n1 {
    margin-right: -0.25rem;
  }
  .aesirxui .me-xxl-n2 {
    margin-right: -0.5rem;
  }
  .aesirxui .me-xxl-n3 {
    margin-right: -1rem;
  }
  .aesirxui .me-xxl-n4 {
    margin-right: -1.5rem;
  }
  .aesirxui .me-xxl-n5 {
    margin-right: -3rem;
  }
  .aesirxui .me-xxl-nsm {
    margin-right: -5px;
  }
  .aesirxui .me-xxl-n8px {
    margin-right: -8px;
  }
  .aesirxui .me-xxl-n15 {
    margin-right: -15px;
  }
  .aesirxui .me-xxl-n16 {
    margin-right: -16px;
  }
  .aesirxui .me-xxl-n20 {
    margin-right: -20px;
  }
  .aesirxui .me-xxl-n24 {
    margin-right: -24px;
  }
  .aesirxui .me-xxl-n6 {
    margin-right: -60px;
  }
  .aesirxui .me-xxl-n7 {
    margin-right: -70px;
  }
  .aesirxui .me-xxl-n8 {
    margin-right: -80px;
  }
  .aesirxui .me-xxl-n10 {
    margin-right: -10px;
  }
  .aesirxui .me-xxl-n13 {
    margin-right: -13px;
  }
  .aesirxui .me-xxl-n14 {
    margin-right: -14px;
  }
  .aesirxui .me-xxl-n40 {
    margin-right: -40px;
  }
  .aesirxui .me-xxl-n18px {
    margin-right: -18px;
  }
  .aesirxui .me-xxl-n32px {
    margin-right: -32px;
  }
  .aesirxui .me-xxl-n9px {
    margin-right: -9px;
  }
  .aesirxui .me-xxl-n12px {
    margin-right: -12px;
  }
  .aesirxui .me-xxl-n19px {
    margin-right: -19px;
  }
  .aesirxui .mb-xxl-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxui .mb-xxl-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxui .mb-xxl-n3 {
    margin-bottom: -1rem;
  }
  .aesirxui .mb-xxl-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxui .mb-xxl-n5 {
    margin-bottom: -3rem;
  }
  .aesirxui .mb-xxl-nsm {
    margin-bottom: -5px;
  }
  .aesirxui .mb-xxl-n8px {
    margin-bottom: -8px;
  }
  .aesirxui .mb-xxl-n15 {
    margin-bottom: -15px;
  }
  .aesirxui .mb-xxl-n16 {
    margin-bottom: -16px;
  }
  .aesirxui .mb-xxl-n20 {
    margin-bottom: -20px;
  }
  .aesirxui .mb-xxl-n24 {
    margin-bottom: -24px;
  }
  .aesirxui .mb-xxl-n6 {
    margin-bottom: -60px;
  }
  .aesirxui .mb-xxl-n7 {
    margin-bottom: -70px;
  }
  .aesirxui .mb-xxl-n8 {
    margin-bottom: -80px;
  }
  .aesirxui .mb-xxl-n10 {
    margin-bottom: -10px;
  }
  .aesirxui .mb-xxl-n13 {
    margin-bottom: -13px;
  }
  .aesirxui .mb-xxl-n14 {
    margin-bottom: -14px;
  }
  .aesirxui .mb-xxl-n40 {
    margin-bottom: -40px;
  }
  .aesirxui .mb-xxl-n18px {
    margin-bottom: -18px;
  }
  .aesirxui .mb-xxl-n32px {
    margin-bottom: -32px;
  }
  .aesirxui .mb-xxl-n9px {
    margin-bottom: -9px;
  }
  .aesirxui .mb-xxl-n12px {
    margin-bottom: -12px;
  }
  .aesirxui .mb-xxl-n19px {
    margin-bottom: -19px;
  }
  .aesirxui .ms-xxl-n1 {
    margin-left: -0.25rem;
  }
  .aesirxui .ms-xxl-n2 {
    margin-left: -0.5rem;
  }
  .aesirxui .ms-xxl-n3 {
    margin-left: -1rem;
  }
  .aesirxui .ms-xxl-n4 {
    margin-left: -1.5rem;
  }
  .aesirxui .ms-xxl-n5 {
    margin-left: -3rem;
  }
  .aesirxui .ms-xxl-nsm {
    margin-left: -5px;
  }
  .aesirxui .ms-xxl-n8px {
    margin-left: -8px;
  }
  .aesirxui .ms-xxl-n15 {
    margin-left: -15px;
  }
  .aesirxui .ms-xxl-n16 {
    margin-left: -16px;
  }
  .aesirxui .ms-xxl-n20 {
    margin-left: -20px;
  }
  .aesirxui .ms-xxl-n24 {
    margin-left: -24px;
  }
  .aesirxui .ms-xxl-n6 {
    margin-left: -60px;
  }
  .aesirxui .ms-xxl-n7 {
    margin-left: -70px;
  }
  .aesirxui .ms-xxl-n8 {
    margin-left: -80px;
  }
  .aesirxui .ms-xxl-n10 {
    margin-left: -10px;
  }
  .aesirxui .ms-xxl-n13 {
    margin-left: -13px;
  }
  .aesirxui .ms-xxl-n14 {
    margin-left: -14px;
  }
  .aesirxui .ms-xxl-n40 {
    margin-left: -40px;
  }
  .aesirxui .ms-xxl-n18px {
    margin-left: -18px;
  }
  .aesirxui .ms-xxl-n32px {
    margin-left: -32px;
  }
  .aesirxui .ms-xxl-n9px {
    margin-left: -9px;
  }
  .aesirxui .ms-xxl-n12px {
    margin-left: -12px;
  }
  .aesirxui .ms-xxl-n19px {
    margin-left: -19px;
  }
  .aesirxui .p-xxl-0 {
    padding: 0;
  }
  .aesirxui .p-xxl-1 {
    padding: 0.25rem;
  }
  .aesirxui .p-xxl-2 {
    padding: 0.5rem;
  }
  .aesirxui .p-xxl-3 {
    padding: 1rem;
  }
  .aesirxui .p-xxl-4 {
    padding: 1.5rem;
  }
  .aesirxui .p-xxl-5 {
    padding: 3rem;
  }
  .aesirxui .p-xxl-sm {
    padding: 5px;
  }
  .aesirxui .p-xxl-8px {
    padding: 8px;
  }
  .aesirxui .p-xxl-15 {
    padding: 15px;
  }
  .aesirxui .p-xxl-16 {
    padding: 16px;
  }
  .aesirxui .p-xxl-20 {
    padding: 20px;
  }
  .aesirxui .p-xxl-24 {
    padding: 24px;
  }
  .aesirxui .p-xxl-6 {
    padding: 60px;
  }
  .aesirxui .p-xxl-7 {
    padding: 70px;
  }
  .aesirxui .p-xxl-8 {
    padding: 80px;
  }
  .aesirxui .p-xxl-10 {
    padding: 10px;
  }
  .aesirxui .p-xxl-13 {
    padding: 13px;
  }
  .aesirxui .p-xxl-14 {
    padding: 14px;
  }
  .aesirxui .p-xxl-40 {
    padding: 40px;
  }
  .aesirxui .p-xxl-18px {
    padding: 18px;
  }
  .aesirxui .p-xxl-32px {
    padding: 32px;
  }
  .aesirxui .p-xxl-9px {
    padding: 9px;
  }
  .aesirxui .p-xxl-12px {
    padding: 12px;
  }
  .aesirxui .p-xxl-19px {
    padding: 19px;
  }
  .aesirxui .px-xxl-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxui .px-xxl-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxui .px-xxl-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxui .px-xxl-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxui .px-xxl-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxui .px-xxl-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxui .px-xxl-sm {
    padding-right: 5px;
    padding-left: 5px;
  }
  .aesirxui .px-xxl-8px {
    padding-right: 8px;
    padding-left: 8px;
  }
  .aesirxui .px-xxl-15 {
    padding-right: 15px;
    padding-left: 15px;
  }
  .aesirxui .px-xxl-16 {
    padding-right: 16px;
    padding-left: 16px;
  }
  .aesirxui .px-xxl-20 {
    padding-right: 20px;
    padding-left: 20px;
  }
  .aesirxui .px-xxl-24 {
    padding-right: 24px;
    padding-left: 24px;
  }
  .aesirxui .px-xxl-6 {
    padding-right: 60px;
    padding-left: 60px;
  }
  .aesirxui .px-xxl-7 {
    padding-right: 70px;
    padding-left: 70px;
  }
  .aesirxui .px-xxl-8 {
    padding-right: 80px;
    padding-left: 80px;
  }
  .aesirxui .px-xxl-10 {
    padding-right: 10px;
    padding-left: 10px;
  }
  .aesirxui .px-xxl-13 {
    padding-right: 13px;
    padding-left: 13px;
  }
  .aesirxui .px-xxl-14 {
    padding-right: 14px;
    padding-left: 14px;
  }
  .aesirxui .px-xxl-40 {
    padding-right: 40px;
    padding-left: 40px;
  }
  .aesirxui .px-xxl-18px {
    padding-right: 18px;
    padding-left: 18px;
  }
  .aesirxui .px-xxl-32px {
    padding-right: 32px;
    padding-left: 32px;
  }
  .aesirxui .px-xxl-9px {
    padding-right: 9px;
    padding-left: 9px;
  }
  .aesirxui .px-xxl-12px {
    padding-right: 12px;
    padding-left: 12px;
  }
  .aesirxui .px-xxl-19px {
    padding-right: 19px;
    padding-left: 19px;
  }
  .aesirxui .py-xxl-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxui .py-xxl-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxui .py-xxl-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxui .py-xxl-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxui .py-xxl-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxui .py-xxl-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxui .py-xxl-sm {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .aesirxui .py-xxl-8px {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .aesirxui .py-xxl-15 {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .aesirxui .py-xxl-16 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .aesirxui .py-xxl-20 {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .aesirxui .py-xxl-24 {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .aesirxui .py-xxl-6 {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .aesirxui .py-xxl-7 {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .aesirxui .py-xxl-8 {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .aesirxui .py-xxl-10 {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .aesirxui .py-xxl-13 {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .aesirxui .py-xxl-14 {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .aesirxui .py-xxl-40 {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .aesirxui .py-xxl-18px {
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .aesirxui .py-xxl-32px {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  .aesirxui .py-xxl-9px {
    padding-top: 9px;
    padding-bottom: 9px;
  }
  .aesirxui .py-xxl-12px {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .aesirxui .py-xxl-19px {
    padding-top: 19px;
    padding-bottom: 19px;
  }
  .aesirxui .pt-xxl-0 {
    padding-top: 0;
  }
  .aesirxui .pt-xxl-1 {
    padding-top: 0.25rem;
  }
  .aesirxui .pt-xxl-2 {
    padding-top: 0.5rem;
  }
  .aesirxui .pt-xxl-3 {
    padding-top: 1rem;
  }
  .aesirxui .pt-xxl-4 {
    padding-top: 1.5rem;
  }
  .aesirxui .pt-xxl-5 {
    padding-top: 3rem;
  }
  .aesirxui .pt-xxl-sm {
    padding-top: 5px;
  }
  .aesirxui .pt-xxl-8px {
    padding-top: 8px;
  }
  .aesirxui .pt-xxl-15 {
    padding-top: 15px;
  }
  .aesirxui .pt-xxl-16 {
    padding-top: 16px;
  }
  .aesirxui .pt-xxl-20 {
    padding-top: 20px;
  }
  .aesirxui .pt-xxl-24 {
    padding-top: 24px;
  }
  .aesirxui .pt-xxl-6 {
    padding-top: 60px;
  }
  .aesirxui .pt-xxl-7 {
    padding-top: 70px;
  }
  .aesirxui .pt-xxl-8 {
    padding-top: 80px;
  }
  .aesirxui .pt-xxl-10 {
    padding-top: 10px;
  }
  .aesirxui .pt-xxl-13 {
    padding-top: 13px;
  }
  .aesirxui .pt-xxl-14 {
    padding-top: 14px;
  }
  .aesirxui .pt-xxl-40 {
    padding-top: 40px;
  }
  .aesirxui .pt-xxl-18px {
    padding-top: 18px;
  }
  .aesirxui .pt-xxl-32px {
    padding-top: 32px;
  }
  .aesirxui .pt-xxl-9px {
    padding-top: 9px;
  }
  .aesirxui .pt-xxl-12px {
    padding-top: 12px;
  }
  .aesirxui .pt-xxl-19px {
    padding-top: 19px;
  }
  .aesirxui .pe-xxl-0 {
    padding-right: 0;
  }
  .aesirxui .pe-xxl-1 {
    padding-right: 0.25rem;
  }
  .aesirxui .pe-xxl-2 {
    padding-right: 0.5rem;
  }
  .aesirxui .pe-xxl-3 {
    padding-right: 1rem;
  }
  .aesirxui .pe-xxl-4 {
    padding-right: 1.5rem;
  }
  .aesirxui .pe-xxl-5 {
    padding-right: 3rem;
  }
  .aesirxui .pe-xxl-sm {
    padding-right: 5px;
  }
  .aesirxui .pe-xxl-8px {
    padding-right: 8px;
  }
  .aesirxui .pe-xxl-15 {
    padding-right: 15px;
  }
  .aesirxui .pe-xxl-16 {
    padding-right: 16px;
  }
  .aesirxui .pe-xxl-20 {
    padding-right: 20px;
  }
  .aesirxui .pe-xxl-24 {
    padding-right: 24px;
  }
  .aesirxui .pe-xxl-6 {
    padding-right: 60px;
  }
  .aesirxui .pe-xxl-7 {
    padding-right: 70px;
  }
  .aesirxui .pe-xxl-8 {
    padding-right: 80px;
  }
  .aesirxui .pe-xxl-10 {
    padding-right: 10px;
  }
  .aesirxui .pe-xxl-13 {
    padding-right: 13px;
  }
  .aesirxui .pe-xxl-14 {
    padding-right: 14px;
  }
  .aesirxui .pe-xxl-40 {
    padding-right: 40px;
  }
  .aesirxui .pe-xxl-18px {
    padding-right: 18px;
  }
  .aesirxui .pe-xxl-32px {
    padding-right: 32px;
  }
  .aesirxui .pe-xxl-9px {
    padding-right: 9px;
  }
  .aesirxui .pe-xxl-12px {
    padding-right: 12px;
  }
  .aesirxui .pe-xxl-19px {
    padding-right: 19px;
  }
  .aesirxui .pb-xxl-0 {
    padding-bottom: 0;
  }
  .aesirxui .pb-xxl-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxui .pb-xxl-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxui .pb-xxl-3 {
    padding-bottom: 1rem;
  }
  .aesirxui .pb-xxl-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxui .pb-xxl-5 {
    padding-bottom: 3rem;
  }
  .aesirxui .pb-xxl-sm {
    padding-bottom: 5px;
  }
  .aesirxui .pb-xxl-8px {
    padding-bottom: 8px;
  }
  .aesirxui .pb-xxl-15 {
    padding-bottom: 15px;
  }
  .aesirxui .pb-xxl-16 {
    padding-bottom: 16px;
  }
  .aesirxui .pb-xxl-20 {
    padding-bottom: 20px;
  }
  .aesirxui .pb-xxl-24 {
    padding-bottom: 24px;
  }
  .aesirxui .pb-xxl-6 {
    padding-bottom: 60px;
  }
  .aesirxui .pb-xxl-7 {
    padding-bottom: 70px;
  }
  .aesirxui .pb-xxl-8 {
    padding-bottom: 80px;
  }
  .aesirxui .pb-xxl-10 {
    padding-bottom: 10px;
  }
  .aesirxui .pb-xxl-13 {
    padding-bottom: 13px;
  }
  .aesirxui .pb-xxl-14 {
    padding-bottom: 14px;
  }
  .aesirxui .pb-xxl-40 {
    padding-bottom: 40px;
  }
  .aesirxui .pb-xxl-18px {
    padding-bottom: 18px;
  }
  .aesirxui .pb-xxl-32px {
    padding-bottom: 32px;
  }
  .aesirxui .pb-xxl-9px {
    padding-bottom: 9px;
  }
  .aesirxui .pb-xxl-12px {
    padding-bottom: 12px;
  }
  .aesirxui .pb-xxl-19px {
    padding-bottom: 19px;
  }
  .aesirxui .ps-xxl-0 {
    padding-left: 0;
  }
  .aesirxui .ps-xxl-1 {
    padding-left: 0.25rem;
  }
  .aesirxui .ps-xxl-2 {
    padding-left: 0.5rem;
  }
  .aesirxui .ps-xxl-3 {
    padding-left: 1rem;
  }
  .aesirxui .ps-xxl-4 {
    padding-left: 1.5rem;
  }
  .aesirxui .ps-xxl-5 {
    padding-left: 3rem;
  }
  .aesirxui .ps-xxl-sm {
    padding-left: 5px;
  }
  .aesirxui .ps-xxl-8px {
    padding-left: 8px;
  }
  .aesirxui .ps-xxl-15 {
    padding-left: 15px;
  }
  .aesirxui .ps-xxl-16 {
    padding-left: 16px;
  }
  .aesirxui .ps-xxl-20 {
    padding-left: 20px;
  }
  .aesirxui .ps-xxl-24 {
    padding-left: 24px;
  }
  .aesirxui .ps-xxl-6 {
    padding-left: 60px;
  }
  .aesirxui .ps-xxl-7 {
    padding-left: 70px;
  }
  .aesirxui .ps-xxl-8 {
    padding-left: 80px;
  }
  .aesirxui .ps-xxl-10 {
    padding-left: 10px;
  }
  .aesirxui .ps-xxl-13 {
    padding-left: 13px;
  }
  .aesirxui .ps-xxl-14 {
    padding-left: 14px;
  }
  .aesirxui .ps-xxl-40 {
    padding-left: 40px;
  }
  .aesirxui .ps-xxl-18px {
    padding-left: 18px;
  }
  .aesirxui .ps-xxl-32px {
    padding-left: 32px;
  }
  .aesirxui .ps-xxl-9px {
    padding-left: 9px;
  }
  .aesirxui .ps-xxl-12px {
    padding-left: 12px;
  }
  .aesirxui .ps-xxl-19px {
    padding-left: 19px;
  }
  .aesirxui .gap-xxl-0 {
    gap: 0;
  }
  .aesirxui .gap-xxl-1 {
    gap: 0.25rem;
  }
  .aesirxui .gap-xxl-2 {
    gap: 0.5rem;
  }
  .aesirxui .gap-xxl-3 {
    gap: 1rem;
  }
  .aesirxui .gap-xxl-4 {
    gap: 1.5rem;
  }
  .aesirxui .gap-xxl-5 {
    gap: 3rem;
  }
  .aesirxui .gap-xxl-sm {
    gap: 5px;
  }
  .aesirxui .gap-xxl-8px {
    gap: 8px;
  }
  .aesirxui .gap-xxl-15 {
    gap: 15px;
  }
  .aesirxui .gap-xxl-16 {
    gap: 16px;
  }
  .aesirxui .gap-xxl-20 {
    gap: 20px;
  }
  .aesirxui .gap-xxl-24 {
    gap: 24px;
  }
  .aesirxui .gap-xxl-6 {
    gap: 60px;
  }
  .aesirxui .gap-xxl-7 {
    gap: 70px;
  }
  .aesirxui .gap-xxl-8 {
    gap: 80px;
  }
  .aesirxui .gap-xxl-10 {
    gap: 10px;
  }
  .aesirxui .gap-xxl-13 {
    gap: 13px;
  }
  .aesirxui .gap-xxl-14 {
    gap: 14px;
  }
  .aesirxui .gap-xxl-40 {
    gap: 40px;
  }
  .aesirxui .gap-xxl-18px {
    gap: 18px;
  }
  .aesirxui .gap-xxl-32px {
    gap: 32px;
  }
  .aesirxui .gap-xxl-9px {
    gap: 9px;
  }
  .aesirxui .gap-xxl-12px {
    gap: 12px;
  }
  .aesirxui .gap-xxl-19px {
    gap: 19px;
  }
  .aesirxui .row-gap-xxl-0 {
    row-gap: 0;
  }
  .aesirxui .row-gap-xxl-1 {
    row-gap: 0.25rem;
  }
  .aesirxui .row-gap-xxl-2 {
    row-gap: 0.5rem;
  }
  .aesirxui .row-gap-xxl-3 {
    row-gap: 1rem;
  }
  .aesirxui .row-gap-xxl-4 {
    row-gap: 1.5rem;
  }
  .aesirxui .row-gap-xxl-5 {
    row-gap: 3rem;
  }
  .aesirxui .row-gap-xxl-sm {
    row-gap: 5px;
  }
  .aesirxui .row-gap-xxl-8px {
    row-gap: 8px;
  }
  .aesirxui .row-gap-xxl-15 {
    row-gap: 15px;
  }
  .aesirxui .row-gap-xxl-16 {
    row-gap: 16px;
  }
  .aesirxui .row-gap-xxl-20 {
    row-gap: 20px;
  }
  .aesirxui .row-gap-xxl-24 {
    row-gap: 24px;
  }
  .aesirxui .row-gap-xxl-6 {
    row-gap: 60px;
  }
  .aesirxui .row-gap-xxl-7 {
    row-gap: 70px;
  }
  .aesirxui .row-gap-xxl-8 {
    row-gap: 80px;
  }
  .aesirxui .row-gap-xxl-10 {
    row-gap: 10px;
  }
  .aesirxui .row-gap-xxl-13 {
    row-gap: 13px;
  }
  .aesirxui .row-gap-xxl-14 {
    row-gap: 14px;
  }
  .aesirxui .row-gap-xxl-40 {
    row-gap: 40px;
  }
  .aesirxui .row-gap-xxl-18px {
    row-gap: 18px;
  }
  .aesirxui .row-gap-xxl-32px {
    row-gap: 32px;
  }
  .aesirxui .row-gap-xxl-9px {
    row-gap: 9px;
  }
  .aesirxui .row-gap-xxl-12px {
    row-gap: 12px;
  }
  .aesirxui .row-gap-xxl-19px {
    row-gap: 19px;
  }
  .aesirxui .column-gap-xxl-0 {
    column-gap: 0;
  }
  .aesirxui .column-gap-xxl-1 {
    column-gap: 0.25rem;
  }
  .aesirxui .column-gap-xxl-2 {
    column-gap: 0.5rem;
  }
  .aesirxui .column-gap-xxl-3 {
    column-gap: 1rem;
  }
  .aesirxui .column-gap-xxl-4 {
    column-gap: 1.5rem;
  }
  .aesirxui .column-gap-xxl-5 {
    column-gap: 3rem;
  }
  .aesirxui .column-gap-xxl-sm {
    column-gap: 5px;
  }
  .aesirxui .column-gap-xxl-8px {
    column-gap: 8px;
  }
  .aesirxui .column-gap-xxl-15 {
    column-gap: 15px;
  }
  .aesirxui .column-gap-xxl-16 {
    column-gap: 16px;
  }
  .aesirxui .column-gap-xxl-20 {
    column-gap: 20px;
  }
  .aesirxui .column-gap-xxl-24 {
    column-gap: 24px;
  }
  .aesirxui .column-gap-xxl-6 {
    column-gap: 60px;
  }
  .aesirxui .column-gap-xxl-7 {
    column-gap: 70px;
  }
  .aesirxui .column-gap-xxl-8 {
    column-gap: 80px;
  }
  .aesirxui .column-gap-xxl-10 {
    column-gap: 10px;
  }
  .aesirxui .column-gap-xxl-13 {
    column-gap: 13px;
  }
  .aesirxui .column-gap-xxl-14 {
    column-gap: 14px;
  }
  .aesirxui .column-gap-xxl-40 {
    column-gap: 40px;
  }
  .aesirxui .column-gap-xxl-18px {
    column-gap: 18px;
  }
  .aesirxui .column-gap-xxl-32px {
    column-gap: 32px;
  }
  .aesirxui .column-gap-xxl-9px {
    column-gap: 9px;
  }
  .aesirxui .column-gap-xxl-12px {
    column-gap: 12px;
  }
  .aesirxui .column-gap-xxl-19px {
    column-gap: 19px;
  }
  .aesirxui .text-xxl-start {
    text-align: left;
  }
  .aesirxui .text-xxl-end {
    text-align: right;
  }
  .aesirxui .text-xxl-center {
    text-align: center;
  }
}
@media (min-width: 1200px) {
  .aesirxui .fs-1 {
    font-size: 2.5rem;
  }
  .aesirxui .fs-2 {
    font-size: 2rem;
  }
  .aesirxui .fs-3 {
    font-size: 1.75rem;
  }
  .aesirxui .fs-24 {
    font-size: 1.5rem;
  }
}
@media print {
  .aesirxui .d-print-inline {
    display: inline;
  }
  .aesirxui .d-print-inline-block {
    display: inline-block;
  }
  .aesirxui .d-print-block {
    display: block;
  }
  .aesirxui .d-print-grid {
    display: grid;
  }
  .aesirxui .d-print-inline-grid {
    display: inline-grid;
  }
  .aesirxui .d-print-table {
    display: table;
  }
  .aesirxui .d-print-table-row {
    display: table-row;
  }
  .aesirxui .d-print-table-cell {
    display: table-cell;
  }
  .aesirxui .d-print-flex {
    display: flex;
  }
  .aesirxui .d-print-inline-flex {
    display: inline-flex;
  }
  .aesirxui .d-print-none {
    display: none;
  }
}
.aesirxui img {
  max-width: 100%;
}
.aesirxui textarea {
  resize: vertical;
}
.aesirxui .lcl {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.aesirxui .lcl-1 {
  -webkit-line-clamp: 1;
}
.aesirxui .btn-success {
  color: #fff !important;
}
.aesirxui .main-panel > .content {
  position: relative;
  float: right;
  width: calc(100% - 260px);
}
.aesirxui .w-248 {
  width: 248px;
  transition: all 0.4s ease;
}
.aesirxui .w-260 {
  width: 260px;
  transition: all 0.4s ease;
}
.aesirxui .w-35 {
  width: 35%;
}
.aesirxui .w-45 {
  width: 45%;
}
.aesirxui .w-350 {
  width: 350px;
}
.aesirxui .w-400 {
  width: 400px;
  transition: all 0.4s ease;
}
.aesirxui .w-450 {
  width: 450px;
}
.aesirxui .pd-t-80 {
  padding-top: 80px;
}
.aesirxui .h-35 {
  height: 35px;
}
.aesirxui .h-45 {
  height: 45px;
}
.aesirxui .h-80 {
  height: 80px;
}
.aesirxui .h-196 {
  height: 196px;
}
.aesirxui .img-avatar-35 {
  width: 32px;
}
.aesirxui .img-avatar-32 {
  min-width: 32px;
  max-width: 32px;
  height: auto;
}
.aesirxui .img-avatar {
  min-width: 45px;
  max-width: 45px;
}
.aesirxui .img-avatar-full {
  min-width: 100%;
  max-width: 100%;
  max-height: 183px;
  border-radius: 5px;
}
.aesirxui .w-80 {
  width: 80px;
}
.aesirxui .w-98 {
  width: 98px;
}
.aesirxui .w-150 {
  width: 150px;
}
.aesirxui .w-110 {
  width: 110px;
}
.aesirxui .w-180 {
  width: 180px;
}
.aesirxui .w-200 {
  width: 200px;
}
.aesirxui .mw-80 {
  min-width: 80px;
}
.aesirxui .mw-100 {
  min-width: 100px;
}
.aesirxui .h-110 {
  height: 110px;
}
.aesirxui .w-20 {
  width: 20px;
}
.aesirxui .w-55 {
  width: 55px;
}
.aesirxui .h-55 {
  height: 55px;
}
.aesirxui .bg-status-1 {
  background-color: rgba(124, 231, 172, 0.4588235294);
  color: #1ab394 !important;
}
.aesirxui .bg-posted {
  background-color: rgba(124, 231, 172, 0.4588235294);
  color: #1ab394 !important;
}
.aesirxui .bg-status-2 {
  background-color: rgba(255, 158, 1, 0.4);
  color: #ff9e01 !important;
}
.aesirxui .bg-schedule {
  background-color: rgba(255, 158, 1, 0.4);
  color: #ff9e01 !important;
}
.aesirxui .bg-status-3 {
  background-color: rgba(239, 55, 55, 0.5019607843);
  color: #cb222c !important;
}
.aesirxui .bg-save_as_draft {
  background-color: rgba(239, 55, 55, 0.5019607843);
  color: #cb222c !important;
}
.aesirxui .bg-status-4 {
  background-color: rgba(25, 156, 227, 0.4);
  color: #199ce3 !important;
}
.aesirxui .bg-processing {
  background-color: rgba(25, 156, 227, 0.4);
  color: #199ce3 !important;
}
.aesirxui .bg-failed {
  background-color: rgba(203, 34, 44, 0.4);
  color: #cb222c !important;
}
.aesirxui .pe-400 {
  padding-right: 400px !important;
}
.aesirxui .z-index-5 {
  z-index: 5;
}
.aesirxui .z-index-10 {
  z-index: 10;
}
.aesirxui .z-index-100 {
  z-index: 100;
}
.aesirxui .btn-light {
  --aesirxui-btn-color: #0a083b;
  --aesirxui-btn-bg: #fff;
  --aesirxui-btn-border-color: #d2d2d2;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #d2d2d2;
  --aesirxui-btn-hover-border-color: #fff;
  --aesirxui-btn-focus-shadow-rgb: 180, 180, 187;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: white;
  --aesirxui-btn-active-border-color: rgb(214.5, 214.5, 214.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #fff;
  --aesirxui-btn-disabled-border-color: #d2d2d2;
}
.aesirxui .btn-light:focus {
  outline: 1px solid #d2d2d2;
}
.aesirxui .btn-light.border-success {
  --aesirxui-btn-color: #0a083b;
  --aesirxui-btn-bg: #fff;
  --aesirxui-btn-border-color: #d2d2d2;
  --aesirxui-btn-hover-color: #fff;
  --aesirxui-btn-hover-bg: #1ab394;
  --aesirxui-btn-hover-border-color: #fff;
  --aesirxui-btn-focus-shadow-rgb: 180, 180, 187;
  --aesirxui-btn-active-color: #000;
  --aesirxui-btn-active-bg: white;
  --aesirxui-btn-active-border-color: rgb(214.5, 214.5, 214.5);
  --aesirxui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxui-btn-disabled-color: #000;
  --aesirxui-btn-disabled-bg: #fff;
  --aesirxui-btn-disabled-border-color: #d2d2d2;
}
.aesirxui .btn-light.border-success .icon {
  background-color: #1ab394;
}
.aesirxui .btn-light.border-success:hover:active .icon {
  background-color: #1ab394;
}
.aesirxui .btn-light.border-success:hover .icon {
  background-color: #fff;
}
.aesirxui .pe-65 {
  padding-right: 65px;
}
.aesirxui .pe-80 {
  padding-right: 80px;
}
.aesirxui .radius-start-0 {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxui .radius-end-0 {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link {
  border: 0;
  margin-bottom: 0;
  color: rgba(10, 8, 59, 0.5);
  position: relative;
  padding: 1rem;
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  right: 0;
  width: 100%;
  height: 2px;
  background-color: #0a5aff;
  opacity: 0;
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link.active, .aesirxui .wrapper_tabs .nav-tabs .nav-link:hover {
  color: #0a5aff;
  background-color: transparent;
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link.active:before, .aesirxui .wrapper_tabs .nav-tabs .nav-link:hover:before {
  opacity: 1;
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link:focus {
  outline: none;
}
.aesirxui .wrapper_tabs.wrapper_tabs_2 .nav-tabs .nav-link {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.aesirxui .wrapper_tabs.wrapper_tabs_2 .nav-tabs .nav-link.active, .aesirxui .wrapper_tabs.wrapper_tabs_2 .nav-tabs .nav-link:hover {
  color: #fff;
  background-color: #0a5aff;
}
.aesirxui .wrapper_tabs.wrapper_tabs_2 .nav-tabs {
  border: 0;
}
.aesirxui .wrapper_tabs.wrapper_tabs_2 .item_tab_2 {
  display: none;
}
.aesirxui .wrapper_tabs.wrapper_tabs_2 .item_tab_2.active {
  display: block;
}
.aesirxui .outline-none:focus {
  outline: none;
}
.aesirxui .popover {
  width: 350px;
  z-index: 10;
}
.aesirxui .popover:before {
  content: "";
  position: absolute;
  left: -8px;
  top: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-right: 8px solid #fff;
  border-bottom: 7px solid transparent;
  margin-top: auto;
  margin-bottom: auto;
}
.aesirxui .main_upload_images .wr_btn_dam {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  width: 100% !important;
  height: 100%;
}
.aesirxui .main_upload_images .lg_btn_dam_assets {
  width: 100% !important;
}
.aesirxui .main_upload_images .lg_btn_dam_assets .w-50 {
  width: 100% !important;
}
.aesirxui .main_upload_images .item_dam_assets {
  border-top: 0 !important;
  margin-top: 0 !important;
}
.aesirxui .wr_upload_images.active_img .wr_icon_upload {
  opacity: 0 !important;
  position: absolute;
  z-index: -1;
}
.aesirxui .wr_video_assets .wr_btn_dam {
  margin-left: 0 !important;
}
.aesirxui .wr_dam_full_width .w-50 {
  width: 100% !important;
}
.aesirxui .icon_not_found {
  font-size: 3.5rem !important;
}
.aesirxui .wr_description_image_asset .item_dam_assets .wr_img_thumbnail_dam {
  width: 100px;
}
.aesirxui .wr_description_image_asset .wr_img_thumbnail_canva {
  width: 100px !important;
}
.aesirxui .react-datepicker__input-container input {
  width: 100%;
}
.aesirxui .btn_add_channel:focus {
  outline: none;
}
.aesirxui .wr_wz_content_page .wr_btn_back_wz {
  justify-content: space-between !important;
}
.aesirxui .wr_wz_content_page .btn_back_wz {
  display: block !important;
}
.aesirxui .avatar_persona .wr_btn_dam {
  z-index: 5;
}
.aesirxui .progress {
  background-color: #d9d9d9;
}
@media (max-width: 991.98px) {
  .aesirxui .w-400 {
    width: 250px;
  }
}
.aesirxui ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #d2d2d2;
}
.aesirxui ::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px transparent;
  border-radius: 5px;
  background-color: #d2d2d2;
  box-shadow: inset 0 0 6px transparent;
}
.aesirxui ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px transparent;
  background-color: #fff;
  box-shadow: inset 0 0 6px transparent;
}
.aesirxui .btn-outline-secondary:not(:hover) {
  background: #fff;
}
.aesirxui .btn-info.dropdown-toggle:focus {
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.aesirxui .form-switch .form-check-input:checked {
  background-color: #1ab394;
}
.aesirxui .form-check.form-switch .form-check-input {
  width: 2.5em;
  height: 1.5em;
  margin-left: -3em;
  margin-top: 0;
}
.aesirxui .form-check .form-check-input {
  width: 16px;
  height: 16px;
  margin-left: -25px;
  margin-top: 4px;
}
.aesirxui .form-check-input[type=checkbox]:checked {
  background-color: #1ab394;
}
.aesirxui .form-check-input[type=checkbox]:focus {
  box-shadow: none;
}
.aesirxui .form-control {
  background-color: var(--aesirxui-white);
}
.aesirxui .form-control::placeholder {
  color: var(--aesirxui-input-placeholder-color);
}
.aesirxui .form-control:disabled {
  background-color: var(--aesirxui-white);
}
.aesirxui form .form-control {
  padding: 10px 16px;
  line-height: 18px;
  font-size: 14px;
  background-color: var(--aesirxui-white);
}
.aesirxui form .form-control::placeholder {
  color: var(--aesirxui-input-placeholder-color);
}
.aesirxui form .form-control:focus {
  box-shadow: none;
  border: 1px solid #0a083b;
  background-color: var(--aesirxui-white);
}
.aesirxui form .form-control:-webkit-autofill:focus {
  background-color: var(--aesirxui-white) !important;
  -webkit-box-shadow: 0 0 0px 1000px var(--aesirxui-white) inset;
}
.aesirxui .react-datepicker .react-datepicker__current-month {
  font-weight: 500;
}
.aesirxui .react-datepicker-wrapper .form-control:focus {
  box-shadow: none;
  border: 1px solid #0a083b;
  background-color: var(--aesirxui-white);
}
.aesirxui .login-form .form-control {
  padding: 14px 16px;
}
.aesirxui .nav-tabs.flex-column {
  border: 0;
}
.aesirxui .nav-tabs.flex-column .nav-item .nav-link {
  padding: 12px 0;
  border: 0;
}
.aesirxui .nav-tabs.flex-column .nav-item .nav-link.active {
  font-weight: 600;
  color: #1ab394;
}
.aesirxui .nav-tabs .nav-item:first-child .nav-link {
  padding-left: 0;
}
.aesirxui .nav-tabs .nav-link.active {
  font-weight: 700;
  border-width: 2px;
}
.aesirxui .nav-pills .nav-link {
  color: var(--bs-body-color);
}
.aesirxui .nav-pills .nav-link.active {
  color: var(--bs-success);
  background-color: var(--aesirxui-white);
  font-weight: 600;
}
.aesirxui .ChartWrapper {
  min-height: 200px;
}
.aesirxui .input-format {
  position: absolute;
  top: 1px;
  right: 0;
  width: 60px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxui .btn svg {
  max-width: 16px;
}
.aesirxui .dropdown-toggle::after {
  display: none !important;
}
.aesirxui .is-list .project-name-logo {
  display: none;
}
.aesirxui .is-list .column-header-shortDescription,
.aesirxui .is-list .cell-shortDescription {
  display: none;
}
.aesirxui .project-name-logo .lazy-load-image-loaded {
  width: 100%;
}
.aesirxui .mode-switcher .form-switch .form-check-input {
  width: 60px;
  height: 30px;
  background-color: #f0f3fb;
  border: 0;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjA3NzEgMjUuNDIwNEMyMC4wODY4IDI1LjQyMDQgMjUuNzY5NCAxOS43Mzc4IDI1Ljc2OTQgMTIuNzI4MUMyNS43Njk0IDUuNzE4MzEgMjAuMDg2OCAwLjAzNTc2NjYgMTMuMDc3MSAwLjAzNTc2NjZDNi4wNjczMSAwLjAzNTc2NjYgMC4zODQ3NjYgNS43MTgzMSAwLjM4NDc2NiAxMi43MjgxQzAuMzg0NzY2IDE5LjczNzggNi4wNjczMSAyNS40MjA0IDEzLjA3NzEgMjUuNDIwNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMy4zODQ0IDYuMDM1NzdDMTMuNzM1OSA2LjAzNTc3IDE0LjAyMDggNi4zMjA2OSAxNC4wMjA4IDYuNjcyMTJWNy45NDQ4NkMxNC4wMjA4IDguMjk2MzEgMTMuNzM1OSA4LjU4MTIxIDEzLjM4NDQgOC41ODEyMUMxMy4wMzI5IDguNTgxMjEgMTIuNzQ4IDguMjk2MjkgMTIuNzQ4IDcuOTQ0ODZWNi42NzIxMkMxMi43NDggNi4zMjA2OSAxMy4wMzI5IDYuMDM1NzcgMTMuMzg0NCA2LjAzNTc3WiIgZmlsbD0iIzVGNUU3MCIvPgo8cGF0aCBkPSJNMTMuMzg0MSA5LjUwNTM3QzExLjQzNDMgOS41MDUzNyA5Ljg1Mzc2IDExLjA4NTkgOS44NTM3NiAxMy4wMzU3QzkuODUzNzYgMTQuOTg1NCAxMS40MzQzIDE2LjU2NiAxMy4zODQxIDE2LjU2NkMxNS4zMzM4IDE2LjU2NiAxNi45MTQ0IDE0Ljk4NTQgMTYuOTE0NCAxMy4wMzU3QzE2LjkxNDQgMTEuMDg1OSAxNS4zMzM4IDkuNTA1MzcgMTMuMzg0MSA5LjUwNTM3WiIgZmlsbD0iIzVGNUU3MCIvPgo8cGF0aCBkPSJNOS4zNDk1MiA4LjEwMDgyQzkuMTAxIDcuODUyMyA4LjY5ODA3IDcuODUyMyA4LjQ0OTU3IDguMTAwODJDOC4yMDEwNSA4LjM0OTM0IDguMjAxMDUgOC43NTIyNyA4LjQ0OTU3IDkuMDAwNzlMOS4zNTg2NyA5LjkwOTg4QzkuNjA3MTkgMTAuMTU4NCAxMC4wMTAxIDEwLjE1ODQgMTAuMjU4NiA5LjkwOTg4QzEwLjUwNzEgOS42NjEzNiAxMC41MDcxIDkuMjU4NDMgMTAuMjU4NiA5LjAwOTkxTDkuMzQ5NTIgOC4xMDA4MloiIGZpbGw9IiM1RjVFNzAiLz4KPHBhdGggZD0iTTYuMzg0NzcgMTMuMDM1OEM2LjM4NDc3IDEyLjY4NDMgNi42Njk2OSAxMi4zOTk0IDcuMDIxMTIgMTIuMzk5NEg4LjI5Mzg1QzguNjQ1MzEgMTIuMzk5NCA4LjkzMDIxIDEyLjY4NDMgOC45MzAyMSAxMy4wMzU4QzguOTMwMjEgMTMuMzg3MiA4LjY0NTMxIDEzLjY3MjEgOC4yOTM4NSAxMy42NzIxSDcuMDIxMTJDNi42Njk2OSAxMy42NzIxIDYuMzg0NzcgMTMuMzg3MyA2LjM4NDc3IDEzLjAzNThaIiBmaWxsPSIjNUY1RTcwIi8+CjxwYXRoIGQ9Ik0xMC4yNTg2IDE3LjA2MTVDMTAuNTA3MSAxNi44MTMgMTAuNTA3MSAxNi40MTAyIDEwLjI1ODYgMTYuMTYxNkMxMC4wMTAxIDE1LjkxMzEgOS42MDcxNiAxNS45MTMxIDkuMzU4NjcgMTYuMTYxNkw4LjQ0OTU3IDE3LjA3MDdDOC4yMDEwNSAxNy4zMTkyIDguMjAxMDUgMTcuNzIyMiA4LjQ0OTU3IDE3Ljk3MDZDOC42OTgwOSAxOC4yMTkxIDkuMTAxIDE4LjIxOTEgOS4zNDk1MiAxNy45NzA2TDEwLjI1ODYgMTcuMDYxNVoiIGZpbGw9IiM1RjVFNzAiLz4KPHBhdGggZD0iTTEzLjM4NDQgMTcuNDkwNEMxMy43MzU5IDE3LjQ5MDQgMTQuMDIwOCAxNy43NzUzIDE0LjAyMDggMTguMTI2N1YxOS4zOTk0QzE0LjAyMDggMTkuNzUwOSAxMy43MzU5IDIwLjAzNTggMTMuMzg0NCAyMC4wMzU4QzEzLjAzMjkgMjAuMDM1OCAxMi43NDggMTkuNzUwOSAxMi43NDggMTkuMzk5NFYxOC4xMjY3QzEyLjc0OCAxNy43NzUzIDEzLjAzMjkgMTcuNDkwNCAxMy4zODQ0IDE3LjQ5MDRaIiBmaWxsPSIjNUY1RTcwIi8+CjxwYXRoIGQ9Ik0xNy40MTA2IDE2LjE2MTZDMTcuMTYyIDE1LjkxMzEgMTYuNzU5MSAxNS45MTMxIDE2LjUxMDYgMTYuMTYxNkMxNi4yNjIxIDE2LjQxMDIgMTYuMjYyMSAxNi44MTMgMTYuNTEwNiAxNy4wNjE1TDE3LjQxOTcgMTcuOTcwNkMxNy42NjgzIDE4LjIxOTEgMTguMDcxMSAxOC4yMTkxIDE4LjMxOTYgMTcuOTcwNkMxOC41NjgyIDE3LjcyMjIgMTguNTY4MiAxNy4zMTkyIDE4LjMxOTYgMTcuMDcwN0wxNy40MTA2IDE2LjE2MTZaIiBmaWxsPSIjNUY1RTcwIi8+CjxwYXRoIGQ9Ik0xNy44MzkxIDEzLjAzNThDMTcuODM5MSAxMi42ODQzIDE4LjEyNCAxMi4zOTk0IDE4LjQ3NTUgMTIuMzk5NEgxOS43NDgyQzIwLjA5OTcgMTIuMzk5NCAyMC4zODQ2IDEyLjY4NDMgMjAuMzg0NiAxMy4wMzU4QzIwLjM4NDYgMTMuMzg3MiAyMC4wOTk3IDEzLjY3MjEgMTkuNzQ4MiAxMy42NzIxSDE4LjQ3NTVDMTguMTI0IDEzLjY3MjEgMTcuODM5MSAxMy4zODczIDE3LjgzOTEgMTMuMDM1OFoiIGZpbGw9IiM1RjVFNzAiLz4KPHBhdGggZD0iTTE4LjMxOTYgOS4wMDA3OUMxOC41NjgyIDguNzUyMjcgMTguNTY4MiA4LjM0OTM0IDE4LjMxOTYgOC4xMDA4MkMxOC4wNzExIDcuODUyMyAxNy42NjgzIDcuODUyMyAxNy40MTk3IDguMTAwODJMMTYuNTEwNiA5LjAwOTkxQzE2LjI2MjEgOS4yNTg0MyAxNi4yNjIxIDkuNjYxMzYgMTYuNTEwNiA5LjkwOTg4QzE2Ljc1OTEgMTAuMTU4NCAxNy4xNjIgMTAuMTU4NCAxNy40MTA2IDkuOTA5ODhMMTguMzE5NiA5LjAwMDc5WiIgZmlsbD0iIzVGNUU3MCIvPgo8L3N2Zz4K);
  background-size: 26px;
  background-position: 2px center;
}
.aesirxui .mode-switcher .form-switch .form-check-input:focus {
  box-shadow: none;
}
.aesirxui .mode-switcher .form-switch .form-check-input:checked {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjA3NzEgMjUuNDIwNEMyMC4wODY4IDI1LjQyMDQgMjUuNzY5NCAxOS43Mzc4IDI1Ljc2OTQgMTIuNzI4MUMyNS43Njk0IDUuNzE4MzEgMjAuMDg2OCAwLjAzNTc2NjYgMTMuMDc3MSAwLjAzNTc2NjZDNi4wNjczMSAwLjAzNTc2NjYgMC4zODQ3NjYgNS43MTgzMSAwLjM4NDc2NiAxMi43MjgxQzAuMzg0NzY2IDE5LjczNzggNi4wNjczMSAyNS40MjA0IDEzLjA3NzEgMjUuNDIwNFoiIGZpbGw9IiMwQzExMjQiLz4KPHBhdGggZD0iTTIwLjI0NzYgMTQuNzcxNkMyMC4xODUxIDE0LjcwOTMgMjAuMTA2MyAxNC42NjYgMjAuMDIwMyAxNC42NDY2QzE5LjkzNDIgMTQuNjI3MyAxOS44NDQ0IDE0LjYzMjggMTkuNzYxNCAxNC42NjI0QzE4LjY0NDkgMTUuMDYwNSAxNy40Mzg0IDE1LjEzMzUgMTYuMjgyIDE0Ljg3MzJDMTUuMTI1NyAxNC42MTI4IDE0LjA2NyAxNC4wMjk3IDEzLjIyODggMTMuMTkxNUMxMi4zOTA3IDEyLjM1MzMgMTEuODA3NiAxMS4yOTQ2IDExLjU0NzMgMTAuMTM4MkMxMS4yODcgOC45ODE4MyAxMS4zNjAyIDcuNzc1MzQgMTEuNzU4MyA2LjY1ODg5QzExLjc4NzkgNi41NzU4IDExLjc5MzMgNi40ODYwMiAxMS43NzQgNi4zOTk5N0MxMS43NTQ2IDYuMzEzOTIgMTEuNzExMyA2LjIzNTExIDExLjY0ODkgNi4xNzI3QzExLjU4NjYgNi4xMTAyOCAxMS41MDc5IDYuMDY2OCAxMS40MjE5IDYuMDQ3MzFDMTEuMzM1OCA2LjAyNzgxIDExLjI0NjEgNi4wMzMxIDExLjE2MjkgNi4wNjI1NUMxMC4xNTY0IDYuNDE3OTkgOS4yNDI5MiA2Ljk5NTg1IDguNDkwNTcgNy43NTMxMkM3LjE0MTg2IDkuMTAyODYgNi4zODQ0MSAxMC45MzMgNi4zODQ3NyAxMi44NDExQzYuMzg1MTMgMTQuNzQ5MiA3LjE0MzI3IDE2LjU3OSA4LjQ5MjUgMTcuOTI4MkM5Ljg0MTcyIDE5LjI3NzQgMTEuNjcxNiAyMC4wMzU2IDEzLjU3OTYgMjAuMDM2QzE1LjQ4NzcgMjAuMDM2MyAxNy4zMTc5IDE5LjI3ODkgMTguNjY3NiAxNy45MzAxQzE5LjQyNDkgMTcuMTc3NyAyMC4wMDI4IDE2LjI2NDEgMjAuMzU4MiAxNS4yNTczQzIwLjM4NzUgMTUuMTc0MiAyMC4zOTI3IDE1LjA4NDQgMjAuMzczMSAxNC45OTg1QzIwLjM1MzUgMTQuOTEyNSAyMC4zMSAxNC44MzM4IDIwLjI0NzYgMTQuNzcxNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=);
  background-position: 30px center;
  background-color: #181f3d;
}
.aesirxui a:hover {
  text-decoration: none !important;
}
.aesirxui .table-border thead th:first-child {
  border-top-left-radius: 10px;
}
.aesirxui .table-border thead th:last-child {
  border-top-right-radius: 10px;
}
.aesirxui .table-border tbody tr:first-child td {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.aesirxui ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #0a083b;
  opacity: 1; /* Firefox */
}
.aesirxui .wrapper_header_logo {
  background-color: var(--aesirxui-sidebar-bg);
}
.aesirxui .damstorage .progress-bar {
  background-color: #0a5aff;
}
.aesirxui .damstorage .progress {
  background-color: rgba(29, 85, 169, 0.662745098);
}
.aesirxui .damstorage .dam-integrate-layout {
  padding-left: 20px;
}
.aesirxui .damstorage a {
  color: white;
}
.aesirxui .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--aesirxui-border-radius-lg);
  border-top-right-radius: var(--aesirxui-border-radius-lg);
}
.aesirxui .modal-center {
  width: 1608px;
  max-width: none;
  height: 1058px;
  margin: 0;
}
.aesirxui .form-control-dam {
  background-color: transparent;
}
.aesirxui .bg-blue-5 {
  background-color: var(--aesirxui-white) !important;
}
.aesirxui .bg-menu {
  background-color: var(--aesirxui-sidebar-bg);
}
.aesirxui .bg-blue-2 {
  background-color: var(--aesirxui-bg-blue-2) !important;
}
.aesirxui .bg-accordion-button {
  background-color: var(--aesirxui-accordion-button-bg) !important;
}
.aesirxui .text-body {
  color: var(--aesirxui-body-color);
}
.aesirxui .bg-body {
  background-color: var(--aesirxui-body-bg);
}
.aesirxui .bg-filter {
  background-color: var(--aesirxui-filter-bg);
}
.aesirxui ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--aesirxui-body-color);
  opacity: 1; /* Firefox */
}
.aesirxui .accordion-button:not(.collapsed) {
  color: var(--aesirxui-body-color);
  background-color: var(--aesirxui-accordion-button-bg);
  box-shadow: none;
}
.aesirxui .accordion {
  --aesirxui-accordion-bg: transparent;
}
.aesirxui .border-bottom {
  border-bottom: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .border-bottom-2 {
  border-bottom: 2px solid var(--aesirxui-gray-dark);
}
.aesirxui .border-start {
  border-top: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .border-top,
.aesirxui .border-top-1 {
  border-top: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .border-end-1,
.aesirxui .border-end {
  border-right: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .border-1 {
  border: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .btn-outline-secondary:not(:hover) {
  background-color: var(--aesirxui-btn-light-bg);
  border-color: var(--aesirxui-gray-dark);
}
.aesirxui .btn:disabled {
  border-color: var(--aesirxui-gray-dark);
}
.aesirxui .btn:hover, .aesirxui .btn:active {
  color: var(--aesirxui-body-color);
  background-color: var(--aesirxui-color-blue-6);
  border-color: var(--aesirxui-gray-dark);
}
.aesirxui .btn.active {
  color: var(--aesirxui-body-color);
  background-color: var(--aesirxui-color-blue-6);
  border-color: var(--aesirxui-gray-dark);
}
.aesirxui .btn-success:disabled {
  border-color: var(--aesirxui-btn-light-bg);
}
.aesirxui .btn-success:hover, .aesirxui .btn-success:active {
  color: var(--aesirxui-btn-hover-color);
  text-decoration: none;
  background-color: var(--aesirxui-btn-hover-bg);
  border-color: var(--aesirxui-btn-hover-border-color);
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link {
  color: var(--aesirxui-item-menu-social-color);
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link.active {
  color: var(--aesirxui-item-menu-social-active);
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link:hover {
  color: var(--aesirxui-item-menu-social-active);
}
.aesirxui .wrapper_tabs .nav-tabs .nav-link::before {
  background-color: #1ab394;
}
.aesirxui .wrapper_calendar_full .rbc-time-header {
  background-color: var(--aesirxui-color-blue-6);
}
.aesirxui .wrapper_calendar_full .css-1w2sb4u-singleValue {
  color: #0a083b;
}
.aesirxui .wrapper_calendar_full .rbc-day-slot.rbc-today {
  background-color: var(--aesirxui-gray-800);
}
.aesirxui .wrapper_calendar_full .rbc-today {
  background-color: var(--aesirxui-color-blue-6);
}
.aesirxui .wrapper_calendar_full .rbc-time-view {
  border: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .wrapper_calendar_full .rbc-time-content {
  border-top: 2px solid var(--aesirxui-gray-dark);
}
.aesirxui .wrapper_calendar_full .rbc-time-content > * + * > * {
  border-left: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .wrapper_calendar_full .rbc-time-header-content {
  border-left: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .wrapper_calendar_full .rbc-timeslot-group {
  border-bottom: 1px solid var(--aesirxui-gray-dark);
}
.aesirxui .bg-gray {
  background-color: var(--aesirxui-color-blue-6);
}
.aesirxui .icon-check {
  padding: 1px;
  width: 20px;
  height: 20px;
}
.aesirxui .file_type input,
.aesirxui .file_size input,
.aesirxui .last_modified input,
.aesirxui .dimension input {
  border: 0;
  padding-left: 0;
  color: #8e8e8e;
}
.aesirxui .modal-80w {
  max-width: none !important;
  width: 80%;
}
.aesirxui .border-select-item {
  border-color: #1ab394;
}
.aesirxui .field_tags svg,
.aesirxui .field_keywords svg {
  display: none;
}
.aesirxui .wr_input_search .form-control:focus {
  box-shadow: none;
}

[data-bs-theme=dark] .aesirxui {
  --aesirxui-body-bg: #101529;
  --aesirxui-color-blue-6: #171e3a;
  --aesirxui-color-blue-9: #181f3d;
  --aesirxui-gray-dark: #1e4284;
  --aesirxui-gray-800: #132342;
  --aesirxui-white: #0c1124;
  --aesirxui-border-color: #1e4284;
  --aesirxui-btn-light-bg: #171e3a;
  --aesirxui-filter-bg: #0c1124;
  --aesirxui-bg-blue-2: #132342;
  --aesirxui-accordion-button-bg: #171e3a;
  --aesirxui-item-menu-social-active: white;
  --aesirxui-menu-lang-hover-bg: #0a5aff;
  --aesirxui-menu-lang-color: white;
  --datepicker-color: #c8c8db;
  --datepicker-range-bg-color: #181f3d;
  --aesirxui-input-disabled-bg: #171e3a;
  --aesirxui-gray-heading: #ffffffcc;
}
[data-bs-theme=dark] .aesirxui .text-gray-heading {
  color: #fff;
}
[data-bs-theme=dark] .aesirxui .bg-white {
  background-color: var(--aesirxui-color-blue-6);
}
[data-bs-theme=dark] .aesirxui .bg-color-blue-9 {
  background-color: var(--aesirxui-color-blue-9);
}
[data-bs-theme=dark] .aesirxui .nav-tabs {
  --aesirxui-nav-tabs-link-active-color: $white;
}
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .wrapper_datepicker .react-datepicker__day-names,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker .react-datepicker__day-names,
[data-bs-theme=dark] .aesirxui .react-datepicker .wrapper_datepicker .react-datepicker__day-names,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker .react-datepicker__day-names {
  border-color: var(--aesirxui-border-color);
}
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__current-month,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day-name,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__current-month,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day-name {
  color: var(--datepicker-color);
}
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day--selected,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day--in-selecting-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day--in-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__month-text--selected,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__month-text--in-selecting-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__month-text--in-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__quarter-text--selected,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__quarter-text--in-selecting-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__quarter-text--in-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__year-text--selected,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__year-text--in-selecting-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__year-text--in-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day.react-datepicker__day--in-range,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day.react-datepicker__day--in-selecting-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day--selected,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day--in-selecting-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day--in-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__month-text--selected,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__month-text--in-selecting-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__month-text--in-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__quarter-text--selected,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__quarter-text--in-selecting-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__quarter-text--in-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__year-text--selected,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__year-text--in-selecting-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__year-text--in-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day.react-datepicker__day--in-range,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day.react-datepicker__day--in-selecting-range {
  background-color: var(--datepicker-range-bg-color);
}
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day.react-datepicker__day--selecting-range-start,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day .react-datepicker__day--selecting-range-end,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day.react-datepicker__day--selecting-range-start,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day .react-datepicker__day--selecting-range-end {
  background-color: var(--aesirxui-menu-lang-hover-bg);
}
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day:hover,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__month-text:hover,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__quarter-text:hover,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__year-text:hover,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day:hover,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__month-text:hover,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__quarter-text:hover,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__year-text:hover {
  background-color: var(--aesirxui-menu-lang-hover-bg);
  color: white;
}
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day.react-datepicker__day--in-range:after,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day.react-datepicker__day--in-selecting-range:after,
[data-bs-theme=dark] .aesirxui .wrapper_datepicker .react-datepicker__day.react-datepicker__day--keyboard-selected:after,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day.react-datepicker__day--in-range:after,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day.react-datepicker__day--in-selecting-range:after,
[data-bs-theme=dark] .aesirxui .react-datepicker .react-datepicker__day.react-datepicker__day--keyboard-selected:after {
  background-color: var(--aesirxui-menu-lang-hover-bg);
}
[data-bs-theme=dark] .aesirxui .react-datepicker,
[data-bs-theme=dark] .aesirxui .react-datepicker__header {
  background-color: var(--aesirxui-body-bg);
}
[data-bs-theme=dark] .aesirxui .date-picker .react-datepicker__input-container input:read-only {
  background-color: var(--aesirxui-body-bg);
  border-color: var(--aesirxui-body-bg);
}
[data-bs-theme=dark] .aesirxui .daterange-picker .react-datepicker__day.react-datepicker__day--in-range:hover,
[data-bs-theme=dark] .aesirxui .daterange-picker .react-datepicker__day.react-datepicker__day--in-selecting-range:hover {
  background-color: #0c1124;
}
[data-bs-theme=dark] .aesirxui #contextMenuItem > div:not(:last-child) svg path {
  fill: #fff;
}
[data-bs-theme=dark] .aesirxui #contextMenuItem > div:not(:last-child) .stroke-dark path {
  stroke: #fff;
  fill: transparent;
}
[data-bs-theme=dark] .aesirxui .border-select-item {
  border-color: var(--aesirxui-gray-dark);
}
[data-bs-theme=dark] .aesirxui .form-switch .form-check-input {
  --aesirxui-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%238dd9ca'/%3e%3c/svg%3e") !important;
}

:root {
  --aesirxui-sidebar-bg: #0c1124;
  --aesirxui-sidebar-submenu-bg: #0c1124;
  --aesirxui-sidebar-menu-item-color: #fff;
  --aesirxui-sidebar-menu-item-hover-bg: #0a5aff;
  --aesirxui-menu-lang-color: #0c1124;
  --aesirxui-menu-lang-hover-bg: #e9e9e9;
  --aesirxui-btn-light-bg: white;
  --aesirxui-filter-bg: white;
  --aesirxui-bg-blue-2: #0c1124;
  --aesirxui-accordion-button-bg: #f0f3fb;
  --aesirxui-item-menu-social-color: #a5a4b5;
  --aesirxui-item-menu-social-active: #132342;
  --aesirxui-input-placeholder-color: #c0c0c0;
  --aesirxui-input-disabled-bg: #e9e9e9;
  --datepicker-range-bg-color: #ebf3f6;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css));
export {
  A8 as ActionsBar,
  AesirXDatePicker,
  AesirXI18nextProvider,
  AesirXSelectExtended as AesirXSelect,
  AppProvider,
  Button,
  B as ButtonNormal,
  Checkbox,
  ComponentCard,
  CustomizedDatePicker,
  DigitalAssetsPage,
  EditMemberProvider,
  EditMemberRoleProvider,
  EditRoleProvider,
  ErrorBoundary,
  FORMAT_DATE,
  FORMAT_DATE_TIME_UPDATE_POST,
  FORMAT_DATE_UPDATE_POST,
  FORMAT_TIME,
  FORM_FIELD_TYPE,
  FormCheckbox,
  A2 as FormColor,
  FormDAMImage,
  FormDateRangePicker,
  FormEditor,
  A3 as FormImage,
  FormRadio,
  FormSelection,
  A4 as FormUrl,
  FormVideo,
  A5 as FormYoutube,
  GlobalFilter,
  Hambuger,
  Header,
  Image,
  A as Input,
  InputPassword,
  LanguagesSwitcher,
  Licenses,
  LoginPage,
  Logo,
  MainLayout,
  MemberRolePage,
  MembersPage,
  Menu,
  ModalComponentExtended as ModalComponent,
  ModalDAMComponent,
  PAGE_STATUS,
  PermissionPage,
  ProfilePage,
  A6 as PublishOptions,
  PulseLoaderComponent,
  RingLoaderComponent,
  RolesPage,
  SVGComponent,
  SbarLeft,
  Spinner,
  A7 as Table,
  TableBar,
  ThemesContext,
  ThemesContextProvider,
  ThumbWithTranslation as Thumb,
  Toast,
  history,
  isLogin,
  listThemes,
  login,
  logout,
  notify,
  notifyHTML,
  renderField,
  renderingGroupFieldHandler,
  useAppContext,
  useI18nextContext,
  useThemeContext,
  withI18nextContext,
  withThemeContext
};
